{
  "AccountInvitations": {
    "AccessAddedBody": "Uw bestaande account is aan {customer} gekoppeld. U kunt met uw huidige wachtwoord inloggen.",
    "AccessAddedTitle": "Toegang toegevoegd",
    "Activate": "Toegang aanvragen",
    "Consent": "Ik wil deze klanttoegang aanvragen en ga akkoord met het aanmaken van mijn toegang.",
    "Context": "Hallo {name}, met deze uitnodiging vraagt u toegang voor {email} tot {customer} aan.",
    "ExistingAccount": "Uw bestaande, geverifieerde account wordt aan deze klant gekoppeld. Uw wachtwoord verandert niet.",
    "Expires": "Deze uitnodiging is geldig tot {date}.",
    "GoToLogin": "Naar inloggen",
    "Loading": "Uitnodiging controleren…",
    "Title": "Accountuitnodiging",
    "UnavailableBody": "De link is ongeldig, verlopen, ingetrokken of al gebruikt. Vraag zo nodig een nieuwe uitnodiging aan.",
    "UnavailableTitle": "Uitnodiging niet beschikbaar",
    "VerificationEmail": "Na uw akkoord wordt de klanttoegang aangemaakt. Daarna ontvangt u op dit e-mailadres de verificatiemail om uw identiteit te bevestigen en een wachtwoord in te stellen.",
    "VerifyEmailBody": "Uw klanttoegang is aangemaakt. Wij hebben de verificatiemail naar {email} gestuurd. Open die e-mail om uw identiteit te bevestigen en een wachtwoord in te stellen.",
    "VerifyEmailTitle": "Controleer uw e-mail"
  },
  "Admin": {
    "AssetsOverview": {
      "searchCategories": "Zoek categorie",
      "noMatchingCategories": "Geen categorieën gevonden.",
      "presence": {
        "present": "Assets aanwezig",
        "empty": "Geen actuele assets",
        "unknown": "Aanwezigheid onbekend"
      },
      "chooseCategory": "Vink links een categorie aan om assets te bekijken.",
      "lastBackupStatus": "Resultaat laatste backup",
      "lastBackupStatusHistory": "Resultaat laatste backup per meetmoment",
      "customers": "Klant | Klanten",
      "workspaceTitle": "Opgeslagen assets per klant",
      "snapshotBadge": "Momentopnames",
      "categories": "Categorie | Categorieën",
      "selection": "Selectie",
      "navigatorHint": "Laad het overzicht om hier tussen assetcategorieën te wisselen.",
      "overview": "Assetoverzicht",
      "notLoaded": "Nog geen overzicht geladen",
      "readHint": "Opgeslagen gegevens · Geen externe API-aanroepen",
      "snapshotHint": "Herkomst van het geladen overzicht",
      "snapshotEmptyHint": "Na het laden zie je hier het meetmoment per klant.",
      "tableOnlyHint": "Voor dit assettype zijn wel tabelgegevens, maar geen diagramgegevens gevonden. Kies Alleen tabellen of Tabellen en diagrammen en laad het overzicht opnieuw.",
      "noAssetData": "Er is geen data gevonden voor dit assettype.",
      "load": "Overzicht laden",
      "allCustomers": "Alle klanten",
      "selectedCustomers": "{count} klant geselecteerd | {count} klanten geselecteerd",
      "allTypes": "Alle assettypen",
      "selectedTypes": "{count} assettype geselecteerd | {count} assettypen geselecteerd",
      "pendingFilters": "Filters gewijzigd. Klik op Overzicht laden om ze toe te passen.",
      "emptyTitle": "Jouw overzicht, op aanvraag",
      "emptyHint": "Stel de filters in en klik op Overzicht laden. Er worden nog geen assets opgehaald.",
      "customerCount": "Geen klanten met assets | {count} klant met assets | {count} klanten met assets",
      "noSnapshot": "Geen snapshot",
      "noAssets": "Geen opgeslagen assets gevonden voor deze selectie.",
      "snapshotDates": "Meetmomenten per klant",
      "collapseSnapshots": "Meetmomenten inklappen",
      "expandSnapshots": "Meetmomenten uitklappen",
      "customerError": "De klantenlijst kon niet worden geladen.",
      "loadError": "Deze gegevens konden niet worden geladen. Probeer opnieuw; laad bij een verlopen snapshot het overzicht opnieuw.",
      "retry": "Opnieuw proberen",
      "confirmTitle": "Assets opnieuw ophalen?",
      "confirmBody": "Alle externe integraties worden opnieuw aangeroepen voor {count} klant. Wil je doorgaan? | Alle externe integraties worden opnieuw aangeroepen voor {count} klanten. Wil je doorgaan?",
      "confirmHint": "Dit kan enkele minuten duren. Het assettypefilter beperkt deze actie niet. Voor alleen het bekijken van opgeslagen gegevens gebruik je Overzicht laden.",
      "cancel": "Annuleren",
      "confirmAction": "Opnieuw ophalen",
      "refreshProgress": "Assets ophalen: {current} van {total} klant verwerkt. | Assets ophalen: {current} van {total} klanten verwerkt.",
      "refreshResult": "Assets opgehaald voor {success} van {total} klant. | Assets opgehaald voor {success} van {total} klanten.",
      "refreshFailed": "Ophalen mislukt. Controleer de integratieconfiguratie en of de opgeslagen secrets met de huidige sleutel leesbaar zijn."
    },
    "Asterisk-status": {
      "Agent warning": "De actuele status van de telefooncentrale is niet beschikbaar of de laatste verwerking is mislukt. De laatst werkende configuratie blijft actief.",
      "Available": "Beschikbaar",
      "Error": "Configuratiefout",
      "Inactive": "Inactief",
      "Label": "Status telefooncentrale",
      "Not configured": "Niet in gebruik",
      "Pending": "Wordt verwerkt",
      "Stale": "Status verouderd",
      "Unavailable": "Niet geregistreerd",
      "Unknown": "Status onbekend"
    },
    "AccountInvitations": {
      "Account": "Account",
      "Actions": "Acties",
      "ApplyFilters": "Filters toepassen",
      "AutomaticCustomerUser": "Na acceptatie maakt Vision automatisch de juiste klantgebruiker en koppeling aan deze klant aan. Voor een nieuw of nog onbevestigd account verstuurt Vision daarna de verificatiemail om de identiteit te bevestigen en een wachtwoord in te stellen. Bestaande accounts die alleen tot het Admin portal behoren worden uitgesloten.",
      "BackToSelection": "Terug naar selectie",
      "Batch": "Batchreferentie",
      "BatchReference": "Batchreferentie",
      "Campaign": "Campagnereferentie",
      "CampaignReference": "Campagnereferentie",
      "Confirm": "Ik heb de selectie en uitsluitingen gecontroleerd en wil deze persoonlijke links voorbereiden.",
      "ContactIds": "Klantcontacten",
      "Contacts": "Klantcontacten",
      "Copied": "Activatielink gekopieerd.",
      "Copy": "Activatielink kopiëren",
      "Customer": "Klant",
      "Delivery_mailchimp": "Mailchimp",
      "Delivery_manual": "Handmatig / Excel",
      "DeliveryMethod": "Aflevermethode",
      "DeliveryMethodOptions": {
        "Mailchimp": "Mailchimp",
        "Manual": "Handmatig / Excel"
      },
      "DownloadExcel": "Excel downloaden",
      "Eligible": "Geschikt",
      "Email": "E-mailadres",
      "ErrorLoading": "De lijst met accountuitnodigingen kon vanwege een fout niet worden geladen.",
      "Excluded": "Uitgesloten",
      "ExclusionReasons": {
        "AdminPortalAccount": "Dit bestaande account behoort alleen tot het Admin portal en kan niet als klantgebruiker worden gekoppeld.",
        "AlreadyHasAccess": "Dit account heeft deze klantrollen al voor deze klant.",
        "AmbiguousAccount": "Bij dit e-mailadres zijn meerdere gebruikersaccounts gevonden.",
        "AmbiguousEmail": "Dit e-mailadres komt meerdere keren voor in de geselecteerde klantcontacten.",
        "MailchimpMergeFieldInvalid": "De URL merge tag VISIONURL in Mailchimp is niet juist geconfigureerd.",
        "MailchimpMergeFieldMissing": "De URL merge tag VISIONURL ontbreekt in Mailchimp.",
        "MailchimpNotSubscribed": "Dit contact is niet of niet meer aangemeld voor e-mail in de Mailchimp-audience.",
        "MailchimpUnavailable": "De status van dit contact in de Mailchimp-audience kon niet worden gecontroleerd.",
        "MissingName": "De voornaam of achternaam ontbreekt bij dit contact.",
        "MissingOrInvalidEmail": "Bij dit contact ontbreekt een geldig e-mailadres.",
        "NonInteractiveAccountConflict": "Dit e-mailadres behoort al bij een technisch account en kan niet voor een klantgebruiker worden gebruikt.",
        "NotMailable": "Bij dit contact staat E-mail ontvangen op nee.",
        "OpenInvitation": "Voor dit contact staat al een geldige accountuitnodiging open."
      },
      "Existing": "Bestaand",
      "Expires": "Geldig tot",
      "GenericError": "De accountuitnodigingen konden niet worden verwerkt.",
      "History": "Uitnodigingshistorie",
      "Intro": "Maak persoonlijke, tijdelijke activatielinks en lever ze handmatig of via Mailchimp af.",
      "LoadingContacts": "Klantcontacten worden geladen…",
      "MailchimpChecking": "Mailchimp-configuratie wordt gecontroleerd…",
      "MailchimpDelivery": "Mailchimp",
      "MailchimpNotReady": "Mailchimp is uitgeschakeld, niet volledig geconfigureerd of mist een private, niet-verplichte URL merge tag",
      "MailchimpReady": "Mailchimp is gereed met de private, niet-verplichte URL merge tag",
      "MailchimpRetryOneTimeWarning": "Een of meer Mailchimp-updates zijn mislukt. Deze volledige activatielinks worden maar één keer getoond. Download het Excel-bestand en probeer de Mailchimp-update opnieuw voordat je dit venster sluit.",
      "MailchimpStatusOptions": {
        "Cleared": "Gewist",
        "Disabled": "Uitgeschakeld",
        "Failed": "Mislukt",
        "Pending": "Wordt verwerkt",
        "Synced": "Bijgewerkt"
      },
      "ManualDelivery": "Handmatig / Excel",
      "ManualDeliveryNotice": "Vision maakt de links alleen aan en toont ze eenmalig voor kopiëren of een door de API gemaakte Excel-export. Mailchimp wordt niet geraadpleegd of gewijzigd en tijdens het voorbereiden verstuurt Vision geen e-mail.",
      "ManualOneTimeWarning": "Deze persoonlijke activatielinks worden maar één keer getoond. Kopieer ze nu of download het Excel-bestand en behandel dat als vertrouwelijke informatie.",
      "New": "Nieuw",
      "NewDialogTitle": "Nieuwe accountuitnodigingen voorbereiden",
      "NewInvitationBatch": "Nieuwe accountuitnodigingen",
      "OneTimeWarning": "Mailchimp is bijgewerkt. Deze volledige activatielinks worden maar één keer getoond. Download het Excel-bestand voordat je dit venster sluit als je ze wilt bewaren.",
      "Prepare": "Links voorbereiden",
      "Prepared": "De accountuitnodigingen zijn voorbereid.",
      "Preview": "Selectie controleren",
      "PreviewTitle": "Voorvertoning: nog niets aangemaakt",
      "Reason": "Reden",
      "Refresh": "Vernieuwen",
      "Reissue": "Nieuwe link uitgeven",
      "ReissueConfirm": "Weet je zeker dat je een nieuwe link voor {email} wilt uitgeven? Een eventueel nog geldige huidige link wordt daarna ingetrokken.",
      "ReissuedFromPortal": "Opnieuw uitgegeven vanuit het beheerportaal",
      "ReissueOneTime": "De nieuwe link wordt eenmalig getoond.",
      "ReplaceOpen": "Trek bestaande open uitnodigingen voor deze selectie in",
      "ReplaceOpenInvitations": "Trek bestaande open uitnodigingen voor deze selectie in",
      "Result": "Voorbereide links",
      "ResultDialogTitle": "Eenmalige activatielinks",
      "Retry": "Mailchimp opnieuw proberen",
      "RetrySuccess": "Mailchimp is bijgewerkt zonder de token te vervangen.",
      "Revoke": "Uitnodiging intrekken",
      "RevokeConfirm": "Weet je zeker dat je de open uitnodiging voor {email} wilt intrekken?",
      "RevokedFromPortal": "Ingetrokken vanuit het beheerportaal",
      "Roles": "Klantrollen",
      "ScheduledSendAt": "Geldig vanaf",
      "Selection": "Selectie en geldigheid",
      "Status": "Status",
      "StatusOptions": {
        "Accepted": "Geaccepteerd",
        "Failed": "Mislukt",
        "Pending": "Open",
        "Processing": "Wordt verwerkt",
        "Revoked": "Ingetrokken"
      },
      "Title": "Accountuitnodigingen",
      "ValidDays": "Aantal dagen geldig",
      "ValidForDays": "Aantal dagen geldig",
      "ValidFrom": "Geldig vanaf",
      "Whitelabel": "Whitelabel"
    },
    "Audit-logs": {
      "ClientIp": "IP-adres",
      "Data": "Data",
      "Differences": "Verschillen",
      "Error loading data": "De lijst met audit-logs kon vanwege een fout niet worden geladen.",
      "Id": "ID",
      "ImpersonatedBy": "Impersonatie door",
      "ImpersonatedByOptions": {
        "NoImpersonation": "Geen impersonatie"
      },
      "Level": "Resultaat",
      "LevelOptions": {
        "Error": "Mislukt",
        "Success": "Succesvol"
      },
      "Meta": {
        "impersonatedBy": "Impersonatie door",
        "method": "Methode",
        "path": "Service",
        "user": "Gebruiker"
      },
      "Method": "Methode",
      "OriginalObject": "Origineel object",
      "Path": "Service",
      "Pipeline": "Pipeline",
      "Query": "Query",
      "RequestId": "Request ID",
      "ResultObject": "Resultaat object",
      "Timestamp": "Datum",
      "User": "Gebruiker",
      "UserOptions": {
        "NoUser": "Geen ingelogde gebruiker"
      },
      "View item": "Audit log details"
    },
    "Authmanagement-roles": {
      "Already assigned": "Al gekoppeld",
      "Assign roles": "Rollen toewijzen",
      "Assign roles to customer": "Rollen aan klant toewijzen",
      "AssignRoles item fail": "Fout bij het toewijzen van rollen. {msg}",
      "AssignRoles item success": "Rollen succesvol toegewezen.",
      "Auth source": "Authenticatiebron",
      "Available roles": "Beschikbare rollen",
      "Customer": "Klant",
      "Customers": "Klanten",
      "Delete": "verwijderen",
      "Delete item": "Rol verwijderen",
      "Delete item fail": "De rol kon niet worden verwijderd. {msg}",
      "Delete item success": "Rol succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je de rol {0} wilt {1}?",
      "Edit item": "Rol wijzigen",
      "Edit item fail": "Fout bij het wijzigen van de rol. {msg}",
      "Edit item success": "Rol succesvol gewijzigd.",
      "Error loading data": "De lijst met rollen kon vanwege een fout niet worden geladen.",
      "Name": "Rol",
      "New item": "Nieuwe rol",
      "New item fail": "Fout bij het aanmaken van de rol. {msg}",
      "New item success": "Rol succesvol toegevoegd.",
      "No assignable roles": "Geen rollen beschikbaar om aan deze klant toe te wijzen.",
      "No roles selected": "Geen rollen geselecteerd.",
      "Refresh list": "Lijst met rollen vernieuwen",
      "Role": "Rol",
      "Roles to assign": "Toe te wijzen rollen",
      "Select customer": "Klant kiezen",
      "Select roles": "Rollen kiezen",
      "Selected customer": "Gekozen klant",
      "Summary": "Samenvatting",
      "Roles": {
        "Assets": "Assetbeheer",
        "Purchase-orders": "Inkooporders",
        "Stock": "Voorraad",
        "Stock-locations": "Voorraadlocaties",
        "Stock-movements": "Voorraadmutaties",
        "Audit-logs": "Audit logs",
        "Account-invitations": "Accountuitnodigingen",
        "Authmanagement-roles": "Authmanagement-rollen",
        "Business-insights": "Vision insights",
        "Card-menus": "Kaartmenu's",
        "Contacts": "Contacten",
        "Contracts": "Contracten",
        "Customer-assets": "Klantassets",
        "Customer-contacts": "Klantcontacten",
        "Customer-offers": "Offertes",
        "Customer-phone-numbers": "Klanttelefoonnummers",
        "Customer-sip-accounts": "Klant-SIP-accounts",
        "Customer-users": "Klant gebruikers",
        "Customers": "Klanten",
        "Dmarc": "DMARC",
        "Dmarc-aggregate-reports": "DMARC aggregatierapporten",
        "Dmarc-failure-reports": "DMARC foutrapporten",
        "Domain-ns-groups": "Nameservergroepen",
        "Domain-tld-settings": "Domein TLD instellingen",
        "Domains": "Domeinen",
        "Email-logs": "E-mailbeheer",
        "Email-message-templates": "Berichttemplates",
        "Email-queue": "E-mail wachtrij",
        "Email-triggers": "E-mail triggers",
        "Feedback-answers": "Feedbackantwoorden",
        "Feedback-questions": "Feedbackvragen",
        "Files": "Bestanden",
        "Invoices": "Facturen",
        "License-partner-programs": "Partnerprogramma's",
        "License-slas": "SLA's",
        "Licenses": "Licenties",
        "Product-groups": "Productgroepen",
        "Products": "Producten",
        "Project-task-time-tracking": "Tijdregistratie",
        "Project-task-types": "Taaktypen",
        "Project-tasks": "Projecttaken",
        "Projects": "Projecten",
        "Sales-orders": "Verkooporders",
        "Sepa": "SEPA",
        "Settings": "Instellingen",
        "Sms-logs": "SMS statistieken",
        "Sharingcenter-meeting-files": "OMNI Sessions meetingbestanden",
        "Sharingcenter-appointments": "OMNI Sessions afspraken",
        "Sharingcenter-calendar-settings": "OMNI Sessions calendar instellingen",
        "Sharingcenter-calendars": "OMNI Sessions agendas",
        "Sharingcenter-contacts": "OMNI Sessions contacten",
        "Sharingcenter-profiles": "OMNI Sessions profielen",
        "Sharingcenter-groups": "OMNI Sessions groepen",
        "Sharingcenter-meeting-logs": "OMNI Sessions statistieken",
        "Sharingcenter-colleagues": "OMNI Sessions collega's",
        "Sharingcenter-ai-queue": "OMNI Sessions AI-taakwachtrij",
        "Ssl-certificates": "SSL-certificaten",
        "Subscriptions": "Abonnementen",
        "User-totp-devices": "Gebruikers TOTP-apparaten",
        "Users": "Gebruikers",
        "Vat": "BTW",
        "Vpn-activity": "VPN-activiteiten",
        "Vpn-certificates": "VPN-certificaten",
        "Vpn-firewall-verification-logs": "VPN-firewallverificatielogs",
        "Vpn-firewalls": "VPN-firewalls",
        "Vpn-mac-address-groups": "VPN-macadresgroepen",
        "Webhooks/health-status": "Health status",
        "Webhosting": "Webhosting",
        "Webhosting-packages": "Webhosting pakketten",
        "Whitelabels": "Whitelabels",
        "Microsoft-privileged-sign-ins": "Microsoft-aanmeldmonitor",
        "Overview-totals": "Globale overzichtstotalen",
        "Webhooks": "Webhooks",
        "Webhook-queue": "Webhook-afleveringen",
        "Webhook-logs": "Webhooklogs",
        "Suppliers": "Leveranciers",
        "Supplier-contacts": "Leverancierscontacten",
        "Supplier-assessments": "Leveranciersbeoordelingen",
        "Supplier-documents": "Leveranciersdocumenten"
      }
    },
    "Card-menus": {
      "App search no results": "Oh nee! Die app lijkt te ontbreken!",
      "Which app can we help you find today": "Welke app zoek je vandaag?"
    },
    "Contacts": {
      "City": "Plaats",
      "Clone item": "Contact klonen",
      "Clone item fail": "Fout bij het klonen van de contactpersoon. {msg}",
      "Clone item success": "Contact succesvol gekloond.",
      "CompanyName": "Bedrijfsnaam",
      "Contact": "Contact",
      "Country": "Land",
      "CountryBirth": "Geboorteland",
      "Customer": "Klant",
      "DateBirth": "Geboortedatum",
      "Delete": "verwijderen",
      "Delete item": "Contactpersoon verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de contactpersoon. {msg}",
      "Delete item success": "Contact verwijderd.",
      "Delete item text": "Weet u zeker dat u de contactpersoon {0} wilt {1}?",
      "Delete ProductCommitments item": "Producttoezegging verwijderen",
      "Domain": "Domein",
      "Edit item": "Contactpersoon bewerken",
      "Edit item fail": "Fout bij het bewerken van de contactpersoon. {msg}",
      "Edit item success": "Contactpersoon succesvol gewijzigd.",
      "Email": "E-mail adres",
      "EnsId": "Geschiktheid en naamselectie-ID",
      "EnsPassword": "Geschiktheids- en naamselectiewachtwoord",
      "Errors": {
        "default": "Er is iets mis gegaan tijdens het verwerken van het contact. {msg}",
        "ErrorCode": {
          "OXXA_API_BAD_STATUS_CODE": "Kan geen verbinding maken met domeinleverancier.",
          "OXXA_API_NO_CHANGES": "Het contactpersoon is ongewijzigd.",
          "OXXA_API_NO_HANDLE_FOUND": "Geen ID gevonden bij de leverancier.",
          "OXXA_API_REMOVE_DATA_NOT_FOUND": "Geen gegevens gevonden om te verwijderen.",
          "OXXA_API_REQUEST_FAILED": "Kan geen verbinding maken met domeinleverancier.",
          "OXXA_API_RESULT_DIFF": "Het contactpersoon is gedeeltelijk gewijzigd, controleer het resultaat.",
          "OXXA_API_RESULT_NOT_FOUND": "Geen resultaten gevonden voor contact."
        }
      },
      "Fax": "Faxnummer",
      "FirstName": "Voornaam",
      "Handle": "Handle",
      "HkIndustryType": "HK Industry Type",
      "HouseNumber": "Huisnummer",
      "HouseNumberSuffix": "Toevoeging",
      "IdCardDate": "Datum identiteitskaart",
      "IdCardIssuer": "Uitgever van identiteitskaart",
      "IdNumber": "ID-kaart nummer",
      "Initials": "Initialen",
      "JobTitle": "Functietitel",
      "LastName": "Achternaam",
      "Name": "Naam",
      "New item": "Nieuw contact",
      "New item fail": "Fout bij het maken van een contactpersoon. {msg}",
      "New item success": "Contact toegevoegd.",
      "No customer attached": "Geen klant gekoppeld",
      "PlaceBirth": "Geboorteplaats",
      "PostalBirth": "Postcode van geboorteplaats",
      "PostalCode": "Postcode",
      "Profession": "Beroep",
      "Registrar": "Registrator",
      "RegistrarOptions": {
        "None": "Geen",
        "Other": "Other",
        "Oxxa": "Oxxa",
        "Xolphin": "Xolphin"
      },
      "RegNumber": "Registratienummer",
      "State": "Staat/Provincie",
      "Street": "Straat",
      "Tabs": {
        "Additional details": {
          "Additional details": "Aanvullende details",
          "Aero domain": ".aero domein specifieke details",
          "CoC details": "Kvk gegevens",
          "Hk domain": ".hk domain specifieke details",
          "ID card": "ID-kaart",
          "Pro domain": ".pro domein specifieke details",
          "Sponsored community": "Gesponsorde communitygegevens",
          "Sponsored community context": "De onderstaande domeinen zijn gesponsorde domeinen en hebben sponsorreferenties nodig, evenals domeinspecifieke details",
          "Trademark details": "Handelsmerk gegevens",
          "Travel domain": ".travel domein specifieke details"
        },
        "Contact details": "Contact gegevens",
        "General": "Algemeen"
      },
      "Tel": "Telefoonnummer",
      "TmCountry": "Land van handelsmerk",
      "TmName": "Handelsmerknaam",
      "TmNumber": "Handelsmerknummer",
      "TravelUinId": "Reisbranche-ID",
      "VatNumber": "BTW-nummer",
      "XxxMemberId": "Gesponsorde communitylid-ID",
      "XxxPassword": "Wachtwoord voor gesponsorde communitylid-ID"
    },
    "Contracts": {
      "Add ProductCommitments item": "Productcommitment toevoegen",
      "Amount": "Aantal",
      "Archive": "archiveren",
      "CancelDate": "Opgezegd per",
      "Cancelled": "Opgezegd",
      "Contract": "Contract",
      "Customer": "Klant",
      "Dates": "Datums",
      "Delete": "verwijderen",
      "Delete item": "Contract verwijderen",
      "Delete item fail": "Fout bij het verwijderen van het contract. {msg}",
      "Delete item success": "Contract verwijderd.",
      "Delete item text": "Weet u zeker dat u het contract {0} wilt {1}?",
      "Delete ProductCommitments item": "Producttoezegging verwijderen",
      "Discount": "Korting",
      "DiscountType": "Type",
      "DiscountTypeOptions": {
        "Percentage": "Percentage"
      },
      "Edit item": "Contract bewerken",
      "Edit item fail": "Fout bij het bewerken van het contract. {msg}",
      "Edit item success": "Contract succesvol gewijzigd.",
      "EndDate": "Einddatum",
      "Errors": {
        "CONTRACT_IS_ACTIVE": "Een actief contract kan niet worden verwijderd.",
        "ErrorCode": {
          "PRODUCTCOMMITMENT_BUNDLE_DISCOUNT_NOT_SUPPORTED": "Kortingen op bundelproducten zijn niet mogelijk voor productverplichtingen.",
          "PRODUCTCOMMITMENT_DOUBLE_PRODUCTS_NOT_SUPPORTED": "Dubbele producten zijn niet mogelijk voor productverplichtingen."
        }
      },
      "InvestmentRepaymentMonths": "Investeringstermijn",
      "IsArchived": "Gearchiveerd",
      "LicenseContractInfo": "Dit contract hoort bij een licentie. De begindatum, einddatum en opzegdatum worden beheerd via licentiebeheer.",
      "Name": "Naam",
      "New item": "Nieuw contract",
      "New item fail": "Fout bij het maken van een contract. {msg}",
      "New item success": "Contract succesvol toegevoegd.",
      "Period": "Opzegperiode",
      "Periodic": "Opzeg periodiek",
      "PriceIndex": "Prijsindex",
      "Product": "Product",
      "ProductCommitments": "Productverplichtingen",
      "RenewalPeriod": "Verlengingsperiode",
      "RenewalPeriodic": "Verlenging periodiek",
      "RenewalPeriodicOptions": {
        "Day": "Dag",
        "Month": "Maand",
        "Year": "Jaar"
      },
      "RenewDate": "Verlengingsdatum",
      "StartDate": "Begindatum",
      "Tabs": {
        "General": "Algemeen",
        "Product commitments": "Productverplichtingen",
        "Subscriptions": "@:Shared.Globals.Subscriptions"
      },
      "This contract has ended or was cancelled, consider removing it": "Dit contract is geëindigd of opgezegd en kan worden verwijderd.",
      "Type": "Type"
    },
    "Customer-assets": {
      "AppDisplayName": "Weergavenaam van app",
      "ClientAppUsed": "Client-app gebruikt",
      "CustomerName": "Naam klant",
      "DeviceDetail": {
        "operatingSystem": "Besturingssysteem"
      },
      "Location": {
        "city": "Plaats",
        "countryOrRegion": "Land of Regio",
        "state": "Provincie"
      },
      "UserPrincipalName": "Principal-naam van gebruiker"
    },
    "Customer-contacts": {
      "Address": "Adres",
      "Address information": "Adresgegevens",
      "Birthday": "Geboortedatum",
      "City": "Plaats",
      "Comments": "Opmerkingen",
      "Contact": "Contact",
      "Country": "Land",
      "Customer": "Klant",
      "Customer address": "Klant adres",
      "Delete": "verwijderen",
      "Delete item": "Klantcontact verwijderen",
      "Delete item fail": "Het verwijderen van klantcontact is mislukt. {msg}",
      "Delete item success": "Klantcontact succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u klant contact {0} wilt {1}?",
      "Edit item": "Klantcontact bewerken",
      "Edit item fail": "Fout bij het wijzigen van het contact. {msg}",
      "Edit item success": "Klantcontact succesvol gewijzigd.",
      "EmailAddress": "E-mail adres",
      "Export": "Exporteer",
      "FirstName": "Voornaam",
      "Initials": "Initialen",
      "InvoiceReference": "Referentie factuur",
      "JobTitle": "Functietitel",
      "Labels": "Labels",
      "LastName": "Achternaam",
      "Name": "Naam",
      "New item": "Nieuw contact",
      "New item fail": "Het is niet gelukt om nieuw klantcontact aan te maken. {msg}",
      "New item success": "Klantcontact succesvol toegevoegd.",
      "No labels": "Geen labels",
      "OverwriteAddress": "Adres overschrijven",
      "Phone": "Telefoonnummer",
      "Salutation": "Aanhef",
      "SalutationOptions": {
        "D": "Afdeling",
        "F": "Vrouw",
        "M": "Man",
        "U": "Niet opgegeven"
      },
      "SendMail": "Verstuur e-mail",
      "Tabs": {
        "General": "Algemeen"
      },
      "Zipcode": "Postcode"
    },
    "Customer-phone-numbers": {
      "Active": "Actief",
      "Customers": "Klanten",
      "Delete": "verwijderen",
      "Delete item": "Telefoonnummer verwijderen",
      "Delete item fail": "Het telefoonnummer kon niet worden verwijderd. {msg}",
      "Delete item success": "Telefoonnummer succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je telefoonnummer {0} wilt {1}?",
      "Direction required": "Schakel minimaal inkomend of uitgaand verkeer in.",
      "Directions": "Richtingen",
      "Edit item": "Telefoonnummer bewerken",
      "Edit item fail": "Fout bij het wijzigen van het telefoonnummer. {msg}",
      "Edit item success": "Telefoonnummer succesvol gewijzigd.",
      "Errors": {
        "ErrorCode": {
          "PHONE_NUMBER_ALREADY_EXISTS": "Dit telefoonnummer bestaat al.",
          "PHONE_NUMBER_DIRECTION_REQUIRED": "Schakel minimaal inkomend of uitgaand verkeer in.",
          "PHONE_NUMBER_IN_USE": "Dit telefoonnummer is geselecteerd in klant- of profielinstellingen van een gekoppelde klant.",
          "PHONE_NUMBER_SIP_ACCOUNT_INACTIVE": "Een actief telefoonnummer vereist een actief SIP-account.",
          "PHONE_NUMBER_SIP_ACCOUNT_NOT_FOUND": "Het geselecteerde SIP-account bestaat niet."
        }
      },
      "Inbound": "Inkomend",
      "Label": "Label",
      "New item": "Nieuw telefoonnummer",
      "New item fail": "Fout bij het toevoegen van het telefoonnummer. {msg}",
      "New item success": "Telefoonnummer succesvol toegevoegd.",
      "Number": "Telefoonnummer (E.164)",
      "Outbound": "Uitgaand",
      "SipAccount": "SIP-account"
    },
    "Customer-sip-accounts": {
      "Active": "Actief",
      "ClientUriDomain": "Client-URI-domein",
      "Codecs": "Codecs",
      "Customers": "Klanten",
      "Delete": "verwijderen",
      "Delete item": "SIP-account verwijderen",
      "Delete item fail": "Het SIP-account kon niet worden verwijderd. {msg}",
      "Delete item success": "SIP-account succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je SIP-account {0} voor alle gekoppelde klanten wilt {1}?",
      "Edit item": "SIP-account bewerken",
      "Edit item fail": "Fout bij het wijzigen van het SIP-account. {msg}",
      "Edit item success": "SIP-account succesvol gewijzigd.",
      "Endpoint": "Endpoint",
      "Errors": {
        "ErrorCode": {
          "SIP_ACCOUNT_ACTIVE_PHONE_NUMBERS": "Dit SIP-account kan niet worden gedeactiveerd zolang er actieve telefoonnummers aan gekoppeld zijn.",
          "SIP_ACCOUNT_CUSTOMER_IN_USE": "Een of meer geselecteerde klanten kunnen niet van het SIP-account worden losgekoppeld zolang een telefoonnummer hiervan in klant- of profielinstellingen is geselecteerd.",
          "SIP_ACCOUNT_CUSTOMER_NOT_FOUND": "Een of meer geselecteerde klanten bestaan niet.",
          "SIP_ACCOUNT_IN_USE": "Verwijder alle gekoppelde telefoonnummers voordat je het SIP-account verwijdert.",
          "SIP_ACCOUNT_REGISTRATION_ALREADY_EXISTS": "Er bestaat al een SIP-account voor deze registratie. Voeg de klant toe aan dat bestaande SIP-account."
        }
      },
      "FromDomain": "From-domein",
      "Host": "Host",
      "Name": "Naam",
      "New item": "Nieuw SIP-account",
      "New item fail": "Fout bij het toevoegen van het SIP-account. {msg}",
      "New item success": "SIP-account succesvol toegevoegd.",
      "Password": "Wachtwoord",
      "PasswordConfigured": "Wachtwoord ingesteld",
      "Port": "Poort",
      "Tabs": {
        "General": "Algemeen",
        "Phone numbers": "Telefoonnummers"
      },
      "Transport": "Transport",
      "Username": "Gebruikersnaam"
    },
    "Customer-offers": {
      "Accept offer": "Offerte accepteren",
      "Accept offer item fail": "Fout bij het accepteren van de offerte. {msg}",
      "Accept offer item success": "Offerte succesvol geaccepteerd, er is een verkooporder aangemaakt.",
      "Add Products item": "Product toevoegen",
      "Amount": "Aantal",
      "Cannot download offer": "Kan het downloaden van de offerte niet starten.",
      "Check dates": "Controleer de startdatums",
      "Clone item": "Offerte klonen",
      "Confirm customer offer accept": "Weet u zeker dat offerte wilt accepteren? Zodra u de offerte accepteert, wordt er een verkooporder aangemaakt.",
      "Confirm customer offer reject": "Weet u zeker dat offerte wilt afwijzen?",
      "Confirm customer offer reject title": "Offerte afwijzen",
      "Customer": "Klant",
      "Customer offers merged successfully": "De geselecteerde offertes zijn succesvol samengevoegd.",
      "CustomPeriodAndPeriodic": "Periode en periodiek",
      "Date": "Datum",
      "Delete": "verwijderen",
      "Delete item": "Offerte verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de offerte. {msg}",
      "Delete item success": "Offerte verwijderd.",
      "Delete item text": "Weet u zeker dat u de offerte van de klant wilt {1} {0}?",
      "Delete Products item": "Product verwijderen",
      "Description": "Beschrijving",
      "Discount": "Korting",
      "Download offer pdf": "Download offerte PDF",
      "Edit item": "Offerte bewerken",
      "Edit item fail": "Er is een fout opgetreden bij het bewerken van de offerte. {msg}",
      "Edit item success": "Offerte succesvol gewijzigd.",
      "Errors": {
        "CAN_ONLY_DELETE_DRAFT_CUSTOMER_OFFERS": "Kan een offerte die niet de status 'concept' heeft, niet verwijderen.",
        "ErrorCode": {
          "CUSTOMER_CONTACT_NOT_SET": "Klant heeft geen offerte contactpersoon ingesteld.",
          "PRODUCT_BUNDLE_CANNOT_HAVE_DISCOUNT": "Een bundelproduct kan geen korting hebben.",
          "PRODUCT_BUNDLE_DUPLICATE": "Een offerte mag niet meerdere keren dezelfde productbundel bevatten.",
          "PRODUCT_BUNDLE_PRICE_NOT_FOUND": "De offerte bevat een productbundel met een bundelprijs die niet kan worden gevonden."
        }
      },
      "Filename": "Bestandsnaam",
      "Generate customer offers": "Genereer offerte",
      "Generation date": "Aanmaakdatum",
      "Memo": "Interne memo",
      "Merge customer offers": "Offertes samenvoegen",
      "New item": "Nieuwe offerte",
      "New item fail": "Fout bij het maken van de offerte. {msg}",
      "New item success": "Offerte succesvol toegevoegd.",
      "Offer": "Offerte",
      "Offer contact not set": "Deze klant heeft geen offertecontact ingesteld. Stel een offertecontact in en probeer het opnieuw.",
      "Offer has missing dates": "Voor een of meer producten in de offerte ontbreekt een datumwaarde 'Periode vanaf'. Stel een datum in voor deze producten.",
      "OfferNumber": "Offerte nummer",
      "OfferReference": "Orderreferentie",
      "OfferTemplate": "Offertesjabloon",
      "OfferTemplateOptions": {
        "En-US": "Engels",
        "Nl-NL": "Nederlands"
      },
      "Period": "Periode",
      "PeriodFrom": "Periode van",
      "Periodic": "Periodiek",
      "PeriodicOptions": {
        "Month": "Maand",
        "One-time": "Eenmalig",
        "Year": "Jaar"
      },
      "PeriodTo": "Periode tot",
      "PriceCalculator": {
        "AmountOfDays": "Aantal dagen",
        "CurrentPrice": "Huidige prijs",
        "EndDate": "Einddatum",
        "NewPrice": "Nieuwe prijs",
        "Period string": "Periode: {startDate} tot {endDate}",
        "PricePerDay": "Prijs per dag",
        "StartDate": "Begindatum",
        "Subscription": "Abonnement",
        "Title": "Prijsberekening"
      },
      "PriceExclPerPiece": "Prijs per stuk (excl. BTW)",
      "Product": "Product",
      "Products": "Producten",
      "Reject offer": "Offerte afwijzen",
      "Reject offer item fail": "Fout bij het afwijzen van het aanbod. {msg}",
      "Reject offer item success": "Offerte succesvol afgewezen.",
      "Select contract": "Selecteer een contract",
      "Select dates": "Selecteer data",
      "Send offer": "Offerte als verstuurd markeren",
      "Set all dates": "Stel alle datums in op: {date}",
      "Set missing dates": "Stel de ontbrekende datums in op:",
      "Status": "Status ",
      "StatusOptions": {
        "Accepted": "Geaccepteerd",
        "Draft": "Concept",
        "Rejected": "Afgewezen",
        "Sent": "Verzonden"
      },
      "Sync customer offers": "Offerte synchroniseren | Offertes synchroniseren",
      "Tabs": {
        "General": "Algemeen",
        "Products": "Producten"
      },
      "To contract": "Naar contract",
      "TotalAmount": "Totaalbedrag (excl. BTW)",
      "Type": "Type",
      "TypeOptions": {
        "Fixed": "Vast bedrag",
        "None": "Geen",
        "Percentage": "Percentage"
      }
    },
    "Customer-users": {
      "Api account": "API-account",
      "Api accounts": "API-accounts",
      "Api token": "API-token",
      "Api token shown once": "Deze token wordt slechts eenmalig getoond. Bewaar deze veilig.",
      "Assigned roles": "Aanwezige rollen",
      "Assign roles": "Rollen toewijzen",
      "Available roles": "Beschikbare rollen",
      "Cannot impersonate user": "Inloggen namens deze gebruiker is mislukt.",
      "Cannot open customer portal": "Kan het klantportaal niet openen voor deze klantgebruiker.",
      "Copy roles from user": "Rollen overnemen van andere gebruiker",
      "Copy roles from user title": "Rollen overnemen",
      "Customer": "Klant",
      "Customer users": "Klantgebruikers",
      "Delete": "verwijderen",
      "Delete api account": "API-account verwijderen",
      "Delete api account text": "Weet u zeker dat u het API-account {0} wilt verwijderen?",
      "Delete item": "Klantgebruiker verwijderen",
      "Delete item fail": "Kan klantgebruiker niet verwijderen. {msg}",
      "Delete item success": "Klantgebruiker succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de klantgebruiker {0} wilt {1}?",
      "Edit item": "Klantgebruiker bewerken",
      "Edit item fail": "Fout bij het wijzigen van de gebruiker. {msg}",
      "Edit item success": "Klantgebruiker succesvol gewijzigd.",
      "Edit api account": "API-account bewerken",
      "Email": "E-mailadres",
      "Error loading data": "De lijst met klantgebruikers kon vanwege een fout niet worden geladen.",
      "FirstName": "Voornaam",
      "Full name": "Volledige naam",
      "Impersonate user": "Inloggen names gebruiker",
      "IsSSO": "Via SSO?",
      "IsVerified": "Activatie bevestigd?",
      "LastImpersonation": "Laatste impersonatie",
      "LastName": "Achternaam",
      "Licenses": "Licenties",
      "Locale": "Taal",
      "LocaleOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Keep existing roles": "Alle huidige rollen van de gebruikers behouden",
      "Name": "Naam",
      "New api account": "Nieuw API-account",
      "New item": "Nieuwe gebruiker",
      "New item fail": "Kan geen nieuwe klantgebruiker maken. {msg}",
      "New item success": "Nieuwe klantgebruiker succesvol toegevoegd.",
      "New user": "Nieuwe gebruiker maken",
      "MultiAssignRoles item fail": "Fout bij het toewijzen van rollen. {msg}",
      "MultiAssignRoles item success": "Rollen succesvol toegewezen.",
      "No assignable roles": "Geen rollen beschikbaar om toe te wijzen.",
      "No users to copy roles from": "Er zijn geen andere klantgebruikers met rollen beschikbaar.",
      "No api accounts found": "Geen API-accounts gevonden",
      "No customer users available": "Geen klantgebruikers beschikbaar.",
      "No customer users selected": "Geen klantgebruikers geselecteerd.",
      "No assigned roles": "Geen rollen aanwezig.",
      "No roles to add": "Geen rollen om toe te voegen.",
      "No roles selected": "Geen rollen geselecteerd.",
      "No users with role": "Geen gebruikers met deze rol.",
      "No users without role": "Geen gebruikers zonder deze rol.",
      "Overwrite existing roles": "Bestaande rollen overschrijven",
      "RegionalSettings": "Regionale instellingen",
      "Regenerate API token": "API-token opnieuw genereren",
      "Regenerate API token confirm": "API-token opnieuw genereren",
      "Regenerate API token confirm text": "Weet u zeker dat u het API-token voor {fullName} opnieuw wilt genereren? Het huidige token stopt dan met werken.",
      "Regenerate API token fail": "Kon API-token niet opnieuw genereren.",
      "RegionalSettingsOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Role assignment mode": "Wijze van toewijzen",
      "Roles to copy": "Over te nemen rollen",
      "Roles": "Rollen",
      "Select customer before copying roles": "Selecteer eerst een klant om rollen over te nemen.",
      "Select customer users": "Selecteer eerst klantgebruikers.",
      "Select roles": "Selecteer rollen",
      "Select user for roles": "Gebruiker om rollen van over te nemen",
      "Selected customer users": "Geselecteerde klantgebruikers",
      "Selected users": "Geselecteerde gebruikers",
      "Roles to add": "Toe te voegen rollen",
      "Roles to assign": "Toe te wijzen rollen",
      "Roles to remove": "Te verwijderen rollen",
      "Summary": "Samenvatting",
      "Take over roles": "Rollen overnemen",
      "User": "Gebruiker",
      "Users with role": "Gebruikers met deze rol",
      "Users without role": "Gebruikers zonder deze rol",
      "Virtual": "Virtueel",
      "What is virtual user": "Een virtuele gebruiker is niet gekoppeld aan een echt inlogaccount. Een of meer rollen voor deze klant zijn altijd verplicht."
    },
    "Customers": {
      "AccountName": "Naam rekeninghouder",
      "Address": "Adres",
      "AppDisplayName": "Weergavenaam van app",
      "AppId": "App ID",
      "Archive": "archiveren",
      "Archived": "Gearchiveerd",
      "Assets": {
        "Assets date": "Activa datum",
        "Comparisons": {
          "Compare Devices": {
            "Amount of too many devices": "Aantal te veel apparaten",
            "Compare Devices": "Apparaten vergelijken",
            "Compare Missing Devices": "Vergelijk ontbrekende apparaten",
            "Compare Protected Items": "Vergelijk beschermde items",
            "Compare Total Devices": "Vergelijk Totaal Apparaten",
            "Microsoft Azure devices not existing in the list of VPN certificates": "Microsoft Azure-apparaten die niet voorkomen in de lijst met VPN-certificaten",
            "More Microsoft Azure or VPN devices": "Meer Microsoft Azure- of VPN-apparaten",
            "VPN certificates not existing in the list of Microsoft Azure devices": "VPN-certificaten die niet voorkomen in de lijst met Microsoft Azure-apparaten"
          },
          "Compare Public IPs": {
            "Compare Public IPs": "Vergelijk publieke IP's",
            "Compare Total Public IPs": "Vergelijk Total Public IP's",
            "NAT Gateway is not required but configured": "NAT Gateway is niet vereist maar geconfigureerd",
            "NAT Gateway is required but not configured": "NAT Gateway is vereist maar niet geconfigureerd"
          },
          "Compare Recovery Services": {
            "Compare Protected Items": "Vergelijk beschermde items",
            "Compare Recovery Services": "Vergelijk herstelservices",
            "List of removed Virtual Machines still existing in Protected Items": "Lijst met verwijderde virtuele machines die nog steeds bestaan in beveiligde items",
            "List of Virtual Machines not existing in Protected Items": "Lijst met virtuele machines die niet bestaan in beveiligde items",
            "More Microsoft Azure or VPN devices": "Meer Microsoft Azure- of VPN-apparaten"
          },
          "Compare Reservations": {
            "Amount reservation points": "Alle bestaande reserveringsreeksen hebben het volgende aantal punten",
            "Compare Reservation Points": "Reserveringspunten vergelijken",
            "Compare Reservation Series": "Reserveringsreeksen vergelijken",
            "Compare Reservations": "Reserveringen vergelijken",
            "Reservation series not existing in Virtual Machine series": "Reserveringsserie bestaat niet in Virtual Machine-serie",
            "Virtual Machine series not existing in Reservation series": "Virtuele machinereeksen bestaan niet in reserveringsreeksen"
          },
          "Compare Veeam": {
            "Compare Mapped Job Repositories": "Vergelijk toegewezen taakopslagplaatsen",
            "Compare Mapped Repository Folders": "Mapped Repository Folders vergelijken",
            "Compare Repository Data": "Repositorygegevens vergelijken",
            "Compare Repository Naming": "Vergelijk naamgeving van opslagplaatsen",
            "Compare Veeam": "Veeam vergelijken",
            "Correct Name": "Correcte naam",
            "Current Name": "Huidige naam",
            "Current Path": "Huidige pad",
            "Job Name": "Job naam",
            "List of jobs with incorrect folder mapped to the repository": "Lijst met taken met onjuiste map toegewezen aan de repository",
            "List of jobs with incorrect repository mapped": "Lijst met taken met onjuiste repository in kaart gebracht",
            "List of repositories with incorrect naming": "Lijst met opslagplaatsen met onjuiste naamgeving",
            "Repositories with incorrect backup data included": "Opslagplaatsen met onjuiste back-upgegevens inbegrepen"
          },
          "Compare Veeam with Microsoft Teams": {
            "Compare Team Backups": "Vergelijk teamback-ups",
            "Compare Veeam with Microsoft Teams": "Vergelijk Veeam met Microsoft Teams",
            "Missing backups from Teams in Veeam": "Ontbrekende back-ups van Teams in Veeam",
            "Too many backups from Teams in Veeam": "Te veel back-ups van Teams in Veeam"
          },
          "FriendlyStatus": {
            "ALL_JOBS_HAVE_CORRECT_REPOS_MAPPED": "Alle taken hebben de juiste opslagplaats gekoppeld.",
            "ALL_MS_TEAMS_HAVE_EXISTING_BACKUP": "Alle Microsoft-teams hebben een bestaande back-up in Veeam.",
            "ALL_REPOS_HAVE_CORRECT_FOLDER_MAPPED": "Alle opslagplaatsen hebben de juiste map toegewezen.",
            "ALL_REPOS_HAVE_CORRECT_NAMING": "Alle repositories hebben de juiste naam, inclusief mailboxen, teams, onedrive of sites.",
            "ALL_REPOS_INCLUDES_CORRECT_BACKUP_DATA": "Alle repositories bevatten de juiste back-upgegevens.",
            "AMOUNT_OF_DEVICES_AND_VPN_CERTS_ARE_EQUAL": "Het totale aantal Microsoft Azure-apparaten is gelijk aan het totale aantal VPN-certificaten.",
            "DEVICES_AND_VPN_CERTS_NAMED_CORRECTLY": "Alle Microsoft Azure-apparaten en VPN-certificaten hebben de juiste naam.",
            "DEVICES_MISSING_IN_VPN_CERTS_LIST": "Er zijn Microsoft Azure-apparaten die niet voorkomen in de lijst met VPN-certificaten.",
            "EXISTING_MS_TEAMS_MISSING_IN_VEEAM": "Er ontbreken bestaande Microsoft-teams in Veeam.",
            "EXISTING_VEEAM_TEAMS_NOT_EXISTING_IN_MS": "Er zijn bestaande teams in Veeam die niet meer bestaan in Microsoft Teams.",
            "INCORRECT_RESERVATION_POINTS": "Niet alle series hebben het juiste aantal reserveringspunten.",
            "MORE_RESERVATION_SERIES_THAN_VM_SERIES": "Er zijn meer reserveringsreeksen dan virtuele machinereeksen, er zijn te veel reeksen gereserveerd.",
            "MORE_VM_SERIES_THAN_RESERVATION_SERIES": "Er zijn meer Virtual Machine-series dan Reserveringsseries, er zijn te te weinig series gereserveerd.",
            "NO_TEAM_BACKUP_FOUND_FROM_REMOVED_MS_TEAM": "Geen verwijderd Microsoft-team gevonden in Veeam-back-up.",
            "NO_TEAM_BACKUPS_ACTIVATED_AND_FOUND": "Geen back-ups van teams in Veeam gevonden, er zijn geen teamtaken geactiveerd voor deze klant.",
            "NOT_ALL_JOBS_HAVE_CORRECT_REPOS_MAPPED": "Niet voor alle taken is de juiste opslagplaats gekoppeld",
            "NOT_ALL_REPOS_HAVE_CORRECT_FOLDER_MAPPED": "Niet alle opslagplaatsen hebben de juiste map toegewezen.",
            "NOT_ALL_REPOS_HAVE_CORRECT_NAMING": "Niet alle repositories hebben de juiste naam, het bevat geen mailboxen, teams, onedrive of sites.",
            "NOT_ALL_REPOS_INCLUDES_CORRECT_BACKUP_DATA": "Niet alle repositories bevatten de juiste back-upgegevens.",
            "PROTECTED_ITEMS_MISSING_IN_VIRTUAL_MACHINES": "Er zijn verwijderde Virtuele Machines, maar ze bestaan nog in beveiligde items.",
            "PUBLIC_IPS_EQUAL_OR_LOWER_THAN_TEN_BUT_NAT_GATEWAY_CONFIGURED": "Het totale aantal toegewezen openbare IP's is gelijk aan of lager dan 10 (huidig totaal van {s}), maar NAT Gateway is geconfigureerd.",
            "PUBLIC_IPS_EQUAL_OR_LOWER_THAN_TEN_BUT_NAT_GATEWAY_NOT_CONFIGURED": "Het totale aantal toegewezen openbare IP's is gelijk aan of lager dan 10 (huidig totaal van {s}), maar NAT Gateway is niet geconfigureerd.",
            "PUBLIC_IPS_HIGHER_THAN_TEN_BUT_NAT_GATEWAY_CONFIGURED": "Het totale aantal toegewezen openbare IP's is hoger dan 10 (huidig totaal van {s}), maar NAT Gateway is geconfigureerd.",
            "PUBLIC_IPS_HIGHER_THAN_TEN_BUT_NAT_GATEWAY_NOT_CONFIGURED": "Het totale aantal toegewezen openbare IP's is hoger dan 10 (huidig totaal van {s}), maar NAT Gateway is niet geconfigureerd.",
            "RESERVATION_POINTS_EQUAL": "Alle reserveringspunten zijn gelijk.",
            "TOO_MANY_DEVICES_COMPARED_TO_VPN_CERTS": "Er zijn in totaal {s} te veel Microsoft Azure-apparaten in vergelijking met VPN-certificaten.",
            "TOO_MANY_VPN_CERTS_COMPARED_TO_DEVICES": "Er zijn in totaal {s} teveel VPN-certificaten in vergelijking met Microsoft Azure-apparaten.",
            "VEEAM_DISK_THRESHOLD_EXCEEDED": "Voor sommige Veeam-back-upschijven wordt de drempel van 95% overschreden.",
            "VEEAM_DISK_THRESHOLD_NOT_EXCEEDED": "De drempel van 95% wordt niet overschreden voor Veeam-back-upschijven.",
            "VIRTUAL_MACHINES_MISSING_IN_PROTECTED_ITEMS": "Er missen Virtuele Machines in beveiligde items.",
            "VM_AND_PROTECTED_ITEMS_EQUAL": "Alle Virtuele Machines en beveiligde items zijn gelijk.",
            "VM_AND_RESERVATION_SERIES_EQUAL": "Alle Virtual Machine-series zijn gelijk aan Reserveringsseries.",
            "VPN_CERTS_MISSING_IN_DEVICES_LIST": "Er zijn VPN-certificaten die niet voorkomen in de lijst met Microsoft Azure-apparaten."
          },
          "Messages": "Berichten"
        },
        "Diagrams only": "Alleen diagrammen",
        "Errors": {
          "NO_ASSETS": "Er zijn geen assets gevonden voor deze klant. Controleer of er minimaal één API is geactiveerd en of de assets zijn vernieuwd."
        },
        "Hetzner": {
          "Architecture": "Architectuur",
          "Backup Window": "Back-upvenster",
          "Backups": "Back-ups",
          "Blocked": "Geblokkeerd",
          "Calculations": {
            "Backups": {
              "Backups": "Backups",
              "Total Backups Per Date": "Totaal aantal back-ups van virtuele machines per datum",
              "Total Protection Status": "Backup status per virtuele machine",
              "Total Unique VMBackups Per Date": "Totaal aantal unieke back-ups van virtuele machines per datum",
              "Virtual Machine Backups": "Back-ups van virtuele machines"
            },
            "Firewalls": "Firewalls",
            "Public IPs": "Publieke IPs",
            "Storages": {
              "Storages": "Opslag",
              "Total Storage Statuses": "Totaal beschikbare opslag"
            },
            "Virtual Machines": {
              "Total Operating Systems": "Totaal aantal besturingssystemen",
              "Total Statuses": "Totaal aantal statussen van virtuele machines",
              "Total Types": "Totaal aantal typen virtuele machines",
              "Virtual Machines": "Virtuele machines"
            }
          },
          "Created Date": "Aangemaakt op",
          "Datacenter": "Datacentrum",
          "Delete protection": "Verwijderbeveiliging",
          "Disk Size": "Schijfgrootte",
          "Errors": {
            "FLOATING_IPS_NOT_FOUND": "Kan geen Floating IPs ophalen.",
            "HETZNER_API_CREDENTIALS_MISSING": "Hetzner API-gegevens kunnen niet worden gevonden in de database en gedeelde TransIP worden niet gebruikt.",
            "HETZNER_API_NOT_ACTIVATED": "Hetzner API is niet actief voor deze klant. Ga naar het tabblad API-referenties om de API te activeren en vul de API-referenties in.",
            "IMAGES_IPS_NOT_FOUND": "Kan geen Images ophalen.",
            "SERVERS_IPS_NOT_FOUND": "Kan geen Servers ophalen.",
            "VOLUMES_NOT_FOUND": "Kan geen Volumes ophalen."
          },
          "Firewall applied": "Firewall toegepast",
          "Format": "Formaat",
          "Image Size": "Image-grootte",
          "IP Address": "IP-adres",
          "IPv4 Address": "IPv4-adres",
          "Location": "Locatie",
          "Locked": "Vergrendeld",
          "Name": "Naam",
          "OS": "Besturingssysteem",
          "Private IPv4 Address": "Privé IPv4-adres",
          "Public IPs": "Publieke IPs",
          "Server": "Server",
          "Server Type": "Servertype",
          "Size": "Grootte",
          "Status": "Status",
          "Storages": "Opslagruimtes",
          "Type": "Type",
          "Virtual machines": "Virtuele machines",
          "Virtual machines backups": "Back-ups van virtuele machines"
        },
        "Locked Vault Backups": {
          "Backups": {
            "Backups": "Backups",
            "Created": "Gemaakt op",
            "Customer name": "Klantnaam",
            "Daily Restore Points": "Dagelijkse Herstelpunten",
            "Hostname": "Hostnaam",
            "Monthly Restore Points": "Maandelijkse Herstelpunten",
            "Repository Url": "Repository Url",
            "Snapshot Id": "Snapshot Id",
            "Snapshot Size Kb": "Snapshot grootte",
            "Status": "Status",
            "Total Repository Size Kb": " Totale Repository grootte",
            "Weekly Restore Points": "Wekelijkse Herstelpunten",
            "Yearly Restore Points": "Jaarlijkse Herstelpunten"
          },
          "Calculations": {
            "Backups": "Backups"
          },
          "Errors": {
            "LOCKED_VAULT_BACKUPS_NOT_FOUND": "Er zijn geen Locked Vault Backups gevonden."
          }
        },
        "MicrosoftAzure": {
          "Applied scope": "Toegepast bereik",
          "Archived": "Gearchiveerd",
          "Billing plan": "Factureringsplan",
          "Calculations": {
            "Disks": {
              "Disks": "Schijven",
              "Total Disk Types": "Totaal aantal schijftypen",
              "Total Disks In Use": "Totaal aantal schijven in gebruik"
            },
            "Host Pools": "Host Pools",
            "Nat Gateways": "NAT-Gateways",
            "Public IPs": "Openbare IP's",
            "Recovery Services": {
              "Total Last Backup Status": "Resultaat laatste backup",
              "Recovery Services": "Hersteldiensten",
              "Total Protection Status": "Totale beschermingsstatus"
            },
            "Reservations": {
              "Reservations": "Reserveringen",
              "Total Active Reservation Points Per Serie": "Totaal actieve reserveringspunten per serie",
              "Total Active Reservations Per Serie": "Totaal actieve reserveringen per serie",
              "Total Created Reservation Per Type": "Totaal gemaakte reservering per type",
              "Total Created Reservations Per Provisioning State": "Totaal gemaakte reserveringen per inrichtingsstatus",
              "Total Reservation Per Type": "Totale reservering per type",
              "Total Reservation Types Per Provisioning State": {
                "Cancelled": "Geannuleerd",
                "Succeeded": "Geslaagd",
                "Total Reservation Types Per Provisioning State": "Totaal aantal reserveringstypen per inrichtingsstatus"
              },
              "Total Reservations Per Provisioning State": "Totaal aantal reserveringen per inrichtingsstatus"
            },
            "Resource Groups": "Resourcegroep",
            "Route Tables": "Routetabellen",
            "Subscriptions": "Abonnementen",
            "Virtual Machines": {
              "Total Agent Statuses": "Totaal aantal agentstatussen",
              "Total Virtual Machine Points Per Serie": "Totaal aantal virtuele machinepunten per serie",
              "Total Virtual Machine Statuses": "Totaal aantal statussen van virtuele machines",
              "Total Virtual Machine Types": "Totaal aantal virtuele machinetypen",
              "Total Virtual Machines Per Serie": "Totaal aantal virtuele machines per serie",
              "Virtual Machines": "Virtuele machines"
            },
            "Virtual Networks": "Virtuele netwerken"
          },
          "Errors": {
            "AZURE_API_CREDENTIALS_MISSING": "Microsoft Azure API-referenties zijn niet gevonden in de database voor deze klant. Ga naar het tabblad API-referenties om de API-referenties in te vullen.",
            "AZURE_API_NOT_ACTIVATED": "Microsoft Azure API is niet ingeschakeld voor deze klant. Ga naar het tabblad API-referenties om de API-referenties in te vullen.",
            "DISKS_NOT_FOUND": "Kan de schijven niet ophalen.",
            "HOST_POOLS_NOT_FOUND": "Kan host pools niet ophalen.",
            "NAT_GATEWAYS_NOT_FOUND": "Kan geen NAT-gateways ophalen.",
            "PUBLIC_IPS_NOT_FOUND": "Kan geen openbare IP's ophalen.",
            "RECOVERY_SERVICES_NOT_FOUND": "Kan geen herstelservices ophalen.",
            "RESERVATIONS_NOT_FOUND": "Kan geen reserveringen ophalen.",
            "RESOURCE_GROUPS_NOT_FOUND": "Kan resource groepen niet ophalen.",
            "ROUTE_TABLES_NOT_FOUND": "Routetabellen kunnen niet worden opgehaald.",
            "SESSION_HOSTS_NOT_FOUND": "Kan sessiehosts niet ophalen.",
            "SUBSCRIPTIONS_NOT_FOUND": "Kan geen abonnementen ophalen.",
            "TOKEN_NOT_FOUND": "Kan het API-token niet ophalen. Zorg ervoor dat de API-referenties correct zijn.",
            "USER_SESSIONS_NOT_FOUND": "Kan gebruikerssessies niet ophalen van Session Host.",
            "VAULT_POLICIES_NOT_FOUND": "Kan geen back-upbeleid voor Vault ophalen.",
            "VAULT_PROTECTED_ITEMS_NOT_FOUND": "Beveiligde items voor Vault kunnen niet worden opgehaald.",
            "VIRTUAL_MACHINES_NOT_FOUND": "Kan virtuele machines niet ophalen.",
            "VIRTUAL_NETWORKS_NOT_FOUND": "Kan virtuele netwerken niet ophalen."
          },
          "Expiry date": "Vervaldatum",
          "Location": "Plaats",
          "Active": "Actief",
          "Archived - Cancelled": "Gearchiveerd - Opgezegd",
          "Archived - Expired": "Gearchiveerd - Verlopen",
          "Cancelled": "Opgezegd",
          "Expired": "Verlopen",
          "Expiring": "Verloopt binnenkort",
          "Failed": "Mislukt",
          "Merged": "Samengevoegd",
          "Name": "Naam",
          "Pending": "In behandeling",
          "Purchase date": "Aankoopdatum",
          "Quantity": "Aantal stuks",
          "Renew": "Vernieuwen",
          "Reservations": "Reserveringen",
          "Reserved resource type": "Gereserveerd resourcetype",
          "SKU name": "SKU-naam",
          "Split": "Gesplitst",
          "Status": "Status",
          "Utilization": "Benutting",
          "Utilization 24 hours": "Benutting 24 uur",
          "Utilization 7 days": "Benutting 7 dagen",
          "Utilization 30 days": "Benutting 30 dagen",
          "Subscriptions": {
            "DisplayName": "Weergavenaam",
            "Resource groups": {
              "Disks": {
                "Disk": "Schijf | Schijven | Schijf {name}",
                "Disk IOPS": "Schijf IOPS lezen/schrijven",
                "Disk Mbps": "Schijf Mbps lezen/schrijven",
                "Disk size GB": "Schijfgrootte (GB)",
                "Disk state": "Schijfstatus",
                "Location": "Locatie",
                "Name": "Naam",
                "OS type": "Type besturingssysteem",
                "SKU name": "SKU-naam",
                "SKU tier": "SKU-laag"
              },
              "Host pools": {
                "Host pool": "Host Pool | Host Pools | Host Pool {name}",
                "Session hosts": {
                  "Assigned user": "Toegewezen gebruiker",
                  "Assigned virtual machine": "Toegewezen virtuele machine",
                  "Name": "Naam",
                  "Session host": "Session Host | Session Hosts | Session Host {host}",
                  "Sessions": "Sessies",
                  "Update state": "Status bijwerken",
                  "User sessions": {
                    "Created time": "Tijd van aanmaken",
                    "Session state": "Sessiestatus",
                    "User principal name": "Principal-naam van gebruiker",
                    "User session": "Gebruikerssessie | Gebruikerssessies | Gebruikerssessie {name}"
                  }
                }
              },
              "Location": "Locatie",
              "Name": "Naam",
              "NAT gateways": {
                "Idle timeout": "Inactiviteit time-out in minuten",
                "Location": "Locatie",
                "Name": "Naam",
                "NAT gateway": "NAT-gateway | NAT-gateways | NAT-gateway {name}",
                "SKU name": "SKU-naam"
              },
              "Public IPs": {
                "Allocation method": "Toewijzingsmethode",
                "Idle timeout": "Inactiviteit time-out (minuten)",
                "IP address": "IP-adres",
                "IP address version": "IP-adres versie",
                "Location": "Locatie",
                "Name": "Naam",
                "Public IP": "Openbare IP | Openbare IP's | IP {address}",
                "SKU name": "SKU-naam",
                "SKU tier": "SKU-laag"
              },
              "Recovery services": {
                "Backup policies": {
                  "Backup policies": "Back-upbeleid",
                  "Daily retention": "Dagelijkse retentie",
                  "Daily schedule retention times": "Dagelijkse retentietijden van het schema",
                  "Monthly retention": "Maandelijkse retentie",
                  "Monthly retention day": "Maandelijkse retentiedag",
                  "Name": "Naam",
                  "Retention duration count": "Aantal bewaartermijnen",
                  "Retention duration type": "Type bewaarduur",
                  "Schedule run frequency": "Uitvoeringsfrequentie",
                  "Schedule run times": "Looptijden",
                  "Schedule weekly frequency": "Wekelijkse frequentie",
                  "Weekly retention": "Wekelijkse retentie",
                  "Weekly retention days": "Wekelijkse retentiedagen",
                  "Yearly retention": "Jaarlijkse retentie",
                  "Yearly retention day": "Jaarlijkse retentiedag"
                },
                "Location": "Locatie",
                "Name": "Naam",
                "Protected items": {
                  "Health status": "Gezondheidsstatus",
                  "Last backup status": "Laatste back-upstatus",
                  "Last backup time": "Laatste back-uptijd",
                  "Last recovery point": "Laatste herstelpunt",
                  "Name": "Naam",
                  "Policy name": "Naam van het beleid",
                  "Protected items": "Beveiligde items",
                  "Protection state": "Beschermingsstatus",
                  "Protection status": "Beschermingsstatus"
                },
                "Recovery service": "Hersteldienst | Hersteldiensten | Hersteldienst {name}",
                "SKU name": "SKU-naam",
                "SKU tier": "SKU-laag",
                "Vault name": "Kluis naam"
              },
              "Resource group": "Resourcegroep | Resourcegroepen | Resourcegroep {resourceGroup}",
              "Route tables": {
                "Address prefix": "Adres voorvoegsel",
                "Has BGP override": "Heeft BGP override",
                "Location": "Locatie",
                "Name": "Naam",
                "Next hop address": "Next hop adres",
                "Next hop type": "Volgende hoptype",
                "Route": "Route | Routes",
                "Route propagation": "BGP-routeverspreiding uitschakelen",
                "Route table": "Routetabel | Routetabellen | Routetabel {name}"
              },
              "Virtual Machines": {
                "Admin username": "Gebruikersnaam beheerder",
                "Agent Messages": "Agent messages",
                "Agent Status": "Agent status",
                "Computer name": "Computernaam",
                "Location": "Locatie",
                "Name": "Naam",
                "OS disk name": "Schijfnaam van besturingssysteem",
                "OS disk size GB": "Schijfgrootte van het besturingssysteem (GB)",
                "OS disk type": "Schijftype besturingssysteem",
                "Virtual Machine": "Virtuele Machine | Virtuele Machines | Virtuele Machine {name}",
                "VM id": "VM-id",
                "VM Size": "VM-grootte",
                "VM Status": "VM-status"
              },
              "Virtual networks": {
                "Address prefixes": "Adresvoorvoegsels",
                "DDOS protection": "DDoS-bescherming",
                "DNS Servers": "DNS-servers",
                "Location": "Locatie",
                "Name": "Naam",
                "Subnets": {
                  "Name": "Naam",
                  "Prefix": "Voorvoegsel subnetadres",
                  "Subnet": "Subnet | Subnetten"
                },
                "Virtual network": "Virtueel Netwerk | Virtuele Netwerken | Virtueel Netwerk {name}"
              }
            },
            "State": "Staat",
            "Subscription": "Abonnement | Abonnementen | Abonnement {subscription}",
            "SubscriptionId": "Abonnements-ID",
            "TenantId": "Tenant-ID"
          },
          "Term": "Termijn"
        },
        "MicrosoftGraph": {
          "Applications": {
            "App id": "App id",
            "Application": "Applicatie | Applicaties",
            "Created date time": "Aanmaak datum en tijd",
            "Display name": "Weergavenaam",
            "Key credentials": {
              "Certificates": "Certificaten",
              "Display name": "Weergavenaam",
              "End datetime": "Eind datum en tijd",
              "Start datetime": "Start datum en tijd",
              "Type": "Type"
            },
            "Password credentials": {
              "Credentials": "Credentials",
              "Display name": "Weergavenaam",
              "End datetime": "Eind datum en tijd",
              "Hint": "Hint",
              "Start datetime": "Start datum en tijd"
            },
            "Publisher domain": "Uitgever domein",
            "Sign in audience": "Toegestane aanmelders"
          },
          "Audit Logs Sign Ins": {
            "App display name": "Weergavenaam van app",
            "Audit Logs Sign In": "Aanmeldingslogboek voor auditlogboeken  | Aanmeldingslogboeken voor auditlogboeken",
            "Browser": "Browser",
            "City": "Plaats",
            "Client app": "Client-app",
            "Conditional access status": "Status van voorwaardelijke toegang",
            "Country or region": "Land of Regio",
            "Created at": "Gemaakt op",
            "Device display name": "Weergavenaam van apparaat",
            "Geo altitude": "Geo hoogte",
            "Geo latitude": "Geo breedtegraad",
            "Geo longitude": "Geo lengtegraad",
            "Id": "ID",
            "Is compliant": "Voldoet aan",
            "Is interactive": "Is interactief",
            "Is managed": "Wordt beheerd",
            "Operating system": "Besturingssysteem",
            "Resource display name": "Weergavenaam van resource",
            "State": "Staat",
            "Status": "Status ",
            "Status failure reason": "Reden voor statusfout",
            "Status message": "Statusbericht",
            "User display name": "Weergavenaam van gebruiker",
            "User principle name": "Principiële gebruikersnaam"
          },
          "Calculations": {
            "Applications": "Applicaties",
            "Audit Logs Sign Ins": {
              "Audit Logs Sign Ins": "Aanmeldingslogboeken voor auditlogboeken",
              "Total Login Attempts Per App Display Name": "Totaal aantal inlogpogingen per weergavenaam van de app",
              "Total Login Attempts Per City": "Totaal aantal inlogpogingen per stad",
              "Total Login Attempts Per Client App": "Totaal aantal inlogpogingen per client-app",
              "Total Login Attempts Per Country Or Region": "Totaal aantal inlogpogingen per land of regio",
              "Total Login Attempts Per Operating System": "Totaal aantal inlogpogingen per besturingssysteem",
              "Total Login Attempts Per State": "Totaal aantal inlogpogingen per staat",
              "Total Login Attempts Per User Principal Name": "Totaal aantal aanmeldingspogingen per principal-naam van de gebruiker"
            },
            "Devices": {
              "Devices": "Apparaten",
              "Total Operating Systems": "Totale besturingssystemen"
            },
            "Shared Mailboxes": "Gedeelde mailboxen",
            "Subscribed Skus": "Geabonneerde Sku's",
            "Teams": "Teams",
            "Users": "Gebruikers"
          },
          "Devices": {
            "Compliance state": "Nalevingsstatus",
            "Device": "Apparaat | Apparaten | Apparaat {device}",
            "Device enrollment type": "Type apparaat registratie",
            "Device name": "Naam apparaat",
            "Enrolled datetime": "Registratie datum/tijd",
            "Ethernet mac address": "Ethernet mac-adres",
            "Free storage space in bytes": "Vrije opslagruimte (bytes)",
            "Imei": "IMEI",
            "Managed device owner": "Eigenaar van beheerde apparaten",
            "Operating system": "Besturingssysteem",
            "Serial number": "Serienummer",
            "Total storage space in bytes": "Totale opslagruimte (bytes)",
            "User display name": "Weergavenaam gebruiker",
            "User principal name": "Principal-naam van gebruiker",
            "WiFi mac address": "WiFi mac-adres"
          },
          "Errors": {
            "APPLICATIONS_NOT_FOUND": "Kan geen applicaties ophalen.",
            "AUDIT_LOGS_SIGN_INS_NOT_FOUND": "Kan geen auditlogboeken van de aanmeldingen verkrijgen.",
            "DEVICES_NOT_FOUND": "Apparaten kunnen niet worden opgehaald.",
            "GRAPH_API_CREDENTIALS_MISSING": "Microsoft Graph API-referenties zijn niet gevonden in de database voor deze klant. Ga naar het tabblad API-referenties om de API-referenties in te vullen.",
            "GRAPH_API_NOT_ACTIVATED": "Microsoft Graph API is niet actief voor deze klant. Ga naar het tabblad API-referenties om de API te activeren en vul de API-referenties in.",
            "SHARED_MAILBOXES_NOT_FOUND": "Kan gedeelde mailboxen niet ophalen. Zorg ervoor dat er één groep bestaat in de Azure Active Directory met de naam: SharedMailboxes.",
            "SUBSCRIBED_SKUS_NOT_FOUND": "Geabonneerde Sku's kunnen niet worden opgehaald.",
            "TEAMS_NOT_FOUND": "Teams kan niet worden opgehaald.",
            "TOKEN_NOT_FOUND": "Kan het API-token niet ophalen. Zorg ervoor dat de API-referenties correct zijn.",
            "USERS_NOT_FOUND": "Kan geen gebruikers ophalen."
          },
          "Microsoft licenses": {
            "Applies to": "Van toepassing op",
            "Capability status": "Status van de mogelijkheden",
            "Consumed units": "Verbruikte eenheden",
            "Microsoft license": "Microsoft-licentie | Microsoft-licenties | Microsoft-licentie {license}",
            "Prepaid units enabled": "Prepaid units ingeschakeld",
            "Prepaid units suspended": "Prepaid eenheden opgeschort",
            "Prepaid units warning": "Waarschuwing voor prepaid-eenheden",
            "SKU id": "SKU-id",
            "SKU name": "SKU-naam",
            "SKU part number": "SKU-onderdeelnummer"
          },
          "Shared mailboxes": {
            "Display name": "Weergavenaam",
            "Mail": "Mail",
            "Mail nickname": "Mail bijnaam",
            "Shared mailbox": "Gedeeld postvak | Gedeelde postvakken | Gedeelde mailbox {mailbox}",
            "User principal name": "Principal-naam van gebruiker"
          },
          "Teams": {
            "Archived": "Gearchiveerd",
            "Description": "Omschrijving",
            "Display name": "Weergavenaam",
            "Team": "Team | Teams | Team {team}",
            "Visibility": "Zichtbaarheid"
          },
          "Users": {
            "Display name": "Weergavenaam",
            "Given name": "Voornaam",
            "Surname": "Achternaam",
            "User": "Gebruiker | Gebruikers | Gebruiker {name}",
            "User principal name": "Principal-naam van gebruiker"
          }
        },
        "MicrosoftSecurity": {
          "Alerts": {
            "Alerts": "Waarschuwing | Waarschuwingen",
            "Assigned to": "Toegewezen aan",
            "Classification": "Classificatie",
            "Computer DNS name": "DNS-naam van computer",
            "Description": "Beschrijving",
            "First event time": "Eerste evenement tijd",
            "Last event time": "Laatste evenement tijd",
            "Last update time": "Laatste update tijd",
            "Related user": "Gerelateerde gebruiker",
            "Resolved time": "Opgeloste tijd",
            "Severity": "Ernst",
            "Title": "Titel"
          },
          "Calculations": {
            "Alerts": {
              "Alerts": "Waarschuwingen",
              "Total Alerts Per Severity": "Totaal aantal waarschuwingen per ernst"
            },
            "Indicators": "Indicatoren",
            "Machine Actions": "Machine acties",
            "Machines": "Machines",
            "Recommendations": "Aanbevelingen",
            "Remediations": "Saneringen",
            "Software": "Software",
            "Vulnerabilities": {
              "Total Vulnerabilities Per Severity": "Totaal aantal kwetsbaarheden per ernst",
              "Vulnerabilities": "Kwetsbaarheden"
            },
            "Vulnerabilities By Machine And Software": {
              "Total Vulnerabilities Per Severity": "Totaal aantal kwetsbaarheden per ernst",
              "Vulnerabilities By Machine And Software": "Kwetsbaarheden per machine en software"
            }
          },
          "Errors": {
            "ALERTS_NOT_FOUND": "Kan geen Waarschuwingen ophalen.",
            "INDICATORS_NOT_FOUND": "Kan geen Indicatoren ophalen.",
            "MACHINE_ACTIONS_NOT_FOUND": "Kan Machineacties niet ophalen.",
            "MICROSOFT_SECURITY_API_CREDENTIALS_MISSING": "Microsoft Security API-gegevens niet gevonden in database.",
            "MICROSOFT_SECURITY_API_NOT_ACTIVATED": "Microsoft Security API is niet actief voor deze klant. Ga naar het tabblad API-referenties om de API te activeren en vul de API-referenties in.",
            "ONBOARDED_MACHINES_NOT_FOUND": "Kan geen Onboarded Machines ophalen.",
            "RECOMMENDATIONS_NOT_FOUND": "Kan geen Aanbevelingen ophalen.",
            "REMEDIATION_NOT_FOUND": "Kan geen herstelgegevens ophalen.",
            "SOFTWARE_NOT_FOUND": "Kan software niet ophalen.",
            "TOKEN_NOT_FOUND": "Kan geen token ophalen.",
            "VULNERABILITIES_BY_MACHINE_AND_SOFTWARE_NOT_FOUND": "Kan kwetsbaarhedenPerMachineAndSoftware niet ophalen.",
            "VULNERABILITIES_NOT_FOUND": "Kan geen kwetsbaarheden ophalen."
          },
          "Machines": {
            "Agent version": "Agentversie",
            "Device value": "Waarde van het apparaat",
            "Exposure level": "Blootstellingsniveau",
            "First seen": "Voor het eerst gezien",
            "Health status": "Gezondheidstoestand",
            "Is Aad joined": "Is Aad lid geworden",
            "Is excluded": "Is uitgesloten",
            "Last external IP address": "Laatste externe IP-adres",
            "Last IP address": "Laatste IP-adres",
            "Last seen": "Laatst gezien",
            "Machine": "Machine | Machines",
            "Managed by": "Beheerd door",
            "Name": "Naam",
            "OS architecture": "OS-architectuur",
            "OS Build": "OS-build",
            "OS platform": "OS-platform",
            "Version": "Versie"
          },
          "Recommendations": {
            "Active alert": "Actieve waarschuwing",
            "Category": "Categorie",
            "Config score impact": "Impact van de configuratiescore",
            "Exposed machine count": "Blootgesteld aantal machines",
            "Exposure impact": "Impact van blootstelling",
            "Has unpatchable CVE": "Heeft unpatchable CVE",
            "Name": "Naam",
            "Product name": "Productnaam",
            "Public exploit": "Publieke exploitatie",
            "Recommendations": "Aanbeveling | Aanbevelingen",
            "Recommended program": "Aanbevolen programma",
            "Recommended vendor": "Aanbevolen leverancier",
            "Recommended version": "Aanbevolen versie",
            "Related components": "Gerelateerde componenten",
            "Remediation type": "Type sanering",
            "Severity score": "Ernstscore",
            "Total machine count": "Totaal aantal machines",
            "Vendor": "Leverancier",
            "Weaknesses": "Zwakke punten"
          },
          "Remediations": {
            "Category": "Categorie",
            "Completer email": "Afronder e-mail",
            "Created on": "Gemaakt op",
            "Description": "Beschrijving",
            "Fixed devices": "Herstelde apparaten",
            "Last modified on": "Laatst gewijzigd op",
            "Priority": "Prioriteit",
            "Recommendation name": "Naam van aanbeveling",
            "Remediations": "Sanering | Saneringen",
            "Requester email": "E-mailadres aanvrager",
            "Requester notes": "Opmerkingen van de aanvrager",
            "Software name": "Naam van de software",
            "Software vendor": "Softwareleverancier",
            "Target devices": "Doelapparaten",
            "Title": "Titel",
            "Type": "Type"
          },
          "Software": {
            "Active alert": "Actieve waarschuwing",
            "Exposed machines": "Blootgestelde machines",
            "Impact score": "Impact Score",
            "Installed machines": "Geïnstalleerde machines",
            "Name": "Naam",
            "Public exploit": "Publieke exploitatie",
            "Recommendation": "Aanbeveling",
            "Software": "Software",
            "Vendor": "Leverancier",
            "Weaknesses": "Zwakke punten"
          },
          "Vulnerabilities": {
            "cvssV3": "CVSSV3",
            "Description": "Beschrijving",
            "Exploit verified": "Exploit geverifieerd",
            "Exposed machines": "Blootgestelde machines",
            "Name": "Naam",
            "Public exploit": "Publieke exploitatie",
            "Published on": "Gepubliceerd op",
            "Severity": "Ernst",
            "Updated on": "Bijgewerkt op",
            "Vulnerabilities": "Kwetsbaarheid | Kwetsbaarheden"
          },
          "Vulnerabilities by machine and software": {
            "cvssV3": "CVSSV3",
            "Description": "Beschrijving",
            "Exploit verified": "Exploit geverifieerd",
            "Exposed machines": "Blootgestelde machines",
            "Machine name": "Machinenaam",
            "Name": "Naam",
            "OS platform": "OS-platform",
            "Public exploit": "Publieke exploitatie",
            "Published on": "Gepubliceerd op",
            "Recommendation name": "Naam van aanbeveling",
            "Severity": "Ernst",
            "Software name": "Naam van de software",
            "Software vendor": "Softwareleverancier",
            "Updated on": "Bijgewerkt op",
            "Vulnerabilities by machine and software": "Kwetsbaarheden per machine en software"
          }
        },
        "Nothing to show": "Niets om weer te geven, selecteer ten minste één itemtype en één klant uit de selectievakken | Niets om weer te geven, selecteer ten minste één itemtype in het selectievakje | Niets om weer te geven, selecteer ten minste één klant uit het selectievakje",
        "Overview": "Overzicht van klantactiva",
        "Reload assets": "Vernieuw assets",
        "Reload complete": "Alle klant- en assetgegevens zijn opnieuw opgehaald",
        "Reload complete title": "Opnieuw ophalen gegevens voltooid",
        "Show history": "Geschiedenis weergeven",
        "Tables and diagrams": "Tabellen en diagrammen",
        "Tables only": "Alleen tabellen",
        "TransIP": {
          "Availability zone": "Beschikbaarheidszone",
          "Block storage backups": "Block opslagback-ups",
          "Block storage description": "Beschrijving van virtuele machine",
          "Block storage name": "Naam van virtuele machine",
          "Block storages": "Block opslag",
          "Calculations": {
            "Block Storage Backups": {
              "Block Storage Backups": "Block opslagback-ups",
              "Total Backups Per Date": "Totaal aantal back-ups van block opslag per datum",
              "Total Unique Block Storage Backups Per Date": "Totaal unieke back-ups van block opslag per datum"
            },
            "Block Storages": {
              "Block Storages": "Block opslag",
              "Total Block Storages Statuses": "Totaal beschikbare opslag"
            },
            "Virtual Machine Backups": {
              "Total Backups Per Date": "Totaal aantal back-ups van virtuele machines per datum",
              "Total Protection Status": "Backup status per virtuele machine",
              "Total Unique VMBackups Per Date": "Totaal aantal unieke back-ups van virtuele machines per datum",
              "Virtual Machine Backups": "Back-ups van virtuele machines"
            },
            "Virtual Machines": {
              "Total Operating Systems": "Totaal aantal besturingssystemen",
              "Total Virtual Machine Statuses": "Totaal aantal statussen van virtuele machines",
              "Total Virtual Machine Types": "Totaal aantal typen virtuele machines",
              "Virtual Machines": "Virtuele machines"
            }
          },
          "CPUs": "Processoren",
          "Created at": "Gemaakt op",
          "Current snaphots": "Huidige snaphots",
          "Description": "Beschrijving",
          "Disk size": "Schijfgrootte",
          "Errors": {
            "BLOCK_STORAGE_BACKUPS_NOT_FOUND": "Kan geen back-ups van block opslag krijgen.",
            "BLOCK_STORAGES_NOT_FOUND": "Kan geen block opslag krijgen.",
            "KEY_SIGNATURE_INVALID": "Kan handtekening niet decoderen.",
            "TOKEN_NOT_FOUND": "Kan geen token krijgen.",
            "TRANSIP_API_CREDENTIALS_MISSING": "TransIP API-gegevens kunnen niet worden gevonden in de database en gedeelde TransIP worden niet gebruikt.",
            "TRANSIP_API_NOT_ACTIVATED": "TransIP API is niet actief voor deze klant. Ga naar het tabblad API-referenties om de API te activeren en vul de API-referenties in.",
            "VIRTUAL_MACHINE_BACKUPS_NOT_FOUND": "Kan geen back-ups ophalen van Virtual Machine.",
            "VIRTUAL_MACHINES_NOT_FOUND": "Kan geen virtuele machines krijgen."
          },
          "IP address": "IP-adres",
          "Is blocked": "Is geblokkeerd",
          "Is customer locked": "Is de klant vergrendeld",
          "Is locked": "Is vergrendeld",
          "MAC address": "MAC-adres",
          "Max snapshots": "Max snapshots",
          "Memory size": "Grootte van het geheugen",
          "Name": "Naam",
          "Offsite backups": "Offsite back-ups",
          "Operating system": "Besturingssysteem",
          "Product name": "Productnaam",
          "Serial": "Serienummer",
          "Status": "Status ",
          "Virtual machine description": "Beschrijving van virtuele machine",
          "Virtual machine name": "Naam van virtuele machine",
          "Virtual machines": "Virtuele machines",
          "Virtual machines backups": "Back-ups van virtuele machines"
        },
        "Veeam": {
          "Calculations": {
            "Backup Items": "Back-upitems",
            "Backup Items Per Date": {
              "Backup Items Per Date": "Back-upitems per datum",
              "Total Mailbox Items Per Date": "Totaal aantal postvakitems per datum",
              "Total One Drive Items Per Date": "Totaal aantal One Drive items per datum",
              "Total Site Items Per Date": "Totaal aantal site-items per datum",
              "Total Team Items Per Date": "Totaal aantal Team items per datum"
            },
            "Job Sessions Backup Status Per Job": {
              "Job Sessions Backup Status Per Job": "Back-upstatus van taaksessies per taak"
            },
            "Job Sessions Total Backup Status": "Totale back-upstatus van taaksessies",
            "Jobs": "Taken",
            "Licensed Users": "Gelicentieerde gebruikers",
            "Storage Usage": {
              "Storage Usage": "Opslag gebruik",
              "Total Usage Per Drive Letter": "Totaal gebruik per stationsletter",
              "Total Usage Per Repository": "Totaal gebruik per opslagplaats"
            }
          },
          "Errors": {
            "BACKUP_REPOSITORY_NOT_FOUND": "Kan geen Back-up Repository ophalen.",
            "JOB_SESSIONS_NOT_FOUND": "Kan geen taaksessies krijgen.",
            "JOBS_NOT_FOUND": "Kan geen taken ophalen.",
            "LICENSED_USERS_NOT_FOUND": "Kan geen gelicentieerde gebruikers ophalen.",
            "LICENSING_INFORMATION_NOT_FOUND": "Licentie-informatie kan niet worden opgehaald.",
            "MAILBOX_DATA_NOT_FOUND": "Mailbox gegevens kunnen niet worden opgehaald.",
            "ONEDRIVE_DATA_NOT_FOUND": "Kan OneDrive-gegevens niet ophalen.",
            "ORGANIZATION_GROUPS_NOT_FOUND": "Kan organisatiegroepen niet ophalen.",
            "ORGANIZATION_SITES_NOT_FOUND": "Kan organisatiesites niet ophalen.",
            "ORGANIZATION_TEAMS_NOT_FOUND": "Kan organisatieteams niet krijgen.",
            "ORGANIZATION_USERS_NOT_FOUND": "Kan organisatiegebruikers niet krijgen.",
            "ORGANIZATION_WITH_TENANT_URL_NOT_FOUND": "Geen organisatie gevonden met Microsoft Azure-tenant-URL. Ga naar het tabblad API-referenties om de juiste tenant-URL in te vullen.",
            "ORGANIZATIONS_NOT_FOUND": "Organisaties kunnen niet worden opgehaald.",
            "PROCESSED_OBJECTS_NOT_FOUND": "Kan verwerkte objecten niet ophalen.",
            "SITE_DATA_NOT_FOUND": "Kan sitegegevens niet ophalen.",
            "TEAM_DATA_NOT_FOUND": "Teamgegevens kunnen niet worden opgehaald.",
            "TOKEN_NOT_FOUND": "Kan het API-token niet ophalen. Zorg ervoor dat de API-referenties correct zijn.",
            "USED_REPOSITORIES_NOT_FOUND": "Kan geen Gebruikte Repositories ophalen.",
            "VEEAM_API_NOT_ACTIVATED": "Veeam API is niet actief voor deze klant. Ga naar het tabblad API-referenties om de API te activeren en vul de API-referenties in.",
            "VEEAM_TENANT_URL_MISSING": "Veeam Microsoft Azure-tenant-URL niet gevonden in database voor deze klant. Ga naar het tabblad API-referenties om de juiste tenant-URL in te vullen."
          },
          "Jobs": {
            "Backup type": "Type back-up",
            "Backup window enabled": "Back-upvenster ingeschakeld",
            "Enabled": "Ingeschakeld",
            "Job": "Taak | Taken | Taak {job}",
            "Job sessions": {
              "Creation time": "Creatietijd",
              "Details": "Details",
              "End time": "Eindtijd",
              "Job session": "Taak sessie | Taak sessies",
              "Job type": "Taak type",
              "Processed objects": {
                "Display name": "Weergavenaam",
                "Name": "Naam",
                "Processed objects": "Verwerkte objecten",
                "Status": "Status ",
                "Type": "Type"
              },
              "Processing rate bytes": "Verwerkingssnelheid bytes",
              "Processing rate items": "Verwerkingssnelheid items",
              "Progress": "Voortgang",
              "Read rate bytes": "Bytes met leessnelheid",
              "Retry count": "Aantal nieuwe pogingen",
              "Retry job": "Taak opnieuw proberen",
              "Status": "Status ",
              "Transferred data bytes": "Overgedragen gegevensbytes",
              "Write rate bytes": "Schrijfsnelheid bytes"
            },
            "Mailbox data": {
              "Archive": "Archief",
              "Backup time": "Back-up tijd",
              "Deleted": "Verwijderd",
              "Display name": "Weergavenaam",
              "Email": "E-mail",
              "Mailbox data": "Postvakgegevens",
              "Type": "Type"
            },
            "Name": "Naam",
            "Next run": "Volgende run",
            "One drive data": {
              "Backup time": "Back-up tijd",
              "Deleted": "Verwijderd",
              "One drive data": "OneDrive-gegevens",
              "Title": "Titel",
              "Type": "Type"
            },
            "Periodically windows enabled": "Periodiek vensters ingeschakeld",
            "Policy daily time": "Beleid dagelijkse tijd",
            "Policy daily type": "Beleid dagelijkse type",
            "Policy type": "Type beleid",
            "Repository daily retention type": "Repository bewaartype dagelijks",
            "Repository daily time": "Repository dagelijkse tijd",
            "Repository daily type": "Repository dagelijks type",
            "Repository free space (bytes)": "Vrije ruimte in repository (bytes)",
            "Repository frequency type": "Frequentietype repository",
            "Repository monthly retention type": "Maandelijks bewaartype repository",
            "Repository name": "Repository naam",
            "Repository out of sync": "Repository loopt niet synchroon",
            "Repository path": "Pad naar repository",
            "Repository retention period": "Bewaartermijn repository",
            "Repository retention type": "Bewaartype repository",
            "Repository yearly retention type": "Jaarlijks bewaartype repository",
            "Retry enabled": "Opnieuw proberen ingeschakeld",
            "Retry interval": "Interval voor nieuwe pogingen",
            "Retry number": "Aantal nieuwe pogingen",
            "Schedule enabled": "Planning ingeschakeld",
            "Site data": {
              "Backup time": "Back-up tijd",
              "Deleted": "Verwijderd",
              "Site data": "Sitegegevens",
              "Title": "Titel",
              "Type": "Type",
              "Url": "Url"
            },
            "Storage details": "Opslaggegevens",
            "Storage used space (bytes)": "Gebruikte opslagruimte (bytes)",
            "Teams data": {
              "Backup time": "Back-up tijd",
              "Deleted": "Verwijderd",
              "Display name": "Weergavenaam",
              "Teams data": "Teams-gegevens",
              "Type": "Type"
            }
          },
          "Licensed users": {
            "Backed up": "Geback-upt",
            "Last backup": "Laatste back-up",
            "License state": "Licentiestatus",
            "Licensed users": "Gelicenseerde gebruikers",
            "Name": "Naam"
          },
          "Licensing Information": {
            "Licensed users": "Gelicenseerde gebruikers",
            "Licensing Information": "Licentie-informatie",
            "New users": "Nieuwe gebruikers"
          },
          "Organization": {
            "Exchange": "Exchange",
            "Exchange account": "Exchange-account",
            "Exchange application ID": "Exchange-toepassings-id",
            "Name": "Naam",
            "Office name": "Office naam",
            "Organization": "Organisatie",
            "Region": "Regio",
            "SharePoint": "SharePoint",
            "SharePoint account": "SharePoint-account",
            "SharePoint application ID": "SharePoint-toepassings-id",
            "Teams": "Teams",
            "Teams chat": "Teams chat",
            "Type": "Type"
          }
        },
        "View type": "Type weergave",
        "VPN": {
          "Assigned to": "Toegewezen aan",
          "Calculations": {
            "Certificates": "Certificaten",
            "Total Certificates": "Totaal Certificaten",
            "Total Devices": "Totaal aantal apparaten",
            "Total Managed Devices": "Totaal beheerde apparaten",
            "Total Other Devices": "Totaal aantal andere apparaten",
            "Total Phones": "Totaal aantal telefoons",
            "Total Routers": "Totaal aantal routers",
            "Total Tablets": "Totaal tabletten"
          },
          "Certificates": "Certificaten",
          "Comments": "Opmerkingen",
          "Created at": "Gemaakt op",
          "Errors": {
            "CERTIFICATES_NOT_FOUND": "Er zijn geen VPN-certificaten gevonden.",
            "TOKEN_NOT_FOUND": "Kan het API-token niet ophalen. Zorg ervoor dat de API-referenties correct zijn.",
            "VPN_API_CREDENTIALS_MISSING": "Gedeelde VPN is niet actief, maar VPN API-referenties zijn niet gevonden in de database voor deze klant. Ga naar het tabblad API-referenties om de API-referenties in te vullen.",
            "VPN_API_NOT_ACTIVATED": "VPN API is niet actief voor deze klant. Ga naar het tabblad API-referenties om de API te activeren en vul de API-referenties in."
          },
          "External IP": "Extern IP",
          "Iroute": "Interne route(s)",
          "Last seen": "Laatst gezien",
          "Name": "Naam",
          "Status": "Status ",
          "VPN IP": "VPN-IP"
        }
      },
      "Assets reloading": "Assets worden vernieuwd",
      "BankCity": "Bank vestigingsplaats",
      "Banking": "Bankgegevens",
      "BankName": "Bank naam",
      "BIC": "Bank Identifier Code (BIC)",
      "Birthday": "Verjaardag",
      "BlockStorageDescription": "Beschrijving van block opslag",
      "BlockStorageName": "Block opslagnaam",
      "City": "Plaats",
      "ClientAppUsed": "Client-app gebruikt",
      "ClientSecret": "Client Secret",
      "CocNumber": "KvK-nummer",
      "Comments": "Opmerkingen",
      "Contact information": "@:Contacts.Contact@.lower:Shared.Globals.Data",
      "Contact person": "Contactpersoon",
      "ContactInfo": "Contact informatie",
      "Country": "Land",
      "CountryOrRegion": "Land of Regio",
      "Custom address": "Aangepast adres",
      "Customer": "Klant",
      "Customer information": "@:Customers.Customer@.lower:Shared.Globals.Data",
      "CustomerId": "Klantnummer",
      "CustomerName": "Klantnaam",
      "DefaultContract": "Standaard contract",
      "Delete": "verwijderen",
      "Delete item": "Klant verwijderen",
      "Delete item fail": "De klant kon niet worden verwijderd. {msg}",
      "Delete item success": "Klant succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je de klant {0} wilt {1}?",
      "DirectDebitMandate": "Machtigingskenmerk",
      "DirectDebitMandateSignatureDate": "Datum van ondertekening van het mandaat",
      "Edit": "Bewerk @.lower:{item}",
      "Edit contact": "Bewerkt @.lower:{contact} informatie",
      "Edit item": "Klant wijzigen",
      "Errors": {
        "CUSTOMER_ARCHIVE_INVOICING_SYNC_FAILED": "De gekoppelde relatie kon niet op non-actief worden gezet in SnelStart. De klant is niet gearchiveerd. Probeer het later opnieuw."
      },
      "Edit item fail": "Fout bij het wijzigen van de klant. {msg}",
      "Edit item success": "Klant succesvol gewijzigd.",
      "EmailAddress": "E-mailadres",
      "Error loading data": "Door een fout kon de data niet opgehaald worden.",
      "Export": "Exporteer",
      "FirstName": "Voornaam",
      "HasInvoices": "Heeft facturen",
      "HetznerAPI": {
        "HetznerInUse": "Hetzner API"
      },
      "HetznerInUse": "Hetzner API",
      "Host": "Host",
      "HostFactCustomerId": "HostFact klantnummer",
      "IBAN": "Rekeningnummer",
      "Initials": "Initialen",
      "Invoice contact information": "@:Customers.InvoiceContact",
      "Invoice information": "@:Invoices.Invoice@.lower:Shared.Globals.Data",
      "InvoiceContact": "Factuur contactpersoon",
      "InvoiceEmailAddress": "Factuur e-mailadres",
      "IsActive": "Actieve klant",
      "IsArchived": "Gearchiveerd",
      "Labels": "Labels",
      "LastName": "Achternaam",
      "LegalForm": "Rechtsvorm",
      "LegalFormOptions": {
        "Bv": "BV",
        "Coop": "Cooperatie",
        "Cv": "CV",
        "Eenmanszaak": "Eenmanszaak",
        "Nv": "NV",
        "Other": "Anders",
        "Stichting": "Stichting",
        "Vereniging": "Vereniging",
        "Vof": "VoF"
      },
      "Machine": {
        "computerDnsName": "Computer naam"
      },
      "MicrosoftAzureAPI": {
        "MicrosoftAzureInUse": "Microsoft Azure API"
      },
      "MicrosoftAzureInUse": "Microsoft Azure API",
      "MicrosoftGraphAPI": {
        "MicrosoftGraphInUse": "Microsoft Graph API"
      },
      "MicrosoftGraphInUse": "Microsoft Graph API",
      "MicrosoftSecurityAPI": {
        "MicrosoftSecurityInUse": "Microsoft Security API"
      },
      "MicrosoftSecurityInUse": "Microsoft Security API",
      "Name": "Naam",
      "New item": "Nieuwe klant",
      "New item fail": "Fout bij het aanmaken van de klant. {msg}",
      "New item success": "Klant succesvol toegevoegd.",
      "No labels": "Geen labels",
      "Offer contact information": "@:Customers.OfferContact",
      "Offer information": "@:Customer-offers.Offer@.lower:Shared.Globals.Data",
      "OfferContact": "Offerte contactpersoon",
      "OfferEmailAddress": "Offerte e-mailadres",
      "OperatingSystem": "Besturingssysteem",
      "PayByDirectDebit": "Betaling per automatische incasso",
      "Phone": "Telefoonnummer",
      "Primary contact information": "@:Customers.PrimaryContact",
      "PrimaryContact": "Primair contactpersoon",
      "PrimaryContactOld": "Primair contactpersoon",
      "Refresh list": "Lijst vernieuwen",
      "Reload assets item success": "Assets zijn succesvol vernieuwd.",
      "Salutation": "Begroeting",
      "SecondaryContacts": "Secundaire contactpersonen",
      "Secret": "Secret",
      "Severity": "Ernst",
      "SharedHetzner": "Hetzner gedeeld",
      "SharedTransIP": "TransIP gedeeld",
      "SharedVPN": "VPN gedeeld",
      "State": "Staat",
      "Tabs": {
        "API Credentials": "API gegevens",
        "Assets": "Assets",
        "Contacts": "Contacten",
        "Contracts": "Contracten",
        "Financial": "Financieel",
        "General": "Algemeen",
        "Invoices": "Facturen",
        "Settings": "Instellingen",
        "Services": {
          "Domains": "Domeinen",
          "Hosting accounts": "Hostingaccounts",
          "Services": "Diensten",
          "SSL certificates": "SSL-certificaten"
        },
        "Subscriptions": "Abonnementen",
        "Users": "Gebruikers"
      },
      "TaxNumber": "BTW-nummer",
      "Tenant": "Tenant",
      "TransIPAPI": {
        "TransIPInUse": "TransIP API"
      },
      "TransIPInUse": "TransIP API",
      "User": "Gebruiker",
      "UserPrincipalName": "Principal-naam van gebruiker",
      "Users": {
        "No users": "Er zijn geen gebruikers voor deze klant om te tonen"
      },
      "VeeamInUse": "Veeam API",
      "VeeamMicrosoftAzureTenantURL": "Tenant URL",
      "View invoices": "Facturen weergeven",
      "VirtualMachineDescription": "Beschrijving van virtuele machine",
      "VirtualMachineName": "Naam van virtuele machine",
      "VPNAPI": {
        "VPNInUse": "OMNI VPN API"
      },
      "VPNInUse": "OMNI VPN API",
      "Website": "Website",
      "Zipcode": "Postcode"
    },
    "Domain-ns-groups": {
      "Add NameServers item": "Nameserver toevoegen",
      "Alias": "Alias",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Nameservergroep verwijderen",
      "Delete item fail": "Kan nameservergroep niet verwijderen. {msg}",
      "Delete item success": "Nameservergroep verwijderd.",
      "Delete item text": "Weet u zeker dat u de nameservergroep {0} wilt {1} ?",
      "Delete NameServers item": "Nameservergroep verwijderen",
      "Domain-ns-group": "Nameservergroep",
      "Edit item": "Nameservergroep bewerken",
      "Edit item fail": "Fout bij bewerken van de nameservergroep. {msg}",
      "Edit item success": "Nameservergroep is bewerkt.",
      "Errors": {
        "default": "Er is iets mis gegaan tijdens het uitvoeren van het nameservergroep verzoek. {msg}",
        "ErrorCode": {
          "default": "Er is iets mis gegaan tijdens het uitvoeren van het nameservergroep verzoek. {msg}",
          "NAMESERVERS_NOT_UNIQUE": "Nameservers zijn niet uniek.",
          "OXXA_API_BAD_STATUS_CODE": "Kan geen verbinding maken met domeinleverancier.",
          "OXXA_API_NO_CHANGES": "Het contactpersoon is ongewijzigd.",
          "OXXA_API_NO_HANDLE_FOUND": "Geen ID gevonden bij de leverancier.",
          "OXXA_API_REMOVE_DATA_NOT_FOUND": "Geen gegevens gevonden om te verwijderen.",
          "OXXA_API_REQUEST_FAILED": "Kan geen verbinding maken met domeinleverancier.",
          "OXXA_API_RESULT_DIFF": "Het contactpersoon is gedeeltelijk gewijzigd, controleer het resultaat.",
          "OXXA_API_RESULT_NOT_FOUND": "Geen resultaten gevonden voor NS groep.",
          "UNIQUE_FIELD_ERROR_NOT_UNIQUE": "Het veld '@.lower:{key}' is niet uniek."
        }
      },
      "isAttached": "Gekoppeld aan domein?",
      "isPublic": "Publieke nameserver?",
      "Nameservers": "Nameservers",
      "NameServers": "Nameserver",
      "NameServers 1": "Nameserver 1",
      "NameServers 2": "Nameserver 2",
      "NameServers 3": "Nameserver 3",
      "NameServers 4": "Nameserver 4",
      "NameServers 5": "Nameserver 5",
      "NameServers 6": "Nameserver 6",
      "New item": "Nieuwe nameservergroep",
      "New item fail": "Kan geen nieuwe nameservergroep maken. {msg}",
      "New item success": "Nieuwe nameservergroep gemaakt.",
      "No customer": "Geen klant"
    },
    "Dmarc": {
      "AggregateAuthorizationRecord": "Aggregatie-autorisatierecord",
      "AggregateReportEmail": "Adres voor aggregatierapporten",
      "AggregateReportDomainDns": "DNS van aggregatierapportagedomein",
      "AggregateReports": "Aggregatierapporten",
      "AggregateReportsEnabled": "Aggregatierapporten",
      "AggregateAndFailureAuthorizationRecord": "Autorisatierecord voor aggregatie- en foutrapporten",
      "AlignmentOptions": {
        "r": "Relaxed",
        "s": "Strikt"
      },
      "Alignment": "Alignment",
      "AlignmentRate": "Alignmentpercentage",
      "AuthFailure": "Authenticatiefout",
      "AuthorizationRecordValue": "Autorisatierecordwaarde",
      "Count": "Aantal",
      "CurrentRecord": "Huidig DNS-record",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "DMARC-domein verwijderen",
      "Delete item fail": "Fout bij verwijderen van DMARC-domein. {msg}",
      "Delete item success": "DMARC-domein verwijderd.",
      "Delete item text": "Weet u zeker dat u het DMARC-domein {0} wilt {1}?",
      "Dkim": "DKIM",
      "DkimAlignment": "DKIM-alignment",
      "Dmarc": "DMARC",
      "Dns": "DNS",
      "DnsDiffers": "Wijkt af",
      "DnsMatches": "Komt overeen",
      "DnsMissing": "Niet gevonden",
      "Domain": "Domein",
      "DomainRecord": "DMARC-record van het domein",
      "DomainRecordTarget": "Voeg dit TXT-record toe op het klantdomein: {domain}",
      "Domains": "Domeinen",
      "Disposition": "Afhandeling",
      "EnvelopeFrom": "Envelope from",
      "Edit item": "DMARC-domein bewerken",
      "Edit item fail": "Fout bij bewerken van DMARC-domein. {msg}",
      "Edit item success": "DMARC-domein succesvol gewijzigd.",
      "Error in fields": "Controleer de DMARC-velden.",
      "FailureAuthorizationRecord": "Fout-autorisatierecord",
      "FailureReportEmail": "Adres voor foutrapporten",
      "FailureReportDomainDns": "DNS van foutrapportagedomein",
      "FailureReportOptions": {
        "0": "Alle mechanismen falen",
        "1": "Elke fout",
        "d": "DKIM-fout",
        "s": "SPF-fout"
      },
      "FailureReportOptionsLabel": "Foutmodus",
      "FailureReports": "Foutrapporten",
      "FailureReportsEnabled": "Foutrapporten",
      "FromDate": "Van",
      "HeaderFrom": "Header from",
      "IdentityAlignment": "Identiteitsalignment",
      "Inherit": "Overnemen",
      "InheritWithValue": "Overnemen ({value})",
      "InvalidEmail": "Voer een geldig e-mailadres in.",
      "InvalidReportDestination": "Selecteer een van de geconfigureerde DMARC-rapportagebestemmingen.",
      "ManagedDomains": "Beheerde domeinen",
      "New item": "Nieuw DMARC-domein",
      "New item fail": "Fout bij aanmaken van DMARC-domein. {msg}",
      "New item success": "DMARC-domein succesvol aangemaakt.",
      "NonexistentSubdomainPolicy": "Policy voor niet-bestaande subdomeinen",
      "Notes": "Notities",
      "OriginalMailFrom": "Originele mail from",
      "Policy": "Policy",
      "PolicyOptions": {
        "none": "Geen",
        "quarantine": "Quarantaine",
        "reject": "Weigeren"
      },
      "ProcessMailbox": "Mailbox verwerken",
      "ProcessMailboxResult": "Verwerkt: {processed}, aangemaakt: {created}, dubbel: {duplicates}, overgeslagen: {skipped}",
      "ProcessedAt": "Verwerkt op",
      "RawReport": "Ruw DMARC-rapport",
      "RawReportUnavailable": "Het ruwe rapport is niet opgeslagen voor dit rapport.",
      "RecordName": "Recordnaam",
      "RecordValue": "Recordwaarde",
      "Records": "Records",
      "ReportAuthorizationRecords": "Autorisatie voor externe rapportage",
      "ReportAuthorizationRecordsText": "Voor externe DMARC-rapportage is een autorisatierecord nodig op het rapportagedomein.",
      "ReportAuthorizationTarget": "Voeg dit TXT-record toe op het OMNI-rapportagedomein: {domain}",
      "ReportDate": "Rapportdatum",
      "ReportDestinationDisabled": "Niet gebruiken",
      "Reporter": "Rapporteur",
      "Reporters": "Rapporteurs",
      "Reporting": "Rapportage",
      "SmtpMailFrom": "SMTP mail from",
      "SourceHost": "Bronhost",
      "SourceIp": "Bron-IP",
      "SourceIps": "Bron-IP's",
      "Spf": "SPF",
      "SpfAlignment": "SPF-alignment",
      "SubdomainPolicy": "Subdomeinpolicy",
      "TargetDomainDns": "DNS van doeldomein",
      "Testing": "Testmodus",
      "TotalMessages": "Berichten",
      "TotalReports": "Rapporten",
      "UntilDate": "Tot",
      "ViewRawReport": "Ruw rapport bekijken"
    },
    "Dmarc-aggregate-reports": {
      "Disposition": "Afhandeling",
      "Dkim": "DKIM",
      "Domain": "Domein",
      "EnvelopeFrom": "Envelope from",
      "HeaderFrom": "Header from",
      "OrgName": "Rapporteur",
      "SourceIp": "Bron-IP",
      "Spf": "SPF"
    },
    "Dmarc-failure-reports": {
      "Domain": "Domein",
      "HeaderFrom": "Header from",
      "SmtpMailFrom": "SMTP mail from",
      "SourceHost": "Bronhost",
      "SourceIp": "Bron-IP"
    },
    "Domains": {
      "Add DNSSEC item": "DNSSEC regel toevoegen",
      "Add Nameservers item": "Nameserver toevoegen",
      "AdministrativeContact": "Administratief contact",
      "Alg": "Algoritme",
      "All customers": "Alle klanten",
      "Auto renew disabled": "Automatisch vernieuwen is uitgeschakeld voor dit domein",
      "AutoRenew": "Automatische verlenging",
      "AutoRenewdisabled": "Automatisch verlengen is uitgeschakeld voor dit domein",
      "BillingContact": "Facturatie contact",
      "Check domain": "Controleer domein",
      "Check domain availability": "Controleer de beschikbaarheid van het domein",
      "Confirm domain force delete text": "Weet je zeker dat je het domein {0} wilt verwijderen? Het domein wordt in quarantaine geplaatst, er zijn kosten aan verbonden om dit terug te draaien.",
      "Confirm domain force delete title": "Domein verwijderen",
      "Confirm domain restore text": "Weet je zeker dat je het domein {0} wilt herstellen? Er zijn kosten aan verbonden om het domein uit quarantaine te halen.",
      "Confirm domain restore title": "Domein herstellen",
      "Copy transfercode": "Klik om de verhuiscode te kopiëren",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete DNSSEC item": "DNSSEC regel verwijderen",
      "Delete domain status not error item success": "Automatisch vernieuwen is uitgeschakeld, domein {name} zal worden verwijderd na de verloopdatum",
      "Delete item": "Domein verwijderen",
      "Delete item fail": "Fout bij het verwijderen van het domein. {msg}",
      "Delete item success": "Domein succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u het domein {0} wilt {1}?",
      "Delete Nameservers item": "Nameserver verwijderen",
      "DNSSEC": "DNSSEC",
      "Dnssec item": "DNSSEC",
      "DNSSECInfo": "Gebruiker het onderstaande formulier om DNSSEC records in te stellen. Let op dat als je een bestaand record wijzigt, deze zal worden verwijderd en opnieuw wordt aangemaakt, controleer het resultaat dus goed!",
      "Domain": "Domein",
      "Domain has no DNS Sec": "Dit domein heeft geen DNSSEC-records geconfigureerd",
      "Domain in quarantaine": "Domein is in quarantaine",
      "Domain not linked": "Domein is niet gekoppeld aan dit hostingaccount in cPanel",
      "DomainNSGroup": "Domein Nameservers Groep",
      "DomainStatus": "Domein status",
      "DomainStatusOptions": {
        "Error": "Fout",
        "Quarantine": "Quarantaine",
        "Registered": "Geregistreerd",
        "Transfer pending": "In behandeling",
        "Transferred": "Verhuisd",
        "Unknown": "Onbekend"
      },
      "Edit domain DNSSEC item fail": "Fout bij het wijzigen van de DNSSEC instellingen. {msg}",
      "Edit domain DNSSEC item success": "Domein DNSSEC instellingen succesvol gewijzigd.",
      "Edit item": "Bewerk domein",
      "Edit item fail": "Fout bij bewerken van het domein. {msg}",
      "Edit item success": "Domein succesvol gewijzigd.",
      "Errors": {
        "default": "Fout bij het uitvoeren van het domein verzoek. {msg}",
        "ErrorCode": {
          "DOMAINS_CHECK_REQUIRED_FIELDS_MISSING": "Verplichte velden ontbreken.",
          "OXXA_API_BAD_STATUS_CODE": "Kan geen verbinding maken met domeinleverancier.",
          "OXXA_API_DISABLED": "Oxxa API is niet ingeschakeld.",
          "OXXA_API_NO_CHANGES": "Het contactpersoon is ongewijzigd.",
          "OXXA_API_NO_HANDLE_FOUND": "Geen ID gevonden bij de leverancier.",
          "OXXA_API_REMOVE_DATA_NOT_FOUND": "Geen gegevens gevonden om te verwijderen.",
          "OXXA_API_REQUEST_FAILED": "Kan geen verbinding maken met domeinleverancier.",
          "OXXA_API_RESULT_DIFF": "Het contactpersoon is gedeeltelijk gewijzigd, controleer het resultaat.",
          "OXXA_API_RESULT_NOT_FOUND": "Geen resultaten gevonden voor NS groep.",
          "UNIQUE_FIELD_ERROR_NOT_UNIQUE": "Het veld '@.lower:{key}' is niet uniek."
        }
      },
      "ExpireDate": "Verloopdatum",
      "Flags": "Flag",
      "Force remove domain": "Verwijder domein geforceerd",
      "Force remove domain item fail": "Domein kon niet geforceerd verwijderd worden. {msg}",
      "Force remove domain item success": "Domein succesvol geforceerd verwijderd.",
      "FullDomain": "Volledig domein resultaat",
      "Hostname": "Hostnaam",
      "IPv4": "IPv4",
      "IPv6": "IPv6",
      "LastRenewDate": "Laatste verlengingsdatum",
      "Lock": "Vergrendel",
      "Lock domain item success": "Domein succesvol vergrendeld.",
      "Lock item": "Domein vergrendelen",
      "Manage DNSSEC": "Beheer DNSSEC",
      "Nameservers": "Nameserver",
      "New item": "Nieuw domein",
      "New item fail": "Fout bij maken van domein. {msg}",
      "New item success": "Domein succesvol toegevoegd.",
      "No customer attached": "No customer attached",
      "NoticeDate": "Datum van kennisgeving",
      "Only one DNSSEC record configured": "Slechts één DNSSEC-record geconfigureerd",
      "OwnerContact": "Contactpersoon eigenaar",
      "Protocol": "Protocol",
      "PubKey": "Publieke sleutel",
      "QuarantaineEnd": "Quarantaine einde",
      "Registrar": "Registrar",
      "RegistrarOptions": {
        "Other": "Other",
        "Oxxa": "Oxxa",
        "Xolphin": "Xolphin"
      },
      "Restore domain": "Herstel domein",
      "Restore domain item fail": "Domein kon niet hersteld worden. {msg}",
      "Restore domain item success": "Domein succesvol hersteld.",
      "Retrieve transfercode": "Wanneer je het domein wilt verhuizen, haal dan hier de verhuiscode op",
      "Send EPP item fail": "Verhuiscode kan niet verstuurd worden.",
      "Send EPP item success": "Verhuiscode succesvol verstuurd.",
      "Send transfercode": "Verstuur",
      "Show transfercode": "Laat zien",
      "Show transfercode item": "Verhuiscode",
      "StartDate": "Startdatum",
      "Subscription": "Abonnement",
      "SubscriptionInfo": {
        "contractInfo": {
          "customer": "Klant"
        }
      },
      "Tabs": {
        "Contacts": "Contacten",
        "General": "Algemeen",
        "Name servers": "@:Domains.Nameservers"
      },
      "TechnicalContact": "Technisch contact",
      "Tld": "Domein extensie",
      "TransferCode": "Verhuiscode",
      "Unlock domain item success": "Domein succesvol ontgrendeld.",
      "Unlock item": "Domein ontgrendelen",
      "Webhosting": "Web hosting"
    },
    "Email-logs": {
      "Attachments": "Bijlages",
      "Bcc": "BCC",
      "BelongsTo": "Behoort tot",
      "Cc": "CC",
      "Content": "Bericht inhoud",
      "CreatedAt": "Gemaakt op",
      "Customer": "Klant",
      "Error loading data": "De lijst met email-logs kon vanwege een fout niet worden geladen.",
      "From": "Afzender",
      "MailSent": "Verzonden",
      "MailSentAt": "Verzonden op",
      "New item": "Nieuwe e-mail",
      "ReplyTo": "Reageer naar",
      "Subject": "Onderwerp",
      "To": "Aan",
      "ToOptions": {
        "NoBcc": "Geen 'bcc' adres",
        "NoCc": "Geen 'cc' adres",
        "NoFrom": "Geen 'from' adres",
        "NoReplyTo": "Geen 'reageren naar' adres",
        "NoTo": "Geen 'aan' adres"
      },
      "VendorResponse": "Reactie leverancier",
      "View item": "E-mail log details"
    },
    "Email-message-templates": {
      "Delete": "verwijderen",
      "Delete item": "Berichttemplate verwijderen",
      "Delete item text": "Weet je zeker dat je berichttemplate {0} wilt {1}? Bestaande mailings blijven behouden.",
      "Delete item success": "Berichttemplate verwijderd.",
      "Delete item fail": "@:Admin.EmailMessageTemplates.DeleteError",
      "Name": "@:Admin.EmailMessageTemplates.Name",
      "Category": "@:Admin.EmailMessageTemplates.Category",
      "Subject": "@:Admin.EmailMessageTemplates.Subject",
      "Content": "@:Admin.EmailMessageTemplates.Content"
    },
    "EmailMessageTemplates": {
      "Title": "Berichttemplates",
      "Subtitle": "Standaardberichten kiezen en beheren.",
      "Library": "Beschikbare templates",
      "Search": "Zoek op naam of onderwerp",
      "Category": "Categorie",
      "Categories": {
        "incident": "Storing",
        "newsletter": "Nieuwsbrief",
        "update": "Update",
        "other": "Overig"
      },
      "New": "Nieuw template",
      "SaveCurrent": "Huidig bericht opslaan",
      "Name": "Naam",
      "Subject": "Onderwerp (optioneel)",
      "Content": "Bericht",
      "SubjectHelp": "Een leeg onderwerp behoudt het onderwerp van de mail.",
      "VariablesHelp": "Gebruik de bestaande invoegcodes via de editor. Controleer het gepersonaliseerde resultaat in het mailvoorbeeld.",
      "PreviewHelp": "Invoegcodes worden bij het toepassen nog niet ingevuld. Controleer daarna het mailvoorbeeld met de gekozen ontvangers.",
      "SelectHelp": "Kies een template om de inhoud te bekijken of maak een nieuw template.",
      "NoSubject": "Behoud het onderwerp van de mail",
      "Empty": "Geen berichttemplates gevonden.",
      "Edit": "Bewerken",
      "Delete": "Verwijderen",
      "Save": "Opslaan",
      "Use": "Gebruiken",
      "Saved": "Berichttemplate opgeslagen.",
      "LoadError": "De berichttemplates konden niet worden geladen. Probeer het opnieuw.",
      "SaveError": "Het berichttemplate kon niet worden opgeslagen. Controleer de invoer en probeer het opnieuw.",
      "DeleteError": "Het berichttemplate kon niet worden verwijderd.",
      "ReplaceTitle": "Bericht vervangen",
      "ReplaceConfirm": "De huidige berichttekst en het onderwerp (als het template een onderwerp bevat) worden vervangen. Doorgaan?",
      "UnsavedTitle": "Onopgeslagen wijzigingen",
      "UnsavedConfirm": "De wijzigingen aan dit template zijn nog niet opgeslagen. Wijzigingen verwerpen?",
      "Required": "Vul dit veld in."
    },
    "Email-queue": {
      "An error occurred while loading the template": "Er is een fout opgetreden bij het laden van de template.",
      "Approve": "Goedkeuren",
      "Approved": "Goedgekeurd",
      "Attachments": "Bijlagen",
      "Attachments too big": "Bijlagen zijn te groot, maximaal toegestane limiet is 10 MB.",
      "Attempts": "Pogingen",
      "Bulk approve confirm": "{selected} e-mail goedkeuren | {selected} e-mails goedkeuren",
      "Bulk approve confirm text": "Weet je zeker dat je {selected} e-mail wilt goedkeuren? | Weet je zeker dat je {selected} e-mails wilt goedkeuren?",
      "Bulk approve fail": "Fout bij het goedkeuren van {fail} e-mail. | Fout bij goedkeuren van {fail} e-mails.",
      "Bulk approve mixed result": "{success} e-mail succesvol goedgekeurd, {fail} mislukt. | {success} e-mails succesvol goedgekeurd, {fail} mislukt.",
      "Bulk approve success": "Succesvol {success} e-mail goedgekeurd. | Succesvol {success} e-mails goedgekeurd.",
      "Bulk remove confirm": "{selected} e-mail verwijderen | {selected} e-mails verwijderen",
      "Bulk remove confirm text": "Weet je zeker dat je {selected} e-mail uit de wachtrij wilt verwijderen? | Weet je zeker dat je {selected} e-mails uit de wachtrij wilt verwijderen?",
      "Bulk remove fail": "Fout bij uit de wachtrij verwijderen van {fail} e-mail. | Fout bij uit de wachtrij verwijderen van {fail} e-mails.",
      "Bulk remove mixed result": "{success} e-mail succesvol uit de wachtrij verwijderd, {fail} mislukt. | {success} e-mails succesvol uit de wachtrij verwijderd, {fail} mislukt.",
      "Bulk remove success": "Succesvol {success} e-mail uit de wachtrij verwijderd. | Succesvol {success} e-mails uit de wachtrij verwijderd.",
      "Bulk requeue confirm": "{selected} e-mail opnieuw in de wachtrij plaatsen | {selected} e-mails opnieuw in de wachtrij plaatsen",
      "Bulk requeue confirm text": "Weet je zeker dat je {selected} e-mail opnieuw in de wachtrij wilt plaatsen? | Weet je zeker dat je {selected} e-mails opnieuw in de wachtrij wilt plaatsen?",
      "Bulk requeue fail": "Fout bij opnieuw in de wachtrij plaatsen van {fail} e-mail. | Fout bij opnieuw in de wachtrij plaatsen van {fail} e-mails.",
      "Bulk requeue mixed result": "{success} e-mail succesvol opnieuw in de wachtrij geplaatst, {fail} mislukt. | {success} e-mails succesvol opnieuw in de wachtrij geplaatst, {fail} mislukt.",
      "Bulk requeue success": "Succesvol {success} e-mail opnieuw in de wachtrij geplaatst. | Succesvol {success} e-mails opnieuw in de wachtrij geplaatst.",
      "Choose send time": "Kies verzendtijd",
      "Confirm item": "E-mail bevestigen",
      "Confirm item fail": "Fout bij het verzenden.",
      "Confirm item success": "E-mail succesvol toegevoegd aan wachtrij.",
      "Contact vars only works when one item is selected": "De invoegcodes <strong>contact.</strong> werken zodra er ten minste één contact is geselecteerd.",
      "Contacts": "Contact | Contacten",
      "Content": "Bericht",
      "Created at": "Gemaakt op",
      "Customer user": "Klantgebruiker",
      "Delete": "verwijderen",
      "Delete item": "E-mail verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de e-mail uit de wachtrij.",
      "Delete item success": "E-mail succesvol verwijderd uit de wachtrij.",
      "Delete item text": "Weet je zeker dat je de email met onderwerp {0} wilt {1} uit de wachtrij?",
      "Delete selected": "Verwijderen",
      "Delivery error": "Fout bij bezorging",
      "Description": "Omschrijving",
      "Email": "E-mail",
      "Error reason": "Foutreden",
      "Errors": {
        "ErrorCode": {
          "INVALID_MESSAGE": "Fout in bericht.",
          "INVALID_SUBJECT": "Fout in onderwerp."
        }
      },
      "Explain marketing purposes": "E-mails met een marketingdoel worden uitsluitend verzonden naar contacten die expliciet hebben aangegeven marketingcommunicatie te willen ontvangen. Deze e-mails bevatten commerciële of promotionele inhoud, zoals aanbiedingen, nieuwsbrieven of productupdates. E-mails zonder marketingdoel dienen strikt informatief te zijn en mogen geen commerciële of promotionele inhoud bevatten. Deze communicatie is uitsluitend functioneel, zoals service-updates, belangrijke meldingen of administratieve berichten.",
      "Explain message variables": "Je kunt de onderstaande invoegcodes gebruiken in je bericht en onderwerp door ze in dubbele accolades te plaatsen, zoals <strong>&#123;&#123;varName&#125;&#125;</strong>. Dit zorgt ervoor dat de invoegcode automatisch wordt vervangen door de juiste waarde.<br /><br />Bijvoorbeeld:<br />Als je <strong>&#123;&#123;currentUser.firstName&#125;&#125;</strong> gebruikt, wordt dit vervangen door de voornaam van jouw gebruikersaccount.<br /><br />{selectOneElement}<br /><br />Hieronder vind je de beschikbare invoegcodes:",
      "From": "Van",
      "General": "Algemeen",
      "Hide message vars": "Verberg invoegcodes",
      "Marketing purposes": "Marketingdoeleinden",
      "MessageVariableListContacts": {
        "contact.address": "Straatnaam en huisnummer van de geselecteerde contactpersoon.",
        "contact.birthday": "Geboortedatum van de geselecteerde contactpersoon.",
        "contact.city": "Woonplaats van de geselecteerde contactpersoon.",
        "contact.country": "Land van de geselecteerde contactpersoon.",
        "contact.customerInfo.address": "Straatnaam en huisnummer van de klant.",
        "contact.customerInfo.city": "Woonplaats van de klant.",
        "contact.customerInfo.country": "Land van de klant.",
        "contact.customerInfo.customerId": "Unieke klant-ID van de geselecteerde contactpersoon.",
        "contact.customerInfo.name": "Naam van de klant waartoe de geselecteerde contactpersoon behoort.",
        "contact.customerInfo.zipcode": "Postcode van de klant.",
        "contact.emailAddress": "E-mailadres van de geselecteerde contactpersoon.",
        "contact.firstName": "Voornaam van de geselecteerde contactpersoon.",
        "contact.initials": "Initialen van de geselecteerde contactpersoon.",
        "contact.lastName": "Achternaam van de geselecteerde contactpersoon.",
        "contact.overwriteAddress": "Geeft aan of het adres van de geselecteerde contactpersoon overschreven mag worden.",
        "contact.phone": "Telefoonnummer van de geselecteerde contactpersoon.",
        "contact.salutation": "Aanhef van de geselecteerde contactpersoon.",
        "contact.sendMail": "Geeft aan of de geselecteerde contactpersoon e-mails ontvangt.",
        "contact.zipcode": "Postcode van de geselecteerde contactpersoon."
      },
      "MessageVariableListCurrentUser": {
        "currentUser.createdAt": "Datum en tijd waarop de huidige gebruiker is aangemaakt.",
        "currentUser.email": "E-mailadres van de huidige gebruiker.",
        "currentUser.firstName": "Voornaam van de huidige gebruiker.",
        "currentUser.fullName": "Volledige naam van de huidige gebruiker.",
        "currentUser.lastLoginAt": "Datum en tijd van de laatste login van de huidige gebruiker.",
        "currentUser.lastName": "Achternaam van de huidige gebruiker.",
        "currentUser.locale": "Taalinstellingen van de huidige gebruiker.",
        "currentUser.regionalSettings": "Regionale instellingen van de huidige gebruiker.",
        "currentUser.updatedAt": "Datum en tijd waarop de gegevens van de huidige gebruiker voor het laatst zijn bijgewerkt."
      },
      "MessageVariableListUsers": {
        "user.createdAt": "Datum en tijd waarop de gebruiker is aangemaakt.",
        "user.email": "E-mailadres van de geselecteerde gebruiker.",
        "user.firstName": "Voornaam van de geselecteerde gebruiker.",
        "user.fullName": "Volledige naam van de geselecteerde gebruiker.",
        "user.lastLoginAt": "Datum en tijd van de laatste login van de gebruiker.",
        "user.lastName": "Achternaam van de geselecteerde gebruiker.",
        "user.locale": "Taalinstellingen van de geselecteerde gebruiker.",
        "user.regionalSettings": "Regionale instellingen van de geselecteerde gebruiker.",
        "user.updatedAt": "Datum en tijd waarop de gegevens van de gebruiker voor het laatst zijn bijgewerkt."
      },
      "Name": "Naam",
      "Name in footer": "Naam in footer",
      "New item": "Nieuwe e-mail",
      "None": "Geen",
      "Now": "Nu",
      "Overview": "Overzicht",
      "Preview": "Voorbeeld",
      "Queue": "Wachtrij",
      "Requeue selected": "Opnieuw in wachtrij",
      "Schedule": "Inplannen",
      "Select a template to load the preview": "Selecteer een template om het voorbeeld te laden.",
      "Send": "Verzenden",
      "Send error": "Verzendfout",
      "Send on behalf of the current user": "Verzenden namens de huidige gebruiker",
      "Send on behalf of the organization": "Verzenden namens de organisatie",
      "Send time": "Verzendtijd",
      "SendAt": "Verzend e-mail op",
      "Show message vars": "Toon invoegcodes",
      "Subject": "Onderwerp",
      "Template": "Template",
      "To": "Aan",
      "Total attachments": "Bijlagen",
      "Triggers": "Triggers",
      "User": "Gebruiker",
      "User vars only works when one item is selected": "De invoegcodes <strong>user.</strong> werken zodra er ten minste één gebruiker is geselecteerd.",
      "Users": "Gebruiker | Gebruikers",
      "Variables": "Invoegcodes",
      "View item": "E-mail bekijken",
      "MailingHistory": "Mailinghistorie",
      "MailingLoadError": "De oorspronkelijke mailing kan niet worden geladen. Mogelijk is deze verwijderd of ontbreken de rechten.",
      "RecipientFilters": {
        "customers": "Klant",
        "services": "Dienst",
        "customerLabels": "Klantlabel",
        "contactLabels": "Contactlabel"
      },
      "RecipientPickerTitle": "Ontvangers",
      "UniqueEmailAddresses": "Unieke e-mailadressen",
      "RecipientSearch": "Contacten zoeken",
      "RecipientSearchPlaceholder": "Naam, e-mailadres, klant, dienst of label",
      "RecipientFilterButton": "Filters",
      "ClearRecipientFilters": "Filters wissen",
      "FilteredRecipientSelection": "{selected} van {total} zichtbare contacten geselecteerd",
      "PersonalisationContext": "Contactgegevens voor {email}",
      "DuplicateMissingRecipients": "{count} oorspronkelijke ontvangers zijn niet meer beschikbaar of mogen deze mailing niet ontvangen.",
      "DuplicateChangedAddresses": "Bij {count} ontvangers is het e-mailadres gewijzigd. Controleer de huidige adressen.",
      "DuplicateMissingAttachments": "{count} oorspronkelijke bijlagen ontbreken. Voeg deze zo nodig opnieuw toe.",
      "DuplicateMissingSender": "De oorspronkelijke afzender is niet meer beschikbaar. Uw eigen afzender is geselecteerd.",
      "DuplicateMissingTemplate": "Het oorspronkelijke template is niet meer beschikbaar. Kies een template.",
      "DuplicateNotice": "Dit is een nieuwe kopie. Controleer ontvangers, toestemming, afzender, template en bijlagen opnieuw voordat u verzendt. Niet meer beschikbare ontvangers zijn niet geselecteerd.",
      "DuplicateMailing": "Mailing dupliceren",
      "DeleteMailing": "Formulierhistorie verwijderen",
      "DeleteMailingConfirm": "De oorspronkelijke formulierinhoud en niet meer benodigde bijlagen worden verwijderd. De mailing kan daarna niet meer worden gedupliceerd. Geplande of nog niet afgeronde verzendingen moeten eerst worden afgehandeld.",
      "MailingDeleteError": "Verwijderen is niet gelukt. Wacht tot de voorbereiding klaar is en handel de bijbehorende wachtrij-items af of verwijder deze. Probeer daarna opnieuw.",
      "HistoryCreated": "Aangemaakt",
      "HistoryState": "Status",
      "HistoryHelp": "Oorspronkelijke mailings blijven bewaard totdat u deze zelf verwijdert. Oudere mails zonder opgeslagen formulier zijn alleen in het logboek beschikbaar.",
      "MailingStates": {
        "preparing": "Wordt voorbereid",
        "ready": "Beschikbaar",
        "failed": "Voorbereiding mislukt",
        "deleting": "Verwijderen wordt afgerond"
      }
    },
    "Email-triggers": {
      "Auto approve": "Automatisch goedkeuren",
      "CreatedAt": "Gemaakt op",
      "Data query": "Data query",
      "Data service": "Data service",
      "Description": "Omschrijving",
      "Enabled": "Ingeschakeld",
      "From": "Van",
      "Group mail": "Groepeer mail",
      "Last occurrence only": "Alleen laatste gebeurtenis",
      "Last triggered": "Laatst getriggerd",
      "NA": "N.v.t.",
      "Name": "Naam",
      "Query based trigger": "Query-gebaseerde trigger",
      "Query per trigger": "Query per trigger",
      "Query results": "Query resultaten",
      "Schedule": "Schedule",
      "Subject": "Onderwerp",
      "Template description": "Template omschrijving",
      "Template name": "Template naam",
      "To": "Aan",
      "To query": "Aan query",
      "To service": "Aan service",
      "Total recipients": "{total} ontvanger | {total} ontvangers",
      "Trigger": "Trigger",
      "Trigger query": "Trigger query",
      "Trigger service": "Trigger service",
      "View item": "Bekijk trigger"
    },
    "Feedback-answers": {
      "Customer": "Klant",
      "Value": "Waarde",
      "Errors": {
        "ErrorCode": {
          "FIELD_REQUIRED": "Het is verplicht om een antwoord te geven."
        }
      }
    },
    "Feedback-questions": {
      "Add Questions item": "Voeg een vraag toe",
      "Answer type": "Antwoord type",
      "CanChangeAnswers": "Antwoorden aanpassen",
      "Delete Questions item": "Verwijder vraag",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Feedback verwijderen",
      "Delete item fail": "Feedback kan niet worden verwijderd. {msg}",
      "Delete item success": "Feedback succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de feedback {0} wilt {1}?",
      "Edit item": "Feedback bewerken",
      "Edit item fail": "Fout bij het wijzigen van de feedback. {msg}",
      "Edit item success": "Feedback succesvol gewijzigd.",
      "En": "Engels",
      "Name": "Naam",
      "New item": "Nieuwe feedback",
      "New item fail": "Kan geen nieuwe feedback maken. {msg}",
      "New item success": "Nieuwe feedback gemaakt.",
      "Nl": "Nederlands",
      "Question": "Vraag",
      "Questions": "Vragen",
      "Required": "Verplicht",
      "Tabs": {
        "Question": "Vraag",
        "Answers": "Antwoorden"
      },
      "Type": "Type",
      "TypeOptions": {
        "Sharingcenter": "OMNI Sessions",
        "Stars": "Sterren",
        "String": "Tekst"
      },
      "View item": "Feedback bekijken"
    },
    "Invoices": {
      "Add Lines item": "Product toevoegen",
      "Additional attachments": "Extra bijlagen",
      "Amount": "Aantal",
      "Amount open": "Open bedrag: {amount}",
      "Amount paid": "Betaald bedrag: {amount}",
      "Cannot download invoice": "Kan het downloaden van de factuur niet starten.",
      "Cannot download invoice attachment": "Kan het downloaden van de factuurbijlage niet starten.",
      "Choose mail type": "Selecteer het e-mailtype dat u wilt verzenden",
      "Choose mail type title": "Selecteer e-mailtype",
      "Create credit": "Maak creditfactuur",
      "Create credit item fail": "Het maken van het credit is mislukt. {msg}",
      "Create credit item success": "Creditfactu(u)r(en) aanmaken geslaagd.",
      "Credit invoice item fail": "Het maken van het credit is mislukt. {msg}",
      "Credit invoice item success": "Creditfactu(u)r(en) aanmaken geslaagd.",
      "Credit invoices": "Crediteer | Maak creditfactu(u)r(en) aan",
      "CustomCreditLine": "Crediteer alle regels | Crediteer regel",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Factuur verwijderen",
      "Delete item fail": "Factuur kan niet worden verwijderd. {msg}",
      "Delete item success": "Factuur succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de factuur {0} wilt {1}?",
      "Delete Lines item": "Product verwijderen",
      "Description": "Omschrijving",
      "Discount": "Korting",
      "Download": "Factuur downloaden",
      "Draft": "Concept",
      "Draft direct debit": "Concept automatische incasso",
      "Edit item": "Factuur bewerken",
      "Edit item fail": "Fout bij het wijzigen van de factuur. {msg}",
      "Edit item success": "Factuur succesvol gewijzigd.",
      "Email address": "E-mailadres",
      "EmailOptions": {
        "Final_notice": "Laatste kennisgeving",
        "Invoice": "Factuur",
        "Reminder_1": "Eerste herinnering",
        "Reminder_2": "Tweede herinnering"
      },
      "Errors": {
        "ErrorCode": {
          "CUSTOMER_CONTACT_NOT_SET": "Klant heeft geen factuurcontactpersoon ingesteld.",
          "INVOICE_CREATION_DATE_BEFORE_LATEST_INVOICE": "De factuur aanmaakdatum kan niet ouder zijn dan de recentste definitieve factuurdatum.",
          "PRODUCT_BUNDLE_CANNOT_HAVE_DISCOUNT": "Een bundelproduct kan geen korting hebben."
        }
      },
      "Filename": "Bestandsnaam",
      "Generate invoices": "Genereer | Genereer facturen",
      "Generation date": "Aanmaakdatum",
      "Invoice": "Factuur",
      "Invoice amount ex VAT": "Factuurbedrag excl. BTW",
      "Invoice amount inc VAT": "Factuurbedrag incl. BTW",
      "Invoice amount open": "Openstaand bedrag",
      "Invoice contact not set": "Deze klant heeft geen factuurcontactpersoon ingesteld. Stel een factuurcontactpersoon in en probeer het opnieuw.",
      "Invoice creation date": "Aanmaakdatum",
      "Invoice date": "Datum",
      "Invoice due date": "Vervaldatum van de factuur",
      "Invoice email status": "E-mail status",
      "Invoice item": "Facturen",
      "Invoice modified date": "Wijzigingsdatum factuur",
      "Invoice number": "Nummer",
      "Invoice overdue": "Factuur is achterstallig | ACHTERSTALLIG",
      "Invoice overdue date": "Vervaldatum",
      "Invoice reference": "Factuurreferenties",
      "InvoiceCreationDate": "Aanmaakdatum van de factuur",
      "InvoiceDueDate": "Vervaldatum van de factuur",
      "InvoiceReference": "Referentie factuur",
      "Invoices loading": "Facturen worden geladen, een moment alstublieft...",
      "Invoices merged successfully": "De geselecteerde facturen zijn succesvol samengevoegd.",
      "InvoiceTemplate": "Factuursjabloon",
      "InvoiceTemplateOptions": {
        "En-US": "Engels",
        "Nl-NL": "Nederlands"
      },
      "InvoicingSoftwareId": "Id van factureringssoftware",
      "LedgerAccountNumber": "Grootboekrekeningnummer",
      "Lines": "Regels",
      "List": "Overzicht facturen",
      "MailType": "Type",
      "Merge invoices": "Samenvoegen | Voeg facturen samen",
      "Name": "Naam",
      "New item": "Nieuw | Maak een nieuwe factuur",
      "New item fail": "Kan geen nieuwe factuur maken. {msg}",
      "New item success": "Nieuwe factuur gemaakt.",
      "No document": "Document niet gevonden | Er is geen document gevonden voor dit factuurnummer. Als u een kopie van deze factuur nodig heeft, neem dan contact op met <strong><a class='text-primary' href='mailto:servicedesk{'@'}omninetworks.nl'>servicedesk{'@'}omninetworks.nl</a><strong>",
      "No invoices": "Er zijn geen facturen te tonen voor deze klant.",
      "Open": "Open",
      "Open credit": "Open credit",
      "Open direct debit": "Open automatische incasso",
      "Overdue": "Achterstallig",
      "Paid": "Betaald",
      "PaymentStatus": "Status",
      "PaymentStatuses": {
        "draft": "Concept",
        "draft direct debit": "Concept",
        "open": "Open",
        "open credit": "Open",
        "open direct debit": "Open",
        "overdue": "Verlopen",
        "paid": "Betaald"
      },
      "PaymentStatusOptions": {
        "Draft": "Concept",
        "Draft direct debit": "Concept automatische incasso",
        "Invoiced": "Gefactureerd",
        "Open": "Open",
        "Open credit": "Open credit",
        "Open direct debit": "Open automatische incasso",
        "Overdue": "Achterstallig",
        "Paid": "Betaald"
      },
      "PriceExclPerPiece": "Prijs per stuk (excl. BTW)",
      "Product": "Product",
      "Remove attachment item success": "Bijlage succesvol verwijderd.",
      "Send invoice to": "De factuur wordt verzonden naar {fullName} ({email}).",
      "Send mail": "Verzenden | Verzend de factu(u)r(en) via de email",
      "Send mail item fail": "Kan geen e-mail verzenden.",
      "Send mail item success": "E-mail is succesvol verzonden.",
      "Sent date": "Verzonden op",
      "Sepa": "SEPA-batch",
      "Status": "Status",
      "StatusOptions": {
        "Draft": "Concept",
        "Invoiced": "Gefactureerd"
      },
      "Sync status booked": "Factuur heeft de status geboekt wat aangeeft dat de factuur bekend is in de facturatiesoftware, maar dat het PDF-bestand nog niet is geüpload.",
      "Tabs": {
        "General": "Algemeen",
        "Lines": "Lijnen"
      },
      "Type": "Type",
      "TypeOptions": {
        "Credit": "Krediet",
        "Invoice": "Factuur"
      },
      "Update invoice": "Factuur bijwerken | Facturen bijwerken",
      "View": "Factuur bekijken | Facturen bekijken",
      "View item": "Factuur weergeven"
    },
    "Product-groups": {
      "Delete": "verwijderen",
      "Delete item": "Productgroep verwijderen",
      "Delete item fail": "Kan productgroep niet verwijderen. {msg}",
      "Delete item success": "Productgroep succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je de productgroep {0} wilt {1}?",
      "Edit item": "Productgroep bewerken",
      "Edit item fail": "Fout bij het wijzigen van de productgroep. {msg}",
      "Edit item success": "Productgroep succesvol gewijzigd.",
      "Errors": {
        "ErrorCode": {
          "PRODUCT_GROUP_VAT_CHANGE_NOT_ALLOWED": "Groep maakt deel uit van een productbundel, de BTW-groep kan niet worden gewijzigd."
        }
      },
      "InvoicingSoftwareEUId": "Facturatiesoftware ID (EU)",
      "InvoicingSoftwareId": "Facturatiesoftware ID (NL)",
      "IsArchived": "Is gearchiveerd",
      "LedgerAccountNumber": "Grootboekrekening",
      "Name": "Naam",
      "New item": "Nieuwe productgroep",
      "New item fail": "Het maken van een nieuwe productgroep is mislukt. {msg}",
      "New item success": "Nieuwe productgroep succesvol toegevoegd.",
      "Percentage": "Percentage",
      "Product group": "Product groep",
      "StartDate": "Begindatum",
      "Tabs": {
        "General": "Algemeen"
      },
      "Vat": "BTW"
    },
    "Products": {
      "Add BundledProducts item": "Voeg een gebundeld product toe",
      "Add PurchasePricesInput item": "Voeg een inkoopprijs toe",
      "Add SalesPricesInput item": "Voeg een verkoopprijs toe",
      "Amount": "Aantal",
      "Archive": "archiveren",
      "ArchivedAt": "Gearchiveerd op",
      "BundledProducts": "Gebundelde producten",
      "Delete": "verwijderen",
      "Delete BundledProducts item": "Verwijder gebundeld product",
      "Delete item": "Product verwijderen",
      "Delete item fail": "Kan het product niet verwijderen. {msg}",
      "Delete item success": "Product succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je het product {0} wilt {1}?",
      "Delete PurchasePricesInput item": "Inkoopprijs verwijderen",
      "Delete SalesPricesInput item": "Verkoopprijs verwijderen",
      "Discount": "Korting",
      "DomainTldSetting": "Domain TLD instellingen",
      "DowngradePaths": "Downgrade paden",
      "Edit item": "Product bewerken",
      "Edit item fail": "Fout bij het wijzigen van het product. {msg}",
      "Edit item success": "Product succesvol gewijzigd.",
      "Errors": {
        "BUNDLED_PRODUCTS_CANNOT_BE_BUNDLES_OR_OF_NON_OTHER_TYPE": "FOUT: Een bundel mag geen bundelproducten of producten van een ander type dan 'overige diensten' bevatten.",
        "DUPLICATE_BUNDLED_PRODUCTS": "FOUT: Een bundel mag niet meerdere keren hetzelfde product bevatten.",
        "ErrorCode": {
          "BUNDLED_PRODUCTS_DIFFERENT_VAT_GROUP": "Product heeft een andere BTW-groep dan het primaire product in de bundel."
        },
        "PURCHASEPRICES_DATE_TOO_EARLY": "FOUT: De startdatum moet later zijn dan of gelijk aan de oudste datum in oude prijzen voor dezelfde periode en periodiek.",
        "PURCHASEPRICES_NO_PRICE_IN_PAST": "FOUT: Ten minste één object moet een prijs in het verleden hebben.",
        "PURCHASEPRICES_SAME_PERIOD_PERIODIC_DATE": "FOUT: Twee objecten met dezelfde periode, periodiek en datum.",
        "PURCHASEPRICES_SAME_PERIOD_PERIODIC_PAST": "FOUT: Twee objecten met dezelfde periode en periodiek met datums in het verleden.",
        "PURCHASEPRICES_SAME_PERIOD_PERIODIC_PRICE": "FOUT: Twee objecten met dezelfde periode, periodiek en prijs.",
        "SALESPRICES_DATE_TOO_EARLY": "FOUT: De startdatum moet later zijn dan of gelijk aan de oudste datum in oude prijzen voor dezelfde periode en periodiek.",
        "SALESPRICES_NO_PRICE_IN_PAST": "FOUT: Ten minste één object moet een prijs in het verleden hebben.",
        "SALESPRICES_SAME_PERIOD_PERIODIC_DATE": "FOUT: Twee objecten met dezelfde periode, periodiek en datum.",
        "SALESPRICES_SAME_PERIOD_PERIODIC_PAST": "FOUT: Twee objecten met dezelfde periode en periodiek met datums in het verleden.",
        "SALESPRICES_SAME_PERIOD_PERIODIC_PRICE": "FOUT: Twee objecten met dezelfde periode, periodiek en prijs.",
        "SUBSCRIBED_BUNDLE_CANNOT_BE_CHANGED": "FOUT: Een bundel die al is toegewezen aan abonnementen kan meer niet worden gewijzigd."
      },
      "Group": "Productgroep",
      "InvoiceDescription": "Factuuromschrijving",
      "IsArchived": "Gearchiveerd",
      "IsBundle": "Is een productbundel",
      "IsStockItem": "Voorraadartikel",
      "Name": "Naam",
      "New item": "Nieuw product",
      "New item fail": "Kan geen nieuw product maken. {msg}",
      "New item success": "Nieuw product succesvol toegevoegd.",
      "Period": "Periode",
      "Period and periodic": "Periode en periodiek",
      "Periodic": "Periodiek",
      "PeriodicOptions": {
        "Month": "Maand",
        "One-time": "Eenmalig",
        "Year": "Jaar"
      },
      "Price": "Prijs",
      "Price list": "Prijslijst (.xlsx)",
      "Price list upload error message": "Foutmelding",
      "Price list upload items processed": "Artikelen verwerkt",
      "Price list upload items skipped due to an error": "Items overgeslagen vanwege een fout",
      "Price list upload items skipped due to empty cells": "Items overgeslagen vanwege lege cellen",
      "Price list upload items skipped due to no price changes": "Artikelen overgeslagen omdat er geen prijswijzigingen zijn doorgevoerd",
      "PriceEx": "Prijs excl. BTW",
      "Prices": "Prijzen",
      "Product": "Product",
      "Product bundle purchase price does not contain all bundle products": "De inkoopprijs van de bundel bevat niet alle producten",
      "ProductCode": "Productcode",
      "ProductDescription": "Productomschrijving",
      "ProductType": "Product type",
      "ProductTypeOptions": {
        "Domain": "Domein",
        "Hosting": "Hosting",
        "License": "Licentie",
        "Other": "Overige diensten",
        "Ssl-certificate": "SSL-certificaten"
      },
      "ProductVAT": "Product VAT group",
      "Purchase price cell": "Cel met aankoopprijs",
      "Purchase price value": "Waarde van de aankoopprijs",
      "PurchasePrices": "Aankoop prijzen",
      "PurchasePricesHistory": "Geschiedenis van inkoopprijzen",
      "PurchasePricesInput": "Aankoop prijzen",
      "SalesPrices": "Verkoopprijzen",
      "SalesPricesHistory": "Geschiedenis van de verkoopprijzen",
      "SalesPricesInput": "Verkoopprijzen",
      "Selling price cell": "Cel Verkoopprijs",
      "Selling price value": "Waarde van de verkoopprijs",
      "Sheet": "Blad",
      "StartDate": "Begin datum",
      "SupplierProductCode": "Leverancier productcode",
      "SupplierProductUrl": "Leverancier product URL",
      "Tabs": {
        "General": "Algemeen",
        "Product bundle": "Productbundel",
        "Purchase price": "Inkoopprijs",
        "Sales price": "Verkoopprijs"
      },
      "Type": "Type",
      "TypeOptions": {
        "Fixed": "Vast bedrag",
        "None": "Geen",
        "Percentage": "Percentage"
      },
      "Upgrade": "Product upgraden of downgraden",
      "UpgradePaths": "Upgrade paden",
      "Upload price list": "Upload price list",
      "Upload price list item failed": "Het uploaden van de prijslijst is mislukt. {msg}",
      "Upload price list item success": "Prijslijst succesvol geüpload. Bekijk de resultaten om te controleren of de import foutloos is voltooid.",
      "Upload price list start date": "Ingangsdatum"
    },
    "Project-task-time-tracking": {
      "Add registration": "Registratie toevoegen",
      "Created and updated items success": "Er zijn {newRecords} aangemaakte en {patchedRecords} bijgewerkte registraties verwerkt.",
      "Created invoice success": "Factuur voor registratie(s) succesvol toegevoegd.",
      "Created items success": " {newRecords} registratie succesvol toegevoegd. | {newRecords} registraties succesvol toegevoegd.",
      "Customer": "Klant",
      "Customer filter": "Filter op klanten",
      "Date": "Datum",
      "Delete": "verwijderen",
      "Delete Products item": "Product verwijderen",
      "Delete item": "Registratie verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de registratie. {msg}",
      "Delete item text": "Weet u zeker dat u de registratie {0} wilt {1}?",
      "Deleted items success": "Tijdregistratie succesvol verwijderd. | {removedRecords} tijdregistraties succesvol verwijderd.",
      "Description": "Beschrijving",
      "Discard changes leave": "Wil je deze pagina verlaten? Onopgeslagen wijzigingen gaan verloren.",
      "Discard changes refresh": "Wil je vernieuwen en alle onopgeslagen wijzigingen verwijderen?",
      "Done but not invoiced": "maar is nog niet gefactureerd",
      "Edit item": "Registratie bewerken",
      "Edit item fail": "Fout bij het wijzigen van de registratie. {msg}",
      "Edit item success": "Registratie succesvol gewijzigd.",
      "Export project registrations": "Projectregistraties exporteren",
      "From date": "Vanaf datum",
      "Generate invoice": "Genereer een factuur voor de geselecteerde registraties",
      "Group registrations on invoice": "Groepeer alle tijdregistraties op de factuur",
      "Hr": "u",
      "Invalid date range": "Kies een geldige periode. De vanafdatum mag niet na de einddatum liggen.",
      "Invalid registrations": "Controleer de gemarkeerde velden. Vul datum, taak, beschrijving en uitvoerder in en gebruik een tijdsduur in stappen van 5 minuten.",
      "Invoice intro text": "Selecteer in de onderstaande tabel welke tijdregistraties als gereed moeten worden gemarkeerd. Standaard wordt elke tijdsregistratie apart op de factuur gezet. Als je alle tijdregistraties wilt groeperen, zorg er dan voor dat je het vinkje aanvinkt om dit te doen.",
      "Invoice item": "Factureer tijdregistraties",
      "IsInvoiced": "Is gefactureerd",
      "Mark as done": "Taak markeren als voltooid",
      "Name": "Naam",
      "New item": "Nieuwe registratie",
      "New item fail": "Er is een fout opgetreden bij het maken van de registratie. {msg}",
      "New item success": "Registratie succesvol toegevoegd.",
      "No projects found": "Er zijn geen projecten gevonden.",
      "No registrations": "(Nog) geen registraties",
      "PerformedBy": "Uitgevoerd door",
      "ProjectTaskInfo": {
        "status": "Taakstatus",
        "statusOptions": {
          "Done": "Gereed",
          "Open": "Open",
          "Started": "Gestart"
        }
      },
      "Registration not yet invoiced": "Deze urenregistratie is nog niet gefactureerd",
      "Registrations": "registraties",
      "Save before invoicing": "Sla eerst de wijzigingen voor dit project op voordat je gaat factureren.",
      "Save registrations": "Registraties opslaan",
      "Saving": "Tijdsregistratie(s) worden opgeslagen, een ogenblik alstublieft...",
      "Search in projects": "Zoeken in projecten",
      "Task": "Taak",
      "Task status": "Taak heeft de status @.upper:{status}",
      "There are no changes to be processed": "Er zijn geen wijzigingen om te verwerken",
      "Time registration": "Tijd registratie",
      "TimeSpent": "Bestede tijd",
      "Total project hours": "Totaal uren",
      "Undo delete item": "Tijdregistratie niet verwijderen",
      "Unsaved changes": "Weet je zeker dat je de datum wilt wijzigen? De wijzigingen die je hebt aangebracht, worden niet opgeslagen.",
      "Unsaved changes invoicing": "Weet je zeker dat je wilt factureren? De wijzigingen die je hebt aangebracht, worden niet opgeslagen.",
      "Until date": "Tot en met datum",
      "Updated items success": "{patchedRecords} registratie succesvol gewijzigd. | {patchedRecords} registraties succesvol gewijzigd.",
      "Week number": "Week"
    },
    "Project-task-types": {
      "Add Products item": "Product toevoegen",
      "Archive": "archiveren",
      "Delete": "verwijderen",
      "Delete item": "Taaktype verwijderen",
      "Delete item fail": "Fout bij het verwijderen van het taaktype. {msg}",
      "Delete item success": "Taaktype verwijderd.",
      "Delete item text": "Weet u zeker dat u het taaktype {0} wilt {1}?",
      "Delete Products item": "Product verwijderen",
      "Description": "Beschrijving",
      "Edit item": "Taaktype bewerken",
      "Edit item fail": "Fout bij het wijzigen van het taaktype. {msg}",
      "Edit item success": "Taaktype succesvol gewijzigd.",
      "IsArchived": "Is gearchiveerd",
      "IsInvoiceable": "Is factureerbaar",
      "Name": "Naam",
      "New item": "Nieuw taaktype",
      "New item fail": "Er is een fout opgetreden bij het maken van het taaktype. {msg}",
      "New item success": "Taaktype succesvol toegevoegd.",
      "Product": "Product",
      "Tabs": {
        "General": "Algemeen"
      },
      "Task type": "Taak type"
    },
    "Project-tasks": {
      "ActualHours": "Werkelijke uren",
      "Delete": "verwijderen",
      "Delete item": "Taak verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de taak. {msg}",
      "Delete item success": "Taak succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de taak {0} wilt {1}?",
      "Description": "Beschrijving",
      "Edit item": "Taak bewerken",
      "Edit item fail": "Fout bij het wijzigen van de taak. {msg}",
      "Edit item success": "Taak succesvol gewijzigd.",
      "EstimatedHours": "Geschatte uren",
      "Hr": "uur | uren",
      "Mark as done": "Markeer taak als gereed",
      "Name": "Naam",
      "New item": "Nieuwe taak",
      "New item fail": "Fout bij het maken van de taak. {msg}",
      "New item success": "Taak succesvol toegevoegd.",
      "Project": "Project",
      "ProjectInfo": {
        "customer": "Klant"
      },
      "ProjectTaskType": "Taaktype",
      "Status": "Status ",
      "StatusOptions": {
        "Done": "Gereed",
        "Open": "Open",
        "Started": "Gestart"
      },
      "Tabs": {
        "General": "Algemeen"
      },
      "Task": "Taak"
    },
    "Projects": {
      "Add project item": "Taak toevoegen",
      "Archive": "archiveren",
      "Contract": "Contract",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Project verwijderen",
      "Delete item fail": "Fout bij het verwijderen van het project. {msg}",
      "Delete item success": "Project succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u het project {0} wilt {1}?",
      "Delete Products item": "Taak verwijderen",
      "Description": "Beschrijving",
      "Edit item": "Project bewerken",
      "Edit item fail": "Er is een fout opgetreden bij het wijzigen van het project. {msg}",
      "Edit item success": "Project succesvol gewijzigd.",
      "Hr": "uur | uren",
      "IsArchived": "Is gearchiveerd",
      "Name": "Naam",
      "New item": "Nieuw project",
      "New item fail": "Fout bij het maken van een project. {msg}",
      "New item success": "Project succesvol toegevoegd.",
      "Project": "Project",
      "ProjectHours": "Projecturen",
      "Status": "Status",
      "StatusOptions": {
        "Done": "Gereed",
        "Open": "Open",
        "Started": "Gestart"
      },
      "Tabs": {
        "General": "Algemeen",
        "Tasks": "Taken"
      }
    },
    "Sales-orders": {
      "Add Products item": "Product toevoegen",
      "Amount": "Aantal",
      "Contract": "Contract",
      "Customer": "Klant",
      "CustomPeriodAndPeriodic": "Periode en periodiek",
      "Date": "Datum",
      "Delete": "verwijderen",
      "Delete item": "Verkooporder verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de verkooporder. {msg}",
      "Delete item success": "Verkooporder succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je de verkooporder {0} wilt {1}?",
      "Delete Products item": "Product verwijderen",
      "Deliver": "Uitgeleverd",
      "DeliveryDate": "Datum van uitlevering",
      "Description": "Omschrijving",
      "Discount": "Korting",
      "Edit item": "Verkooporder bewerken",
      "Edit item fail": "Fout bij het wijzigen van de verkooporder. {msg}",
      "Edit item success": "Verkooporder succesvol gewijzigd.",
      "Errors": {
        "ErrorCode": {
          "CAN_ONLY_DELETE_OPEN_SALES_ORDERS": "Een verkooporders mag alleen worden verwijderd als de status 'open' is.",
          "CUSTOMER_CONTACT_NOT_SET": "Klant heeft geen factuurcontactpersoon ingesteld.",
          "PRODUCT_BUNDLE_CANNOT_HAVE_DISCOUNT": "Een bundelproduct kan geen korting hebben.",
          "PRODUCT_BUNDLE_DUPLICATE": "Een verkooporder mag niet meerdere keren dezelfde productbundel bevatten.",
          "PRODUCT_BUNDLE_PRICE_NOT_FOUND": "De verkooporder bevat een productbundel met een bundelprijs die niet kan worden gevonden."
        }
      },
      "Invoice templates": {
        "Invoice - EU (EN)": "Factuur - EU (EN)",
        "Invoice - EU (NL)": "Factuur - EU (NL)",
        "Invoice - NL (EN)": "Factuur - NL (EN)",
        "Invoice - NL (NL)": "Factuur - NL (NL)"
      },
      "InvoiceTemplate": "Factuursjabloon",
      "Memo": "Interne memo",
      "Merge sales orders": "Verkooporders samenvoegen",
      "New item": "Nieuwe verkooporder",
      "New item fail": "Fout bij maken van verkooporder. {msg}",
      "New item success": "Verkooporder succesvol toegevoegd.",
      "OrderReference": "Referentie",
      "Period": "Periode",
      "PeriodFrom": "Periode vanaf",
      "Periodic": "Periodiek",
      "PeriodicOptions": {
        "Month": "Maand",
        "One-time": "Eenmalig",
        "Year": "Jaar"
      },
      "PeriodTo": "Periode tot",
      "PriceCalculator": {
        "AmountOfDays": "Aantal dagen",
        "CurrentPrice": "Huidige prijs",
        "EndDate": "Einddatum",
        "NewPrice": "Nieuwe prijs",
        "Period string": "Periode: {startDate} tot {endDate}",
        "PricePerDay": "Prijs per dag",
        "StartDate": "Begindatum",
        "Subscription": "Abonnement",
        "Title": "Prijs berekenen"
      },
      "PriceExclPerPiece": "Prijs per stuk (excl. BTW)",
      "Product": "Product",
      "Products": "Producten",
      "Sales order": "Verkooporder",
      "Sales orders merged successfully": "De geselecteerde verkooporders zijn succesvol samengevoegd.",
      "Status": "Status ",
      "StatusOptions": {
        "Done": "Gereed",
        "In progress": "Bezig",
        "Open": "Open"
      },
      "Sync sales orders": "Verkooporder synchroniseren | Verkooporders synchroniseren",
      "Tabs": {
        "General": "Algemeen",
        "Products": "Producten"
      },
      "TotalAmount": "Totaalbedrag (excl. BTW)",
      "Type": "Type",
      "TypeOptions": {
        "Fixed": "Vast bedrag",
        "None": "Geen",
        "Percentage": "Percentage"
      }
    },
    "Sepa": {
      "Batch": "Batch",
      "BatchId": "Batch ID",
      "BatchTotalInvoiceAmount": "Totaal factuurbedrag",
      "DebitDate": "Incassodatum",
      "Delete": "verwijderen",
      "Delete item": "SEPA batch verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de SEPA batch. {msg}",
      "Delete item success": "SEPA batch verwijderd.",
      "Delete item text": "Weet u zeker dat u de SEPA batch wilt {1}?",
      "Download item": "Download batch",
      "Edit item": "SEPA batch bewerken",
      "Edit item fail": "Bewerken van {item} mislukt. {msg}",
      "Edit item success": "Bewerken van {item} geslaagd.",
      "Errors": {
        "ErrorCode": {
          "SEPA_BATCH_CONTAINS_DRAFTS": "Deze batch bevat minimaal één conceptfactuur, verwijder deze uit de batch of maak de conceptfacturen definitief."
        }
      },
      "Generated batches": "Verwerkte batches",
      "Initialized batches": "Openstaande batches",
      "InvoicesInBatch": "Facturen in batch",
      "Remove from batch item fail": "Het verwijderen van de factuur uit de batch is mislukt. {msg}",
      "Remove from batch item success": "Factuur succesvol uit batch verwijderd.",
      "Remove invoices from batch": "Facturen uit batch verwijderen",
      "Status": "Status",
      "StatusOptions": {
        "Generated": "Gegenereerd",
        "Initialized": "Concept"
      },
      "Tabs": {
        "General": "Algemeen",
        "Invoices": "Facturen"
      }
    },
    "Settings": {
      "AdminsOnly": "Alleen beheerders mogen bewerken",
      "AllowedMimeTypes": "Toegestane bestandstypes",
      "MaxSizeMb": "Maximale bestandsgrootte (MB)",
      "Image aspect ratio": "Beeldverhouding van de afbeelding",
      "Image dimensions": "Afbeeldingsafmetingen",
      "Ratio": "Verhouding",
      "Tolerance": "Tolerantie",
      "Height": "Hoogte",
      "KeepAspectRatio": "Beeldverhouding behouden",
      "MaxHeight": "Maximale hoogte",
      "MaxWidth": "Maximale breedte",
      "MinHeight": "Minimale hoogte",
      "MinWidth": "Minimale breedte",
      "FitMode": "Schalen",
      "FitModeOptions": {
        "None": "Niet schalen of aanpassen (alleen valideren)",
        "Contain": "Schalen om passend te maken zonder bijsnijden (contain)",
        "Cover": "Schalen en bijsnijden om passend te maken (cover)",
        "Pad": "Aanpassen met opvulling/randen om passend te maken (pad)",
        "Fill": "Schalen met vervorming om exact passend te maken (fill)"
      },
      "PreventUpscale": "Opschalen van afbeelding voorkomen",
      "ExcludeFromUI": "Uitsluiten voor UI",
      "Add Options item": "Optie toevoegen",
      "Add Type item": "Type toevoegen",
      "Delete": "verwijderen",
      "Delete item": "Instelling verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de instelling. {msg}",
      "Delete item success": "Instelling succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de instelling {0} wilt {1}?",
      "Delete Options item": "Optie verwijderen",
      "Delete Type item": "Type verwijderen",
      "Edit item": "Instelling bewerken",
      "Edit item fail": "Fout bij het wijzigen van de instelling. {msg}",
      "Edit item success": "Instelling succesvol gewijzigd.",
      "New item": "Nieuwe instelling",
      "New item fail": "Fout bij maken van instelling. {msg}",
      "New item success": "Instelling succesvol toegevoegd.",
      "No options": "Er zijn nog geen beschikbare opties.",
      "Reorder settings": "Volgorde opslaan",
      "Found translations": "Gevonden vertalingen",
      "General": "Algemeen",
      "Dependency": "Afhankelijk van instelling",
      "Base Settings": "Basis",
      "Setting": "Instelling",
      "ClearOnMismatch": "Waarde van het huidige veld wissen wanneer voorwaarde niet voldoet",
      "Settings": "Instellingen",
      "Validation": "Validatie",
      "UI": "Weergave",
      "Config": "Configuratie",
      "Key": "Key",
      "Type": "Type",
      "TypeOptions": {
        "Show": "Instelling tonen",
        "Enable": "Instelling inschakelen"
      },
      "Color": "Kleur",
      "Control": "Element",
      "ControlOptions": {
        "Boolean": "Aan/uit keuze",
        "Text": "Tekstveld (één regel)",
        "Textarea": "Tekstvak (meerdere regels)",
        "Textarea-rte": "Teksteditor (RTE)",
        "Number": "Numerieke invoer",
        "Range": "Schuifregelaar",
        "Select": "Selectievak (enkele waarde)",
        "Multiselect": "Meervoudige selectie",
        "Radio": "Radioknoppen",
        "Checkbox": "Checkbox",
        "Color": "Kleurkiezer",
        "Files": "Bestand uploader",
        "Date": "Datumveld",
        "Datetime": "Datum- en tijdveld",
        "Time": "Tijdveld",
        "Json": "JSON-invoer",
        "Code": "Code-editor",
        "Steps": "Stappenconfiguratie"
      },
      "CustomOptions": "Gegenereerde opties",
      "CustomValidation": "Handmatige validatie",
      "Name": "Naam",
      "NameOptions": {
        "Customers": "Klanten",
        "Customer-users": "Klantgebruikers",
        "Users": "Gebruikers",
        "Sharingcenter-profiles": "OMNI Sessions"
      },
      "Readonly": "Alleen lezen",
      "Value": "Waarde",
      "ValueType": "Waarde type",
      "ValueTypeOptions": {
        "String": "Tekstwaarde",
        "Number": "Numerieke waarde",
        "Boolean": "Waar/onwaar waarde",
        "Array": "Lijst van waarden",
        "Array-strings": "Lijst van tekst waarden",
        "Array-numbers": "Lijst van numerieke waarden",
        "Object": "Gegevensobject"
      },
      "Code config": "Code-editor configuratie",
      "Lang": "Taal",
      "LangOptions": {
        "Css": "CSS",
        "Html": "HTML",
        "Javascript": "JavaScript"
      },
      "Mask Strings": "Waardes maskeren",
      "Enabled": "Ingeschakeld",
      "ShowFirstChars": "Eerste karakters tonen",
      "ShowLastChars": "Laatste karakters tonen",
      "Enum": "Enumeratie",
      "Files": "Bestandsinstellingen",
      "Options": "Opties",
      "Default": "Standaardwaarde",
      "Required": "Vereist",
      "Min": "Minimum",
      "Max": "Maximum",
      "Step": "Stap",
      "Pattern": "Patroon",
      "MinLength": "Minimale lengte",
      "MaxLength": "Maximale lengte",
      "Ui": "Weergave",
      "Label": "Label",
      "Description": "Omschrijving",
      "Placeholder": "Plaatsaanduider",
      "Help": "Help",
      "Documentation": "Documentatie",
      "Tooltip": "Tooltip",
      "Icon": "Icoon",
      "Width": "Breedte",
      "Order": "Volgorde",
      "Group": "Groep",
      "Kind": "Soort",
      "KindOptions": {
        "Steps": "Stappenconfiguratie",
        "Range": "Bereikinstellingen"
      },
      "Steps": "Stappen",
      "Optional": "Optioneel",
      "DefaultEnabled": "Standaard geactiveerd",
      "Operator": "Operator",
      "OperatorOptions": {
        "Eq": "is",
        "Neq": "is niet",
        "Lt": "kleiner dan",
        "Lte": "kleiner dan of gelijk aan",
        "Gt": "groter dan",
        "Gte": "groter dan of gelijk aan",
        "Contains": "bevat",
        "StartsWith": "start met",
        "EndsWith": "eindigt met"
      },
      "Errors": {
        "ErrorCode": {
          "STEP_DOES_NOT_MATCH": "Toegestane stap: {step}.",
          "PATTERN_DOES_NOT_MATCH": "Toegestaan patroon: {pattern}.",
          "INVALID_OPTION": "Ongeldige @.lower:{key}, toegestaan {allowed}.",
          "INVALID_MAXIMUM": "@:{key} overschrijdt maximum ({maximum}MB).",
          "INVALID_IMAGE_DATA": "Ongeldig afbeeldingsbestand.",
          "INVALID_IMAGE_METADATA": "Afbeeldingsmetadata niet beschikbaar.",
          "INVALID_IMAGE_ASPECTRATIO": "Ongeldige beeldverhouding ({actual}), verwacht {expected}.",
          "INVALID_IMAGE_TRANSFORM": "Transformatie niet toegestaan voor type {currentMimeType}, toegestaan is: {allowedMimeTypes}",
          "INVALID_IMAGE_WIDTH": "Ongeldige breedte ({actual}px), verwacht {expected}px.",
          "INVALID_IMAGE_HEIGHT": "Ongeldige hoogte ({actual}px), verwacht {expected}px.",
          "INVALID_IMAGE_MINWIDTH": "Breedte ({actual}px) onder minimum ({expected}px).",
          "INVALID_IMAGE_MINHEIGHT": "Hoogte ({actual}px) onder minimum ({expected}px).",
          "INVALID_IMAGE_MAXWIDTH": "Breedte ({actual}px) boven maximum ({expected}px).",
          "INVALID_IMAGE_MAXHEIGHT": "Hoogte ({actual}px) boven maximum ({expected}px)."
        }
      },
      "RemoveSettings item fail": "Fout bij het herstellen van de instelling. | Fout bij het herstellen van de instellingen.",
      "RemoveSettings item success": "Instelling succesvol hersteld. | Instellingen succesvol hersteld.",
      "SaveSettings item fail": "Fout bij het opslaan van de instelling. | Fout bij het opslaan van de instellingen.",
      "SaveSettings item success": "Instelling succesvol opgeslagen. | Instellingen succesvol opgeslagen.",
      "Remove setting confirm": "Instellingen herstellen",
      "Remove setting confirm text": "Weet u zeker dat u de instellingen wilt herstellen naar de standaardwaarden?",
      "Remove single setting confirm": "Instelling herstellen",
      "Remove single setting confirm text": "Weet u zeker dat u de instelling wilt herstellen naar de standaardwaarde?"
    },
    "Sms-logs": {
      "CreatedAt": "Datum",
      "Customer": "Klant",
      "To": "Ontvanger",
      "Content": "Inhoud",
      "Error loading data": "De lijst met sms-logs kon vanwege een fout niet worden geladen.",
      "SmsSent": "Verzonden",
      "SmsSentAt": "Verzonden op",
      "VendorResponse": "Antwoord van de leverancier",
      "View item": "Logboek bekijken",
      "View item fail": "Fout bij het bekijken van het logboek. {msg}",
      "View item success": "Logboek succesvol geopend."
    },
    "Ssl-certificates": {
      "AdministrativeContact": "Administratief contact",
      "ApproverEmail": "Goedkeurder e-mail",
      "Autorenew": "Automatisch verlengen",
      "BillingContact": "Facturatie contact",
      "Certificate": "Certificaat",
      "Certificate expired": "Certificaat is verlopen!",
      "CommonName": "Algemene naam",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Certificaat verwijderen",
      "Delete item fail": "Fout bij het verwijderen van het certificaat. {msg}",
      "Delete item success": "Certificaat succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u het certificaat {0} wilt {1}?",
      "Edit item": "Certificaat bewerken",
      "Edit item fail": "Fout bij het wijzigen van het certificaat. {msg}",
      "Edit item success": "Certificaat succesvol gewijzigd.",
      "Externally managed": "Het certificaat wordt extern beheerd",
      "IsMultiDomain": "Multi domein",
      "IsWildcard": "Wildcard",
      "MultiDomains": "Meerdere domeinen",
      "New item": "Nieuw certificaat",
      "New item fail": "Fout bij maken van certificaat. {msg}",
      "New item success": "Certificaat succesvol toegevoegd.",
      "No subscription": "Er is nog geen abonnement geselecteerd",
      "OwnerContact": "Contactpersoon eigenaar",
      "Registrar": "Registrar",
      "RegistrarOptions": {
        "External": "Extern beheerd",
        "Oxxa": "Oxxa",
        "Xolphin": "Xolphin"
      },
      "RenewDate": "Verlengingsdatum",
      "RequestDate": "Datum van aanvraag",
      "Subscription": "Abonnement",
      "SubscriptionInfo": {
        "contractInfo": {
          "customer": "Klant"
        }
      },
      "Tabs": {
        "Contacts": "Contacten",
        "General": "Algemeen"
      },
      "TechnicalContact": "Technisch contact",
      "Type": "Type",
      "TypeOptions": {
        "Dv": "Domeinvalidatie",
        "Ev": "Uitgebreide validatie",
        "Ov": "Organisatie validatie"
      }
    },
    "Subscription-cancellation": {
      "Cancel date": "Verwijderdatum",
      "Cancel reason": "Reden van opzegging",
      "Cancel subscription": "Opzeggen",
      "Cancellation date select text": "Kies hieronder een datum waarop de dienst moet worden opgezegd. Er geldt een opzegtermijn van {noticePeriod}.",
      "Cancellation domain note": "{0} op de gekozen datum wordt het domein verwijderd en tijdelijk in quarantaine geplaatst. Er zijn kosten aan verbonden om het domein uit quarantaine te halen.",
      "Cancellation hosting note": "{0} op de gekozen datum wordt het hostingaccount definitief verwijderd.",
      "Cancellation ssl note": "{0} op de gekozen datum wordt het SSL-certificaat definitief verwijderd.",
      "Cancellation warning": "Hoewel de dienst binnen de opzegtermijn beëindigd kan worden, ontvangt de klant nog wel een factuur voor de resterende periode. De dienst wordt alsnog verwijderd op de gekozen verwijderdatum.",
      "Confirm termination": "Opzegging bevestigen",
      "Confirm undo termination text": "Wilt u de annulering van de dienst ongedaan maken?",
      "PeriodicOptions": {
        "Day": "Dag | Dagen",
        "Month": "Maand | Maanden",
        "Year": "Jaar"
      },
      "Subscription cancel item success": "Abonnement is opgezegd.",
      "Subscription cancel reversed item success": "Opzegging is ongedaan gemaakt.",
      "Termination date after invoiced until": "{0} De gekozen verwijderdatum ligt na de huidige facturatieperiode. Hierdoor wordt uw dienst automatisch verlengd.",
      "Undo cancellation": "Opzegging annuleren"
    },
    "Subscriptions": {
      "Amount": "Aantal",
      "Attached service": "Gekoppelde service",
      "Cancel date": "Verwijderdatum",
      "Cancel reason": "Reden van opzegging",
      "Cancel subscription": "Opzeggen",
      "CancelDate": "Opgezegd op",
      "Cancellation date select text": "Kies hieronder een datum waarop de dienst moet worden opgezegd. Er geldt een opzegtermijn van {noticePeriod}.",
      "Cancellation domain note": "{0} op de gekozen datum wordt het domein verwijderd en tijdelijk in quarantaine geplaatst. Er zijn kosten aan verbonden om het domein uit quarantaine te halen.",
      "Cancellation hosting note": "{0} op de gekozen datum wordt het hostingaccount definitief verwijderd.",
      "Cancellation ssl note": "{0} op de gekozen datum wordt het SSL-certificaat definitief verwijderd.",
      "Cancellation warning": "Hoewel de dienst binnen de opzegtermijn beëindigd kan worden, ontvangt de klant nog wel een factuur voor de resterende periode. De dienst wordt alsnog verwijderd op de gekozen verwijderdatum.",
      "ChangedBy": "Gewijzigd door",
      "Confirm": "Bevestigen",
      "Confirm termination": "Opzegging bevestigen",
      "Confirm undo termination text": "Wilt u de annulering van de dienst ongedaan maken?",
      "Contract": "Contract",
      "Contract takeover": "Contractovername",
      "Contract takeover confirm": "Verplaats alle afhankelijkheden van dit abonnement samen met de contractovername",
      "Contract takeover confirm item": "Contractovername bevestigen",
      "Contract takeover confirm item success": "Contractovername succesvol uitgevoerd.",
      "Contract takeover item": "Contractovername",
      "Contract takeover text": "De contractoverdracht kan alleen worden uitgevoerd door afhankelijke abonnementen te verplaatsen.",
      "ContractEndDate": "Einde contractdatum",
      "ContractInfo": {
        "_id": "Contract",
        "customer": "Klant"
      },
      "ContractStartDate": "Startdatum contract",
      "Contractual discount": "Contractueel bepaalde korting",
      "Contractual discount description": "Volgens het contract is er al een korting van {0} vastgesteld. Als u hieronder een waarde instelt, wordt deze contractuele korting overschreven.",
      "Current product discount": "Actuele korting | Korting op de huidige {from} ",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Abonnement verwijderen",
      "Delete item fail": "Kan abonnement niet verwijderen. {msg}",
      "Delete item success": "Abonnement succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u dit abonnement wilt {1}?",
      "Discount": "Abonnementskorting",
      "Discount excl": "Korting excl",
      "Edit item": "Abonnement bewerken",
      "Edit item fail": "Fout bij het wijzigen van het abonnement. {msg}",
      "Edit item success": "Abonnement succesvol gewijzigd.",
      "EndDate": "Einddatum",
      "Errors": {
        "ErrorCode": {
          "GENERATE_SALES_ORDER_DATE_BEFORE_INVOICE_START_DATE": "Verkooporderdatum mag niet eerder dan de startdatum zijn.",
          "LICENSE_SUBSCRIPTION_MANAGED_BY_LICENSE": "Dit abonnement wordt beheerd via licenties.",
          "REVERT_SUBSCRIPTION_UPDATE_ERROR": "Er ging iets fout met het terugzetten van het abonnement.",
          "SUBSCRIPTION_LICENSE_CONTRACT_NOT_ALLOWED": "Licentiecontracten kunnen alleen via licentiebeheer worden gebruikt.",
          "SUBSCRIPTION_LICENSE_PRODUCT_NOT_ALLOWED": "Licentieproducten kunnen alleen via licentiebeheer worden gebruikt.",
          "SUBSCRIPTION_BUNDLE_CANNOT_HAVE_DISCOUNT": "FOUT: Een bundelabonnement kan geen korting hebben.",
          "SUBSCRIPTION_BUNDLE_CANNOT_SET_CUSTOM_PRICE": "FOUT: Een bundelabonnement kan geen aangepaste prijs hebben.",
          "SUBSCRIPTION_CONTRACT_MOVE_HAS_DEPENDENCIES": "FOUT: Kan het abonnement niet overzetten naar een nieuw contract omdat er services zijn gekoppeld aan contacten van verschillende klanten."
        }
      },
      "Failed to update subscription prices": "De prijzen van {amount} abonnementen konden niet worden bijgewerkt.",
      "First select a new contract": "Selecteer eerst een nieuw contract",
      "First time invoice": "Datum van eerste factuur",
      "GenerateSalesOrder": "Genereer verkooporder",
      "GenerateSalesOrderDate": "Vanaf datum",
      "HasCustomPrice": "Heeft aangepaste prijs",
      "HasDiscount": "Heeft korting",
      "HasEndedOrCancelled": "Contract geëindigd of opgezegd",
      "Invoice Description preview": "Voorbeeld van factuurbeschrijving",
      "InvoiceDescription": "Factuurbeschrijving",
      "InvoicedUntilDate": "Gefactureerd tot",
      "InvoiceNextDate": "Volgende factuur",
      "InvoiceStartDate": "Begindatum factuur",
      "Is attached": "Dienst gekoppeld",
      "IsAttached": "Dienst gekoppeld",
      "Move contract": "Contract verhuizen",
      "New contract summary": "Samenvatting van het nieuwe contract",
      "New item": "Nieuw abonnement",
      "New item fail": "Kan geen nieuw abonnement maken. {msg}",
      "New item success": "Nieuw abonnement aangemaakt.",
      "New price": "Nieuwe prijs",
      "New product discount": "Nieuwe korting | Nieuw {from} korting",
      "No service attached": "Er is geen dienst gekoppeld",
      "Old contract summary": "Samenvatting van het oude contract",
      "Old price": "Oude prijs",
      "Period": "Periodes | Periode",
      "Periodic": "Periodiek",
      "PeriodicOptions": {
        "Day": "Dag",
        "Month": "Maand",
        "Year": "Jaar"
      },
      "PriceExcl": "Prijs excl",
      "Product": "Product",
      "ProductInfo": {
        "productType": "Product type"
      },
      "ProductTypeOptions": {
        "Domain": "Domein",
        "Hosting": "Hosting",
        "License": "Licentie",
        "Other": "Overige diensten | Overig",
        "Ssl-certificate": "SSL-certificaten | SSL"
      },
      "Revert item success": "Abonnement succesvol teruggezet.",
      "Revert last invoice": "Herstel laatste factuur",
      "Select new contract": "Selecteer eerst een nieuw contract",
      "SetNoticePeriod": "Opzegtermijn instellen",
      "SetNoticePeriodFromContract": "Opzegtermijn overnemen van contract",
      "Skipped subscription prices because the period and periodic are no longer available": "De prijzen van {amount} abonnementen zijn overgeslagen omdat de periode en periodiek niet langer beschikbaar zijn.",
      "Subscription": "Abonnement",
      "Subscription amount is less then product commitments": "Abonnement aantal is lager dan het aantal productverbintenissen.",
      "Subscription cancel item success": "Abonnement is opgezegd.",
      "Subscription cancel reversed item success": "Opzegging is ongedaan gemaakt.",
      "Subscription contract date expired": "Einddatum abonnementscontract is verstreken.",
      "Subscription period no longer available": "Huidige abonnementsperiode niet meer beschikbaar",
      "Subscription period with custom price": "Aangepaste prijs",
      "Subscription prices did not change": "De prijzen van {amount} abonnementen zijn ongewijzigd gebleven.",
      "SubscriptionAmount": "Aantal",
      "Subtotal": "Subtotaal excl",
      "Successfully updated subscription prices": "De prijzen van {amount} abonnementen zijn succesvol gewijzigd.",
      "Sync prices": "Prijzen synchroniseren",
      "Tabs": {
        "Discount": "Korting",
        "General": "Algemeen",
        "PriceHistory": "Prijsgeschiedenis"
      },
      "TerminationDate": "Verwijderdatum",
      "This subscription belongs to a cancelled contract, consider removing it": "Dit abonnement behoort tot een geëindigd of opgezegd contract en kan worden verwijderd.",
      "TotalPriceExcl": "Totaal Prijs excl",
      "Type": "Type",
      "TypeOptions": {
        "Fixed": "Vast",
        "None": "Geen",
        "Percentage": "Percentage"
      },
      "Undo cancellation": "Opzegging annuleren",
      "UpgradeCalculator": {
        "Current Product": "Huidig product",
        "Current sales price": "Huidige verkoopprijs",
        "Current sales price with discount": "Huidige verkoopprijs met korting",
        "Days": "Dagen",
        "Days in subscription": "Dagen in abonnement",
        "Days to next invoice": "Dagen tot volgende factuur",
        "Discount on price change": "Korting op prijswijziging",
        "Downgrade": "Downgrade",
        "New Product": "Nieuw product",
        "New sales price": "Nieuwe verkoopprijs",
        "New sales price with discount": "Nieuwe verkoopprijs met korting",
        "Percentage": "Percentage",
        "Perform up- or downgrade": "Voer de {type} onmiddellijk uit",
        "Price change": "Prijswijziging",
        "Price change with discount": "Prijswijziging met korting",
        "Settlement on price change": "Verrekening over prijswijziging",
        "Title": "{type}-calculator",
        "Up- or downgrade date": "{type} datum",
        "Upgrade": "Upgrade"
      }
    },
    "Users": {
      "Value": "Afbeelding",
      "Errors": {
        "ErrorCode": {
          "ADMIN_API_ROLES_REQUIRED": "Kies minimaal één interne rol.",
          "ADMIN_API_ROLES_INVALID": "Kies alleen actieve interne rollen."
        },
        "Formats": {
          "phone": "Telefoonnummer moet een geldig internationaal geformatteerd telefoonnummer zijn."
        }
      }
    },
    "Vat": {
      "Add VAT item": "BTW toevoegen",
      "Delete": "verwijderen",
      "Delete item": "BTW-instelling verwijderen",
      "Delete item fail": "Kan BTW-instelling niet verwijderen. {msg}",
      "Delete item success": "BTW-instelling succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je de BTW-instelling {0} wilt {1}?",
      "Delete VAT item": "BTW verwijderen",
      "Edit item": "BTW-instelling bewerken",
      "Edit item fail": "Fout bij het wijzigen van de BTW-instelling. {msg}",
      "Edit item success": "BTW-instelling succesvol gewijzigd.",
      "InvoicingSoftwareName": "Naam in factureringssoftware",
      "Name": "Naam",
      "New item": "Nieuwe BTW-instelling",
      "New item fail": "Het maken van een nieuwe BTW-instelling is mislukt. {msg}",
      "New item success": "Nieuwe BTW-instelling succesvol aangemaakt.",
      "Percentage": "Percentage",
      "StartDate": "Begindatum",
      "Tabs": {
        "General": "Algemeen",
        "VAT": "BTW"
      },
      "VAT": "BTW"
    },
    "Licenses": {
      "AlignWithLicense": "Verlengingsdatum gelijkzetten met licentie",
      "Amount": "Aantal",
      "AmountBelowAssigned": "Aantal mag niet lager zijn dan het aantal toegewezen gebruikers.",
      "AmountMustBeZero": "Zet het aantal eerst op 0 voordat je deze licentie verwijdert.",
      "Assigned": "Toegewezen gebruikers",
      "EffectiveAssigned": "Effectieve gebruikers",
      "ChangeOnRenewDate": "Aantal en betaalwijze wijzigen per verlengdatum",
      "Customer": "Klant",
      "CustomerInfo": {
        "customerId": "Klant"
      },
      "Delete": "verwijderen",
      "Delete Assigned item": "Toegewezen gebruiker verwijderen",
      "Delete item": "Licentie verwijderen",
      "Delete item fail": "Licentie verwijderen mislukt. {msg}",
      "Delete item success": "Licentie succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je licentie {0} wilt {1}?",
      "Edit item": "Licentie bewerken",
      "Edit item fail": "Licentie wijzigen mislukt. {msg}",
      "Edit item success": "Licentie succesvol gewijzigd.",
      "Email": "E-mail",
      "Errors": {
        "ErrorCode": {
          "LICENSE_AMOUNT_BELOW_ASSIGNED": "Aantal mag niet lager zijn dan het aantal toegewezen gebruikers.",
          "LICENSE_AMOUNT_CANNOT_DECREASE": "Aantal kan alleen direct verhoogd worden.",
          "LICENSE_ALIGN_AMOUNT_MUST_BE_GREATER_THAN_ZERO": "Aantal moet hoger zijn dan 0 wanneer je de verlengingsdatum gelijkzet met een licentie.",
          "LICENSE_ALIGN_PAYMENT_METHOD_MISMATCH": "Je kunt alleen gelijkzetten met een licentie met dezelfde betaalwijze.",
          "LICENSE_ALIGN_RENEW_DATE_BEFORE_START_DATE": "De startdatum moet vóór de verlengingsdatum van de gekozen licentie liggen.",
          "LICENSE_AMOUNT_MUST_BE_ZERO": "Zet het aantal eerst op 0 voordat je deze licentie verwijdert.",
          "LICENSE_ASSIGNED_CAPACITY_EXCEEDED": "Te veel actieve gebruikers.",
          "LICENSE_ASSIGNED_CUSTOMER_MISMATCH": "Toegewezen gebruikers moeten bij dezelfde klant horen als de licentie.",
          "LICENSE_ASSIGNED_DATE_IN_PAST": "Start- en einddatums van toegewezen gebruikers mogen niet in het verleden liggen.",
          "LICENSE_ASSIGNED_USER_INVALID": "Ongeldige gebruiker.",
          "LICENSE_ASSIGNED_USER_REQUIRED": "Kies een gebruiker.",
          "LICENSE_ASSIGNED_USERS_NOT_UNIQUE": "Een gebruiker kan maar één keer toegewezen worden.",
          "LICENSE_CONTRACT_CANCEL_DATE_AMOUNT_INCREASE": "Deze licentie is opgezegd en kan niet meer verhoogd worden.",
          "LICENSE_CONTRACT_INVALID": "Deze licentie heeft geen geldig contract en kan alleen verwijderd worden.",
          "LICENSE_USER_ALREADY_ASSIGNED_TO_PRODUCT": "Product al toegewezen.",
          "LICENSE_PAYMENT_METHOD_NOT_AVAILABLE": "Deze betaalwijze is niet beschikbaar voor dit licentieproduct.",
          "LICENSE_PENDING_ASSIGNED_CAPACITY_EXCEEDED": "Te veel actieve gebruikers na de verlengdatum.",
          "LICENSE_PENDING_AMOUNT_BELOW_RENEWAL_ASSIGNED": "Het nieuwe aantal is lager dan het aantal toegewezen gebruikers op de verlengdatum.",
          "LICENSE_PERIOD_NOT_AVAILABLE": "Deze periode is niet beschikbaar voor dit licentieproduct.",
          "LICENSE_START_DATE_IN_PAST": "De startdatum mag niet in het verleden liggen."
        }
      },
      "Add Assigned item": "Toegewezen gebruiker toevoegen",
      "EndDate": "Einddatum",
      "LoadError": "Licenties laden mislukt.",
      "LicensesTab": "Licenties",
      "Name": "Naam",
      "New item": "Nieuwe licentie",
      "New item fail": "Licentie aanmaken mislukt. {msg}",
      "New item success": "Licentie succesvol aangemaakt.",
      "NoAssignedUsers": "Geen toegewezen gebruikers.",
      "PaymentMethod": "Betaalwijze",
      "PendingAmount": "Nieuw aantal",
      "PendingPaymentMethod": "Nieuwe betaalwijze",
      "PendingProduct": "Nieuw licentieproduct",
      "Period": "Periode",
      "PartnerProgramsTab": "Partner programma's",
      "SlasTab": "SLA's",
      "PeriodOptions": {
        "Month": "Maand",
        "Year": "Jaar"
      },
      "Product": "Product",
      "RenewDate": "Verlengingsdatum",
      "Required": "Verplicht",
      "SetAssignedEndDatesToRenewDate": "Einddatum op verlengdatum zetten",
      "StartDate": "Startdatum",
      "Tabs": {
        "General": "Algemeen",
        "Users": "Gebruikers"
      },
      "User": "Gebruiker"
    },
    "License-partner-programs": {
      "Active": "Actief",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Partnerprogramma verwijderen",
      "Delete item fail": "Partnerprogramma verwijderen mislukt. {msg}",
      "Delete item success": "Partnerprogramma succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je partnerprogramma {0} wilt {1}?",
      "Discount": "Korting",
      "DiscountType": "Kortingstype",
      "DiscountTypeOptions": {
        "Fixed": "Vast bedrag",
        "Percentage": "Percentage",
        "fixed": "Vast bedrag",
        "percentage": "Percentage"
      },
      "Disabled": "Uitgeschakeld",
      "Edit item": "Partnerprogramma bewerken",
      "Edit item fail": "Partnerprogramma wijzigen mislukt. {msg}",
      "Edit item success": "Partnerprogramma succesvol gewijzigd.",
      "Enabled": "Actief",
      "EndDate": "Einddatum",
      "Errors": {
        "ErrorCode": {
          "LICENSE_PARTNER_PROGRAM_FIXED_AMOUNT_REQUIRED": "Vul een maandbedrag of jaarbedrag in.",
          "LICENSE_PARTNER_PROGRAM_END_DATE_INVALID": "Vul een geldige einddatum in.",
          "LICENSE_PARTNER_PROGRAM_PERCENTAGE_REQUIRED": "Vul een percentage in.",
          "LICENSE_PARTNER_PROGRAM_PERIOD_INVALID": "De einddatum moet na de startdatum liggen.",
          "LICENSE_PARTNER_PROGRAM_PRODUCT_INVALID": "Selecteer een licentie- of overig product.",
          "LICENSE_PARTNER_PROGRAM_RANGE_INVALID": "Het vanaf-aantal mag niet hoger zijn dan het tot-aantal.",
          "LICENSE_PARTNER_PROGRAM_RANGE_OVERLAP": "Dit bereik overlapt met een bestaand partnerprogramma voor deze klant.",
          "LICENSE_PARTNER_PROGRAM_RANGE_PERIOD_OVERLAP": "Bereik/periode overlapt.",
          "LICENSE_PARTNER_PROGRAM_START_DATE_REQUIRED": "Vul een geldige startdatum in."
        },
        "FixedAmountRequired": "Vul een maandbedrag of jaarbedrag in.",
        "PercentageRequired": "Vul een percentage in.",
        "RangeOrder": "Het vanaf-aantal mag niet hoger zijn dan het t/m-aantal.",
        "RangeOverlap": "Dit bereik overlapt met {name} ({from} - {to})."
      },
      "FixedMonthAmount": "Maandbedrag",
      "FixedYearAmount": "Jaarbedrag",
      "FromAmount": "Vanaf aantal",
      "Inactive": "Inactief",
      "License-partner-program": "Partnerprogramma | Partnerprogramma's | Partnerprogramma {licensePartnerProgram}",
      "LoadError": "Partnerprogramma's laden mislukt.",
      "Month": "Maand",
      "Name": "Naam",
      "New item": "Nieuw partnerprogramma",
      "New item fail": "Partnerprogramma aanmaken mislukt. {msg}",
      "New item success": "Partnerprogramma succesvol aangemaakt.",
      "Percentage": "Percentage",
      "Product": "Product",
      "ProductInfo": "Dit product wordt gebruikt voor de kortingsregel op de factuur. De grootboekrekening komt van dit product.",
      "StartDate": "Startdatum",
      "ToAmount": "T/m aantal",
      "Year": "Jaar"
    },
    "License-slas": {
      "Active": "Actief",
      "Availability": "Beschikbaarheid",
      "Charge": "Toeslag",
      "ChargeType": "Toeslagtype",
      "ChargeTypeOptions": {
        "Fixed": "Vast bedrag",
        "Percentage": "Percentage",
        "fixed": "Vast bedrag",
        "percentage": "Percentage"
      },
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "SLA verwijderen",
      "Delete item fail": "SLA verwijderen mislukt. {msg}",
      "Delete item success": "SLA succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je SLA {0} wilt {1}?",
      "Disabled": "Uitgeschakeld",
      "Edit item": "SLA bewerken",
      "Edit item fail": "SLA wijzigen mislukt. {msg}",
      "Edit item success": "SLA succesvol gewijzigd.",
      "Enabled": "Actief",
      "EndDate": "Einddatum",
      "Errors": {
        "ErrorCode": {
          "LICENSE_SLA_AVAILABILITY_REQUIRED": "Vul beschikbaarheid in.",
          "LICENSE_SLA_END_DATE_INVALID": "Vul een geldige einddatum in.",
          "LICENSE_SLA_FIXED_AMOUNT_REQUIRED": "Vul een maandbedrag of jaarbedrag in.",
          "LICENSE_SLA_PERCENTAGE_REQUIRED": "Vul een percentage in.",
          "LICENSE_SLA_PERIOD_INVALID": "De einddatum moet na de startdatum liggen.",
          "LICENSE_SLA_PERIOD_OVERLAP": "Periode overlapt.",
          "LICENSE_SLA_PRODUCT_INVALID": "Selecteer een licentie- of overig product.",
          "LICENSE_SLA_RESPONSE_TIME_REQUIRED": "Vul reactietijd in.",
          "LICENSE_SLA_RESPONSE_TIME_UNIT_REQUIRED": "Kies een reactietijdseenheid.",
          "LICENSE_SLA_SERVICE_HOURS_REQUIRED": "Vul servicetijden in.",
          "LICENSE_SLA_SERVICE_HOURS_TYPE_REQUIRED": "Kies servicetijden.",
          "LICENSE_SLA_START_DATE_REQUIRED": "Vul een geldige startdatum in."
        }
      },
      "FixedMonthAmount": "Maandbedrag",
      "FixedYearAmount": "Jaarbedrag",
      "Inactive": "Inactief",
      "License-sla": "SLA | SLA's | SLA {licenseSla}",
      "LoadError": "SLA's laden mislukt.",
      "Month": "Maand",
      "Name": "Naam",
      "New item": "Nieuwe SLA",
      "New item fail": "SLA aanmaken mislukt. {msg}",
      "New item success": "SLA succesvol aangemaakt.",
      "Percentage": "Percentage",
      "Product": "Product",
      "ProductInfo": "Dit product wordt gebruikt voor de SLA-toeslagregel op de factuur. De grootboekrekening komt van dit product.",
      "ResponseTime": "Reactietijd",
      "ResponseTimeAmount": "Reactietijd",
      "ResponseTimeUnit": "Reactietijdseenheid",
      "ResponseTimeUnitOptions": {
        "BusinessDays": "Werkdagen",
        "Hours": "Uur",
        "Minutes": "Minuten",
        "businessDays": "werkdagen",
        "hours": "uur",
        "minutes": "minuten"
      },
      "ServiceHours": "Servicetijden",
      "ServiceHoursFrom": "Servicetijden vanaf",
      "ServiceHoursTo": "Servicetijden t/m",
      "ServiceHoursType": "Servicetijden",
      "ServiceHoursTypeOptions": {
        "Custom": "Hele week",
        "OfficeHours": "Kantooruren",
        "custom": "Hele week",
        "officeHours": "Kantooruren"
      },
      "StartDate": "Startdatum",
      "Year": "Jaar"
    },
    "Whitelabels": {
      "AllowedCustomers": "Toegestane klanten",
      "Active": "Actief",
      "BrandingCustomer": "Standaard branding klant",
      "Delete": "verwijderen",
      "Delete item": "Whitelabel verwijderen",
      "Delete item fail": "Whitelabel verwijderen mislukt. {msg}",
      "Delete item success": "Whitelabel succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je whitelabel {0} wilt {1}?",
      "Domain": "Domein",
      "Edit item": "Whitelabel bewerken",
      "Edit item fail": "Whitelabel wijzigen mislukt. {msg}",
      "Edit item success": "Whitelabel succesvol gewijzigd.",
      "Enabled": "Actief",
      "Inactive": "Inactief",
      "LoadError": "Whitelabels laden mislukt.",
      "LocalLoginEnabled": "Local login toestaan",
      "Name": "Naam",
      "New item": "Nieuwe whitelabel",
      "New item fail": "Whitelabel aanmaken mislukt. {msg}",
      "New item success": "Whitelabel succesvol aangemaakt.",
      "Notes": "Notities",
      "Off": "Uit",
      "On": "Aan",
      "SSO": "SSO",
      "SMTP": "SMTP",
      "Smtp": {
        "Enabled": "Eigen SMTP inschakelen",
        "FromEmail": "Afzender e-mailadres",
        "FromName": "Afzender naam",
        "Host": "SMTP host",
        "Password": "SMTP wachtwoord",
        "Port": "SMTP poort",
        "ReplyTo": "Reply-to e-mailadres",
        "Security": "SMTP beveiliging",
        "SecurityOptions": {
          "None": "Geen",
          "Starttls": "STARTTLS",
          "Tls": "TLS / SMTPS"
        },
        "Secure": "Beveiligde verbinding",
        "enabled": "SMTP",
        "Username": "SMTP gebruikersnaam"
      },
      "Sso": {
        "AccessUrl": "Token URL",
        "AuthorizeUrl": "Authorize URL",
        "AutoProvisionCustomerUserRoles": "Default customer-user rollen voor SSO provisioning",
        "AutoProvisionCustomerUsers": "Customer-users automatisch aanmaken",
        "ClientId": "Client ID",
        "ClientSecret": "Client secret",
        "Enabled": "Azure SSO inschakelen voor dit domein",
        "ProfileUrl": "Profile URL",
        "Prompt": "Prompt",
        "RedirectUri": "Redirect URI",
        "Scope": "Scope",
        "enabled": "SSO"
      },
      "Tabs": {
        "General": "Algemeen",
        "SSO": "SSO",
        "SMTP": "SMTP"
      }
    },
    "Vpn-activity": {
      "External IP": "Extern IP",
      "Offline at": "Offline sinds",
      "Online at": "Online sinds",
      "VPN IP": "VPN IP"
    },
    "Vpn-access-graph": {
      "Access map": "Toegangskaart",
      "All": "Alle",
      "All destinations": "alles",
      "All sources": "alles",
      "All protocols": "Alle protocollen",
      "Allowed": "Toegestaan",
      "Addresses reachable within route": "{count} IP-adressen bereikbaar binnen {route}",
      "Any": "Alle adressen",
      "Asset legend": "Legenda apparaattypen",
      "Asset types": {
        "MD": "Beheerd apparaat",
        "OTHER": "Overig",
        "PHONE": "Telefoon",
        "RTR": "Router",
        "SERVER": "Server",
        "TABLET": "Tablet",
        "UD": "Unmanaged Device",
        "VPN_SERVER": "VPN-server"
      },
      "Assigned to": "Toegewezen aan",
      "Blocked": "Geblokkeerd",
      "Broader firewall range": "Firewallregel geldt voor een breder netwerk",
      "Broader source range": "Breder bronbereik",
      "Broader target range": "Breder doelbereik",
      "Both certificate types": "Routers en clients",
      "Calculating": "Firewallregels worden doorgerekend…",
      "Certificate": "VPN-certificaat",
      "Certificate prefix": "Certificaat prefix",
      "Certificate type": "Certificaattype",
      "Certificate route": "Certificaatroute",
      "Certificates": "Certificaten",
      "Clients only": "Alleen clients",
      "Choose destination": "Kies een doelcertificaat",
      "Choose certificate": "Kies een certificaat",
      "Choose source": "Kies een broncertificaat",
      "Clear destination": "Doel wissen",
      "Clear focus": "Focus wissen",
      "Clear source": "Bron wissen",
      "Customer group": "Klantnummer",
      "Default deny": "Standaard geblokkeerd",
      "Description": "Actuele VPN-toegang volgens firewallregels",
      "Details": "Details",
      "Effective access": "Effectieve toegang",
      "Explain result": "Onderbouwing van de geselecteerde toegang",
      "Explicitly blocked": "Expliciet geblokkeerd",
      "Firewall source note": "Berekend uit de actuele firewallregels",
      "Firewalls": "Firewalls",
      "Fit": "Passend maken",
      "Focused node": "De toegangsrelaties voor dit onderdeel worden getoond.",
      "From": "Van",
      "From IP": "Van IP",
      "Inspector": "Inspectie",
      "Inspector hint": "Selecteer links een certificaat om de effectieve toegang te analyseren.",
      "Invalid IP": "Vul een geldig IPv4-adres of subnet in, bijvoorbeeld 10.10.0.15 of 10.10.0.0/24.",
      "Invalid port": "Gebruik poorten van 1 t/m 65535, bijvoorbeeld 443, 80,443 of 8000:8100.",
      "Load failed": "Het VPN-toegangsschema kon niet worden geladen.",
      "Matching rules": "Bepalende firewallregels",
      "Network": "Netwerk",
      "No access": "Geen toegang",
      "No access explanation": "Deze certificaten hebben voor het gekozen protocol of de gekozen poort geen toegestane verbinding in de gekozen richting. Zonder match geldt default deny.",
      "No blocked objects": "Geen geblokkeerde objecten binnen dit filter.",
      "No line means deny": "Geen lijn betekent standaard geblokkeerd",
      "No matching rule": "Geen firewallregel staat deze verbinding toe. Daarom geldt default deny.",
      "No objects": "Geen certificaten gevonden",
      "No source selected": "Nog geen certificaat geselecteerd",
      "Node types": {
        "certificate-pattern": "Certificaatpatroon",
        "client": "VPN-client",
        "host-alias": "Host-alias",
        "network": "Extern netwerk",
        "router": "VPN-router",
        "subnet": "Subnet",
        "vpn-server": "VPN-server"
      },
      "Not reachable": "niet bereikbaar",
      "Nothing selected": "Nog niets om te inspecteren",
      "Objects": "VPN-certificaten",
      "Online only": "Alleen online",
      "One address reachable within route": "1 IP-adres bereikbaar binnen {route}",
      "One source address within route": "Toegang vanaf 1 IP-adres binnen {route}",
      "Other ports blocked": "Overige poorten geblokkeerd",
      "Partial": "Gedeeltelijk",
      "Part of": "Onderdeel van",
      "Port": "Poort",
      "Port examples": "80,443 of 8000:8100",
      "Protocol": "Protocol",
      "Reachable": "bereikbaar",
      "Read only": "Alleen lezen",
      "Relationship limit": "{shown} van {total} relaties worden getekend. Gebruik een protocol of poort voor een gerichter beeld.",
      "Relationships": "Relaties",
      "Route": "Route",
      "Route subnets": "Route-subnets",
      "Routers only": "Alleen routers",
      "Search": "Zoek certificaatnaam of VPN-IP",
      "Select relation": "Selecteer een object of verbinding in de kaart voor details.",
      "Select destination": "Selecteer een doelcertificaat",
      "Select source": "Selecteer een broncertificaat",
      "Select node hint": "Kies links Van of Naar en selecteer een certificaat om de toegangsrelaties te berekenen.",
      "Source range": "Bronbereik",
      "Source addresses within route": "Toegang vanaf {count} IP-adressen binnen {route}",
      "Source subnet within route": "Toegang vanaf een beperkt subnet binnen {route}",
      "Source subnets within route": "Toegang vanaf {count} beperkte subnetten binnen {route}",
      "Swap endpoints": "Van en Naar wisselen",
      "Subnet reachable within route": "Beperkt subnet bereikbaar binnen {route}",
      "Subnets reachable within route": "{count} beperkte subnetten bereikbaar binnen {route}",
      "Target range": "Doelbereik",
      "Title": "VPN-toegangsschema",
      "To": "Naar",
      "To IP": "Naar IP",
      "VPN IP": "VPN-IP",
      "VPN server": "VPN-server"
    },
    "Vpn-certificates": {
      "Active": "Actief",
      "Activity": "Activiteit",
      "AssignedTo": "Toegewezen aan",
      "Certificate": "Certificaat",
      "Certificate {NAME}": "Certificaat {NAME}",
      "Certificates": "Certificaten",
      "Combined": "Gecombineerd",
      "Comments": "Opmerkingen",
      "Delete": "Verwijder",
      "Delete item": "Verwijder certificaat",
      "Delete item fail": "Het certificaat kon niet worden verwijderd.",
      "Delete item success": "Certificaat succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je certificaat {0} wilt verwijderen?",
      "Deleted": "Verwijderd",
      "DHCP": "DHCP",
      "Download": "Download",
      "Download certificate combined or separated": "Download certificaat {NAME} gecombineerd or gescheiden?",
      "Download certificate item fail": "Fout bij downloaden van certificaat.",
      "Download certificate item success": "Certificaat succesvol gedownload.",
      "Edit item": "Certificaat wijzigen",
      "Edit item fail": "Fout bij het wijzigen van het certificaat.",
      "Edit item success": "Certificaat succesvol gewijzigd.",
      "Errors": {
        "ErrorCode": {
          "FIELD_IROUTE_ALREADY_IN_USE": "Route is al in gebruik.",
          "FIELD_IROUTE_IP_INVALID": "Routes zijn ongeldig.",
          "FIELD_NAME_INVALID_CHARS": "Geldige chars: 0-9 A-z _ -",
          "FIELD_PUSH_IROUTE_INVALID": "Niet alle certificaten hebben routes ingesteld.",
          "FIELD_PUSHCUSTOMROUTES_IP_INVALID": "Routes zijn ongeldig."
        }
      },
      "External IP": "Extern IP",
      "Filter": "Filter",
      "HasPushRoutes": "Heeft push-routes",
      "Iroute": "Route subnets (comma gescheiden)",
      "Last seen": "Laatst gezien",
      "Manual IP": "Static IP",
      "Name": "Naam",
      "Never": "Nooit",
      "New item": "Nieuw certificaat",
      "New item fail": "Fout bij het maken van het certificaat.",
      "New item success": "Certificaat succesvol toegevoegd.",
      "No items found": "Geen resultaten gevonden",
      "Offline": "Offline",
      "Offline at": "Offline op",
      "Online": "Online",
      "Online at": "Online op",
      "PushCustomRoutes": "Routes handmatig naar deze client pushen (comma gescheiden)",
      "PushIroute": "Push routes naar andere clients",
      "PushManualIroutes": "Routes van geselecteerde clients naar deze client pushen",
      "RedirectGateway": "Verkeer via VPN routeren",
      "Reset filter": "Wis",
      "Route subnets": "Route subnets",
      "RouteSubnet": "Routeert subnets",
      "Routing": "Routing",
      "Separated": "Gescheiden",
      "Status": "Status",
      "StatusOptions": {
        "Offline": "Offline",
        "Online": "Online"
      },
      "Tabs": {
        "Activity": "Activiteiten",
        "General": "Algemeen"
      },
      "VPN IP": "VPN IP",
      "Copy certificate": "Certificaat kopiëren",
      "Retry route suggestion": "Beschikbare adressen konden niet worden geladen. Opnieuw proberen",
      "Range full": "Geen beschikbaar adres binnen {range}",
      "Use available route": "Gebruik beschikbare route {route}"
    },
    "Vpn-firewalls": {
      "Action": "Actie",
      "Add firewall": "Firewall toevoegen",
      "Allow": "Toestaan",
      "Both": "TCP/UDP",
      "Cancel": "Annuleren",
      "Cert": "Cert",
      "Certificate name": "Naam certificaat",
      "Copy": "Kopiëren",
      "Copy of": "kopie_van_",
      "Delete": "Verwijderen",
      "Delete item": "Verwijder firewall",
      "Delete item fail": "De firewall kon niet worden verwijderd.",
      "Delete item success": "Firewall succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je firewall {0} wilt verwijderen?",
      "Deny": "Negeren",
      "Description": "Omschrijving",
      "Error in fields": "Niet alle velden zijn juist ingevuld.",
      "Errors": {
        "ErrorCode": {
          "FIELD_FROM_CERT_INVALID": "Geldige chars: 0-9 A-z _ -",
          "FIELD_FROM_INVALID": "IP is niet geldig.",
          "FIELD_NAME_INVALID_CHARS": "Geldige chars: 0-9 A-z _ -",
          "FIELD_PORT_INVALID": "Port is niet geldig.",
          "FIELD_TO_CERT_INVALID": "Geldige chars: 0-9 A-z _ -",
          "FIELD_TO_INVALID": "IP is niet geldig."
        }
      },
      "External IP": "Extern IP",
      "Firewalls": "Firewalls",
      "From": "Van",
      "FromType": "Type",
      "ICMP": "ICMP",
      "IP": "IP",
      "IP address": "IP adres",
      "Item is saved": "{NAME} is saved.",
      "Name": "Naam",
      "No items found": "Geen resultaten gevonden.",
      "No rules found": "Geen regels gevonden",
      "Not saved": "Niet opgeslagen",
      "On Off": "On/Off",
      "Online only": "Alleen online",
      "Options": "Opties",
      "Port": "Poort",
      "Protocol": "Protocool",
      "Reject": "Afwijzen",
      "Reset": "Reset",
      "Save conflict": "Deze firewall is intussen gewijzigd. Vernieuw de pagina, controleer de actuele regels en sla daarna opnieuw op.",
      "Rule impact": {
        "Action": "Actie",
        "Close": "Sluiten",
        "Determining rule": "Bepalende regel",
        "Edit": "Bewerken",
        "Effective": "Bepalend",
        "Effective pairs": "Volledig bepalend",
        "Effective pairs help": "Aantal bron-doelverbindingen waarvoor deze regel al het geselecteerde verkeer bepaalt.",
        "Error": "De impact van deze regel kon niet worden berekend.",
        "Exceptions": "Uitzonderingen door eerdere regels",
        "Exceptions truncated": "Niet alle uitzonderingen worden getoond. Verfijn de regel om de analyse kleiner te maken.",
        "From": "Van",
        "Impact": "Impact bekijken",
        "Impact counts": "{effective} bepalend · {partial} gedeeltelijk · {shadowed} overschaduwd",
        "Impact summary": "Werkelijke impact na verwerking van de firewallvolgorde",
        "No exceptions": "Deze regel is voor de volledige gevonden scope bepalend.",
        "No matches": "Geen overeenkomende verbindingen",
        "No matches description": "De bron- en doelselectors leveren geen analyseerbare verbindingen op.",
        "Pairs": "Verbindingen",
        "Pairs help": "Totaal aantal geanalyseerde bron-doelverbindingen binnen de selectors van deze regel.",
        "Partial": "Gedeeltelijk bepalend",
        "Partial pairs": "Gedeeltelijk",
        "Partial pairs help": "Aantal bron-doelverbindingen waarvoor deze regel slechts een deel van het geselecteerde verkeer bepaalt, omdat eerdere regels ook van toepassing zijn.",
        "Port": "Poort",
        "Protocol": "Protocol",
        "Rule": "Regel #{number}",
        "Save first": "Sla de firewall eerst op om de actuele impact te bekijken.",
        "Scope sources": "Bronnen binnen scope",
        "Scope sources help": "Aantal herleidbare bronnen waarop de bronselector van deze regel van toepassing is.",
        "Scope targets": "Doelen binnen scope",
        "Scope targets help": "Aantal herleidbare doelen waarop de doelselector van deze regel van toepassing is.",
        "Shadowed": "Overschaduwd",
        "Shadowed pairs": "Overschaduwd",
        "Shadowed pairs help": "Aantal bron-doelverbindingen waarvoor deze regel geen effect heeft, omdat eerdere regels al het geselecteerde verkeer bepalen.",
        "Status effective": "Volledig bepalend",
        "Status no-matches": "Geen verbindingen",
        "Status partial": "Gedeeltelijk bepalend",
        "Status shadowed": "Volledig overschaduwd",
        "Title": "Regelimpact",
        "To": "Naar",
        "Unmapped": "Niet volledig herleidbaar"
      },
      "Rule verification": {
        "Active": "Actief",
        "Allow only help": "Verificatie is alleen beschikbaar voor regels die toegang toestaan.",
        "Button": "Verify rules",
        "Cancel": "Annuleren",
        "Close": "Sluiten",
        "Confirm": "Regel verifiëren",
        "Confirm revocation": "Verificatie intrekken",
        "Current revocation": "Ingetrokken door {name} op {date}.",
        "Current verification": "Geverifieerd door {name} en actief tot {date}.",
        "Explanation": "Tijdelijke activering van beveiligde regels",
        "Explanation help": "Regels waarvoor verificatie vereist is, worden alleen actief met een geldige verificatie. Een verificatie mag maximaal {days} dagen geldig zijn.",
        "Expired help": "De verificatie is verlopen; deze regel is niet actief.",
        "Future required": "Kies een einddatum en -tijd in de toekomst.",
        "Load failed": "De verificatiestatussen konden niet worden geladen.",
        "Loading": "Firewallverificaties laden",
        "Maximum exceeded": "De einddatum mag maximaal {days} dagen in de toekomst liggen.",
        "Maximum help": "De gekozen verificatie mag maximaal {days} dagen geldig zijn.",
        "No description": "Geen omschrijving",
        "No rules": "Er zijn geen firewallregels waarvoor verificatie vereist is.",
        "Not required help": "Deze regel is zonder afzonderlijke verificatie actief.",
        "Reason": "Reden voor verificatie",
        "Reason required": "Vul een reden voor de verificatie in.",
        "Refresh": "Verificatiestatussen vernieuwen",
        "Replacement help": "Een nieuwe verificatie vervangt de huidige verificatie voor deze exacte regelversie en mag de eindtijd verkorten of verlengen.",
        "Revoke": "Intrekken",
        "Revoke failed": "De verificatie kon niet worden ingetrokken.",
        "Revoke title": "Firewallverificatie intrekken",
        "Revocation changed": "De verificatie of firewallregel is intussen gewijzigd. Vernieuw het overzicht en controleer de actuele status.",
        "Revocation reason": "Reden voor intrekking",
        "Revocation reason required": "Vul een reden voor de intrekking in.",
        "Revocation warning": "De firewallregel wordt direct inactief. Deze intrekking wordt onveranderlijk vastgelegd.",
        "Revoked": "De firewallverificatie is ingetrokken.",
        "Revoked help": "De verificatie is ingetrokken; deze regel is niet actief.",
        "Rule changed": "De firewallregel is intussen gewijzigd. Controleer de actuele regel en probeer opnieuw.",
        "Required": "Verificatie vereist",
        "Required help": "Deze regel wordt pas actief na een geldige verificatie.",
        "Required rules": "Regels met verificatie",
        "Requires attention": "Actie vereist",
        "Status": {
          "active": "Actief",
          "expired": "Verlopen",
          "revoked": "Ingetrokken",
          "unverified": "Niet geverifieerd"
        },
        "Subtitle": "Beheer regels die pas na tijdelijke goedkeuring actief worden",
        "Title": "Firewallregels verifiëren",
        "Try again": "Opnieuw proberen",
        "Unverified help": "Deze regel is nog niet geverifieerd en daarom niet actief.",
        "Valid until": "Actief tot",
        "Verified": "De firewallregel is geverifieerd.",
        "Verify": "Verifiëren",
        "Verify again": "Opnieuw verifiëren",
        "Verify failed": "De firewallregel kon niet worden geverifieerd.",
        "Verify title": "Firewallregel verifiëren"
      },
      "Rules analysis": {
        "All ports score": "Alle poorten",
        "Analyzing": "Firewallregels analyseren",
        "Analyzing help": "De first-match-volgorde en effectieve bron-doelverbindingen worden doorgerekend.",
        "Button": "Rule analyse",
        "Close": "Sluiten",
        "Completed in": "Analyse voltooid in {duration}",
        "Determined by": "Eerder bepaald door",
        "Determining rule": "Bepalende firewallregel",
        "Direct lateral access": "Directe laterale toegang",
        "Error": "De rule analyse kon niet worden uitgevoerd.",
        "Fully shadowed": "Volledig overschaduwd",
        "High risk": "Hoog risico",
        "Invalid rules": "{count} regels konden niet volledig worden geanalyseerd. Controleer deze regels op ongeldige waarden.",
        "Lateral access": "Laterale toegang",
        "Lateral access help": "Allow-regels die rechtstreeks toegang geven van een beheerd certificaat, iroute of VPN-servernetwerk naar een ander beheerd netwerk. Externe en onbekende netwerken tellen niet mee.",
        "Lateral scope": "Verbindingen: {connections} · bronnetwerken: {sources} · doelnetwerken: {targets}",
        "Medium risk": "Verhoogd risico",
        "No description": "Geen omschrijving",
        "No lateral access": "Geen directe toegang tussen verschillende beheerde netwerken gevonden.",
        "No matching scope": "Geen herleidbaar bereik",
        "No risky rules": "Geen breed ingestelde risicoregels gevonden.",
        "No unused rules": "Geen structureel ongebruikte regels gevonden.",
        "Not listed": "Niet opgenomen",
        "Part of": "onderdeel van",
        "Port score": "Aantal poorten",
        "Protocol score": "Protocollen",
        "Refresh": "Analyse opnieuw uitvoeren",
        "Results truncated": "De analyse bevat meer resultaten dan in deze dialoog worden getoond.",
        "Risk reasons": {
          "all-ports": "Alle poorten",
          "both-protocols": "TCP en UDP",
          "from-any": "Vanaf iedereen",
          "from-broad-network": "Breed bronnetwerk",
          "large-scope": "Zeer veel verbindingen",
          "many-ports": "Zeer veel poorten",
          "multiple-connections": "Veel verbindingen",
          "multiple-ports": "Meerdere poorten",
          "to-any": "Naar iedereen",
          "to-broad-network": "Breed doelnetwerk"
        },
        "Risky": "Riskante regels",
        "Risky help": "Allow-regels met een brede bron, breed doel, veel poorten of een groot gevonden bereik. De score is een heuristische indicatie van het configuratierisico.",
        "Scope score": "Gevonden bron-doelverbindingen",
        "Score explanation": "Zo wordt het configuratierisico bepaald",
        "Score explanation help": "Alleen allow-regels met effectieve impact worden beoordeeld. De punten voor bron, doel, protocollen, poorten en gevonden omvang vormen samen de OMNI-configuratierisicoscore van maximaal 100.",
        "Selector any": "Any / iedereen",
        "Selector narrow": "Certificaat of IP /25–/32",
        "Selector score": "Bron en doel (per zijde)",
        "Single protocol": "Eén protocol",
        "Rules analyzed": "Regels geanalyseerd",
        "Rules analyzed help": "Aantal opgeslagen firewallregels dat met de actuele first-match-volgorde is doorgerekend.",
        "Source": "Bron",
        "Source any": "Bron: any",
        "Structural analysis": "Structurele configuratieanalyse",
        "Structural analysis help": "Ongebruikt betekent hier: geen herleidbaar bereik of volledig overschaduwd door eerdere regels. Zonder iptables-hitcounters kan niet worden vastgesteld of een effectieve regel in de praktijk verkeer verwerkt.",
        "Subtitle": "Ongebruikte regels, brede toegang en directe netwerkoverschrijding",
        "Target": "Doel",
        "Target any": "Doel: any",
        "Title": "Rule analyse",
        "Try again": "Opnieuw proberen",
        "Unused": "Ongebruikte regels",
        "Unused help": "Regels zonder herleidbare bron-doelverbinding of regels waarvan al het geselecteerde verkeer eerder in de firewallvolgorde wordt bepaald.",
        "View rule": "Regel bekijken"
      },
      "Verification logs": {
        "Button": "Verificatielogs",
        "Clear search": "Zoekopdracht wissen",
        "Close": "Sluiten",
        "Details": "Verificatiedetails",
        "Event time": "Tijdstip",
        "Expired": "Verlopen",
        "Firewall": "Firewall",
        "Load failed": "De verificatielogs konden niet worden geladen.",
        "No logs": "Geen verificatielogs gevonden.",
        "No results": "Geen verificatielogs gevonden voor deze zoekopdracht.",
        "Performed by": "Uitgevoerd door",
        "Reason": "Reden",
        "Refresh": "Logs vernieuwen",
        "Route": "Verbinding",
        "Rule": "Regel",
        "Rule snapshot": "Firewallregel op het verificatiemoment",
        "Revocation reason": "Reden van intrekking",
        "Revoked at": "Ingetrokken op",
        "Revoked by": "Ingetrokken door",
        "Search": "Zoek op firewall, reden of medewerker",
        "Status": "Status",
        "Status values": {
          "Active": "Actief",
          "Expired": "Verlopen",
          "Policy changed": "Ongeldig door beleidswijziging",
          "Revoked": "Ingetrokken",
          "Rule removed": "Regel verwijderd",
          "Superseded": "Vervangen door nieuwere verificatie",
          "Unknown": "Status onbekend"
        },
        "Subtitle": "Onveranderlijke registratie van tijdelijke firewallverificaties",
        "Title": "Firewallverificatielogs",
        "Try again": "Opnieuw proberen",
        "Valid until": "Geldig tot",
        "Verified at": "Geverifieerd op",
        "Verified by": "Geverifieerd door",
        "View details": "Details bekijken"
      },
      "Rules": "Rules",
      "Rules count": "{count} regel | {count} regels",
      "Save": "Opslaan",
      "TCP": "TCP",
      "To": "Naar",
      "ToType": "Type",
      "Type": "Type",
      "UDP": "UDP",
      "VPN IP": "VPN IP"
    },
    "Vpn-mac-address-groups": {
      "Action": "Actie",
      "Add group": "Groep toevoegen",
      "Address": "MAC adres",
      "BandwidthDown": "Bandbreedte down (KBs)",
      "BandwidthUp": "Bandbreedte up (KBs)",
      "Block": "Weigeren",
      "Cancel": "Annuleren",
      "Copy": "Kopiëren",
      "Copy of": "kopie_van_",
      "Delete": "Verwijderen",
      "Delete item": "Verwijder groep",
      "Delete item fail": "De groep kon niet worden verwijderd.",
      "Delete item success": "Groep succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je groep {0} wilt verwijderen?",
      "Description": "Omschrijving",
      "Error in fields": "Niet alle velden zijn juist ingevuld.",
      "Errors": {
        "ErrorCode": {
          "FIELD_BANDWIDTH_DOWN_INVALID": "Ongeldige bandbreedte down.",
          "FIELD_BANDWIDTH_UP_INVALID": "Ongeldige bandbreedte up.",
          "FIELD_MAC_ADDRESS_INVALID": "MAC-adres is niet geldig.",
          "FIELD_MAC_ADDRESS_NOT_UNIQUE": "MAC-adres is niet uniek.",
          "FIELD_NAME_INVALID_CHARS": "Geldige chars: 0-9 A-z _ -"
        }
      },
      "Item is saved": "{NAME} is saved.",
      "Mac Addresses": "MAC adressen",
      "MACs": "MAC-adressen",
      "MACs count": "{count} regel | {count} regels",
      "Name": "Naam",
      "No items found": "Geen MAC adres groepen gevonden",
      "No MACs found": "Geen MAC adressen gevonden",
      "Not saved": "Niet opgeslagen",
      "Options": "Opties",
      "Pass": "Toestaan",
      "Reset": "Reset",
      "Save": "Opslaan"
    },
    "Webhooks/health-status": {
      "5 mins": "5 min | 5 min gem",
      "15 mins": "15 min",
      "Actions": "Acties",
      "Adapters": "Adapters",
      "AgentPlatform": "Platform",
      "AgentPlatformOptions": {
        "Pfsense": "pfSense router",
        "Raspberry-pi": "Raspberry Pi",
        "Teltonika": "Teltonika router",
        "Ubuntu": "Ubuntu Server",
        "Ubuntu-client": "Ubuntu Client",
        "Windows": "Windows Server",
        "Windows-client": "Windows Client"
      },
      "AgentVersion": "Agent versie",
      "Assets": "Assets",
      "Available updates": "Beschikbare updates",
      "Bulk actions": {
        "Label": "Bulkacties",
        "SetCheckForUpdate": "Stel 'Controleren op updates' in voor alles | Haal 'Controleren op updates' weg voor alles",
        "SetCleanupPackages": "Stel 'Pakketten opruimen' in voor alles | Haal 'Pakketten opruimen' weg voor alles",
        "SetDownloadUpdate": "Stel 'Updates downloaden' in voor alles | Haal 'Updates downloaden' weg voor alles",
        "SetInstallModemUpdate": "Stel 'Modemupdates installeren' in voor alles | Haal 'Modemupdates installeren' weg voor alles",
        "SetInstallUpdate": "Stel 'Updates installeren' in voor alles | Haal 'Updates installeren' weg voor alles",
        "SetRebootAfterUpdate": "Stel 'Herstarten na updates' in voor alles | Haal 'Herstarten na updates' weg voor alles",
        "SetRebootNow": "Stel 'Nu herstarten' in voor alles | Haal 'Nu herstarten' weg voor alles",
        "SetRebootWhenNoUser": "Stel 'Herstart zonder gebruikers' in voor alles | Haal 'Herstart zonder gebruikers' weg voor alles"
      },
      "CPU": "CPU",
      "CPU cores": "Aantal CPU-kernen",
      "CPU load average": "Gemiddelde systeembelasting",
      "CPU load percentage": "CPU-belastingspercentage",
      "Current": "Nu",
      "Current version": "Huidige versie",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Server verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de server. {msg}",
      "Delete item success": "Server succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de server {0} wilt {1}?",
      "Disks": "Schijven",
      "Enable auto refresh": "Automatisch verversen",
      "ExecuteCommands": {
        "CheckForUpdates": "Controleren op updates",
        "CleanupPackages": "Pakketten opruimen",
        "DownloadUpdates": "Updates downloaden",
        "InstallModemUpdates": "Modemupdates installeren",
        "InstallUpdates": "Updates installeren",
        "RebootAfterUpdates": "Herstarten na updates",
        "RebootNow": "Nu herstarten",
        "RebootWhenNoUsers": "Herstart zonder gebruikers"
      },
      "HasUpdates": "Updates beschikbaar",
      "Health-status": "Systeemstatus | Systeemstatussen",
      "History": "Geschiedenis",
      "Hostname": "Hostnaam",
      "Memory": "Geheugen",
      "Metadata": "Metadata",
      "Name": "Naam",
      "NeedsReboot": "Herstart nodig",
      "New version": "Nieuwe versie",
      "Nothing to update": "Er zijn geen wijzigingen om op te slaan.",
      "Operating system": "Besturingssysteem",
      "Path": "Pad",
      "Select customer": "Selecteer klant",
      "signedInUsers": "Ingelogde gebruikers",
      "Status": "Status",
      "StatusOptions": {
        "Degraded": "Degraded",
        "Healthy": "Healthy",
        "NeedsReboot": "Reboot",
        "Unhealthy": "Unhealthy"
      },
      "Updated items success": "Instellingen succesvol bijgewerkt.",
      "UpdatedAt": "Bijgewerkt op",
      "Updates": "Updates",
      "Uptime": "Beschikbaarheid"
    },
    "Webhosting": {
      "Account": "Account",
      "Account has error": "Dit account heeft een foutstatus.",
      "Account pending": "Dit account heeft de status 'In behandeling'.",
      "Account suspended": "Dit account is geblokkeerd.",
      "AccountEmailAddress": "Notificatie e-mailadres",
      "Autologin": "Automatisch inloggen op {product}",
      "Autologin item fail": "Autologin mislukt. {msg}",
      "Autologin item success": "Het webhosting beheerderspaneel is geopend in een nieuw tabblad.",
      "Bandwidth quota does not match package settings": "Bandbreedtequota komt niet overeen met pakketinstellingen.",
      "Bandwidth quota exceeds limit": "Quota voor bandbreedte overschrijdt limiet.",
      "BandwidthQuota": "Bandbreedtequota",
      "Confirm delete": "Ik ben me ervan bewust dat het verwijderen van dit account ook het cPanel-account en alle bijbehorende gegevens zal verwijderen.",
      "Cpanel": "cPanel",
      "Customer": "Klant",
      "Delete": "Verwijderen",
      "Delete item": "Hostingaccount verwijderen",
      "Delete item fail": "Fout bij het verwijderen van het hostingaccount. {msg}",
      "Delete item success": "Hostingaccount {item} verwijderd.",
      "Delete item text": "Weet u zeker dat u hostingaccount {0} wilt {1}?",
      "Directadmin": "DirectAdmin",
      "Disk quota does not match package settings": "Schijfquota komt niet overeen met pakketinstellingen.",
      "Disk quota exceeds limit": "Schijfquota overschrijdt limiet.",
      "Disk Space": "Schijfruimte",
      "DiskQuota": "Schijfquota",
      "DiskspaceMB": "Schijfruimte (MB)",
      "Edit item": "Hostingaccount bewerken",
      "Edit item fail": "Fout bij het wijzigen van het hostingaccount. {msg}",
      "Edit item success": "Hostingaccount succesvol gewijzigd.",
      "Errors": {
        "ErrorCode": {
          "CPANEL_CREATE_ACCOUNT_USERNAME_ALREADY_IN_USE": "Opgegeven gebruikersnaam is niet beschikbaar.",
          "FIELD_SUBSCRIPTION_IS_REQUIRED": "Abonnement is een verplicht veld.",
          "PASSWORD_CONTAINS_INVALID_CHARACTERS": "Wachtwoord bevat illegale tekens."
        }
      },
      "HasSubscription": "Heeft een abonnement",
      "Hide password": "Wachtwoord verbergen",
      "Mail account details": "Verstuur gegevens van het account",
      "Name": "Naam",
      "New item": "Nieuw hostingaccount",
      "New item fail": "Fout bij het maken van het nieuwe hostingaccount. {msg}",
      "New item success": "Hostingaccount succesvol toegevoegd.",
      "New item success with warning": "Hostingaccount succesvol toegevoegd, maar met waarschuwing(en). {warning}",
      "No password set": "Er is geen wachtwoord ingesteld of aanwezig in onze database voor dit account.",
      "No subscription set": "Er is geen abonnement ingesteld voor dit account!",
      "Package does not match subscription product": "Geconfigureerd pakket komt niet overeen met abonnement.",
      "Packages dont match": "Geconfigureerd pakket in cPanel komt niet overeen met Vision.",
      "Password": "Wachtwoord",
      "PrimaryDomain": "Hoofddomein",
      "PrimaryIP": "Primair IP-adres",
      "ServerUrl": "Server URL",
      "Show password": "Wachtwoord weergeven",
      "Status": "Status ",
      "StatusOptions": {
        "Active": "Actief",
        "Error": "Fout",
        "Pending": "In afwachting",
        "Suspended": "Geblokkeerd"
      },
      "Subscription": "Abonnement",
      "SubscriptionInfo": {
        "contractInfo": {
          "customer": "Klant"
        }
      },
      "Tabs": {
        "Domains": "Domeinen",
        "General": "Algemeen"
      },
      "Unlimited": "Onbeperkt",
      "Username": "Gebruikersnaam",
      "WebhostingPackage": "Hosting pakket"
    },
    "Webhosting-packages": {
      "Bandwidth": "Bandbreedte",
      "BandwidthMB": "Bandbreedte (MB)",
      "Delete": "verwijderen",
      "Delete item": "Hosting pakket verwijderen",
      "Delete item fail": "Fout bij het verwijderen van hosting pakket. {msg}",
      "Delete item success": "Hosting pakket succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je het hosting pakket {0} wilt {1}?",
      "Disk Space": "Schijfruimte",
      "DiskspaceMB": "Schijfgrootte (MB)",
      "Edit item": "Hosting pakket bewerken",
      "Edit item fail": "Fout bij het wijzigen van hosting pakket. {msg}",
      "Edit item success": "Hosting pakket succesvol gewijzigd.",
      "Name": "Naam",
      "New item": "Nieuw hosting pakket",
      "New item fail": "Fout bij het toevoegen van het hosting pakket. {msg}",
      "New item success": "Hosting pakket succesvol toegevoegd.",
      "Product": "Product",
      "SupplierPackageName": "Pakketnaam van leverancier",
      "Webhosting package": "Hosting pakket"
    },
    "Webhosting-send-account-details": {
      "Change password": "Wachtwoord wijzigen?",
      "Change password now": "Wijzig het wachtwoord in het cPanel-account",
      "Email address": "E-mail adres",
      "Mail details": "De gegevens van uw webhostingaccount worden naar het volgende e-mailadres gestuurd:",
      "New password": "Nieuw cPanel wachtwoord",
      "Randomize password": "Willekeurig wachtwoord maken",
      "Send account details item": "Accountgegevens verzenden",
      "Send account details item fail": "Het is niet mogelijk om accountgegevens te verzenden. {msg}",
      "Send account details item success": "Accountgegevens zijn succesvol verzonden.",
      "Send mail": "E-mail verzenden"
    },
    "Sharingcenter-calendars": {
      "Calendar": "Agenda",
      "Calendars": "Agenda | Agenda's",
      "Color": "Kleur",
      "CreatedAt": "Aangemaakt op",
      "Customer": "Klant",
      "Change owner": "Eigenaar wijzigen",
      "Delete": "verwijderen",
      "Delete item": "Agenda verwijderen",
      "Delete item fail": "De agenda kon niet worden verwijderd. {msg}",
      "Delete item success": "Agenda succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je de agenda {0} wilt {1}?",
      "Edit item": "Agenda bewerken",
      "Edit item fail": "Fout bij het wijzigen van de agenda. {msg}",
      "Edit item success": "Agenda succesvol gewijzigd.",
      "Groups": "Groepen",
      "Name": "Naam",
      "New item": "Nieuwe agenda",
      "New item fail": "Fout bij het toevoegen van de agenda. {msg}",
      "New item success": "Agenda succesvol toegevoegd.",
      "Owner": "Eigenaar",
      "Permissions": {
        "AvailabilityOnly": "Alleen beschikbaarheid",
        "Editor": "Bewerker",
        "Owner": "Eigenaar",
        "Viewer": "Lezer"
      },
      "Remove appointments": "Afspraken verwijderen",
      "Search": "Zoeken",
      "SharedWith": "Gedeeld met",
      "SharedWithGroups": "Gedeeld met groepen",
      "SharedWithUsers": "Gedeeld met gebruikers",
      "Tabs": {
        "General": "Algemeen"
      },
      "Take over appointments": "Afspraken overdragen aan nieuwe eigenaar",
      "UpdatedAt": "Bijgewerkt op",
      "User": "Eigenaar",
      "Users": "Gebruikers",
      "What to do with appointments": "Wat wilt u doen met de bestaande afspraken?"
    },
    "Sharingcenter-contacts": {
      "Cancel": "Annuleren",
      "Confirm owner or sharing change": "Wijziging van eigenaar of gedeelde instellingen",
      "Confirm owner or sharing text": "Het wijzigen van de eigenaar of gedeelde instellingen kan gevolgen hebben voor bestaande afspraken waarin dit contact wordt gebruikt.",
      "Contact": "Contact",
      "Contacts": "Contact | Contacten",
      "Continue": "Doorgaan",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Contact verwijderen",
      "Delete item fail": "Het contact kon niet worden verwijderd. {msg}",
      "Delete item success": "Contact succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je het contact {0} wilt {1}?",
      "Editor": "Bewerker",
      "Edit item": "Contact bewerken",
      "Edit item fail": "Fout bij het wijzigen van het contact. {msg}",
      "Edit item success": "Contact succesvol gewijzigd.",
      "Email": "E-mailadres",
      "FirstName": "Voornaam",
      "Groups": "Groepen",
      "Keep appointments unchanged": "Afspraken ongewijzigd laten",
      "LastName": "Achternaam",
      "New item": "Nieuw contact",
      "New item fail": "Fout bij het toevoegen van het contact. {msg}",
      "New item success": "Contact succesvol toegevoegd.",
      "Owner": "Eigenaar",
      "Phone": "Telefoon",
      "Resolve future appointments": "Toekomstige afspraken verwerken",
      "Search": "Zoeken",
      "SharedWith": "Gedeeld met",
      "SharedWithGroups": "Gedeeld met groepen",
      "SharedWithUsers": "Gedeeld met gebruikers",
      "Tabs": {
        "General": "Algemeen"
      },
      "This contact is linked to upcoming appointments, what would you like to do": "Dit contact is gekoppeld aan {count} toekomstige afspraak/afspraken. Wat wilt u doen?",
      "Update participants with new contact info": "Deelnemers bijwerken met nieuwe contactgegevens",
      "User": "Eigenaar",
      "Users": "Gebruikers",
      "Viewer": "Lezer"
    },
    "Sharingcenter-groups": {
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Groep verwijderen",
      "Delete item fail": "De groep kon niet worden verwijderd. {msg}",
      "Delete item success": "Groep succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je de groep {0} wilt {1}?",
      "Edit item": "Groep bewerken",
      "Edit item fail": "Fout bij het wijzigen van de groep. {msg}",
      "Edit item success": "Groep succesvol gewijzigd.",
      "Group": "Groep",
      "Groups": "Groep | Groepen",
      "Name": "Naam",
      "New item": "Nieuwe groep",
      "New item fail": "Fout bij het toevoegen van de groep. {msg}",
      "New item success": "Groep succesvol toegevoegd.",
      "Tabs": {
        "General": "Algemeen"
      },
      "Users": "Gebruikers"
    },
    "Sharingcenter-profiles": {
      "Cancel": "Annuleren",
      "Confirm owner or sharing change": "Wijziging van eigenaar of gedeelde instellingen",
      "Confirm owner or sharing text": "Het wijzigen van de eigenaar of gedeelde instellingen kan ertoe leiden dat dit profiel wordt ontkoppeld van bestaande afspraken.",
      "Continue": "Doorgaan",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete item": "Profiel verwijderen",
      "Delete item fail": "Het profiel kon niet worden verwijderd. {msg}",
      "Delete item success": "Profiel succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je het profiel {0} wilt {1}?",
      "Description": "Omschrijving",
      "Editor": "Bewerker",
      "Edit item": "Profiel bewerken",
      "Edit item fail": "Fout bij het wijzigen van het profiel. {msg}",
      "Edit item success": "Profiel succesvol gewijzigd.",
      "Groups": "Groepen",
      "IsPublic": "Openbaar",
      "Name": "Naam",
      "New item": "Nieuw profiel",
      "New item fail": "Fout bij het toevoegen van het profiel. {msg}",
      "New item success": "Profiel succesvol toegevoegd.",
      "Owner": "Eigenaar",
      "OwnerId": "Eigenaar",
      "Private": "Privé",
      "Profile": "Profiel",
      "Profiles": "Profiel | Profielen",
      "Public": "Openbaar",
      "Search": "Zoeken",
      "SharedWith": "Gedeeld met",
      "SharedWithGroups": "Gedeeld met groepen",
      "SharedWithUsers": "Gedeeld met gebruikers",
      "Tabs": {
        "General": "Algemeen",
        "Settings": "Instellingen"
      },
      "Type": "Type",
      "TypeOptions": {
        "Fileshare": "Bestanden delen",
        "Screenshare": "Scherm delen",
        "Chat": "Chat",
        "Meeting": "Vergadering"
      },
      "User": "Eigenaar",
      "Users": "Gebruikers",
      "Viewer": "Lezer"
    },
    "Sharingcenter-meeting-logs": {
      "Customer": "Klant",
      "Status": "Status"
    },
    "Sharingcenter-ai-queue": {
      "Status": "Status",
      "TaskType": "Taak"
    },
    "MicrosoftSignInMonitor": {
      "cardHints": {
        "total": "Unieke Microsoft-tenants van actieve klanten waarvoor de Graph-koppeling is ingeschakeld. Iedere tenant telt één keer mee.",
        "available": "Monitoring is beschikbaar en de laatste geslaagde Graph-controle is maximaal 30 minuten oud.",
        "license": "Graph geeft aan dat de vereiste licentie ontbreekt. De monitor probeert het na 24 uur opnieuw, zonder storingsmail. Deze tenants tellen niet mee bij Aandacht nodig.",
        "attention": "Monitoring is niet beschikbaar, de laatste geslaagde controle is ouder dan 30 minuten, of er is nog geen monitoringstatus bekend. Na een geslaagde controle verdwijnt de tenant uit deze teller. Vernieuw het overzicht om de nieuwste status te zien."
      },
      "all": "Alle",
      "title": "Microsoft-aanmeldmonitor",
      "refresh": "Vernieuwen",
      "updated": "Bijgewerkt om {time}",
      "overview": "Tenantstatus",
      "history": "Aanmeldhistorie",
      "scope": "Controle op azure-admin en omni-break-glass-accounts. De historie bevat ook meldingen over de beschikbaarheid van de monitor.",
      "total": "Ingestelde tenants",
      "available": "Actieve monitoring",
      "license": "Licentiebeperking",
      "attention": "Aandacht nodig",
      "search": "Zoek klant, tenant of account",
      "StatusFilter": "Monitoringstatus",
      "KindFilter": "Gebeurtenis",
      "DeliveryFilter": "Verzending",
      "Period": "Periode",
      "days": "Afgelopen {count} dagen",
      "customer": "Klant / tenant",
      "status": "Monitoringstatus",
      "lastSuccess": "Laatste geslaagde controle",
      "lastFailure": "Laatste mislukte controle",
      "nextPoll": "Geplande hercontrole",
      "regularPoll": "Normaal controleschema",
      "notChecked": "Nog niet gecontroleerd",
      "openHistory": "Bekijk historie",
      "time": "Tijdstip",
      "account": "Account / gebeurtenis",
      "result": "Resultaat",
      "delivery": "Verzending",
      "noRows": "Geen resultaten",
      "noRowsHint": "Er zijn geen gegevens die overeenkomen met deze selectie.",
      "error": "De monitorgegevens konden niet worden geladen. Probeer het opnieuw.",
      "retry": "Opnieuw proberen",
      "forbidden": "Je hebt geen toegang tot de Microsoft-aanmeldmonitor.",
      "policy": "Bij een licentiebeperking volgt na 24 uur een nieuwe poging, zonder storingsmail. Als monitoring mogelijk wordt, volgt een eenmalige melding.",
      "staleHint": "Een geslaagde controle ouder dan 30 minuten wordt als verouderd getoond. Vernieuwen haalt het opgeslagen overzicht op.",
      "historyHint": "Gebeurtenissen blijven 90 dagen bewaard. Verzendstatus toont of de mailverwerking de melding heeft verzonden.",
      "tenantFilter": "Historie van {name}",
      "clearTenant": "Alle tenants",
      "details": "Gebeurtenisdetails",
      "close": "Sluiten",
      "eventId": "Gebeurtenis-ID",
      "tenantId": "Tenant-ID",
      "detectedAt": "Waargenomen",
      "sentAt": "Verzonden op",
      "queuedAt": "In wachtrij sinds",
      "app": "Applicatie",
      "resource": "Resource",
      "ip": "IP-adres",
      "location": "Locatie",
      "reason": "Reden / toelichting",
      "errorCode": "Foutcode",
      "interactive": "Interactieve aanmelding",
      "yes": "Ja",
      "no": "Nee",
      "unknown": "Niet beschikbaar",
      "delay": "Vertraging",
      "seconds": "{count} seconden",
      "success": "Geslaagd",
      "failed": "Niet geslaagd",
      "intermediate": "Tussenstap",
      "statuses": {
        "available": "Actief",
        "license-restricted": "Licentiebeperking",
        "unavailable": "Niet beschikbaar",
        "waiting": "Nog niet gecontroleerd",
        "stale": "Controle verouderd"
      },
      "kinds": {
        "sign-in": "Aanmelding",
        "availability": "Monitoring actief",
        "health": "Monitoring niet beschikbaar",
        "recovery": "Monitoring hersteld"
      },
      "deliveries": {
        "sent": "Verzonden",
        "queued": "In wachtrij",
        "pending": "Nog te verzenden",
        "suppressed": "Geen melding"
      },
      "suppressedHint": "De keuze om aangemeld te blijven (50140) is een tussenstap en krijgt geen melding.",
      "searchTenant": "Zoek klant of tenant",
      "diagnostics": {
        "stage": "Mislukte stap",
        "code": "Technische foutcode",
        "action": "Vervolgactie",
        "current": "Laatste fout",
        "stages": {
          "token": "Token aanvragen",
          "graph": "Aanmeldingen ophalen",
          "monitor": "Aanmeldcontrole"
        },
        "reasons": {
          "TIMEOUT": "Microsoft reageerde niet binnen 60 seconden.",
          "DNS": "De Microsoft-hostnaam kon niet worden opgezocht.",
          "CONNECTION": "De verbinding met Microsoft is geweigerd of onderbroken.",
          "TLS": "De beveiligde verbinding met Microsoft kon niet worden geverifieerd.",
          "SOURCE_ERROR": "De controle mislukte zonder nader vastgelegde oorzaak.",
          "INVALID_JSON": "Microsoft gaf geen geldig JSON-antwoord.",
          "SECRET_EXPIRED": "Het clientsecret van de Microsoft-appregistratie is verlopen (AADSTS7000222).",
          "SECRET_INVALID": "Microsoft weigert het clientsecret (AADSTS7000215).",
          "APP_NOT_FOUND": "De appregistratie is niet gevonden in de ingestelde tenant (AADSTS700016).",
          "CONFIGURATION_MISSING": "Tenant-ID, app-ID of clientsecret ontbreekt.",
          "CONFIGURATION_INVALID": "De Microsoft Graph-configuratie is ongeldig.",
          "TOKEN_MISSING": "Microsoft gaf geen toegangstoken terug.",
          "INVALID_RESPONSE": "Microsoft gaf geen geldige lijst met aanmeldingen terug.",
          "INVALID_NEXT_LINK": "Microsoft gaf een ongeldige vervolgpagina terug.",
          "INVALID_EVENT": "Een aanmeldgebeurtenis bevat ongeldige gegevens.",
          "LEASE_LOST": "De monitor verloor de exclusieve verwerking van deze controle.",
          "STORAGE_ERROR": "Aanmeldgegevens konden niet worden opgeslagen.",
          "LICENSE_RESTRICTED": "Microsoft staat het ophalen van aanmeldingen niet toe door een licentie- of toegangsbeperking.",
          "UNAUTHORIZED": "Microsoft weigert de authenticatie (HTTP {status}).",
          "FORBIDDEN": "Microsoft weigert toegang (HTTP {status}).",
          "THROTTLED": "Microsoft begrenst het aantal aanvragen (HTTP {status}).",
          "SERVER_ERROR": "Microsoft meldt een serverfout (HTTP {status}).",
          "HTTP_ERROR": "Microsoft weigert de aanvraag (HTTP {status})."
        },
        "actions": {
          "TIMEOUT": "Controleer de verbinding en de beschikbaarheid van Microsoft. De monitor probeert opnieuw.",
          "DNS": "Controleer DNS en de netwerkverbinding van de Vision-server.",
          "CONNECTION": "Controleer netwerk, proxy en firewall. De monitor probeert opnieuw.",
          "TLS": "Controleer certificaten, systeemtijd en eventuele TLS-inspectie.",
          "SOURCE_ERROR": "De precieze oorzaak van deze melding is niet meer te bepalen. Bekijk de actuele tenantstatus of een volgende controle voor een specifiekere diagnose.",
          "INVALID_JSON": "Controleer de beschikbaarheid van Microsoft en eventuele proxyfouten.",
          "SECRET_EXPIRED": "Vernieuw het secret en werk de Graph-integratie in Vision bij.",
          "SECRET_INVALID": "Controleer de secretwaarde in de Graph-integratie en de appregistratie.",
          "APP_NOT_FOUND": "Controleer tenant-ID, app-ID en toestemming voor de app.",
          "CONFIGURATION_MISSING": "Vul de Microsoft Graph-integratie voor deze klant aan.",
          "CONFIGURATION_INVALID": "Controleer de ingestelde endpoints en scope.",
          "TOKEN_MISSING": "Controleer de appregistratie en de Graph-integratie.",
          "INVALID_RESPONSE": "De controle is niet als geslaagd verwerkt. Controleer de Microsoft-dienst.",
          "INVALID_NEXT_LINK": "De monitor heeft deze geweigerd. De controle wordt opnieuw geprobeerd.",
          "INVALID_EVENT": "Het controlepunt is niet verplaatst. Onderzoek de brongegevens.",
          "LEASE_LOST": "Controleer de jobs en databaseverbinding.",
          "STORAGE_ERROR": "Controleer de database en validatie. Het controlepunt is niet verplaatst.",
          "LICENSE_RESTRICTED": "Controleer de Entra-licentie. Een nieuwe controle volgt na 24 uur.",
          "UNAUTHORIZED": "Controleer de appregistratie en Graph-integratie.",
          "FORBIDDEN": "Controleer Graph-rechten, beheerderstoestemming en licentievoorwaarden.",
          "THROTTLED": "De monitor probeert opnieuw bij de volgende controle.",
          "SERVER_ERROR": "Controleer de beschikbaarheid van Microsoft. De monitor probeert opnieuw.",
          "HTTP_ERROR": "Controleer de Graph-configuratie en de ondersteunde aanvraag."
        }
      }
    },
    "AdminApiAccounts": {
      "Accounts": "Admin-API-accounts",
      "Customer accounts": "Klantaccounts",
      "Admin accounts": "Adminaccounts",
      "Account": "Admin-API-account",
      "New account": "Nieuw adminaccount",
      "Scope explanation": "Deze API-accounts werken zonder klantkoppeling. Geef alleen de interne rollen die de integratie nodig heeft.",
      "Rotate token": "API-token vernieuwen",
      "Delete account": "Adminaccount verwijderen",
      "Rotate confirmation": "API-token van {name} vernieuwen? Het huidige token en de daarmee uitgegeven toegangstokens worden direct ongeldig.",
      "Delete confirmation": "Adminaccount {name} verwijderen? De API-toegang wordt direct ingetrokken."
    },
    "Stock-movements": {
      "Type": "Mutatiesoort",
      "StockInfo": {
        "product": "Product"
      },
      "New item": "Voorraadactie",
      "Edit item": "Voorraadactie",
      "View item": "Voorraadmutaties",
      "Receive": "Binnenmelden",
      "Product": "Product",
      "PurchaseDate": "Aanschafdatum",
      "Amount": "Aantal",
      "RegistrationMode": "Registratie",
      "Location": "Locatie",
      "Position": "Vak",
      "SupplierWarranty": "Leveranciersgarantie",
      "CustomerWarranty": "Klantgarantie",
      "StartDate": "Begindatum",
      "DurationMonths": "Termijn in maanden",
      "ScanInput": "Serienummer scannen",
      "PasteInput": "Serienummers plakken, één per regel",
      "Customer": "Ontvanger / klant",
      "SalesOrder": "Verkooporder",
      "SalesOrderLine": "Verkooporderregel",
      "DeliveryMode": "Klantlevering",
      "RelatedMovement": "Oorspronkelijke uitgifte",
      "AllowReallocation": "Expliciet herbestemmen",
      "Reason": "Reden",
      "Memo": "Voorraadnotitie",
      "Errors": {
        "ErrorCode": {
          "STOCK_PRICES_UNKNOWN": "De inkoop- of verkoopprijs op de inkoopdatum ontbreekt. Vul de ontbrekende prijs aan voordat je de ontvangst boekt."
        }
      }
    },
    "Stock-locations": {
      "New item": "Nieuwe voorraadlocatie",
      "Edit item": "Voorraadlocatie",
      "View item": "Voorraadlocatie",
      "Name": "Naam",
      "Description": "Omschrijving",
      "Customer": "Klant",
      "Positions": "Vakken",
      "Add Positions item": "Vak toevoegen",
      "Delete Positions item": "Vak verwijderen"
    },
    "Logistics": {
      "Internal": "Intern",
      "Customer stock": "Klantvoorraad",
      "Unknown": "Onbekend",
      "Months": "maanden",
      "Asset": "Asset",
      "Warranties": "Garanties",
      "History": "Historie",
      "Stock details": "Voorraaddetails",
      "Show empty stock": "Ook uitgegeven voorraad tonen",
      "Open details": "Details openen",
      "Open tracking": "Zending bekijken",
      "Quantity registration": "Op aantal",
      "Saved": "De gegevens zijn opgeslagen.",
      "Asset details": "Assetgegevens",
      "Receipt details": "Ontvangst",
      "Last delivery": "Laatste levering",
      "Current warehouse position": "Huidige magazijnpositie",
      "Last warehouse position": "Laatste magazijnpositie",
      "Write-off date": "Afschrijfdatum",
      "Open sales order": "Verkooporder openen",
      "Open purchase order": "Inkooporder openen",
      "Source location": "Van locatie",
      "Source position": "Van vak",
      "Destination location": "Naar locatie",
      "Destination position": "Naar vak",
      "Returned by": "Retour van",
      "Source warehouse position": "Van locatie / vak",
      "Destination warehouse position": "Naar locatie / vak",
      "No warehouse position": "Geen huidige magazijnpositie",
      "Location explanation": "Vakken horen bij deze locatie. Zonder klant is de voorraad intern; met een klant is zij voor die klant bestemd. Bezette vakken blijven behouden.",
      "Order explanation": "Productcode en leveranciers-URL blijven bij het product. Voor sluiten of annuleren geef je per regel het resterende geannuleerde aantal en een reden op. Ontvangen aantallen blijven behouden.",
      "Warranty explanation": "Leveranciersgarantie en klantgarantie hebben een eigen begindatum en termijn. Leeg betekent een onbekende termijn; 0 betekent geen garantie. Klantgarantie start bij de bijbehorende klantlevering.",
      "Fields": {
        "Name": "Naam",
        "Number": "Nummer",
        "Product": "Product",
        "Date": "Datum",
        "Booked on": "Geboekt op",
        "Status": "Status",
        "Type": "Type",
        "Customer": "Klant",
        "Positions": "Vakken",
        "Location": "Locatie",
        "Position": "Vak",
        "Amount": "Aantal",
        "Total": "Totaal aanwezig",
        "Received": "Ontvangen",
        "Remaining": "Resterend",
        "Tracking": "Track-and-trace",
        "Serial": "Serienummer",
        "Previous serial": "Oud serienummer",
        "New serial": "Nieuw serienummer",
        "Situation": "Situatie",
        "Where": "Opslagplek / laatste ontvanger",
        "Purchase date": "Aanschafdatum",
        "Purchase price": "Inkoopprijs",
        "Sales price": "Verkoopprijs",
        "Balance": "Stand voor / na",
        "Reason": "Reden",
        "Delivery date": "Uitleverdatum",
        "Received date": "Ontvangstdatum",
        "Delivered to": "Levering aan",
        "Sales order": "Verkooporder",
        "Warranty end": "Einddatum",
        "Delivery reference": "Levering",
        "Actor": "Gebruiker"
      },
      "Errors": {
        "Load": "De gegevens konden niet worden geladen.",
        "Save": "Opslaan is niet gelukt.",
        "Required": "Vul de verplichte velden in.",
        "Duplicate positions": "Vaknamen moeten uniek zijn binnen deze locatie.",
        "Received line": "Een ontvangen productregel kan niet worden verwijderd.",
        "Order lines": "Controleer de datum, producten, aantallen en annuleringsredenen.",
        "Tracking URL": "Gebruik een volledige http- of https-URL.",
        "Warranty": "Vul beide begindatums in en gebruik een geheel aantal maanden vanaf 0, of laat de termijn leeg.",
        "Duplicate serial": "Serienummer {serial} staat al in deze ontvangst.",
        "Serial count": "Het aantal serienummers mag het te ontvangen aantal niet overschrijden.",
        "Registered serial": "Serienummer {serial} is al geregistreerd. Gebruik retour voor een teruggekomen asset.",
        "Serial check": "De serienummers konden niet worden gecontroleerd. Je invoer is behouden.",
        "Receipt selection": "Vink minimaal één product aan om nu binnen te melden.",
        "Receipt fields": "Controleer de gemarkeerde velden in deze productregel.",
        "Receipt product": "Kies het product dat je binnenmeldt.",
        "Receipt purchase date": "Vul een geldige aanschafdatum in, of laat een onbekende datum leeg.",
        "Receipt amount": "Vul een geheel aantal van minimaal 1 in. Meld je dit product nu niet binnen? Vink de productregel uit.",
        "Receipt maximum": "Je kunt nog maximaal {remaining} binnenmelden.",
        "Receipt location": "Kies een voorraadlocatie.",
        "Receipt position": "Kies een geldig vak binnen de geselecteerde locatie.",
        "Receipt allocation total": "Je hebt {allocated} verdeeld, maar meldt {amount} binnen. Verdeel precies {amount} over de opslagplekken.",
        "Receipt serial count": "Je hebt {count} serienummers toegevoegd, maar meldt {amount} binnen. Voeg precies {amount} serienummers toe of pas het aantal aan.",
        "Warranty start": "Vul een geldige begindatum van deze garantie in.",
        "Warranty duration": "Gebruik een geheel aantal maanden van 0 tot en met 1200, of laat de termijn leeg.",
        "Action quantity": "Gebruik een geldig geheel aantal dat past bij de beschikbare voorraad.",
        "Reason": "Vul een reden in voor deze voorraadactie.",
        "Placement": "Kies een locatie met een geldig vak.",
        "Related issue": "Kies de bijbehorende oorspronkelijke uitgifte.",
        "Sales order customer": "Kies eerst een klant en daarna een bijbehorende verkooporder.",
        "Sales order line": "Kies een passende productregel bij de geselecteerde verkooporder.",
        "Stock changed": "Dit item is intussen gewijzigd of verplaatst. Vernieuw de voorraad en probeer opnieuw.",
        "Serial required": "Vul een serienummer in.",
        "Serial duplicate": "Dit serienummer is al geregistreerd voor dit product.",
        "Supplier required": "Kies een leverancier."
      },
      "Order statuses": {
        "open": "Open",
        "ordered": "Besteld",
        "partially_received": "Deels ontvangen",
        "received": "Ontvangen",
        "closed": "Gesloten",
        "cancelled": "Geannuleerd"
      },
      "Situations": {
        "in_stock": "Op voorraad",
        "reserved": "Gereserveerd",
        "issued": "Uitgegeven",
        "written_off": "Afgeschreven",
        "unknown": "Onbekend"
      },
      "Warranty statuses": {
        "valid": "Geldig",
        "expired": "Verlopen",
        "not_started": "Nog niet gestart",
        "none": "Geen garantie",
        "unknown": "Onbekend",
        "expiring_soon": "Verloopt binnen 30 dagen"
      },
      "Warranty kinds": {
        "supplier": "Leveranciersgarantie",
        "customer": "Klantgarantie"
      },
      "Warranty reasons": {
        "changed": "Aangepast",
        "new_delivery": "Nieuwe klantlevering"
      },
      "Movement types": {
        "receipt": "Ontvangst",
        "opening": "Beginvoorraad",
        "issue": "Uitgifte",
        "transfer": "Verplaatsing",
        "return": "Retour",
        "adjustment": "Correctie",
        "write_off": "Afschrijving",
        "reserve": "Reserveren",
        "release": "Reservering vrijgeven"
      },
      "Serial registration": "Met serienummers",
      "Receive": "Binnenmelden",
      "Opening stock": "Beginvoorraad invoeren",
      "Opening explanation": "Registreer bestaande voorraad zonder inkooporder. Laat een onbekende aanschafdatum leeg. Kies per product aantallen of serienummers.",
      "Receipt selection explanation": "Vink alleen de producten aan die nu geleverd zijn. Vink de overige regels uit; die blijven open voor een volgende levering.",
      "Select receipt line": "Binnenmelden: {product}",
      "Not receiving now": "Nu niet binnenmelden",
      "Add product line": "Productregel toevoegen",
      "Remove line": "Productregel verwijderen",
      "Line progress": "{amount} binnenmelden van {remaining} resterend",
      "Scan and paste": "Scannen en plakken",
      "Scan label": "Scan of typ een serienummer en druk op Enter",
      "Serial progress": "{count} van {amount}",
      "Add pasted serials": "Geplakte serienummers toevoegen",
      "Remove serial": "Serienummer verwijderen",
      "Add allocation": "Opslagplek toevoegen",
      "Remove allocation": "Opslagplek verwijderen",
      "Default serial placement": "Opslagplek voor nieuwe serienummers (optioneel)",
      "Default serial placement explanation": "Deze opslagplek wordt ingevuld bij het toevoegen van een serienummer. Pas de plek daarna direct per toestel aan; bestaande toestellen wijzigen niet mee.",
      "Individual warranties": "Individuele garanties",
      "Shared warranties": "Gezamenlijke garanties",
      "Override warranties": "Individuele garanties aanpassen",
      "Use shared warranties": "Gezamenlijke garanties gebruiken",
      "Review": "Controleren",
      "Review receipt": "Controleer de producten, aantallen, opslagplekken en garanties voordat je deze ontvangst boekt.",
      "Confirm receipt": "Ontvangst boeken",
      "Review action": "Controleer de gegevens voordat je deze voorraadactie boekt.",
      "Confirm action": "Voorraadactie boeken",
      "Booked": "De voorraadactie is geboekt.",
      "Pending actions": "Onvoltooide voorraadacties",
      "Pending explanation": "De boeking is nog niet bevestigd. Hervat dezelfde aanvraag om de verwerking af te ronden; de oorspronkelijke invoer blijft behouden.",
      "No pending actions": "Er zijn geen onvoltooide voorraadacties.",
      "Resume": "Hervatten",
      "New delivery": "Nieuwe klantlevering",
      "Same delivery": "Dezelfde oorspronkelijke klantlevering, garantie behouden",
      "Stock actions": "Voorraadacties",
      "Allocation change": "Bestemming wijzigt van {from} naar {to}; geef hiervoor een reden op.",
      "Adjustment explanation": "Voer de verandering in: een positief aantal voegt voorraad toe, een negatief aantal haalt voorraad weg. Een reden is verplicht.",
      "Issue explanation": "Uitgifte voor een verkooporder gebruikt de reservering van de gekozen orderregel. Facturatie gebeurt bij verwerken van de verkooporder.",
      "Save asset before stock action": "Sla de gewijzigde assetgegevens eerst op voordat je een voorraadactie uitvoert.",
      "Edit stock note": "Voorraadnotitie aanpassen",
      "Open delivery": "Levering bekijken",
      "All movements": "Alle mutaties",
      "Save order before receipt": "Sla de gewijzigde inkooporder eerst op voordat je producten binnenmeldt.",
      "Manage stock": "Voorraad beheren",
      "Stock registration label": "{amount} stuks · {date}",
      "Stock note": "Voorraadnotitie",
      "Asset note": "Assetnotitie",
      "Stock items": "Voorraaditems",
      "Search stock items": "Zoek een item of serienummer",
      "Selected stock amount": "{records} regels geselecteerd · {amount} stuks",
      "Select stock item": "Selecteer voorraaditem {item}",
      "Unsaved stock changes": "Je hebt niet-opgeslagen wijzigingen. Sla ze op of verwerp ze voordat je een ander item kiest of een voorraadactie uitvoert.",
      "Discard stock changes": "Wijzigingen verwerpen",
      "No stock remaining": "Van dit item is geen voorraad meer aanwezig. De registratie en historie blijven behouden.",
      "Data": "Gegevens",
      "Serial corrections": "Serienummercorrecties",
      "Warranty history": "Garantiehistorie",
      "Choose stock": "Voorraad kiezen",
      "Change stock selection": "Voorraadselectie wijzigen",
      "Stock choice count": "{selected} van {ordered} stuk gekozen | {selected} van {ordered} stuks gekozen",
      "Stock availability": "Aanwezig: {present} · Gereserveerd: {reserved} · Beschikbaar: {available}",
      "Reserved amount": "Gereserveerd: {amount}",
      "Reserved for order": "{amount} stuks gereserveerd voor verkooporder {order}",
      "Reserved stock explanation": "Deze voorraad is aanwezig, maar gekoppeld aan een verkooporder. Uitgifte gebruikt die koppeling; vrijgeven of wijzigen kan vanuit de verkooporder.",
      "Reserve available stock": "Alleen vrij beschikbare voorraad wordt geselecteerd voor een nieuwe reservering. Kies een orderregel zonder bestaande koppeling aan deze items; wijzig een bestaande koppeling vanuit de verkooporder.",
      "No available stock": "Geen voorraad gevonden",
      "Shared customer warranty": "Gezamenlijke klantgarantie",
      "Apply to selected assets": "Toepassen op geselecteerde toestellen",
      "Link stock": "Voorraad koppelen",
      "Clear stock selection": "Voorraadselectie wissen",
      "Linked stock amount": "Uit voorraad gekoppeld: {amount}",
      "Issued stock amount": "Al uit voorraad uitgegeven: {amount}",
      "Reserved": "Gereserveerd",
      "Available": "Beschikbaar",
      "Unknown warranty duration": "termijn onbekend",
      "No warranty": "geen garantie",
      "Warranty through": "t/m",
      "Warranty duration": "{count} maand | {count} maanden",
      "Serial number": "Serienummer",
      "Customer warranty": "Klantgarantie",
      "Individual warranty explanation": "Bestaande garantie-instellingen blijven per toestel behouden. Wijzig de onderstaande garantievelden om deze instellingen op alle geselecteerde toestellen toe te passen. De controle toont de periode per toestel.",
      "Order line choice": "{description} · {amount} stuks | {description} · {amount} stuk | {description} · {amount} stuks",
      "Add order line": "Productregel toevoegen",
      "No matching order line": "Deze verkooporder heeft geen passende openstaande regel voor dit product.",
      "Stock choice availability": "Aanwezig: {present} · Gereserveerd: {reserved} · Te kiezen voor deze regel: {available}"
    },
    "Purchase-orders": {
      "New item": "Nieuwe inkooporder",
      "Edit item": "Inkooporder",
      "View item": "Inkooporder",
      "Date": "Inkoopdatum",
      "OrderReference": "Bestelreferentie",
      "ExpectedDeliveryDate": "Verwachte leverdatum",
      "TrackingUrl": "Track-and-trace-URL",
      "Description": "Omschrijving",
      "Memo": "Interne notities",
      "Status": "Status",
      "Products": "Productregels",
      "Product": "Product",
      "Amount": "Aantal",
      "CancelledAmount": "Geannuleerd",
      "CancellationReason": "Annuleringsreden",
      "Add Products item": "Productregel toevoegen",
      "Delete Products item": "Productregel verwijderen",
      "ReceiptInfo": {
        "status": "Status"
      },
      "SupplierProductUrl": "Leveranciersproduct openen",
      "Tabs": {
        "General": "Algemeen",
        "Products": "Producten"
      },
      "Supplier": "Leverancier"
    },
    "Assets": {
      "New item": "Asset",
      "Edit item": "Assetbeheer",
      "View item": "Assetbeheer",
      "Product": "Product",
      "Memo": "Notities",
      "SupplierWarranty": "Leveranciersgarantie",
      "CustomerWarranty": "Klantgarantie",
      "StartDate": "Begindatum",
      "DurationMonths": "Termijn in maanden",
      "LogisticsInfo": {
        "location": "Locatie",
        "customer": "Klant",
        "situation": "Situatie",
        "supplierWarrantyStatus": "Leveranciersgarantie",
        "customerWarrantyStatus": "Klantgarantie"
      },
      "SerialNumber": "Serienummer"
    },
    "Stock": {
      "New item": "Beginvoorraad",
      "Edit item": "Voorraad",
      "View item": "Voorraad",
      "Product": "Product",
      "Location": "Locatie",
      "Memo": "Notities",
      "LocationInfo": {
        "customer": "Klant"
      },
      "Scope": "Bestemming",
      "PurchaseDateFrom": "Aanschafdatum",
      "PurchaseDateUntil": "Aanschafdatum t/m",
      "UnknownPurchaseDate": "Onbekende aanschafdatum",
      "Position": "Vak"
    },
    "Webhooks": {
      "Name": "Naam",
      "Scope": "Bereik",
      "Customer": "Klant",
      "Service": "Service",
      "Events": "Gebeurtenissen",
      "Url": "URL",
      "Active": "Actief",
      "Webhooks": "Webhooks",
      "ScopeOptions": {
        "Customer": "Eén klant",
        "Global": "Alle klanten"
      },
      "EventsOptions": {
        "Create": "Aanmaken",
        "Patch": "Wijzigen"
      },
      "New item": "Nieuwe webhook",
      "Edit item": "Webhook aanpassen",
      "View item": "Webhook bekijken",
      "Delete item": "Webhook verwijderen",
      "New item success": "Webhook toegevoegd.",
      "Edit item success": "Webhook opgeslagen.",
      "Delete item success": "Webhook verwijderd.",
      "New item fail": "Webhook toevoegen mislukt.",
      "Edit item fail": "Webhook opslaan mislukt.",
      "Delete item fail": "Webhook verwijderen mislukt.",
      "Summary": {
        "totalConfigurations": "Configuraties totaal",
        "active": "Actieve webhooks",
        "inactive": "Uitgeschakelde webhooks",
        "global": "Globale webhooks",
        "totalDeliveries": "Afleveringen totaal",
        "delivered": "Afgeleverd",
        "pending": "In behandeling",
        "failed": "Mislukt",
        "cancelled": "Geannuleerd",
        "totalAttempts": "Pogingen totaal",
        "retry": "Opnieuw proberen"
      },
      "SummaryLoadFailed": "De samenvatting of filters konden niet worden vernieuwd. Probeer opnieuw."
    },
    "Webhook-queue": {
      "Name": "Naam",
      "Scope": "Bereik",
      "Customer": "Klant",
      "Service": "Service",
      "Events": "Gebeurtenissen",
      "DestinationHost": "Bestemming",
      "Active": "Actief",
      "WebhookName": "Webhook",
      "Method": "Gebeurtenis",
      "Status": "Status",
      "Attempts": "Pogingen",
      "Attempt": "Poging",
      "StatusCode": "HTTP-status",
      "ErrorCode": "Foutcode",
      "CreatedAt": "Tijdstip",
      "Webhook": "Webhook",
      "Webhooks": "Webhooks",
      "View item": "Webhook-aflevering bekijken"
    },
    "Webhook-logs": {
      "Name": "Naam",
      "Scope": "Bereik",
      "Customer": "Klant",
      "Service": "Service",
      "Events": "Gebeurtenissen",
      "DestinationHost": "Bestemming",
      "Active": "Actief",
      "WebhookName": "Webhook",
      "Method": "Gebeurtenis",
      "Status": "Status",
      "Attempts": "Pogingen",
      "Attempt": "Poging",
      "StatusCode": "HTTP-status",
      "ErrorCode": "Foutcode",
      "CreatedAt": "Tijdstip",
      "Webhook": "Webhook",
      "Webhooks": "Webhooks",
      "View item": "Webhooklog bekijken"
    },
    "Supplier-contacts": {
      "Address": "Adres",
      "Address information": "Adresgegevens",
      "Birthday": "Geboortedatum",
      "City": "Plaats",
      "Comments": "Opmerkingen",
      "Contact": "Contact",
      "Country": "Land",
      "Supplier": "Leverancier",
      "Supplier address": "Leverancier adres",
      "Delete": "verwijderen",
      "Delete item": "Leveranciercontact verwijderen",
      "Delete item fail": "Het verwijderen van leveranciercontact is mislukt. {msg}",
      "Delete item success": "Leveranciercontact succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u leverancier contact {0} wilt {1}?",
      "Edit item": "Leveranciercontact bewerken",
      "Edit item fail": "Fout bij het wijzigen van het contact. {msg}",
      "Edit item success": "Leveranciercontact succesvol gewijzigd.",
      "EmailAddress": "E-mail adres",
      "Export": "Exporteer",
      "FirstName": "Voornaam",
      "Initials": "Initialen",
      "InvoiceReference": "Referentie factuur",
      "JobTitle": "Functietitel",
      "Labels": "Labels",
      "LastName": "Achternaam",
      "Name": "Naam",
      "New item": "Nieuw contact",
      "New item fail": "Het is niet gelukt om nieuw leveranciercontact aan te maken. {msg}",
      "New item success": "Leveranciercontact succesvol toegevoegd.",
      "No labels": "Geen labels",
      "OverwriteAddress": "Adres overschrijven",
      "Phone": "Telefoonnummer",
      "Salutation": "Aanhef",
      "SalutationOptions": {
        "D": "Afdeling",
        "F": "Vrouw",
        "M": "Man",
        "U": "Niet opgegeven"
      },
      "SendMail": "Verstuur e-mail",
      "Tabs": {
        "General": "Algemeen"
      },
      "Zipcode": "Postcode"
    },
    "Suppliers": {
      "Address": "Adres",
      "ContactInfo": "@:Admin.Customers.ContactInfo",
      "Archived": "Gearchiveerd",
      "IsArchived": "Gearchiveerd",
      "City": "Plaats",
      "CocNumber": "KvK-nummer",
      "Comments": "Opmerkingen",
      "Country": "Land",
      "InvoiceContact": "Factuur contactpersoon",
      "Labels": "Labels",
      "LegalForm": "Rechtsvorm",
      "LegalFormOptions": {
        "Bv": "BV",
        "Coop": "Cooperatie",
        "Cv": "CV",
        "Eenmanszaak": "Eenmanszaak",
        "Nv": "NV",
        "Other": "Anders",
        "Stichting": "Stichting",
        "Vereniging": "Vereniging",
        "Vof": "VoF"
      },
      "Name": "Naam",
      "OfferContact": "Offerte contactpersoon",
      "PrimaryContact": "Primair contactpersoon",
      "TaxNumber": "BTW-nummer",
      "Website": "Website",
      "Zipcode": "Postcode",
      "Delete": "verwijderen",
      "Delete item": "Leverancier verwijderen",
      "Delete item fail": "De leverancier kon niet worden verwijderd. {msg}",
      "Delete item success": "Leverancier succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je de leverancier {0} wilt {1}?",
      "Edit item": "Leverancier wijzigen",
      "Edit item fail": "Fout bij het wijzigen van de leverancier. {msg}",
      "Edit item success": "Leverancier succesvol gewijzigd.",
      "New item": "Nieuwe leverancier",
      "New item fail": "Fout bij het aanmaken van de leverancier. {msg}",
      "New item success": "Leverancier succesvol toegevoegd.",
      "Export": "Exporteer",
      "No labels": "Geen labels",
      "Criticality": "Kriticiteit",
      "IsmsRelevance": "ISMS-relevantie",
      "RelevanceReason": "Onderbouwing ISMS-scope",
      "CriticalityReason": "Onderbouwing criticiteit",
      "Activated": "Functie geactiveerd",
      "ServiceName": "Dienstnaam",
      "ContractReference": "Contractreferentie",
      "ContractOwner": "Contractpartij",
      "AccountOwner": "Accounteigenaar",
      "StartDate": "Begindatum",
      "EndDate": "Einddatum",
      "DecisionDate": "Beslisdatum verlenging",
      "NoticePeriod": "Opzegtermijn",
      "AutomaticRenewal": "Automatische verlenging",
      "Archive": "archiveren",
      "Errors": {
        "SUPPLIER_ARCHIVE_BLOCKED": "Deze leverancier kan nog niet worden gearchiveerd. Handel eerst de onderstaande inkooporders, diensten en contractafspraken of beoordelingen af."
      }
    },
    "SupplierManagement": {
      "General": "Algemeen",
      "Contacts": "Contacten",
      "Assessments": "Beoordelingen",
      "Assessment": "Leveranciersbeoordeling",
      "Documents": "Documenten",
      "Save before contacts": "Sla de leverancier eerst op om contacten toe te voegen.",
      "ISMS scope": "ISMS-relevantie",
      "Services and contracts": "Diensten en contractafspraken",
      "New service": "Nieuwe dienst",
      "Add service": "Dienst toevoegen",
      "Service name": "Dienstnaam",
      "Contract reference": "Contractreferentie",
      "Contract owner": "Contractpartij",
      "Account owner": "Accounteigenaar",
      "Start date": "Begindatum",
      "End date": "Einddatum",
      "Decision date": "Beslisdatum verlenging",
      "Notice period": "Opzegtermijn",
      "Automatic renewal": "Automatische verlenging",
      "Remove service": "Dienst verwijderen",
      "Required": "Dit veld is verplicht",
      "Saved": "Opgeslagen",
      "Save failed": "Opslaan mislukt",
      "Load failed": "Laden mislukt",
      "Archived supplier": "Deze leverancier is gearchiveerd.",
      "Restore": "Herstellen",
      "Archive": "Archiveren",
      "Title": "Titel",
      "Category": "Categorie",
      "Version": "Versie",
      "Valid until": "Geldig tot",
      "Upload document": "Document toevoegen",
      "File": "Bestand",
      "File limit": "PDF, PNG, JPEG, DOCX of XLSX, maximaal 25 MB. Elk bestand wordt op malware gescand.",
      "Upload failed": "Uploaden mislukt",
      "Download failed": "Downloaden mislukt",
      "Download": "Downloaden",
      "New version": "Nieuwe versie",
      "No documents": "Geen documenten",
      "New assessment": "Volledige beoordeling toevoegen",
      "No assessments": "Geen beoordelingen",
      "Review type": "Type beoordeling",
      "Review date": "Beoordelingsdatum",
      "Status": "Status",
      "Decision": "Besluit",
      "Next review": "Volgende beoordeling",
      "Light check not applicable": "De halfjaarcontrole geldt alleen voor kritieke en geactiveerde conditioneel kritieke leveranciers.",
      "Full follow-up": "Volledige vervolgbeoordeling",
      "Full follow-up hint": "Jaarlijkse herbeoordeling of wezenlijke wijziging; eerdere gegevens worden hergebruikt.",
      "Light follow-up hint": "Vier korte controles op deze beoordeling; het bestaande besluit blijft gelden.",
      "Full assessment notice": "Initieel, periodiek volledig en tussentijds volledig gebruiken dezelfde volledige vragenlijst. Voor de korte wijzigingencontrole kiest u Halfjaarcontrole op de tab Beoordelingen.",
      "Review cycle": "Jaarlijks volledig beoordelen en bij wezenlijke wijzigingen volledig herbeoordelen. Kritieke en geactiveerde conditioneel kritieke leveranciers krijgen daarnaast een korte halfjaarcontrole.",
      "Open assessment": "Beoordeling openen",
      "Follow-up assessment": "Vervolgbeoordeling",
      "Evidence and actions": "Bewijs en acties",
      "Decision and approvals": "Besluit en goedkeuring",
      "Service agreement": "Dienst / contractafspraak",
      "Review scope": "Reikwijdte beoordeling",
      "Questionnaire version": "Versie vragenlijst",
      "Result": "Resultaat",
      "Explanation": "Toelichting en bewijs",
      "Evidence versions": "Gebruikte documentversies",
      "Save before evidence": "Sla de beoordeling eerst op om eigen bijlagen toe te voegen.",
      "Actions": "Opvolgacties",
      "Add action": "Actie toevoegen",
      "Remove action": "Actie verwijderen",
      "Action description": "Actieomschrijving",
      "Owner": "Eigenaar",
      "Due date": "Uiterste datum",
      "Action reference": "Link naar opvolgactie",
      "Risk level": "Risiconiveau",
      "Impact": "Impact (1 laag, 3 kritiek)",
      "Conclusion": "Conclusie en onderbouwing",
      "Exception reason": "Motivering voorwaardelijke acceptatie",
      "Compensating measures": "Compenserende maatregelen",
      "Exception expiry": "Vervaldatum uitzondering",
      "Contract review": "Contractuele beoordeling",
      "Technical review": "Technische beoordeling",
      "Confirm review": "Beoordeling bevestigen",
      "Awaiting review": "Nog niet beoordeeld",
      "Authorized reviewer": "Bevoegde beoordelaar",
      "Complete assessment": "Beoordeling afronden",
      "Completion confirmation": "Na afronden staan de beoordeling, goedkeuringen en gebruikte bewijsversies vast. Wilt u de beoordeling afronden?",
      "Completed immutable": "Deze beoordeling is afgerond en kan niet meer worden gewijzigd. Start een vervolgbeoordeling om wijzigingen vast te leggen.",
      "Completed on": "Afgerond op",
      "Review reset notice": "Elke inhoudelijke wijziging laat beide goedkeuringen vervallen. Beide beoordelaars moeten de gewijzigde versie opnieuw bevestigen.",
      "Confirm approval invalidation": "Goedkeuringen laten vervallen?",
      "Approval invalidation confirmation": "Door deze wijziging vervallen de eerder gegeven goedkeuringen. De gewijzigde versie moet opnieuw worden bevestigd. Wilt u de wijzigingen opslaan?",
      "Save invalidating approvals": "Wijzigingen opslaan",
      "Dual review notice": "Hoog risico of impact 3 vereist contractuele en technische bevestiging door twee verschillende bevoegde beoordelaars.",
      "Values": {
        "pending": "Nog te bepalen",
        "required": "ISMS-relevant",
        "excluded": "Buiten ISMS-scope",
        "important": "Belangrijk",
        "critical": "Kritiek",
        "conditional": "Voorwaardelijk",
        "initial": "Initieel volledig",
        "periodic": "Periodiek volledig",
        "light": "Lichte halfjaarlijkse controle",
        "interim": "Tussentijds volledig",
        "draft": "In bewerking",
        "review": "Ter beoordeling",
        "completed": "Afgerond",
        "approved": "Goedgekeurd",
        "rejected": "Afgewezen",
        "low": "Laag",
        "medium": "Middel",
        "high": "Hoog",
        "unknown": "Onbekend / onvoldoende bewijs",
        "met": "Voldoet",
        "not_met": "Voldoet niet",
        "not_applicable": "Niet van toepassing",
        "open": "Open",
        "unchanged": "Geen wijzigingen",
        "follow_up": "Opvolging nodig"
      },
      "Categories": {
        "contract": "Contracten en verwerkersafspraken",
        "assurance": "Certificaten en assurance",
        "security": "Beveiligingsdocumenten"
      },
      "Criteria": {
        "contract": "Contractuele afspraken",
        "locations": "Verwerkingslocaties",
        "incident": "Incident- en meldafspraken",
        "access": "Toegang en accounts",
        "exit": "Exit en overdraagbaarheid",
        "data": "Gegevens en privacy",
        "subprocessors": "Subverwerkers",
        "assurance": "Assurance en certificaten",
        "encryption": "Versleuteling",
        "logging": "Logging en monitoring",
        "backup": "Back-up en herstel",
        "retention": "Bewaren en vernietigen",
        "sla": "Beschikbaarheid en SLA",
        "contacts": "Contacten controleren",
        "certificates": "Certificaten controleren",
        "changes": "Wijzigingen en incidenten",
        "high_actions": "Hoge risico’s en acties"
      },
      "CriteriaHelp": {
        "contract": "Controleer ondertekende afspraken, verantwoordelijkheden, SLA en verwerkersovereenkomst waar van toepassing.",
        "locations": "Leg landen van opslag, verwerking en toegang vast en controleer de juridische basis.",
        "incident": "Controleer meldtermijnen, contactpunten en samenwerking bij incidenten.",
        "access": "Controleer minimale rechten, MFA en het beëindigen van toegang.",
        "exit": "Beoordeel export, overdracht, verwijdering en leveranciersafhankelijkheid.",
        "data": "Beoordeel gegevenscategorieën, doeleinden en privacywaarborgen.",
        "subprocessors": "Controleer de keten, wijzigingen en contractuele waarborgen.",
        "assurance": "Controleer scope, geldigheid en afwijkingen van onafhankelijk bewijs.",
        "encryption": "Controleer versleuteling tijdens transport en opslag en sleutelbeheer.",
        "logging": "Beoordeel detectie, toegang tot logs en opvolging.",
        "backup": "Controleer herstelbaarheid, hersteltests en continuïteit.",
        "retention": "Controleer bewaartermijnen en aantoonbare vernietiging.",
        "sla": "Beoordeel prestaties, beschikbaarheid en afgesproken escalatie.",
        "contacts": "Controleer actuele eigenaar, contactpersonen en escalatiegegevens.",
        "certificates": "Controleer geldigheid en gewijzigde scope van certificaten.",
        "changes": "Beoordeel veranderingen in dienstverlening, keten en incidenten.",
        "high_actions": "Controleer openstaande acties en de geldigheid van risicoacceptaties."
      },
      "Review confirmed": "Beoordeling bevestigd",
      "Save before completion": "Sla wijzigingen op en laat beide beoordelingen opnieuw bevestigen.",
      "Periodic assessment": "Periodieke leveranciersbeoordeling",
      "Light check": "Halfjaarcontrole",
      "Baseline assessment": "Bestaande volledige beoordeling",
      "Additional note": "Aanvullende opmerking (optioneel)",
      "Full assessment required": "De halfjaarcontrole vereist een afgeronde volledige beoordeling met een goedgekeurd of voorwaardelijk goedgekeurd besluit.",
      "Light check notice": "Controleer de vier onderwerpen op wijzigingen. Het bestaande leveranciersbesluit blijft gelden; alleen afwijkingen vragen om opvolging.",
      "Light action required": "Leg bij een afwijking een actie met eigenaar en uiterste datum vast.",
      "Record check": "Controle vastleggen",
      "Check recorded": "Halfjaarcontrole vastgelegd",
      "Recorded by": "Vastgesteld door",
      "Outcome": "Uitkomst",
      "Single review notice": "Eén bevoegde, inhoudelijk bekwame beoordelaar kan deze beoordeling vaststellen. Vraag aanvullende expertise waar nodig. Alleen hoog risico of impact 3 vereist twee afzonderlijke bevestigingen.",
      "Approval history": "Goedkeuringshistorie",
      "Approval history notice": "Bekijk wie welke versie heeft bevestigd en wanneer goedkeuringen door een wijziging zijn vervallen. Via het oogje opent u de toen vastgelegde inhoud.",
      "Historical version notice": "U bekijkt een vastgelegde historische versie. Deze kan niet worden gewijzigd of goedgekeurd.",
      "Historical version": "Historische versie",
      "Content version": "Inhoudsversie",
      "Event": "Gebeurtenis",
      "Recorded at": "Vastgelegd op",
      "View reviewed version": "Vastgelegde versie bekijken",
      "Review reconfirmation required": "Opnieuw bevestigen vereist: deze goedkeuring is niet aan een inhoudsversie gekoppeld.",
      "Different reviewer required": "U heeft de andere beoordeling al bevestigd. Een andere bevoegde beoordelaar moet deze bevestigen.",
      "Review history events": {
        "contractReview": "Contractuele beoordeling bevestigd",
        "technicalReview": "Technische beoordeling bevestigd",
        "invalidated": "Goedkeuringen vervallen",
        "completed": "Beoordeling afgerond"
      }
    },
    "Supplier-assessments": {
      "Title": "Titel",
      "Notes": "Toelichting en bewijs",
      "Type": "Type beoordeling",
      "ReviewDate": "Beoordelingsdatum",
      "ScopeId": "Dienst / contractafspraak",
      "ServiceScope": "Reikwijdte beoordeling",
      "Documents": "Gebruikte documentversies",
      "Decision": "Besluit",
      "RiskLevel": "Risiconiveau",
      "Impact": "Impact (1 laag, 3 kritiek)",
      "Conclusion": "Conclusie en onderbouwing",
      "NextReviewDate": "Volgende beoordeling",
      "ExceptionReason": "Motivering voorwaardelijke acceptatie",
      "CompensatingMeasures": "Compenserende maatregelen",
      "ExceptionUntil": "Vervaldatum uitzondering",
      "Description": "Actieomschrijving",
      "Owner": "Eigenaar",
      "DueDate": "Uiterste datum",
      "Status": "Status",
      "Reference": "Link naar opvolgactie",
      "New item": "Leveranciersbeoordeling toevoegen",
      "Edit item": "Leveranciersbeoordeling wijzigen",
      "View item": "Leveranciersbeoordeling bekijken",
      "Errors": {
        "ErrorCode": {
          "SUPPLIER_LIGHT_BASELINE_REQUIRED": "Kies een afgeronde volledige beoordeling voor dezelfde leverancier en dienst.",
          "SUPPLIER_LIGHT_EXCEPTION_EXPIRED": "De bestaande uitzondering is verlopen. Voer een volledige herbeoordeling uit.",
          "SUPPLIER_LIGHT_CHECKS_REQUIRED": "Controleer alle vier onderwerpen voordat u de controle vastlegt.",
          "SUPPLIER_LIGHT_ACTION_REQUIRED": "Geef een toelichting bij de afwijking en leg een open actie met eigenaar en uiterste datum vast.",
          "SUPPLIER_LIGHT_NO_ACCEPTANCE": "Een halfjaarcontrole geeft geen nieuw leveranciersakkoord en accepteert geen nieuwe uitzondering. Gebruik daarvoor een volledige beoordeling.",
          "SUPPLIER_DUAL_REVIEW_REQUIRED": "Hoog risico of impact 3 vereist bevestiging door twee verschillende bevoegde beoordelaars.",
          "SUPPLIER_REVIEW_PERSONAL_LOGIN_REQUIRED": "Bevestig de beoordeling vanuit uw eigen persoonlijke account. Dit kan niet via een API-account of tijdens het imiteren van een gebruiker.",
          "SUPPLIER_DISTINCT_REVIEWER_REQUIRED": "U heeft de andere beoordeling al bevestigd. Een andere bevoegde beoordelaar moet deze bevestigen."
        }
      }
    },
    "Supplier-documents": {
      "Title": "Titel",
      "Supplier": "Leverancier",
      "Assessment": "Leveranciersbeoordeling",
      "Category": "Categorie",
      "ValidUntil": "Geldig tot",
      "Errors": {
        "default": "Het leveranciersdocument kon niet worden verwerkt.",
        "ErrorCode": {
          "SUPPLIER_DOCUMENT_REJECTED": "De malwarecontrole heeft het bestand afgekeurd. Het document is niet opgeslagen.",
          "SUPPLIER_EVIDENCE_IMMUTABLE": "Deze bewijsversie is al beoordeeld en blijft behouden. Upload een nieuwe versie voor wijzigingen."
        }
      }
    }
  },
  "Customer": {
    "Contacts": {
      "City": "Plaats",
      "CompanyName": "Bedrijfsnaam",
      "Contact": "Contact | Contacten",
      "Country": "Land",
      "Delete": "verwijderen",
      "Delete contact": "Contact verwijderen",
      "Delete item": "Contactpersoon verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de contactpersoon.",
      "Delete item success": "Contact succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de contactpersoon {0} wilt verwijderen?",
      "Edit contact": "Contact bewerken",
      "Edit item fail": "Fout bij wijzigen van het contact. {msg}",
      "Edit item success": "Contact succesvol gewijzigd.",
      "Email": "E-mail adres",
      "Errors": {
        "Delete item has dependencies": "Contact is in gebruik en kan niet worden verwijderd.",
        "ErrorCode": {
          "OXXA_API_NO_CHANGES": "Het contactpersoon is ongewijzigd.",
          "OXXA_API_RESULT_DIFF": "Het contactpersoon is gedeeltelijk gewijzigd, controleer het resultaat."
        }
      },
      "FirstName": "Voornaam",
      "HouseNumber": "Huisnummer",
      "HouseNumberSuffix": "Toevoeging",
      "Initials": "Initialen",
      "JobTitle": "Functietitel",
      "LastName": "Achternaam",
      "New item": "Nieuw contact",
      "New item fail": "Fout bij toevoegen van het contact. {msg}",
      "New item success": "Contact succesvol toegevoegd.",
      "No contacts found": "Geen contacten gevonden.",
      "PostalCode": "Postcode",
      "State": "Staat/Provincie",
      "Street": "Straat",
      "Tel": "Telefoonnummer"
    },
    "Customer-contacts": {
      "Address": "Adres",
      "Address information": "Adresgegevens",
      "Birthday": "Geboortedatum",
      "City": "Plaats",
      "Contact": "Contact",
      "Country": "Land",
      "Customer": "Klant",
      "Customer address": "Klant adres",
      "Delete": "verwijderen",
      "Delete item": "Klantcontact verwijderen",
      "Delete item fail": "Het verwijderen van klantcontact is mislukt.",
      "Delete item success": "Klantcontact succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u klant contact {0} wilt {1}?",
      "Edit item": "Klantcontact bewerken",
      "Edit item fail": "Fout bij het wijzigen van contactgegevens.",
      "Edit item success": "Contactgegevens succesvol gewijzigd.",
      "EmailAddress": "E-mail adres",
      "FirstName": "Voornaam",
      "Initials": "Initialen",
      "InvoiceReference": "Referentie factuur",
      "LastName": "Achternaam",
      "Name": "Naam",
      "OverwriteAddress": "Adres overschrijven",
      "Phone": "Telefoonnummer",
      "Salutation": "Aanhef",
      "SalutationOptions": {
        "D": "Afdeling",
        "F": "Vrouw",
        "M": "Man",
        "U": "Niet opgegeven"
      },
      "SendMail": "Verstuur e-mail",
      "Tabs": {
        "General": "Algemeen"
      },
      "Zipcode": "Postcode"
    },
    "Customer-users": {
      "Api account": "API-account",
      "Api accounts": "API-accounts",
      "Api token": "API-token",
      "Api token shown once": "Deze token wordt slechts eenmalig getoond. Bewaar deze veilig.",
      "Copy roles from user": "Rollen overnemen van andere gebruiker",
      "Copy roles from user title": "Rollen overnemen",
      "Customer user": "Gebruiker",
      "Customer users": "Gebruikers",
      "Delete api account": "API-account verwijderen",
      "Delete api account text": "Weet u zeker dat u het API-account {0} wilt verwijderen?",
      "Delete item": "Gebruiker verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de gebruiker.",
      "Delete item success": "Gebruiker succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de gebruiker {0} wilt verwijderen?",
      "Edit item": "Gebruiker bewerken",
      "Edit item fail": "Fout bij wijzigen van de gebruiker. {msg}",
      "Edit item success": "Gebruiker succesvol gewijzigd.",
      "Edit api account": "API-account bewerken",
      "Email": "E-mailadres",
      "FirstName": "Voornaam",
      "Initials": "Initialen",
      "IsSSO": "SSO",
      "Is MFA configured": "MFA ingesteld",
      "Last login": "Laatst ingelogd",
      "LastName": "Achternaam",
      "License": "Licentie",
      "LicenseCode": "Code",
      "LicenseProduct": "Product",
      "Licenses": "Licenties",
      "Locale": "Taal",
      "LocaleOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "New api account": "Nieuw API-account",
      "New item": "Nieuwe gebruiker",
      "New item fail": "Fout bij toevoegen van de gebruiker. {msg}",
      "New item success": "Gebruiker succesvol toegevoegd.",
      "New user": "Nieuwe gebruiker aanmaken",
      "No users to copy roles from": "Er zijn geen andere gebruikers met rollen beschikbaar.",
      "No assigned licenses": "Geen licenties toegewezen.",
      "No api accounts found": "Geen API-accounts gevonden",
      "No customer users found": "Geen gebruiker gevonden",
      "RegionalSettings": "Regionale instellingen",
      "Regenerate API token": "API-token opnieuw genereren",
      "Regenerate API token confirm": "API-token opnieuw genereren",
      "Regenerate API token confirm text": "Weet u zeker dat u het API-token voor {fullName} opnieuw wilt genereren? Het huidige token stopt dan met werken.",
      "Regenerate API token fail": "Kon API-token niet opnieuw genereren.",
      "RegionalSettingsOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Resend invite": "Uitnodiging opnieuw versturen",
      "Resend invite text": "Weet u zeker dat u de uitnodiging aan {fullName} opnieuw wilt versturen?",
      "Reset mfa": "MFA resetten",
      "Reset MFA text": "Weet u zeker dat u Multi-Factor Authenticatie (MFA) wilt resetten voor {fullName}?",
      "Roles to copy": "Over te nemen rollen",
      "Roles": "Rollen",
      "Select user for roles": "Gebruiker om rollen van over te nemen",
      "Take over roles": "Rollen overnemen",
      "User": "Gebruiker",
      "Virtual": "Virtueel",
      "What is virtual user": "Een virtuele gebruiker is niet gekoppeld aan een echt inlogaccount. Een of meer rollen voor deze klant zijn altijd verplicht.",
      "VerifiedOptions": {
        "True": "Geverifieerd",
        "False": "Niet geverifieerd"
      },
      "Delete": "verwijderen"
    },
    "Backups": {
      "Title": "Backups",
      "Description": "Bekijk de laatst beschikbare backupgegevens voor uw klantomgeving. Deze informatie is uitsluitend ter inzage.",
      "LastSynchronization": "Laatste synchronisatie",
      "Refresh": "Backupgegevens vernieuwen",
      "LoadError": "Backupgegevens konden niet worden geladen",
      "LoadErrorDescription": "Probeer het later opnieuw of neem contact op met uw beheerder wanneer de fout blijft optreden.",
      "NoBackupsFound": "Geen backups gevonden",
      "NoBackupsFoundDescription": "Voor deze klant zijn momenteel geen backupgegevens beschikbaar.",
      "NoSourceBackupsFound": "Geen {source}-backups gevonden",
      "NoRecentSessions": "Geen recente backupsessies gevonden",
      "NoProtectedItems": "Geen beschermde Microsoft 365-items gevonden",
      "UnknownOperatingSystem": "Onbekend",
      "NotApplicable": "Niet van toepassing",
      "SourceError": "Gegevens van deze backupbron konden niet worden geladen",
      "SourceErrorDescription": "Andere backupbronnen blijven beschikbaar. Probeer de gegevens later opnieuw te laden.",
      "BackupRecords": "backuprecords",
      "Enabled": "Ingeschakeld",
      "Disabled": "Uitgeschakeld",
      "Microsoft365Description": "Bekijk backupjobs, beschermde accounts en Teams, planningen en recente uitvoeringen van Microsoft 365.",
      "Microsoft365Jobs": "Backupjobs",
      "ProtectedItems": "Beschermde items",
      "RecentSessions": "Recente sessies",
      "LockedVaultDescription": "Bekijk de laatste Locked Vault-backups en aantallen herstelpunten.",
      "LockedVaultBackups": "Locked Vault-backups",
      "CloudDescription": "Bekijk de laatst beschikbare backups van uw cloudsystemen, inclusief status, backuptijdstip en beschikbare systeemgegevens.",
      "Tabs": {
        "Overview": "Overzicht",
        "Microsoft365": "Microsoft 365",
        "LockedVault": "Locked Vault",
        "Cloud": "Cloudback-ups"
      },
      "Status": {
        "Available": "Beschikbaar",
        "Empty": "Geen gegevens",
        "Error": "Niet beschikbaar",
        "Partial": "Gedeeltelijk beschikbaar",
        "Loading": "Laden"
      },
      "Sources": {
        "microsoft365": {
          "Title": "Microsoft 365",
          "Description": "Backupjobs, beschermde items en recente sessies",
          "ActionLabel": "Naar Microsoft 365",
          "Icon": "sym_o_business_center"
        },
        "lockedVault": {
          "Title": "Locked Vault",
          "Description": "Restic-backups en herstelpunten",
          "ActionLabel": "Naar Locked Vault",
          "Icon": "sym_o_lock"
        },
        "cloud": {
          "Title": "Cloudback-ups",
          "Description": "Backups van virtuele machines en opslag",
          "ActionLabel": "Naar cloudback-ups",
          "Icon": "sym_o_cloud_queue"
        }
      },
      "Fields": {
        "Architecture": "Architectuur",
        "Asset": "Asset",
        "BackupType": "Backuptype",
        "CreatedAt": "Aangemaakt",
        "DiskSize": "Schijfgrootte",
        "Enabled": "Actief",
        "EndedAt": "Afgerond",
        "Failed": "Mislukt",
        "Hostname": "Hostname",
        "Item": "Item",
        "Job": "Job",
        "LastBackup": "Laatste backup",
        "NextRun": "Volgende uitvoering",
        "OperatingSystem": "Besturingssysteem",
        "RestorePoints": "Herstelpunten",
        "Schedule": "Planning",
        "Server": "Server",
        "Size": "Omvang",
        "StartedAt": "Gestart",
        "Status": "Status",
        "Succeeded": "Geslaagd",
        "Total": "Totaal",
        "Type": "Type",
        "Vault": "Vault",
        "Zone": "Zone"
      },
      "Types": {
        "virtualMachine": "Virtuele machine",
        "blockStorage": "Block storage",
        "account": "Account",
        "team": "Team",
        "oneDrive": "OneDrive",
        "site": "SharePoint-site"
      }
    },
    "Licenses": {
      "Add Assigned item": "Toegewezen gebruiker toevoegen",
      "AlignWithLicense": "Verlengingsdatum gelijkzetten met licentie",
      "Amount": "Aantal",
      "AmountMustBeZero": "Zet het aantal eerst op 0 voordat u deze licentie verwijdert.",
      "Assigned": "Toegewezen gebruikers",
      "AssignedLicenses": "Toegewezen licenties",
      "EffectiveAssigned": "Effectieve gebruikers",
      "ChangeOnRenewDate": "Aantal en betaalwijze wijzigen per verlengdatum",
      "ComingSoon": "Coming soon.",
      "Delete": "verwijderen",
      "Delete Assigned item": "Toegewezen gebruiker verwijderen",
      "Delete item": "Licentie verwijderen",
      "Delete item fail": "Licentie verwijderen mislukt. {msg}",
      "Delete item success": "Licentie succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je licentie {0} wilt {1}?",
      "Edit item": "Licentie bewerken",
      "Edit item fail": "Licentie wijzigen mislukt. {msg}",
      "Edit item success": "Licentie succesvol gewijzigd.",
      "Email": "E-mail",
      "EndDate": "Einddatum",
      "Id": "ID",
      "InvoiceDateHistory": {
        "EndDate": "Einddatum",
        "InvoiceDate": "Factuurdatum",
        "StartDate": "Startdatum"
      },
      "InvoiceHistory": "Factuurgeschiedenis",
      "Errors": {
        "ErrorCode": {
          "LICENSE_AMOUNT_BELOW_ASSIGNED": "Aantal mag niet lager zijn dan het aantal toegewezen gebruikers.",
          "LICENSE_AMOUNT_CANNOT_DECREASE": "Aantal kan alleen direct verhoogd worden.",
          "LICENSE_ALIGN_AMOUNT_MUST_BE_GREATER_THAN_ZERO": "Aantal moet hoger zijn dan 0 wanneer je de verlengingsdatum gelijkzet met een licentie.",
          "LICENSE_ALIGN_PAYMENT_METHOD_MISMATCH": "Je kunt alleen gelijkzetten met een licentie met dezelfde betaalwijze.",
          "LICENSE_ALIGN_RENEW_DATE_BEFORE_START_DATE": "De startdatum moet vóór de verlengingsdatum van de gekozen licentie liggen.",
          "LICENSE_AMOUNT_MUST_BE_ZERO": "Zet het aantal eerst op 0 voordat u deze licentie verwijdert.",
          "LICENSE_ASSIGNED_CAPACITY_EXCEEDED": "Te veel actieve gebruikers.",
          "LICENSE_ASSIGNED_CUSTOMER_MISMATCH": "Toegewezen gebruikers moeten bij dezelfde klant horen als de licentie.",
          "LICENSE_ASSIGNED_DATE_IN_PAST": "Start- en einddatums van toegewezen gebruikers mogen niet in het verleden liggen.",
          "LICENSE_ASSIGNED_USER_INVALID": "Ongeldige gebruiker.",
          "LICENSE_ASSIGNED_USER_REQUIRED": "Kies een gebruiker.",
          "LICENSE_ASSIGNED_USERS_NOT_UNIQUE": "Een gebruiker kan maar één keer toegewezen worden.",
          "LICENSE_CONTRACT_CANCEL_DATE_AMOUNT_INCREASE": "Deze licentie is opgezegd en kan niet meer verhoogd worden.",
          "LICENSE_CONTRACT_INVALID": "Deze licentie heeft geen geldig contract en kan alleen verwijderd worden.",
          "LICENSE_PAYMENT_METHOD_NOT_AVAILABLE": "Deze betaalwijze is niet beschikbaar voor dit licentieproduct.",
          "LICENSE_PENDING_ASSIGNED_CAPACITY_EXCEEDED": "Te veel actieve gebruikers na de verlengdatum.",
          "LICENSE_PENDING_AMOUNT_BELOW_RENEWAL_ASSIGNED": "Het nieuwe aantal is lager dan het aantal toegewezen gebruikers op de verlengdatum.",
          "LICENSE_PERIOD_NOT_AVAILABLE": "Deze periode is niet beschikbaar voor dit licentieproduct.",
          "LICENSE_START_DATE_IN_PAST": "De startdatum mag niet in het verleden liggen.",
          "LICENSE_USER_ALREADY_ASSIGNED_TO_PRODUCT": "Product al toegewezen."
        }
      },
      "FromRenewDate": "Vanaf verlengdatum",
      "GoToMicrosoftLicenses": "Naar Microsoft-licenties",
      "GoToOmniLicenses": "Naar OMNI-licenties",
      "License": "Licentie | Licenties | Licentie {license}",
      "LoadError": "Licenties laden mislukt.",
      "MicrosoftLicenses": "Microsoft-licenties",
      "MicrosoftLicensesDescription": "Bekijk uw actuele Microsoft-licenties.",
      "MicrosoftLicensesLoadError": "Microsoft-licenties laden mislukt.",
      "MicrosoftAppliesTo": {
        "Company": "Bedrijf",
        "Device": "Apparaat",
        "User": "Gebruiker"
      },
      "MicrosoftCapabilityStatus": {
        "Deleted": "Verwijderd",
        "Disabled": "Uitgeschakeld",
        "Enabled": "Ingeschakeld",
        "LockedOut": "Geblokkeerd",
        "Suspended": "Opgeschort",
        "Warning": "Waarschuwing"
      },
      "MicrosoftLicenseTable": {
        "AppliesTo": "Van toepassing op",
        "CapabilityStatus": "Status",
        "ConsumedUnits": "Gebruikt",
        "LastUpdated": "Laatst bijgewerkt",
        "PrepaidUnitsEnabled": "Beschikbaar",
        "PrepaidUnitsSuspended": "Opgeschort",
        "PrepaidUnitsWarning": "Waarschuwing",
        "SkuName": "SKU-naam",
        "SkuPartNumber": "SKU-onderdeelnummer",
        "TotalConsumed": "Totaal gebruikt",
        "TotalEnabled": "Totaal beschikbaar"
      },
      "Name": "Naam",
      "New item": "Nieuwe licentie",
      "New item fail": "Licentie aanmaken mislukt. {msg}",
      "New item success": "Licentie succesvol aangemaakt.",
      "NoInvoiceHistory": "Er is nog geen factuurgeschiedenis.",
      "NoMicrosoftLicensesFound": "Er zijn geen Microsoft-licenties gevonden.",
      "NoAssignedUsers": "Geen toegewezen gebruikers.",
      "No licenses found": "Geen licenties gevonden.",
      "OmniLicenses": "OMNI-licenties",
      "OmniLicensesDescription": "Beheer OMNI-licenties, aantallen en toegewezen gebruikers.",
      "Overview": "Overzicht",
      "PaymentMethod": "Betaalwijze",
      "PendingAmount": "Nieuw aantal",
      "PendingPaymentMethod": "Nieuwe betaalwijze",
      "PendingProduct": "Nieuw licentieproduct",
      "Period": "Periode",
      "PricePerLicense": "Prijs per licentie",
      "PricePeriod": "per {period}",
      "PeriodOptions": {
        "Month": "Maand",
        "Year": "Jaar"
      },
      "Product": "Product",
      "RenewDate": "Verlengingsdatum",
      "SetAssignedEndDatesToRenewDate": "Einddatum op verlengdatum zetten",
      "StartDate": "Startdatum",
      "Tabs": {
        "General": "Algemeen",
        "Users": "Gebruikers"
      },
      "TotalPrice": "Totaalprijs",
      "User": "Gebruiker",
      "ViewAssignments": "Toewijzingen bekijken"
    },
    "Customers": {
      "Address": "Adres",
      "Address information": "Adresgegevens",
      "Birthday": "Geboortedatum",
      "City": "Plaats",
      "CocNumber": "KvK-nummer",
      "Contact": "Contact",
      "Contact information": "Contactgegevens",
      "Contact person": "Contactpersoon",
      "ContactInfo": "Contact informatie",
      "Country": "Land",
      "CountryOrRegion": "Land of Regio",
      "Customer": "Klant",
      "Customer address": "Klant adres",
      "Customer information": "Klantgegevens",
      "CustomerName": "Klantnaam",
      "Edit": "@:{item} wijzigen",
      "Edit item fail": "Fout bij het wijzigen van klantgegevens.",
      "Edit item success": "Klantgegevens succesvol gewijzigd.",
      "Invoice information": "Factuurgegevens",
      "InvoiceContact": "Factuur contactpersoon",
      "InvoiceEmailAddress": "Factuur e-mailadres",
      "InvoiceReference": "Referentie factuur",
      "Name": "Klantnaam",
      "Offer information": "Offertegegevens",
      "OfferContact": "Offerte contactpersoon",
      "OfferEmailAddress": "Offerte e-mailadres",
      "See all domains": "Bekijk alle domeinen",
      "See all invoices": "Bekijk alle facturen",
      "See all webhosting accounts": "Bekijk alle hostingaccounts",
      "See customer profile": "Bekijk klantgegevens",
      "SendMail": "E-mail ontvangen",
      "State": "Staat",
      "TaxNumber": "BTW-nummer",
      "Zipcode": "Postcode"
    },
    "Domain-contacts": {
      "AdministrativeContact": "Administratief contact",
      "All contacts": "Alle contacten",
      "BillingContact": "Facturatie contact",
      "Choose a contact": "Kies een contact",
      "Link contacts": "Contacten koppelen",
      "OwnerContact": "Contact eigenaar",
      "Set this for all contacts": "Stel het eigenaarscontact in voor alle contacten",
      "TechnicalContact": "Technisch contact"
    },
    "Domains": {
      "Add DNSSEC item": "DNSSEC regel toevoegen",
      "Add Nameservers item": "Nameserver toevoegen",
      "Administrative contact is required": "Administratief contactpersoon is een verplicht veld.",
      "AdministrativeContact": "Administratief contactpersoon",
      "Alg": "Algoritme",
      "All customers": "Alle klanten",
      "Auto renew disabled": "Automatisch vernieuwen is uitgeschakeld voor dit domein.",
      "AutoRenew": "Automatische verlenging",
      "AutoRenewdisabled": "Automatisch verlengen is uitgeschakeld voor dit domein.",
      "Back to domains": "Terug naar domeinen",
      "Billing contact is required": "Facturatie contactpersoon is een verplicht veld.",
      "BillingContact": "Facturatie contact",
      "Cancel subscription": "Opzeggen",
      "CancelDate": "Opgezegd op",
      "Cancellation warning": "Hoewel het domein binnen de opzegtermijn verhuisd kan worden, ontvangt u nog wel een factuur voor de resterende periode.",
      "Cancelled": "Opgezegd",
      "Change webhosting account": "Kies hieronder een hostingaccount waaraan {domain} moet worden gekoppeld.",
      "Change webhosting account title": "Koppel hostingaccount",
      "Check domain": "Controleer domein",
      "Check domain availability": "Controleer de beschikbaarheid van het domein",
      "City": "Plaats",
      "CompanyName": "Bedrijfsnaam",
      "Confirm domain force delete text": "Weet je zeker dat je het domein {domain} wilt verwijderen? Het domein wordt in quarantaine geplaatst, er zijn kosten aan verbonden om dit terug te draaien.",
      "Confirm domain force delete title": "Domein verwijderen",
      "Confirm domain restore text": "Weet je zeker dat je het domein {domain} wilt herstellen? Er zijn kosten aan verbonden om het domein uit quarantaine te halen.",
      "Confirm domain restore title": "Domein herstellen",
      "Contacts": "Alle contacten",
      "Copy transfercode": "Klik om de verhuiscode te kopiëren",
      "Country": "Land",
      "Customer": "Klant",
      "Delete": "verwijderen",
      "Delete DNSSEC item": "DNSSEC regel verwijderen",
      "Delete domain status not error item success": "Automatisch vernieuwen is uitgeschakeld, domein {name} zal worden verwijderd na de verloopdatum.",
      "Delete domain webhosting item fail": "Fout bij het verwijderen van hostingaccount voor het domein. {msg}",
      "Delete domain webhosting item success": "Hostingaccount voor het domein succesvol verwijderd.",
      "Delete item": "Domein verwijderen",
      "Delete item fail": "Fout bij het verwijderen van het domein. {msg}",
      "Delete item success": "Domein succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u het domein {0} wilt {1}?",
      "Delete Nameservers item": "Nameserver verwijderen",
      "discount": "korting",
      "DNSSEC": "DNSSEC",
      "Dnssec item": "DNSSEC",
      "DNSSECInfo": "Gebruiker het onderstaande formulier om DNSSEC records in te stellen. Let op dat als je een bestaand record wijzigt, deze zal worden verwijderd en opnieuw wordt aangemaakt, controleer het resultaat dus goed!",
      "Domain": "Domein | Domeinen",
      "Domain has no DNS Sec": "Dit domein heeft geen DNSSEC-records geconfigureerd.",
      "Domain in quarantaine": "Domein is in quarantaine",
      "DomainNSGroup": "Domein nameservers groep | Domein nameservers groepen",
      "DomainStatus": "Domein status",
      "DomainStatusOptions": {
        "Error": "Fout",
        "Quarantine": "Quarantaine",
        "Registered": "Geregistreerd",
        "Transfer pending": "In behandeling",
        "Transferred": "Verhuisd",
        "Unknown": "Onbekend"
      },
      "Edit contact": "Contact bewerken",
      "Edit domain DNSSEC item fail": "Fout bij het wijzigen van de DNSSEC instellingen. {msg}",
      "Edit domain DNSSEC item success": "Domein DNSSEC instellingen zijn gewijzigd.",
      "Edit domain webhosting item fail": "Fout bij wijzigen van het hostingaccount van het domein. {msg}",
      "Edit domain webhosting item success": "Hostingaccount voor domein is succesvol gewijzigd.",
      "Edit item": "Bewerk domein",
      "Edit item fail": "Fout bij het wijzigen van het domein.",
      "Edit item success": "Domein succesvol gewijzigd.",
      "Email": "E-mail adres",
      "Errors": {
        "default": "Fout bij het uitvoeren van het domein verzoek. {msg}",
        "ErrorCode": {
          "DOMAINS_CHECK_REQUIRED_FIELDS_MISSING": "Verplichte velden ontbreken.",
          "OXXA_API_BAD_STATUS_CODE": "Kan geen verbinding maken met domeinleverancier.",
          "OXXA_API_DISABLED": "Oxxa API is niet ingeschakeld.",
          "OXXA_API_NO_CHANGES": "Het contactpersoon is ongewijzigd.",
          "OXXA_API_NO_HANDLE_FOUND": "Geen ID gevonden bij de leverancier.",
          "OXXA_API_REMOVE_DATA_NOT_FOUND": "Geen gegevens gevonden om te verwijderen.",
          "OXXA_API_REQUEST_FAILED": "Kan geen verbinding maken met domeinleverancier.",
          "OXXA_API_RESULT_DIFF": "Het contactpersoon is gedeeltelijk gewijzigd, controleer het resultaat.",
          "OXXA_API_RESULT_NOT_FOUND": "Geen resultaten gevonden voor NS groep.",
          "UNIQUE_FIELD_ERROR_NOT_UNIQUE": "Het veld '@.lower:{key}' is niet uniek."
        }
      },
      "ExpireDate": "Verloopdatum",
      "FirstName": "Voornaam",
      "Flags": "Flag",
      "Force remove domain": "Verwijder domein geforceerd",
      "Force remove domain item fail": "Domein kon niet geforceerd verwijderd worden. {msg}",
      "Force remove domain item success": "Domein succesvol geforceerd verwijderd.",
      "FullDomain": "Volledig domein resultaat",
      "Get EPP item fail": "Verhuiscode kan niet opgehaald worden.",
      "Get EPP item success": "Verhuiscode succesvol opgehaald.",
      "Hostname": "Hostnaam",
      "HouseNumber": "Huisnummer",
      "HouseNumberSuffix": "Toevoeging",
      "incl": "incl.",
      "Initials": "Initialen",
      "InvoiceDateHistory": {
        "EndDate": "Einddatum",
        "InvoiceDate": "Factuurdatum",
        "StartDate": "Stardatum"
      },
      "InvoicedUntilDate": "Gefactureerd t/m",
      "InvoiceHistory": "Factuurgeschiedenis",
      "InvoiceNextDate": "Volgende factuur",
      "InvoiceStartDate": "Begindatum factuur",
      "IPv4": "IPv4",
      "IPv6": "IPv6",
      "JobTitle": "Functietitel",
      "LastName": "Achternaam",
      "LastRenewDate": "Laatste verlengingsdatum",
      "Link webhosting account": "Koppelen",
      "Linked webhosting account": "Gekoppeld hostingaccount",
      "Lock": "Vergrendel",
      "Lock domain item false success": "Domein succesvol ontgrendeld.",
      "Lock domain item true success": "Domein succesvol vergrendeld.",
      "Lock item": "Domein vergrendelen",
      "Lock item fail": "Domein kon niet worden vergrendeld.",
      "Manage contacts": "Contacten beheren",
      "Manage DNSSEC": "Beheer DNSSEC",
      "Manage nameservers": "Nameservers beheren",
      "More info": "Meer informatie",
      "Move domain": "Domein verhuizen",
      "Move domain info": "Onderstaand kunt u de verhuiscode opvragen. Als u het domein verhuisd, zal automatisch het abonnement worden opgezegd op de dag van verhuizing. Er geldt een opzegtermijn van {noticePeriod}.",
      "Nameservers": "Nameserver | Nameservers",
      "New contact": "Nieuw contact",
      "New domain webhosting item fail": "Fout bij toevoegen van hostingaccount aan domein. {msg}",
      "New domain webhosting item success": "Hostingaccount succesvol toegevoegd aan domein.",
      "New item": "Nieuw domein",
      "New item fail": "Fout bij maken van domein. {msg}",
      "New item success": "Domein succesvol toegevoegd.",
      "No customer attached": "No customer attached",
      "No domains found": "Geen domeinen gevonden.",
      "No items": "Er is momenteel geen gekoppeld hostingaccount beschikbaar.",
      "NoticeDate": "Datum van kennisgeving",
      "Only one DNSSEC record configured": "Slechts één DNSSEC-record geconfigureerd.",
      "Owner contact is required": "Contact eigenaar is een verplicht veld.",
      "OwnerContact": "Contact eigenaar",
      "Period": "Periode",
      "PeriodicOptions": {
        "Day": "Dag | Dagen",
        "Month": "Maand | Maanden",
        "Year": "Jaar"
      },
      "PostalCode": "Postcode",
      "Price": "Prijs",
      "Protocol": "Protocol",
      "PubKey": "Publieke sleutel",
      "QuarantaineEnd": "Quarantaine einde",
      "Registrar": "Registrar",
      "RegistrarOptions": {
        "Other": "Other",
        "Oxxa": "Oxxa",
        "Xolphin": "Xolphin"
      },
      "Restore domain": "Herstel domein",
      "Restore domain item fail": "Domein kon niet hersteld worden. {msg}",
      "Restore domain item success": "Domein succesvol hersteld.",
      "Retrieve transfercode": "Wanneer je het domein wilt verhuizen, haal dan hier de verhuiscode op",
      "Send EPP info": "Wanneer u ervoor kiest de verhuiscode te versturen, zal deze worden verstuurd aan het ingestelde e-mailadres van de eigenaar.",
      "Send EPP item fail": "Verhuiscode kan niet verstuurd worden.",
      "Send EPP item success": "Verhuiscode succesvol verstuurd.",
      "Send transfercode": "Verstuur",
      "Set auto renew failed": "Automatisch vernieuwen kan niet aangepast worden.",
      "Set auto renew false success": "Automatisch vernieuwen succesvol uitgeschakeld.",
      "Set auto renew true success": "Automatisch vernieuwen succesvol ingeschakeld.",
      "Show transfercode": "Tonen",
      "Show transfercode item": "Verhuiscode",
      "StartDate": "Startdatum",
      "State": "Staat/Provincie",
      "Street": "Straat",
      "Subscription": "Abonnement",
      "SubscriptionInfo": {
        "contractInfo": {
          "customer": "Klant"
        }
      },
      "Tabs": {
        "Contacts": "Contacten",
        "General": "Algemeen",
        "Name servers": "@:Customer.Domains.Nameservers"
      },
      "Technical contact is required": "Technisch contactpersoon is een verplicht veld.",
      "TechnicalContact": "Technisch contactpersoon",
      "Tel": "Telefoonnummer",
      "TerminationDate": "Verwijderdatum",
      "Tld": "Domein extensie",
      "Transfer domain": "Domein verhuizen",
      "TransferCode": "Verhuiscode",
      "Undo cancellation": "Opzegging annuleren",
      "Unlock item": "Domein ontgrendelen",
      "Webhosting": "Hostingaccount",
      "What are nameservers": "Nameservers zijn als telefoonboeken voor het internet; ze helpen uw computer het juiste adres te vinden voor de website die u wilt bezoeken.",
      "What is DNSSEC": "DNSSEC is een beveiliging die ervoor zorgt dat je computer zeker weet dat hij met de juiste website verbinding maakt en niet wordt misleid naar een nepwebsite."
    },
    "Email-logs": {
      "MailSent": "E-mail status"
    },
    "Feedback-answers": {
      "Customer": "Klant",
      "Value": "Waarde"
    },
    "Globals": {
      "Customer-users": "Gebruikers"
    },
    "Invoices": {
      "Cannot download invoice": "Kan het downloaden van de factuur niet starten.",
      "Download invoice": "Factuur downloaden",
      "Invoice": "Factuur | Facturen",
      "Invoice date": "Datum",
      "Invoice due date": "Uiterste betaaldatum",
      "Invoice item": "Factuur",
      "Invoice overdue": "Factuur is achterstallig | ACHTERSTALLIG",
      "Invoice overdue date": "Vervaldatum",
      "Invoices loading": "Facturen worden geladen, een moment alstublieft...",
      "List": "Overzicht facturen",
      "No invoices found": "Geen facturen gevonden.",
      "PaymentStatuses": {
        "open": "Open",
        "open credit": "Open",
        "open direct debit": "Open",
        "overdue": "Verlopen",
        "paid": "Betaald"
      },
      "View invoice": "Factuur bekijken"
    },
    "Main-page": {
      "Customer data": "Klantgegevens",
      "Domains": "Domeinen",
      "Statistics": "Statistieken",
      "Hosting accounts": "Hostingaccounts",
      "Invoices": "Facturen",
      "See all domains": "Bekijk alle domeinen",
      "See all invoices": "Bekijk alle facturen",
      "See all webhosting accounts": "Bekijk alle hostingaccounts",
      "See customer profile": "Bekijk klantprofiel",
      "New appointment": "Nieuwe afspraak",
      "Go to new appointment": "Ga naar nieuwe afspraak",
      "Appointments": "Afspraken",
      "Go to appointments": "Ga naar afspraken",
      "Go to statistics": "Ga naar statistieken",
      "Go to licenses": "Bekijk alle licenties",
      "Licenses": "Licenties"
    },
    "New-domain": {
      "Back to domains": "Terug naar domeinen",
      "Choose package": "Kies een pakket",
      "Create new webhosting account": "Nieuw webhostingaccount",
      "discount": "korting",
      "Do not link to webhosting account": "Niet koppelen aan webhostingaccount",
      "I agree with the terms": "Ik verklaar hierbij akkoord te gaan met de {termsLink}.",
      "incl": "incl.",
      "Link a webhosting account to your new domain": "Koppel een webhostingaccount aan uw nieuwe domein.",
      "Link contacts to domain": "Koppel contacten aan domein",
      "Linked hosting": "Gekoppelde webhosting",
      "New": "nieuw",
      "New domain": "Nieuw domein",
      "Order": "Bestellen",
      "Order completed": "Bestelling afgerond",
      "Order failed": "Bestelling mislukt",
      "Order partially completed": "Bestelling deels afgerond",
      "Overview": "Overzicht",
      "per year": "per jaar",
      "Register domain": "Registreer een domein",
      "Select webhosting account": "Selecteer webhostingaccount",
      "Something went wrong with the domain order": "Er ging iets mis met de bestelling van het domein. Neem contact op met onze Service Desk.",
      "Something went wrong with the order of the web hosting account": "Er ging iets mis met de bestelling van het webhostingaccount. Neem contact op met onze Service Desk.",
      "terms and conditions": "algemene voorwaarden",
      "terms url": "https://omninetworks.nl/algemene-voorwaarden/",
      "Thank you for your order": "Bedankt voor uw bestelling!",
      "The transfer code is invalid": "De verhuiscode is onjuist.",
      "Webhosting account": "Webhostingaccount",
      "Your domain registration is in progress": "Uw domeinregistratie is in behandeling. U kunt de status van de registratie volgen op de domeinenpagina.",
      "Your new web hosting account is now available": "Uw nieuwe webhostingaccount is direct beschikbaar. Ga naar de webhostingpagina om in te loggen."
    },
    "New-webhosting-account": {
      "Back to accounts": "Terug naar hostingaccounts",
      "Choose package": "Kies een pakket",
      "discount": "korting",
      "I agree with the terms": "Ik verklaar hierbij akkoord te gaan met de {termsLink}.",
      "incl": "incl.",
      "Link a primary domain to your new hosting account": "Koppel een primair domein aan uw nieuwe hostingaccount.",
      "Link contacts to domain": "Koppel contacten aan domein",
      "New": "nieuw",
      "New hosting account": "Nieuw hostingaccount",
      "Order": "Bestellen",
      "Order completed": "Bestelling afgerond",
      "Order failed": "Bestelling mislukt",
      "Order partially completed": "Bestelling deels afgerond",
      "Overview": "Overzicht",
      "per year": "per jaar",
      "Primary domain": "Primair domein",
      "Register domain": "Registreer een domein",
      "Register new domain": "Registreer nieuw domein",
      "Select primary domain": "Selecteer primair domein",
      "Something went wrong with the domain order": "Er ging iets mis met de bestelling van het domein. Neem contact op met onze Service Desk.",
      "Something went wrong with the order of the web hosting account": "Er ging iets mis met de bestelling van het webhostingaccount. Neem contact op met onze Service Desk.",
      "terms and conditions": "algemene voorwaarden",
      "terms url": "https://omninetworks.nl/algemene-voorwaarden/",
      "Thank you for your order": "Bedankt voor uw bestelling!",
      "The transfer code is invalid": "De verhuiscode is onjuist.",
      "Your domain registration is in progress": "Uw domeinregistratie is in behandeling. U kunt de status van de registratie volgen op de domeinenpagina.",
      "Your new web hosting account is now available": "Uw nieuwe webhostingaccount is direct beschikbaar. Ga naar de webhostingpagina om in te loggen."
    },
    "Register-domain": {
      "Available": "Beschikbaar",
      "Choose": "Kiezen",
      "discount": "korting",
      "domain": "domein",
      "Domain is available": "Domein is vrij voor registratie.",
      "Domain is taken": "Domein is bezet.",
      "extension": "extensie",
      "Failed to check domain": "Fout bij controleren van domein.",
      "incl": "incl.",
      "Is the domain yours, and do you have a transfer code": "Wilt u de domeinnaam verhuizen? Vul hieronder de verhuiscode in.",
      "Most chosen": "Meest gekozen",
      "per year": "per jaar",
      "Check availability": "Controleer beschikbaarheid",
      "Selected domain": "Geselecteerde domein",
      "Selected domain is changed": "Geselecteerde domein is gewijzigd.",
      "Suggestions": "Andere suggesties",
      "Taken": "Bezet",
      "The domain cannot be transferred": "Het domein kan niet worden verhuisd.",
      "Transfer code": "Verhuiscode"
    },
    "Settings": {
      "Delete": "verwijderen",
      "Delete item": "Instelling verwijderen",
      "Delete item fail": "Fout bij het verwijderen van de instelling. {msg}",
      "Delete item success": "Instelling succesvol verwijderd.",
      "Delete item text": "Weet u zeker dat u de instelling {0} wilt {1}?",
      "Edit item": "Instelling bewerken",
      "Edit item fail": "Fout bij het wijzigen van de instelling. {msg}",
      "Edit item success": "Instelling succesvol gewijzigd.",
      "New item": "Nieuwe instelling",
      "New item fail": "Fout bij maken van instelling. {msg}",
      "New item success": "Instelling succesvol toegevoegd.",
      "Value": "Waarde",
      "Errors": {
        "ErrorCode": {
          "STEP_DOES_NOT_MATCH": "Toegestane stap: {step}.",
          "PATTERN_DOES_NOT_MATCH": "Toegestaan patroon: {pattern}.",
          "INVALID_OPTION": "Ongeldige @.lower:{key}, toegestaan {allowed}.",
          "INVALID_MAXIMUM": "@:{key} overschrijdt maximum ({maximum}MB).",
          "INVALID_IMAGE_DATA": "Ongeldig afbeeldingsbestand.",
          "INVALID_IMAGE_METADATA": "Afbeeldingsmetadata niet beschikbaar.",
          "INVALID_IMAGE_ASPECTRATIO": "Ongeldige beeldverhouding ({actual}), verwacht {expected}.",
          "INVALID_IMAGE_TRANSFORM": "Transformatie niet toegestaan voor type {currentMimeType}, toegestaan is: {allowedMimeTypes}",
          "INVALID_IMAGE_WIDTH": "Ongeldige breedte ({actual}px), verwacht {expected}px.",
          "INVALID_IMAGE_HEIGHT": "Ongeldige hoogte ({actual}px), verwacht {expected}px.",
          "INVALID_IMAGE_MINWIDTH": "Breedte ({actual}px) onder minimum ({expected}px).",
          "INVALID_IMAGE_MINHEIGHT": "Hoogte ({actual}px) onder minimum ({expected}px).",
          "INVALID_IMAGE_MAXWIDTH": "Breedte ({actual}px) boven maximum ({expected}px).",
          "INVALID_IMAGE_MAXHEIGHT": "Hoogte ({actual}px) boven maximum ({expected}px)."
        }
      },
      "RemoveSettings item fail": "Fout bij het herstellen van de instelling. | Fout bij het herstellen van de instellingen.",
      "RemoveSettings item success": "Instelling succesvol hersteld. | Instellingen succesvol hersteld.",
      "SaveSettings item fail": "Fout bij het opslaan van de instelling. | Fout bij het opslaan van de instellingen.",
      "SaveSettings item success": "Instelling succesvol opgeslagen. | Instellingen succesvol opgeslagen.",
      "My settings": "Mijn instellingen",
      "Customer settings": "Instellingen van {customerName}",
      "My customer settings": "Mijn instellingen bij {customerName}",
      "Remove setting confirm": "Instellingen herstellen",
      "Remove setting confirm text": "Weet u zeker dat u de instellingen wilt herstellen naar de standaardwaarden?",
      "Remove single setting confirm": "Instelling herstellen",
      "Remove single setting confirm text": "Weet u zeker dat u de instelling wilt herstellen naar de standaardwaarde?"
    },
    "Sharingcenter": {
      "Calendar": "Agenda",
      "Contacts": "Contacten",
      "Groups": "Groepen",
      "MeetingStatistics": "Statistieken",
      "New": "Nieuw",
      "Overview": "Overzicht",
      "Profiles": "Profielen",
      "Recordings": "Opnamen",
      "Fileshare": "Bestanden delen",
      "Screenshare": "Scherm delen",
      "Chat": "Chat",
      "Meeting": "Vergadering",
      "Appointment": "Appointment",
      "CallColleague": "Collega's",
      "CallColleagueIntro": "Bekijk welke collega's online zijn en start direct een meeting.",
      "Accept": "Accepteren",
      "Colleague": "Collega",
      "Colleagues": "Collega's",
      "Decline": "Weigeren",
      "LoadColleaguesError": "De collega's konden niet worden geladen.",
      "NoColleagues": "Geen collega's gevonden.",
      "NoMatchingColleagues": "Geen collega's gevonden.",
      "Offline": "Offline",
      "Online": "Online",
      "PresenceStatus": "Status",
      "PresenceStatusAppearOffline": "Offline weergeven",
      "PresenceStatusAway": "Afwezig",
      "PresenceStatusDoNotDisturb": "Bezet",
      "PresenceStatusHelp": "Bepaalt hoe collega's u zien en kunnen bellen.",
      "PresenceStatusMeetingManaged": "Automatisch ingesteld zolang u in een meeting zit.",
      "PresenceStatusOffline": "Offline",
      "PresenceStatusOnline": "Online",
      "SearchColleagues": "Zoek collega's",
      "BrowserNotificationsTitle": "Browsermeldingen voor oproepen en uitnodigingen",
      "BrowserNotificationsDescription": "Ontvang een melding wanneer een collega u belt of uitnodigt voor een meeting, ook als de portal op de achtergrond staat.",
      "BrowserNotificationsEnable": "Browsermeldingen inschakelen",
      "BrowserNotificationsOpen": "OMNI Sessions openen",
      "BrowserNotificationsDefault": "Niet ingeschakeld",
      "BrowserNotificationsGranted": "Ingeschakeld",
      "BrowserNotificationsDenied": "Geblokkeerd",
      "BrowserNotificationsUnsupported": "Niet ondersteund",
      "BrowserNotificationsDeniedHelp": "Meldingen zijn in deze browser geblokkeerd. Pas de toestemming aan via de site-instellingen van de browser.",
      "BrowserNotificationsUnsupportedHelp": "Deze browser ondersteunt geen systeemmeldingen voor de portal.",
      "BrowserNotificationsCallerNameToggle": "Naam van collega in systeemmelding tonen",
      "BrowserNotificationsCallerNameHelp": "Als deze optie uitstaat, toont de systeemmelding geen naam. Alleen deze voorkeur wordt in deze browser opgeslagen.",
      "BrowserNotificationsPermissionError": "De toestemming voor browsermeldingen kon niet worden opgevraagd.",
      "BrowserNotificationsLoginPromptTitle": "Geen oproep of uitnodiging missen?",
      "BrowserNotificationsLoginPromptMessage": "Sta browsermeldingen toe, zodat u oproepen en meetinguitnodigingen ook ziet wanneer de portal op de achtergrond staat.",
      "BrowserNotificationsLoginPromptPrivacy": "De naam van de collega wordt standaard niet in de melding getoond. U kunt dit later wijzigen bij",
      "BrowserNotificationsLoginPromptPrivacyLink": "Collega's",
      "BrowserNotificationsLoginPromptLater": "Niet nu",
      "DirectCallButton": "Bellen",
      "CallingColleague": "{colleague} bellen...",
      "DirectCallConfirmTitle": "Collega bellen",
      "DirectCallConfirmMessage": "Wilt u {colleague} bellen?",
      "DirectCallConfirmOk": "Ja, bellen",
      "DirectCallConfirmCancel": "Annuleren",
      "DirectCallReasonLabel": "Reden van de oproep (optioneel)",
      "DirectCallReasonHint": "Geef kort aan waarom u belt.",
      "DirectCallReasonDetailLabel": "Reden",
      "DirectCallWaitingTitle": "Collega bellen",
      "DirectCallWaitingMessage": "Wachten tot {colleague} opneemt.",
      "DirectCallCancelButton": "Oproep annuleren",
      "DirectCallCancelFailed": "De oproep kon niet worden geannuleerd.",
      "DirectCallAcceptFailed": "De oproep kon niet worden geaccepteerd.",
      "DirectCallDeclineFailed": "De oproep kon niet worden geweigerd.",
      "DirectCallRequestFailed": "De oproep kon niet worden gestart.",
      "DirectCallCallerInMeeting": "U kunt geen collega bellen terwijl u in een meeting zit.",
      "DirectCallTargetBusy": "Deze collega wordt al gebeld. Probeer het later opnieuw.",
      "IncomingDirectCallTitle": "Inkomende oproep",
      "IncomingDirectCallMessage": "Rechtstreekse collega-oproep.",
      "IncomingDirectCallNotificationTitle": "Inkomende collega-oproep",
      "IncomingDirectCallNotificationGenericBody": "Open OMNI Sessions om de oproep te bekijken.",
      "IncomingDirectCallNotificationNamedBody": "{caller}",
      "DirectCallAcceptedToast": "Oproep geaccepteerd.",
      "DirectCallAlreadyInCallToast": "Collega zit al in een gesprek.",
      "DirectCallAppearedOfflineToast": "Collega heeft zichzelf offline gezet.",
      "DirectCallDeclinedToast": "Oproep geweigerd.",
      "DirectCallDoNotDisturbToast": "Collega is bezet.",
      "DirectCallCancelledToast": "De oproep is geannuleerd.",
      "DirectCallCallerDisconnectedToast": "{caller} heeft de verbinding verbroken. De oproep is ingetrokken.",
      "DirectCallCalleeDisconnectedToast": "{callee} heeft de verbinding verbroken. De oproep is geweigerd.",
      "DirectCallMeetingUnavailableToast": "De oproep kon niet worden gestart.",
      "DirectCallNoAnswerToast": "{callee} reageert niet.",
      "DirectCallMeetingOpenFailed": "De oproep kon niet worden geopend.",
      "Errors": {
        "ErrorCode": {
          "DIRECT_CALL_CUSTOMER_REQUIRED": "Er is geen klantcontext gevonden.",
          "DIRECT_CALL_CUSTOMER_USER_REQUIRED": "Er is geen geldige klantgebruiker gevonden.",
          "DIRECT_CALL_TARGET_REQUIRED": "Selecteer een collega om te bellen.",
          "DIRECT_CALL_SELF_CALL_NOT_ALLOWED": "U kunt uzelf niet bellen.",
          "DIRECT_CALL_CALLER_IN_MEETING": "U kunt geen collega bellen terwijl u in een meeting zit.",
          "DIRECT_CALL_TARGET_UNAVAILABLE": "Deze collega is niet beschikbaar voor oproepen.",
          "DIRECT_CALL_TARGET_OFFLINE": "Deze collega is offline.",
          "DIRECT_CALL_TARGET_NOT_CALLABLE": "Deze collega is momenteel niet bereikbaar.",
          "DIRECT_CALL_TARGET_BUSY": "Deze collega wordt al gebeld. Probeer het later opnieuw.",
          "DIRECT_CALL_REASON_TOO_LONG": "De reden mag maximaal 500 tekens bevatten.",
          "DIRECT_CALL_UNAVAILABLE": "Deze oproep is niet meer beschikbaar.",
          "DIRECT_CALL_PARTICIPANTS_INVALID": "De deelnemers voor deze oproep zijn ongeldig.",
          "DIRECT_CALL_PARTICIPANTS_UNAVAILABLE": "Een deelnemer is niet beschikbaar binnen deze klantomgeving.",
          "DIRECT_CALL_PARTICIPANT_CUSTOMER_CONTEXT_MISMATCH": "Een deelnemer hoort niet bij de actieve klantomgeving.",
          "DIRECT_CALL_PARTICIPANTS_MISSING_MEETING_PERMISSIONS": "Een deelnemer heeft geen rechten om meetings te gebruiken.",
          "DIRECT_CALL_PARTICIPANTS_MISSING_MEET_LICENSE": "Een deelnemer heeft geen actieve OMNI Sessions Meet-licentie.",
          "DIRECT_CALL_PARTICIPANTS_MISSING_CALENDAR": "Een deelnemer heeft geen agenda voor meetings.",
          "DIRECT_CALL_MEETING_CREATE_FAILED": "De meeting voor deze oproep kon niet worden aangemaakt.",
          "PRESENCE_CUSTOMER_USER_REQUIRED": "Er is geen geldige klantgebruiker gevonden om uw status bij te werken."
        }
      },
      "IncomingMeetingInviteTitle": "Uitnodiging voor een meeting",
      "IncomingMeetingInviteMessage": "{caller} nodigt u uit om nu deel te nemen.",
      "IncomingMeetingInviteNotificationTitle": "Uitnodiging voor een meeting",
      "IncomingMeetingInviteNotificationGenericBody": "Open OMNI Sessions om de uitnodiging te bekijken.",
      "IncomingMeetingInviteNotificationNamedBody": "{caller} nodigt u uit voor ‘{subject}’.",
      "IncomingMeetingInviteNotificationNamedBodyWithoutSubject": "{caller} nodigt u uit voor een meeting.",
      "MeetingInviteSubjectLabel": "Onderwerp",
      "MeetingInviteStartLabel": "Gestart",
      "MeetingInviteNoSubject": "Geen onderwerp",
      "MeetingInviteNoStartTime": "Onbekend",
      "MeetingInviteAcceptFailed": "De uitnodiging kon niet worden geaccepteerd.",
      "MeetingInviteDeclineFailed": "De uitnodiging kon niet worden geweigerd.",
      "MeetingInviteDeclinedToast": "Uitnodiging geweigerd."
    },
    "Sms-logs": {
      "SmsSent": "SMS status"
    },
    "Statistics": {
      "Overview": "Overzicht",
      "Meetings": "Meetings",
      "Feedback": "Feedback",
      "Sms": "SMS",
      "Email": "E-mail",
      "Licenses": "Licenties",
      "MeetingsDescription": "Bekijk aantallen vergaderingen, deelnemers, sessies en duur.",
      "FeedbackDescription": "Bekijk aantallen ingevulde feedback en unieke respondenten.",
      "SmsDescription": "Bekijk verzonden, mislukte en aflevertrends van sms-verkeer.",
      "EmailDescription": "Bekijk verzendprestatie, ontvangers en e-mailtypetrends.",
      "LicensesDescription": "Bekijk licentiekosten, seats, bezetting, verlengingen en geplande wijzigingen.",
      "GoToMeetings": "Ga naar meetings",
      "GoToFeedback": "Ga naar feedback",
      "GoToSms": "Ga naar SMS",
      "GoToEmail": "Ga naar e-mail",
      "GoToLicenses": "Ga naar licentiestatistieken"
    },
    "LicenseStatistics": {
      "LoadError": "De licentiestatistieken konden niet worden geladen.",
      "OverviewSection": "Licentieoverzicht",
      "CapacitySection": "Capaciteit",
      "FinancialSection": "Totaalkosten",
      "LicenseRevenueSection": "Licenties",
      "SlaRevenueSection": "SLA's",
      "PartnerProgramRevenueSection": "Partnerkorting",
      "LicenseRevenueSubject": "licenties",
      "SlaRevenueSubject": "SLA's",
      "PartnerProgramRevenueSubject": "partnerkorting",
      "RenewalSection": "Verlengingen en wijzigingen",
      "ScopeSection": "Scope",
      "TrendSection": "Trends",
      "ProductBreakdownSection": "Per product",
      "CustomerBreakdownSection": "Per klant",
      "LicenseListSection": "Licenties",
      "activeLicenses": "Actieve licenties",
      "totalSeats": "Afgenomen seats",
      "assignedSeats": "Toegewezen seats",
      "availableSeats": "Beschikbare seats",
      "occupancyRate": "Bezettingsgraad",
      "renewalsNext30Days": "Verlengingen binnen 30 dagen",
      "fullLicenses": "Volledig benut",
      "unusedLicenses": "Onbenut",
      "underusedLicenses": "Onderbenut",
      "periodRevenue": "Kosten in periode",
      "currentMrr": "Huidige maandkosten",
      "currentArr": "Huidige jaarkosten",
      "projectedMrr": "Verwachte maandkosten peildatum",
      "futureProjectedMrr": "Verwachte maandkosten incl. toekomstige wijzigingen",
      "projectedMrrDelta": "Verwachte wijziging maandkosten peildatum",
      "projectedArr": "Verwachte jaarkosten peildatum",
      "futureProjectedArr": "Verwachte jaarkosten incl. toekomstige wijzigingen",
      "projectedArrDelta": "Verwachte wijziging jaarkosten peildatum",
      "partnerProgramDiscountPeriodRevenue": "Korting in periode",
      "partnerProgramDiscountCurrentMrr": "Huidige maandkorting",
      "partnerProgramDiscountCurrentArr": "Huidige jaarkorting",
      "partnerProgramDiscountProjectedMrr": "Verwachte maandkorting peildatum",
      "partnerProgramDiscountFutureProjectedMrr": "Verwachte maandkorting incl. toekomstige wijzigingen",
      "partnerProgramDiscountProjectedMrrDelta": "Verwachte wijziging maandkorting peildatum",
      "partnerProgramDiscountProjectedArr": "Verwachte jaarkorting peildatum",
      "partnerProgramDiscountFutureProjectedArr": "Verwachte jaarkorting incl. toekomstige wijzigingen",
      "partnerProgramDiscountProjectedArrDelta": "Verwachte wijziging jaarkorting peildatum",
      "pendingChanges": "Geplande wijzigingen",
      "pendingSeatDelta": "Geplande seat-wijziging",
      "pendingProductChanges": "Geplande productwijzigingen",
      "endingOnRenewal": "Eindigt bij verlenging",
      "activeProducts": "Producten in gebruik",
      "activeCustomers": "Klanten met licenties",
      "periodRevenueCaption": "Prorata licentiekosten over de geselecteerde periode. Start of stopt een subscription halverwege een maand, dan tellen alleen de actieve dagen mee.",
      "currentMrrCaption": "Maandelijkse terugkerende licentiekosten als run-rate. Jaarbedragen worden omgerekend naar maandbedrag; gedeeltelijke maanden worden niet geprorateerd.",
      "currentArrCaption": "Jaarlijkse terugkerende licentiekosten als run-rate. Dit zijn de huidige maandkosten maal 12.",
      "projectedMrrCaption": "Verwachte maandkosten op basis van licenties die op de peildatum binnen de selectie vallen. Toekomstige aankopen met een latere startdatum tellen hier niet mee.",
      "futureProjectedMrrCaption": "Dezelfde verwachte maandkosten, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "projectedMrrDeltaCaption": "Verschil tussen verwachte maandkosten op peildatum en huidige maandkosten.",
      "projectedArrCaption": "Verwachte jaarkosten nadat geplande licentiewijzigingen bij de volgende verlenging zijn toegepast. Dit zijn de verwachte maandkosten maal 12.",
      "futureProjectedArrCaption": "Dezelfde verwachte jaarkosten, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "projectedArrDeltaCaption": "Verschil tussen verwachte jaarkosten op peildatum en huidige jaarkosten.",
      "RevenueBreakdownPeriodRevenueCaption": "Prorata kosten voor {subject} over de geselecteerde periode. Start of stopt een subscription halverwege een maand, dan tellen alleen de actieve dagen mee.",
      "RevenueBreakdownCurrentMrrCaption": "Maandelijkse terugkerende kosten voor {subject} als run-rate. Jaarbedragen worden omgerekend naar maandbedrag; gedeeltelijke maanden worden niet geprorateerd.",
      "RevenueBreakdownCurrentArrCaption": "Jaarlijkse terugkerende kosten voor {subject} als run-rate. Dit zijn de huidige maandkosten maal 12.",
      "RevenueBreakdownProjectedMrrCaption": "Verwachte maandkosten voor {subject} op basis van licenties die op de peildatum binnen de selectie vallen. Toekomstige aankopen met een latere startdatum tellen hier niet mee.",
      "RevenueBreakdownFutureProjectedMrrCaption": "Dezelfde verwachte maandkosten voor {subject}, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "RevenueBreakdownProjectedMrrDeltaCaption": "Verschil tussen verwachte maandkosten op peildatum en huidige maandkosten voor {subject}.",
      "RevenueBreakdownProjectedArrCaption": "Verwachte jaarkosten voor {subject} nadat geplande licentiewijzigingen bij de volgende verlenging zijn toegepast. Dit zijn de verwachte maandkosten maal 12.",
      "RevenueBreakdownFutureProjectedArrCaption": "Dezelfde verwachte jaarkosten voor {subject}, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "RevenueBreakdownProjectedArrDeltaCaption": "Verschil tussen verwachte jaarkosten op peildatum en huidige jaarkosten voor {subject}.",
      "PartnerProgramDiscountBreakdownPeriodRevenueCaption": "Prorata partnerkorting over de geselecteerde periode. Start of stopt een subscription halverwege een maand, dan tellen alleen de actieve dagen mee.",
      "PartnerProgramDiscountBreakdownCurrentMrrCaption": "Maandelijkse terugkerende partnerkorting als run-rate. Jaarbedragen worden omgerekend naar maandbedrag; gedeeltelijke maanden worden niet geprorateerd.",
      "PartnerProgramDiscountBreakdownCurrentArrCaption": "Jaarlijkse terugkerende partnerkorting als run-rate. Dit is de huidige maandkorting maal 12.",
      "PartnerProgramDiscountBreakdownProjectedMrrCaption": "Verwachte maandkorting op basis van licenties die op de peildatum binnen de selectie vallen. Toekomstige aankopen met een latere startdatum tellen hier niet mee.",
      "PartnerProgramDiscountBreakdownFutureProjectedMrrCaption": "Dezelfde verwachte maandkorting, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "PartnerProgramDiscountBreakdownProjectedMrrDeltaCaption": "Verschil tussen verwachte maandkorting op peildatum en huidige maandkorting.",
      "PartnerProgramDiscountBreakdownProjectedArrCaption": "Verwachte jaarkorting nadat geplande licentiewijzigingen bij de volgende verlenging zijn toegepast. Dit is de verwachte maandkorting maal 12.",
      "PartnerProgramDiscountBreakdownFutureProjectedArrCaption": "Dezelfde verwachte jaarkorting, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "PartnerProgramDiscountBreakdownProjectedArrDeltaCaption": "Verschil tussen verwachte jaarkorting op peildatum en huidige jaarkorting.",
      "pendingChangesCaption": "Aantal licenties met geplande wijzigingen voor de volgende verlenging.",
      "pendingSeatDeltaCaption": "Netto wijziging in seats door geplande licentiewijzigingen.",
      "pendingProductChangesCaption": "Aantal geplande wijzigingen waarbij het licentieproduct wijzigt.",
      "endingOnRenewalCaption": "Aantal licenties dat bij de volgende verlenging naar 0 seats gaat.",
      "FromDate": "Trend vanaf",
      "UntilDate": "Peildatum",
      "ForecastRange": "Forecastperiode",
      "ForecastMonthsOption": "{months} maanden",
      "DateRangeHelp": "De begindatum bepaalt waar de trendgrafieken starten. De peildatum bepaalt de stand in de cards en is tegelijk het einde van de trendperiode.",
      "PeriodRevenueTrendTitle": "Kosten per maand",
      "RevenueTrendTitle": "Maandkosten per maand",
      "FutureRevenueForecastTitle": "Verwachte kostenontwikkeling",
      "SeatTrendTitle": "Seats per maand",
      "RenewalTrendTitle": "Verlengingen per maand",
      "PeriodRevenuePerMonth": "Kosten",
      "CurrentMrrPerMonth": "Huidige maandkosten",
      "ProjectedMrrPerMonth": "Verwachte maandkosten",
      "ForecastMrr": "Verwachte maandkosten",
      "TotalSeatsPerMonth": "Afgenomen seats",
      "AssignedSeatsPerMonth": "Toegewezen seats",
      "AvailableSeatsPerMonth": "Beschikbare seats",
      "RenewalsPerMonth": "Verlengingen",
      "PendingChangesPerMonth": "Geplande wijzigingen",
      "NoPeriodRevenueTrendData": "Er zijn geen kostengegevens beschikbaar in de geselecteerde periode.",
      "NoRevenueTrendData": "Er zijn geen kostentrendgegevens beschikbaar in de geselecteerde periode.",
      "NoFutureRevenueForecastData": "Er zijn geen forecastgegevens beschikbaar voor de gekozen periode.",
      "NoSeatTrendData": "Er zijn geen seattrendgegevens beschikbaar in de geselecteerde periode.",
      "NoRenewalTrendData": "Er zijn geen verlengingstrendgegevens beschikbaar in de geselecteerde periode.",
      "Name": "Naam",
      "Customer": "Klant",
      "Product": "Product",
      "ActiveLicenses": "Actieve licenties",
      "TotalSeats": "Afgenomen seats",
      "AssignedSeats": "Toegewezen seats",
      "AvailableSeats": "Beschikbaar",
      "OccupancyRate": "Bezettingsgraad",
      "CurrentMrr": "Maandkosten",
      "RenewDate": "Verlengdatum",
      "PendingChanges": "Geplande wijzigingen",
      "Pending": "Gepland",
      "User": "Gebruiker",
      "Email": "E-mail",
      "StartDate": "Startdatum",
      "EndDate": "Einddatum",
      "NoAssignedUsers": "Geen toegewezen gebruikers."
    },
    "Sharingcenter-meeting-logs": {
      "Customer": "Klant",
      "Status": "Status"
    },
    "Sharingcenter-appointments": {
      "Unable to join": "Kan niet deelnemen.",
      "Confirm profile change": "Profiel wijzigen",
      "Overwrite settings question": "Dit profiel heeft eigen instellingen. Wilt u de huidige instellingen vervangen door de instellingen van dit profiel?",
      "Overwrite": "Vervangen",
      "Keep": "Huidige behouden",
      "Profile": "Profiel",
      "No profile": "Geen profiel",
      "TimeZone": "Tijdzone",
      "Tzid": "Tijdzone",
      "Edit only this occurrence": "Bewerk alleen deze gebeurtenis",
      "Edit all future occurrences": "Bewerk alle toekomstige gebeurtenissen",
      "Edit all occurrences in this series": "Bewerk alle gebeurtenissen in deze reeks",
      "Delete only this occurrence": "Verwijder alleen deze gebeurtenis",
      "Delete all future occurrences": "Verwijder alle toekomstige gebeurtenissen",
      "Delete all occurrences in this series": "Verwijder alle gebeurtenissen in deze reeks",
      "Message optional": "Bericht (optioneel)",
      "Email organizer": "E-mail organisator",
      "Mail everyone": "Mail iedereen",
      "InvalidLink": "Link is ongeldig.",
      "RsvpAccepted": "Afspraak gemarkeerd als geaccepteerd.",
      "RsvpDeclined": "Afspraak gemarkeerd als geweigerd.",
      "RsvpTentative": "Afspraak gemarkeerd als 'voorlopig'.",
      "RsvpGeneric": "RSVP verwerkt.",
      "Decline": "Afwijzen",
      "Maybe": "Voorlopig",
      "Accept": "Accepteren",
      "Send": "Verzenden",
      "RSVP sent": "RSVP verzonden.",
      "RSVP failed": "RSVP instelling mislukt.",
      "Status": "Status",
      "Link": "Link",
      "StatusOptions": {
        "Accepted": "Geaccepteerd",
        "Declined": "Geweigerd",
        "Tentative": "Voorlopig",
        "Waiting": "In afwachting"
      },
      "Show link": "Toon link",
      "Show more": "Toon meer",
      "Show less": "Toon minder",
      "Copy link": "Kopieer link",
      "Copy code": "Kopieer code",
      "Copied": "Gekopieerd.",
      "Copy failed": "Kopiëren mislukt/",
      "UserOrContact": "Gebruiker of contact",
      "Select participant": "Selecteer deelnemer (optioneel)",
      "Edit existing contact": "Bestaand contact bewerken",
      "Create new contact": "Nieuw contact maken",
      "Revert from contact": "Update vanuit contact",
      "Guest": "Gast",
      "Add participant": "Deelnemer toevoegen",
      "Add participants (max x)": "Deelnemers toevoegen (max {max})",
      "More options": "Meer opties",
      "Agent": "Agent",
      "All day": "Hele dag",
      "AllDay": "Hele dag",
      "Pattern": "Herhalingspatroon",
      "RecurrenceRangeMode": "Einde van reeks",
      "RecurrencePattern": "Herhalingspatroon",
      "Recurrence": {
        "In month": "In de maand",
        "DoesNotRepeat": "Herhaalt zich niet",
        "RepeatAppointment": "Afspraak herhalen",
        "RepeatDaily": "Herhaal dagelijks",
        "RepeatWeekly": "Herhaal wekelijks",
        "RepeatMonthly": "Herhaal maandelijks",
        "RepeatYearly": "Herhaal jaarlijks",
        "Title": "Herhaling",
        "Pattern": "Herhalingspatroon",
        "Daily": "Dagelijks",
        "Weekly": "Wekelijks",
        "Monthly": "Maandelijks",
        "Yearly": "Jaarlijks",
        "Every": "Iedere",
        "Days": "dag(en)",
        "Weeks": "week/weken",
        "Months": "maand(en)",
        "Range": "Bereik van herhaling",
        "RangeNever": "Geen einddatum",
        "RangeAfter": "Eindigt na",
        "RangeOn": "Eindigt op",
        "Occurrences": "keer",
        "EndBy": "Einddatum",
        "Clear": "Herhaling verwijderen",
        "MonthlyModeDay": "Op dag",
        "MonthlyModeOnThe": "Op de",
        "WeekIndex": {
          "First": "Eerste",
          "Second": "Tweede",
          "Third": "Derde",
          "Fourth": "Vierde",
          "Last": "Laatste"
        },
        "MonthWeekday": {
          "Day": "Dag",
          "Weekday": "Werkdag",
          "WeekendDay": "Weekenddag"
        }
      },
      "RecurrenceSummary": {
        "DoesNotRepeat": "Herhaalt zich niet",
        "DailySingular": "Herhaalt zich elke dag",
        "DailyPlural": "Herhaalt zich elke {interval} dagen",
        "WeeklyWithDaysSingular": "Herhaalt zich elke week op {days}",
        "WeeklyWithDaysPlural": "Herhaalt zich elke {interval} weken op {days}",
        "WeeklyNoDaysSingular": "Herhaalt zich elke week",
        "WeeklyNoDaysPlural": "Herhaalt zich elke {interval} weken",
        "MonthlyDayOfMonthSingular": "Herhaalt zich elke maand op dag {day}",
        "MonthlyDayOfMonthPlural": "Herhaalt zich elke {interval} maanden op dag {day}",
        "MonthlyNthWeekdaySingular": "Herhaalt zich elke maand op de {index} {weekday}",
        "MonthlyNthWeekdayPlural": "Herhaalt zich elke {interval} maanden op de {index} {weekday}",
        "YearlyDayOfMonthSingular": "Herhaalt zich elk jaar op {day} {month}",
        "YearlyNthWeekdaySingular": "Herhaalt zich elk jaar op de {index} {weekday} in {month}",
        "YearlyGenericSingular": "Herhaalt zich elk jaar",
        "RangeAfter": "eindigt na {count} herhalingen",
        "RangeOn": "eindigt op {date}",
        "And": "en",
        "WeekdayNames": {
          "MO": "maandag",
          "TU": "dinsdag",
          "WE": "woensdag",
          "TH": "donderdag",
          "FR": "vrijdag",
          "SA": "zaterdag",
          "SU": "zondag"
        },
        "WeekIndexNames": {
          "First": "eerste",
          "Second": "tweede",
          "Third": "derde",
          "Fourth": "vierde",
          "Last": "laatste"
        },
        "MonthNames": {
          "10": "oktober",
          "11": "november",
          "12": "december",
          "01": "januari",
          "02": "februari",
          "03": "maart",
          "04": "april",
          "05": "mei",
          "06": "juni",
          "07": "juli",
          "08": "augustus",
          "09": "september"
        },
        "MonthWeekdayNames": {
          "DAY": "dag",
          "WEEKDAY": "werkdag",
          "WEEKEND": "weekenddag"
        }
      },
      "Weekday": {
        "Mon": "Ma",
        "Tue": "Di",
        "Wed": "Wo",
        "Thu": "Do",
        "Fri": "Vr",
        "Sat": "Za",
        "Sun": "Zo"
      },
      "Appointment types": {
        "chat": "Chat",
        "fileshare": "Bestanden delen",
        "meeting": "Vergadering",
        "screenshare": "Scherm delen"
      },
      "Appointment types heading": {
        "chat": "Chat",
        "fileshare": "Bestanden delen",
        "meeting": "Vergadering",
        "screenshare": "Scherm delen"
      },
      "Appointments": "Afspraak | Afspraken",
      "By email": "Per e-mail",
      "By SMS": "Per SMS",
      "Calendar": "Agenda",
      "CalendarView": "Weergave",
      "Choose a user or set role to guest": "Kies een gebruiker of stel de rol in op gast",
      "Code": "Code",
      "Code description icon": "Deel deze code met de gebruiker via een tweede kanaal (bijv. WhatsApp, sms of een telefoongesprek). De gebruiker moet de code invoeren bij het openen van de afspraak als extra beveiligingslaag.",
      "Created at": "Gemaakt op",
      "Created by": "Gemaakt door",
      "Current calendar": "Huidige agenda",
      "Default calendar": "Standaardagenda",
      "Delete": "verwijderen",
      "Delete appointment": "Afspraak verwijderen",
      "Delete item": "Afspraak verwijderen",
      "Delete item fail": "De afspraak kon niet worden verwijderd.",
      "Delete item success": "Afspraak succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je afspraak {0} wilt {1}?",
      "Delete item text series this": "Weet je zeker dat je alleen deze gebeurtenis van afspraak {0} wilt {1}?",
      "Delete item text series future": "Weet je zeker dat je alle toekomstige gebeurtenissen van afspraak {0} wilt {1}?",
      "Description": "Omschrijving",
      "Do not notify": "Niet informeren",
      "Edit appointment": "Afspraak bewerken",
      "Edit item fail": "Fout bij het wijzigen van de afspraak.",
      "Edit item success": "Afspraak succesvol gewijzigd.",
      "Email": "E-mail",
      "End": "Eind",
      "End must be after start": "Eindtijd moet na starttijd liggen.",
      "EndAt": "Eind",
      "Errors": {
        "Error loading data": "Fout bij laden van gegevens"
      },
      "Explain message variables": "Gebruik de onderstaande invoegcodes; ze worden automatisch vervangen bij het verzenden van de e-mail.",
      "FirstName": "Voornaam",
      "Form heading": "{name}",
      "FromDate": "Van",
      "General": "Algemeen",
      "Generate": "Genereren",
      "Link by email / Code by SMS": "Link per e-mail / Code per SMS",
      "Link by SMS / Code by email": "Link per SMS / Code per e-mail",
      "Guest fields are required when sending by email": "Bij verzenden via e-mail zijn de gastvelden verplicht",
      "Guestemail": "E-mail gast",
      "Guestfirstname": "Voornaam gast",
      "Guestlastname": "Achternaam gast",
      "Hide message vars": "Verberg invoegcodes",
      "Join": "Deelnemen",
      "Join disabled active meeting": "Andere afspraak actief.",
      "Join disabled not started": "Deelname nog niet beschikbaar.",
      "Join disabled expired": "Deelname niet meer beschikbaar.",
      "Kind": "Type",
      "Kind options": {
        "Agent": "Agent",
        "Guest": "Gast"
      },
      "LastName": "Achternaam",
      "Message": "Bericht",
      "MessageVariableList": {
        "email": "E-mailadres van de deelnemer.",
        "firstName": "Voornaam van de deelnemer.",
        "fullName": "Volledige naam van de deelnemer.",
        "lastName": "Achternaam van de deelnemer."
      },
      "Name": "Naam",
      "Narrow view": "Versmal weergave",
      "New appointment": "Nieuwe afspraak",
      "New item fail": "Fout bij het aanmaken van de afspraak.",
      "New item success": "Afspraak succesvol aangemaakt.",
      "No subject": "Geen onderwerp",
      "No user": "Geen gebruiker",
      "Notes": "Notities",
      "Only shared calendars available": "Deze afspraak kan alleen in een gedeelde agenda worden gemaakt.",
      "Overlapping appointments one": "Er is 1 overlappende afspraak.",
      "Overlapping appointments other": "Er zijn {count} overlappende afspraken.",
      "Own calendar": "Eigen agenda",
      "Starts in": "Begint over {time}",
      "In progress": "Nu",
      "Ended": "Afgelopen",
      "participants": "deelnemer | deelnemers",
      "Participants": "Deelnemers",
      "Phone": "Telefoon",
      "Please choose agent or guest for each participant": "Kies voor elke deelnemer agent of gast",
      "Please choose an agent for participant": "Kies een agent voor deelnemer",
      "Role": "Rol",
      "Search": "Zoeken",
      "Settings": "Instellingen",
      "Share": "Delen",
      "Shared calendar": "Gedeelde agenda",
      "Sharemethod": "Hoe wil je de link delen",
      "ShareMethod": "Informeren",
      "Sharemethod options": {
        "Email": "Per e-mail",
        "Self": "Ik deel het zelf"
      },
      "Show message vars": "Toon invoegcodes",
      "Start": "Start",
      "StartAt": "Start",
      "Subject": "Onderwerp",
      "Switch to calendar view": "Schakel naar kalenderweergave",
      "Switch to list view": "Schakel naar lijstweergave",
      "TillDate": "Tot",
      "Type": "Type",
      "User": "Gebruiker",
      "User calendar": "Agenda van gebruiker",
      "UserCalendar": "Agenda",
      "Variables": "Invoegcodes",
      "View participants": "Deelnemers bekijken",
      "Widen view": "Verbreed weergave",
      "You can add up to 3 persons": "Je kunt maximaal 3 personen toevoegen"
    },
    "Sharingcenter-calendars": {
      "Calendars": "Agenda | Agenda's",
      "Cancel": "Annuleren",
      "Change owner": "Eigenaar wijzigen",
      "Choose color": "Kies kleur",
      "Choose target calendar": "Kies doelagenda",
      "Default": "Default",
      "Delete": "verwijderen",
      "Delete all": "Alles verwijderen",
      "Delete calendar": "Agenda verwijderen",
      "Delete item": "Agenda verwijderen",
      "Delete item fail": "De agenda kon niet worden verwijderd.",
      "Delete item success": "Agenda succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je agenda {0} wilt {1}? Alle afspraken in deze agenda worden ook verwijderd.",
      "Edit calendar": "Agenda bewerken",
      "Edit item fail": "Fout bij het wijzigen van de agenda.",
      "Edit item success": "Agenda succesvol gewijzigd.",
      "Errors": {
        "Error loading data": "Fout bij laden van gegevens"
      },
      "Groups": "Groepen",
      "Make default": "Standaard maken",
      "Manage calendars": "Agenda's beheren",
      "Move and delete": "Verhuizen en verwijderen",
      "Move to another calendar": "Verhuizen naar andere agenda",
      "My calendars": "Mijn agenda's",
      "Name": "Naam",
      "New calendar": "Nieuwe agenda",
      "New item fail": "Fout bij het maken van de agenda.",
      "New item success": "Agenda succesvol toegevoegd.",
      "No available target calendars": "Geen beschikbare agenda van dezelfde eigenaar",
      "Owner": "Eigenaar",
      "OwnerId": "Eigenaar ID",
      "Permissions": {
        "AvailabilityOnly": "Alleen beschikbaarheid",
        "Editor": "Bewerker",
        "Owner": "Eigenaar",
        "Viewer": "Lezer"
      },
      "Pick color": "Kleur kiezen",
      "Save": "Opslaan",
      "Search": "Zoeken",
      "Shared with": "Gedeeld met",
      "Shared with me": "Gedeeld met mij",
      "This calendar is shared": "Deze agenda is gedeeld",
      "Users": "Gebruikers",
      "Visible": "Zichtbaar",
      "What to do with appointments": "Wat wilt u doen met de afspraken?"
    },
    "Sharingcenter-contacts": {
      "Resolve future appointments": "Toekomstige afspraken oplossen",
      "This contact is linked to upcoming appointments, what would you like to do": "Dit contact is gekoppeld aan komende afspraken. Wat wilt u doen?",
      "Update participants with new contact info": "Deelnemers bijwerken met nieuwe contactgegevens",
      "Keep appointments unchanged": "Afspraken ongewijzigd laten",
      "Contacts": "Contacten",
      "My contacts": "Mijn contacten",
      "Shared with me": "Gedeeld met mij",
      "Manage contacts": "Contacten beheren",
      "New contact": "Nieuw contact",
      "Edit contact": "Contact bewerken",
      "Save": "Opslaan",
      "Cancel": "Annuleren",
      "Search": "Zoeken",
      "Shared with": "Gedeeld met",
      "Users": "Gebruikers",
      "Groups": "Groepen",
      "FirstName": "Voornaam",
      "LastName": "Achternaam",
      "Email": "E-mail",
      "Phone": "Telefoon",
      "Unknown": "Onbekend",
      "Make default": "Als standaard instellen",
      "Visible": "Zichtbaar",
      "Default": "Standaard",
      "Pick color": "Kies kleur",
      "Choose color": "Kies kleur",
      "Errors": {
        "Error loading data": "Fout bij laden van gegevens"
      },
      "Delete": "verwijderen",
      "Delete all": "Alles verwijderen",
      "Delete contact": "Contact verwijderen",
      "Delete item": "Contact verwijderen",
      "Delete item fail": "Het contact kon niet worden verwijderd.",
      "Delete item success": "Contact succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je contact {0} wilt {1}?.",
      "New item success": "Contact succesvol toegevoegd.",
      "New item fail": "Fout bij het maken van het contact.",
      "Edit item success": "Contact succesvol gewijzigd.",
      "Edit item fail": "Fout bij het wijzigen van het contact.",
      "Viewer": "Lezer",
      "Editor": "Bewerker",
      "OwnerId": "Eigenaar",
      "Confirm owner or sharing change": "Wijziging van eigenaar of gedeelde instellingen",
      "Continue": "Doorgaan",
      "Confirm owner or sharing text": "Het wijzigen van de eigenaar of gedeelde instellingen kan ertoe leiden dat dit contact wordt ontkoppeld van bestaande afspraken en dat automatische updates van de contactgegevens niet meer worden uitgevoerd."
    },
    "Sharingcenter-profiles": {
      "Settings": "Instellingen",
      "Resolve future appointments": "Toekomstige afspraken oplossen",
      "This profile is linked to upcoming appointments, what would you like to do": "Dit profiel is gekoppeld aan komende afspraken. Wat wilt u doen?",
      "Update participants with new profile info": "Deelnemers bijwerken met nieuwe profielgegevens",
      "Keep appointments unchanged": "Afspraken ongewijzigd laten",
      "Profiles": "Profielen",
      "My profiles": "Mijn profielen",
      "Shared with me": "Gedeeld met mij",
      "Manage profiles": "Profielen beheren",
      "New profile": "Nieuw profiel",
      "Edit profile": "Profiel bewerken",
      "Save": "Opslaan",
      "Cancel": "Annuleren",
      "Search": "Zoeken",
      "Shared with": "Gedeeld met",
      "Users": "Gebruikers",
      "Groups": "Groepen",
      "Name": "Naam",
      "Description": "Omschrijving",
      "IsPublic": "Openbaar",
      "Public": "Openbaar",
      "Public profile info": "Openbare profielen zijn zichtbaar voor iedereen binnen de organisatie. Alleen beheerders met rechten om openbare profielen te beheren kunnen deze profielen wijzigen. Een openbaar profiel kan niet meer privé worden gemaakt.",
      "Unknown": "Onbekend",
      "Errors": {
        "Error loading data": "Fout bij laden van gegevens"
      },
      "Delete": "verwijderen",
      "Delete all": "Alles verwijderen",
      "Delete profile": "Profiel verwijderen",
      "Delete item": "Profiel verwijderen",
      "Delete item fail": "Het profiel kon niet worden verwijderd.",
      "Delete item success": "Profiel succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je profiel {0} wilt {1}?",
      "New item success": "Profiel succesvol toegevoegd.",
      "New item fail": "Fout bij het maken van het profiel.",
      "Edit item success": "Profiel succesvol gewijzigd.",
      "Edit item fail": "Fout bij het wijzigen van het profiel.",
      "Type": "Type",
      "TypeOptions": {
        "Fileshare": "Bestanden delen",
        "Screenshare": "Scherm delen",
        "Chat": "Chat",
        "Meeting": "Vergadering"
      },
      "Viewer": "Lezer",
      "Editor": "Bewerker",
      "OwnerId": "Eigenaar",
      "Confirm owner or sharing change": "Wijziging van eigenaar of gedeelde instellingen",
      "Continue": "Doorgaan",
      "Confirm owner or sharing text": "Het wijzigen van de eigenaar of gedeelde instellingen kan ertoe leiden dat dit profiel wordt ontkoppeld van bestaande afspraken."
    },
    "Sharingcenter-groups": {
      "Cancel": "Annuleren",
      "Delete group": "Groep verwijderen",
      "Delete item": "Groep verwijderen",
      "Delete item fail": "De groep kon niet worden verwijderd.",
      "Delete item success": "Groep succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je groep {0} wilt verwijderen?",
      "Edit": "Bewerken",
      "Edit group": "Groep bewerken",
      "Edit item fail": "Fout bij het wijzigen van de groep.",
      "Edit item success": "Groep succesvol gewijzigd.",
      "Errors": {
        "Error loading data": "Fout bij laden van gegevens",
        "Error saving": "Fout bij opslaan",
        "Missing group id": "Groeps-ID ontbreekt"
      },
      "Group name": "Groepsnaam",
      "Groups": "Groepen",
      "Manage groups": "Groepen beheren",
      "members": "lid | leden",
      "My groups": "Mijn groepen",
      "Name": "Naam",
      "New group": "Nieuwe groep",
      "New item fail": "Fout bij het maken van de groep.",
      "New item success": "Groep succesvol toegevoegd.",
      "Save": "Opslaan",
      "Saved": "Opgeslagen",
      "Search": "Zoeken",
      "Users": "Leden",
      "Validation": {
        "Name is required": "Naam is verplicht"
      },
      "View members": "Leden bekijken"
    },
    "Sharingcenter-new-appointment": {
      "Share a file": "Bestanden delen",
      "Share a file - CTA": "Bestanden delen",
      "Share a file - Description": "Stuur een beveiligde link die automatisch verloopt, zodat bestanden veilig te downloaden zijn.",
      "Share your screen": "Scherm delen",
      "Share your screen - CTA": "Schermdeling starten",
      "Share your screen - Description": "Deel direct uw scherm of laat uw klant hun scherm delen en begeleid ze live.",
      "SharedCalendarOnly": "Deze optie is beschikbaar door een gedeelde agenda. Nieuwe afspraken kunnen alleen in een gedeelde agenda worden gemaakt.",
      "Start a chat": "Chat starten",
      "Start a chat - CTA": "Chat starten",
      "Start a chat - Description": "Open een beveiligde chat om tijdelijk berichten en bestanden uit te wisselen.",
      "Start a meeting": "Vergadering starten",
      "Start a meeting - CTA": "Vergadering starten",
      "Start a meeting - Description": "Start een vergadering met camera, microfoon, chat, schermdeling en meer."
    },
    "Sharingcenter-overview": {
      "Appointments": "Afspraken",
      "Go to appointments": "Ga naar afspraken",
      "Go to calendar": "Ga naar agenda",
      "Go to groups": "Ga naar groepen",
      "Go to profiles": "Ga naar profielen",
      "Go to contacts": "Ga naar contacten",
      "Go to new appointment": "Ga naar nieuwe afspraak",
      "New appointment": "Nieuwe afspraak"
    },
    "Sharingcenter-meeting": {
      "Verify token invalid": "De link is ongeldig of verlopen.",
      "Verify token expired": "De link is verlopen.",
      "Verify token error": "Er ging iets mis bij het laden.",
      "Verify license missing": "Geen beschikbare licentie gevonden.",
      "Verify code text": "Voer de code in om door te gaan.",
      "Verify code": "Code verifiëren",
      "Verify code invalid": "De code is ongeldig.",
      "Meeting end text": "Bedankt voor uw deelname.",
      "Feedback already answered": "Antwoord al bekend.",
      "Feedback already answered text": "Bedankt voor uw antwoord.",
      "Feedback submitted text": "Bedankt voor uw antwoord."
    },
    "Subscription-cancellation": {
      "Cancel date": "Verwijderdatum",
      "Cancel reason": "Reden van opzegging",
      "Cancel subscription": "Opzeggen",
      "Cancellation date select text": "Kies hieronder een datum waarop de dienst moet worden opgezegd. Er geldt een opzegtermijn van {noticePeriod}.",
      "Cancellation domain note": "{0} op de gekozen datum wordt het domein verwijderd en tijdelijk in quarantaine geplaatst. Er zijn kosten aan verbonden om het domein uit quarantaine te halen.",
      "Cancellation hosting note": "{0} op de gekozen datum wordt het hostingaccount definitief verwijderd.",
      "Cancellation ssl note": "{0} op de gekozen datum wordt het SSL-certificaat definitief verwijderd.",
      "Cancellation warning": "Hoewel de dienst binnen de opzegtermijn beëindigd kan worden, ontvangt u nog wel een factuur voor de resterende periode. De dienst wordt alsnog verwijderd op de gekozen verwijderdatum.",
      "Confirm termination": "Opzegging bevestigen",
      "Confirm undo termination text": "Wilt u de annulering van de dienst ongedaan maken?",
      "PeriodicOptions": {
        "Day": "Dag | Dagen",
        "Month": "Maand | Maanden",
        "Year": "Jaar"
      },
      "Subscription cancel item success": "Abonnement is opgezegd.",
      "Subscription cancel reversed item success": "Opzegging is ongedaan gemaakt.",
      "Termination date after invoiced until": "{0} De gekozen verwijderdatum ligt na de huidige facturatieperiode. Hierdoor wordt uw dienst automatisch verlengd.",
      "Undo cancellation": "Opzegging annuleren"
    },
    "Users": {
      "Value": "Afbeelding",
      "Errors": {
        "Formats": {
          "phone": "Telefoonnummer moet een geldig internationaal geformatteerd telefoonnummer zijn."
        }
      }
    },
    "Webhosting": {
      "Account": "Hostingaccount | Hostingaccounts",
      "Autologin item fail": "Autologin mislukt. {msg}",
      "Autologin item success": "Het webhosting beheerderspaneel is geopend in een nieuw tabblad.",
      "Back to accounts": "Terug naar hostingaccounts",
      "Bandwidth": "Bandbreedte",
      "BandwidthQuota": "Bandbreedtequota",
      "Cancel subscription": "Opzeggen",
      "CancelDate": "Opgezegd op",
      "Cancelled": "Opgezegd",
      "Cpanel login": "Inloggen op hosting",
      "discount": "korting",
      "Disk Space": "Schijfruimte",
      "DiskQuota": "Schijfquota",
      "Email": "E-mail adres",
      "Errors": {
        "ErrorCode": {
          "CPANEL_CREATE_ACCOUNT_USERNAME_ALREADY_IN_USE": "Opgegeven gebruikersnaam is niet beschikbaar.",
          "PASSWORD_CONTAINS_INVALID_CHARACTERS": "Wachtwoord bevat illegale tekens."
        }
      },
      "incl": "incl.",
      "InvoiceDateHistory": {
        "EndDate": "Einddatum",
        "InvoiceDate": "Factuurdatum",
        "StartDate": "Stardatum"
      },
      "InvoicedUntilDate": "Gefactureerd t/m",
      "InvoiceHistory": "Factuurgeschiedenis",
      "InvoiceNextDate": "Volgende factuur",
      "InvoiceStartDate": "Begindatum factuur",
      "Linked domains": "Gekoppelde domeinen",
      "Lost password": "Accountgegevens opvragen",
      "More info": "Meer informatie",
      "New item": "Nieuw hostingaccount",
      "No hosting accounts found": "Geen hostingaccounts gevonden.",
      "No items": "Er zijn momenteel geen gekoppelde domeinen beschikbaar.",
      "Password": "Wachtwoord",
      "Period": "Periode",
      "PeriodicOptions": {
        "Day": "Dag | Dagen",
        "Month": "Maand | Maanden",
        "Year": "Jaar"
      },
      "Price": "Prijs",
      "PrimaryDomain": "Primair domein",
      "StartDate": "Startdatum",
      "Subscription": "Abonnement",
      "TerminationDate": "Verwijderdatum",
      "Undo cancellation": "Opzegging annuleren",
      "Unlimited": "Onbeperkt",
      "Upgraden": "Upgraden",
      "Username": "Gebruikersnaam",
      "WebhostingPackage": "Hosting pakket"
    },
    "Webhosting-packages": {
      "30 days backup": "30 dagen back-ups",
      "Amount due by": "Te betalen tot",
      "bandwidth": "bandbreedte",
      "Choose package": "Kies pakket",
      "discount": "korting",
      "diskspace": "schijfruimte",
      "Free SSL certificates": "Gratis SSL-certificaten",
      "incl": "incl.",
      "Included features": "Inbegrepen features:",
      "Most chosen": "Meest gekozen",
      "One-Click WordPress installation": "One-Click WordPress-installatie",
      "per year": "per jaar",
      "Support included": "Support inbegrepen",
      "Unlimited databases": "Onbeperkt databases",
      "Unlimited domain links": "Onbeperkt domeinen koppelen",
      "Unlimited mailboxes": "Onbeperkt mailboxen",
      "Unlimited subdomains": "Onbeperkt subdomeinen"
    },
    "Webhosting-send-account-details": {
      "Change password": "Wachtwoord wijzigen?",
      "Change password now": "Wijzig het wachtwoord in het hostingaccount",
      "Email address": "E-mail adres",
      "Mail details": "De gegevens van uw hostingaccount worden naar het volgende e-mailadres gestuurd:",
      "New password": "Nieuw wachtwoord",
      "Randomize password": "Willekeurig wachtwoord maken",
      "Send account details item": "Accountgegevens opvragen",
      "Send account details item fail": "Het is niet mogelijk om accountgegevens te verzenden. {msg}",
      "Send account details item success": "Accountgegevens zijn succesvol verzonden.",
      "Send mail": "E-mail verzenden"
    },
    "Webhosting-upgrade": {
      "Change package": "Pakket wijzigen",
      "New hosting package": "Nieuw hosting pakket",
      "Order now": "Bestellen",
      "Upgrade hosting": "Upgrade hosting",
      "Upgrade item fail": "Fout bij upgraden van hostingaccount. {msg}",
      "Upgrade item success": "Hostingaccount succesvol geüpgraded."
    },
    "Webhooks": {
      "Name": "Naam",
      "Scope": "Bereik",
      "Customer": "Klant",
      "Service": "Service",
      "Events": "Gebeurtenissen",
      "Url": "URL",
      "Active": "Actief",
      "Webhooks": "Webhooks",
      "ScopeOptions": {
        "Customer": "Eén klant",
        "Global": "Alle klanten"
      },
      "EventsOptions": {
        "Create": "Aanmaken",
        "Patch": "Wijzigen"
      },
      "New item": "Nieuwe webhook",
      "Edit item": "Webhook aanpassen",
      "View item": "Webhook bekijken",
      "Delete item": "Webhook verwijderen",
      "New item success": "Webhook toegevoegd.",
      "Edit item success": "Webhook opgeslagen.",
      "Delete item success": "Webhook verwijderd.",
      "New item fail": "Webhook toevoegen mislukt.",
      "Edit item fail": "Webhook opslaan mislukt.",
      "Delete item fail": "Webhook verwijderen mislukt."
    },
    "Webhook-queue": {
      "Name": "Naam",
      "Scope": "Bereik",
      "Customer": "Klant",
      "Service": "Service",
      "Events": "Gebeurtenissen",
      "DestinationHost": "Bestemming",
      "Active": "Actief",
      "WebhookName": "Webhook",
      "Method": "Gebeurtenis",
      "Status": "Status",
      "Attempts": "Pogingen",
      "Attempt": "Poging",
      "StatusCode": "HTTP-status",
      "ErrorCode": "Foutcode",
      "CreatedAt": "Tijdstip",
      "Webhook": "Webhook",
      "Webhooks": "Webhooks",
      "View item": "Webhook-aflevering bekijken"
    },
    "Webhook-logs": {
      "Name": "Naam",
      "Scope": "Bereik",
      "Customer": "Klant",
      "Service": "Service",
      "Events": "Gebeurtenissen",
      "DestinationHost": "Bestemming",
      "Active": "Actief",
      "WebhookName": "Webhook",
      "Method": "Gebeurtenis",
      "Status": "Status",
      "Attempts": "Pogingen",
      "Attempt": "Poging",
      "StatusCode": "HTTP-status",
      "ErrorCode": "Foutcode",
      "CreatedAt": "Tijdstip",
      "Webhook": "Webhook",
      "Webhooks": "Webhooks",
      "View item": "Webhooklog bekijken"
    }
  },
  "Shared": {
    "AzureBackupDisks": {
      "title": "Schijven in backup",
      "osDisk": "OS-schijf",
      "dataDisk": "Dataschijf - LUN {lun}",
      "included": "Geselecteerd",
      "excluded": "Niet geselecteerd",
      "unknown": "Onbekend",
      "status": {
        "complete": "Alle schijven geselecteerd",
        "incomplete": "Schijf ontbreekt in backupselectie",
        "unknown": "Schijfdekking niet te beoordelen",
        "notApplicable": "Geen Azure VM-backup"
      },
      "reason": {
        "vmUnavailable": "De bijbehorende VM ontbreekt in dit assetmeetmoment.",
        "inventoryUnavailable": "De schijfinventaris is onvolledig of niet eenduidig te koppelen.",
        "selectionUnavailable": "De backupselectie kon niet worden vastgesteld."
      }
    },
    "Licenses": {
      "Conditions": {
        "Button": "Voorwaarden",
        "Examples": {
          "Alignment": {
            "Monthly": "Bij maandelijkse betaling wordt in dit voorbeeld eerst een kortere periode dan één maand berekend: van 15 juni tot 1 juli. Daarna volgt de normale maandelijkse facturatie tot de licentie gelijkloopt met 1 oktober.",
            "Result": "Vanaf de gekozen verlengdatum loopt de nieuwe licentie mee met dezelfde facturatieperiode als de bestaande licentie.",
            "Situation": "U maakt op 15 juni een nieuwe licentie aan en zet de facturatieperiode gelijk met een bestaande licentie met verlengdatum 1 oktober.",
            "Title": "Facturatieperiode gelijkzetten",
            "Yearly": "Bij jaarlijkse betaling wordt de periode tot de gekozen verlengdatum in één keer berekend en gefactureerd."
          },
          "Assignments": {
            "Calculation": "De gebruiker met einddatum telt vanaf 1 september niet meer mee. De gebruiker met startdatum telt vanaf 1 september juist wel mee.",
            "Result": "Het aantal actieve toegewezen gebruikers blijft 5 en past binnen het beschikbare aantal licenties.",
            "Situation": "U heeft 5 licenties en 5 actieve toegewezen gebruikers. Eén gebruiker krijgt einddatum 1 september en een nieuwe gebruiker krijgt startdatum 1 september.",
            "Title": "Gebruikers wisselen met start- en einddatum"
          },
          "Decrease": {
            "Calculation": "Geef minimaal 3 gebruikers een einddatum op 1 oktober of eerder, of zorg dat gebruikers met een toekomstige startdatum pas actief worden wanneer dit binnen het nieuwe aantal past.",
            "Result": "Op 1 oktober zijn er maximaal 7 actieve toegewezen gebruikers en kan de geplande verlaging worden verwerkt.",
            "Situation": "U heeft 10 licenties met verlengdatum 1 oktober en wilt vanaf die datum terug naar 7 licenties.",
            "Title": "Aantal verlagen per verlengdatum"
          },
          "Increase": {
            "Calculation": "De 3 extra licenties worden berekend vanaf 15 juni tot de eerstvolgende verlengdatum. Daarna loopt het nieuwe totaal door.",
            "Result": "U kunt direct extra gebruikers toewijzen, zolang er maximaal 8 actieve toegewezen gebruikers zijn.",
            "Situation": "U heeft 5 licenties met verlengdatum 1 oktober. Op 15 juni verhoogt u het aantal naar 8 licenties.",
            "Title": "Aantal direct verhogen"
          },
          "Intro": "Deze voorbeelden laten zien hoe aantallen, gebruikers en facturatieperiodes in veelvoorkomende situaties worden berekend.",
          "Stop": {
            "Calculation": "Geef alle toegewezen gebruikers einddatum 1 oktober en zet het geplande aantal op 0.",
            "Result": "Vanaf 1 oktober zijn er geen actieve toegewezen gebruikers meer en kan de licentie worden beëindigd.",
            "Situation": "U wilt een licentie met verlengdatum 1 oktober stoppen.",
            "Title": "Stoppen per verlengdatum"
          }
        },
        "Intro": "Hieronder staan de belangrijkste voorwaarden voor het aanmaken, wijzigen en stoppen van uw licenties.",
        "Sections": {
          "Alignment": {
            "SalesOrderGap": "Bij gelijkzetten met een toekomstige verlengdatum wordt de eerste periode automatisch berekend en overeenkomstig gefactureerd. Deze periode kan afwijken van de navolgende periodes.",
            "SameCustomer": "Het gelijkstellen van de facturatieperiode kan alleen met een andere licentie binnen uw huidige klantomgeving met dezelfde periode en betaalwijze.",
            "StartBeforeRenew": "De startdatum van de nieuwe licentie moet vóór of op de verlengdatum van de gekozen licentie liggen.",
            "Title": "Facturatieperiode gelijkzetten met een andere licentie"
          },
          "Changes": {
            "CustomerDecrease": "Het verlagen van het aantal licenties kan alleen per verlengdatum via een geplande wijziging.",
            "DirectIncrease": "Het aantal licenties mag per direct worden verhoogd. De periode tot de volgende verlengdatum wordt automatisch berekend en overeenkomstig gefactureerd.",
            "PendingCapacity": "Een geplande wijziging kan alleen worden opgeslagen wanneer er op de verlengdatum voldoende licenties beschikbaar zijn om de wijziging door te voeren.",
            "PendingChanges": "Wijzigingen in aantal, licentie en betaalwijze kunnen per verlengdatum worden klaargezet.",
            "Title": "Aantallen en wijzigingen"
          },
          "General": {
            "CreateAmount": "Bij aanmaken van een nieuwe licentie geldt een minimale afname van één.",
            "Customer": "Licenties zijn alleen geldig per gebruiker binnen dezelfde klant.",
            "RenewDate": "De verlengdatum wordt automatisch bepaald en kan niet handmatig worden gekozen.",
            "StartDate": "Het opgeven van een startdatum is verplicht en mag bij het aanmaken niet in het verleden liggen.",
            "Title": "Algemeen"
          },
          "Processing": {
            "Automatic": "Looptijd en facturatie worden automatisch aan de licentie gekoppeld.",
            "RenewDate": "Wijzigingen per verlengdatum worden automatisch verwerkt zodra die datum is bereikt.",
            "Title": "Verwerking"
          },
          "Removal": {
            "AmountZero": "Een licentie kan pas worden verwijderd wanneer het licentieaantal op 0 staat.",
            "CancelContract": "Bij verwijderen wordt de licentie en daarmee de overeenkomst beëindigd.",
            "RenewAmountZero": "Wilt u stoppen per verlengdatum, geef de gebruikers een einddatum op de verlengdatum en zet het geplande aantal op 0.",
            "Title": "Stoppen en verwijderen"
          },
          "Users": {
            "ActiveCapacity": "Er kunnen nooit meer actieve toegewezen gebruikers zijn dan het beschikbare aantal licenties.",
            "EndDate": "Een toewijzing met een einddatum telt vanaf die datum niet mee als actieve toegewezen gebruiker.",
            "JobCleanup": "Start- en einddatums en bijbehorende producttoegang worden automatisch verwerkt zodra de ingestelde datum is bereikt.",
            "StartDate": "Een toewijzing met een startdatum in de toekomst telt vanaf die datum mee als actieve toegewezen gebruiker.",
            "Title": "Gebruikers",
            "UniqueUser": "Een gebruiker kan binnen dezelfde klant maar één keer aan dezelfde licentie worden toegewezen."
          }
        },
        "Tabs": {
          "Conditions": "Voorwaarden",
          "Examples": "Rekenvoorbeelden"
        },
        "Title": "Voorwaarden licentiebeheer"
      }
    },
    "Sharingcenter-calendars": {
      "Delete": "verwijderen"
    },
    "Sharingcenter-profiles": {
      "Delete": "verwijderen"
    },
    "SharingCenterMeetingStatistics": {
      "Title": "Vergaderbeheer",
      "Subtitle": "Blader door vergaderhistorie, inspecteer breakout-activiteit en zie wie wanneer aanwezig was.",
      "StatusAll": "Alles",
      "StatusActive": "Actief",
      "StatusEnded": "Beëindigd",
      "Status": "Status",
      "Appointment": "Afspraak",
      "Meeting": "Vergadering",
      "StartedAt": "Gestart",
      "Duration": "Duur",
      "UpdatedAt": "Bijgewerkt op",
      "Meetings": "Vergaderingen",
      "MeetingDetails": "Vergaderdetails",
      "BackToOverview": "Terug naar statistieken",
      "LoadError": "Het vergaderlogboek kon niet worden geladen.",
      "NoMeetingFound": "Er is geen vergaderlogboek gevonden voor deze afspraak.",
      "OpenDetail": "Details openen",
      "Active": "Actief",
      "Ended": "Beëindigd",
      "Participant": "Deelnemer",
      "Participants": "Deelnemers",
      "ParticipantNoLongerInMeeting": "Niet meer aanwezig in deze vergadering",
      "Sessions": "Sessies",
      "MeetingSessionsSection": "Vergadersessies",
      "MeetingParticipantsSection": "Deelnemers in vergaderingen",
      "Breakout": "Breakout",
      "MainRoom": "Hoofdruimte",
      "BreakoutRoom": "Breakoutruimte",
      "BreakoutRooms": "Breakoutruimtes",
      "ParticipantTimelineTitle": "Aanwezigheid in de vergadering over tijd",
      "ConcurrentParticipantsTitle": "Deelnemers in de vergadering over tijd",
      "EventTreeTitle": "Vergadergebeurtenissen",
      "EventTreeSubtitle": "Ruimtesessies, breakout-vertakkingen en deelnemersbewegingen over tijd.",
      "NoEventTreeData": "Er zijn nog geen tijdlijngegevens voor ruimten beschikbaar.",
      "MeetingStarted": "Vergadering gestart",
      "MeetingEnded": "Vergadering beëindigd",
      "BreakoutOpened": "Breakout geopend",
      "BreakoutClosed": "Breakout gesloten",
      "ParticipantJoined": "Deelnemer binnengekomen",
      "ParticipantLeft": "Deelnemer vertrokken",
      "SessionHierarchyTitle": "Hoofdsessies en breakout-vertakkingen in de vergadering",
      "NoTimelineData": "Er zijn nog geen tijdlijngegevens voor deelnemers beschikbaar.",
      "TimelineStart": "Start",
      "TimelineEnd": "Einde",
      "CurrentlyActive": "Momenteel actief",
      "uniqueParticipants": "Unieke deelnemers",
      "participantSessions": "Deelnemerssessies",
      "mainSessions": "Hoofdsessies",
      "breakoutRooms": "Breakoutruimtes",
      "breakoutSessions": "Breakoutsessies",
      "PeakConcurrent": "Piek gelijktijdig",
      "peakConcurrent": "Hoogste gelijktijdige deelnemers",
      "PeakReachedAt": "Bereikt om {time}",
      "peakConcurrentMeetings": "Hoogste gelijktijdige vergaderingen",
      "duration": "Duur",
      "meetings": "Totaal aantal vergaderingen",
      "active": "Actieve vergaderingen",
      "ended": "Beëindigde vergaderingen",
      "totalMeetingSessions": "Totale vergadersessies",
      "totalParticipantSessions": "Totale deelnemerssessies",
      "totalParticipantSessionDuration": "Totale duur van deelnemerssessies",
      "averageParticipants": "Gemiddelde deelnemers",
      "totalParticipants": "Totaal aantal deelnemers",
      "totalMeetingDuration": "Totale vergaderduur",
      "averageMeetingDuration": "Gemiddelde vergaderduur",
      "totalMeetingSessionDuration": "Totale vergadersessieduur",
      "longestMeetingDuration": "Langste vergaderduur",
      "DurationSection": "Vergaderduur",
      "MeetingsPerDayTitle": "Vergaderingen per dag",
      "DurationsPerDayTitle": "Vergaderduur per dag",
      "ParticipantsPerDay": "Deelnemers per dag",
      "MeetingDurationPerDay": "Vergaderduur per dag",
      "ParticipantSessionDurationPerDay": "Duur van deelnemerssessies per dag",
      "NoDailyChartData": "Er zijn geen gegevens beschikbaar in de geselecteerde periode.",
      "NoMeetingsPerDayData": "Er waren geen actieve vergaderingen in de geselecteerde periode.",
      "DailyStatisticsSection": "Dagelijkse vergaderstatistieken",
      "MeetingListSection": "Vergaderoverzicht",
      "RecordingsOverviewTitle": "Opnamen",
      "RecordingsOverviewDescription": "Bekijk per vergadering de opnamebestanden, transcripties en notulen.",
      "NoMeetingRecordingsFound": "Er zijn geen vergaderingen gevonden.",
      "OpenRecordingFiles": "Opnamebestanden openen",
      "RecordingFilesTitle": "Opnamen",
      "RecordingFilesDescription": "Transcripties worden na het stoppen van de opname verwerkt en kunnen even duren voordat ze beschikbaar zijn.",
      "RecordingFilesTab": "Bestanden",
      "RecordingTranscriptTab": "Transcript",
      "MeetingMinutesTab": "Notulen",
      "CreateTranscription": "Transcriptie maken",
      "CreateTranscriptionTitle": "Transcriptie maken",
      "TranscriptionSession": "Sessie",
      "TranscriptionRecording": "Opname",
      "TranscriptionNoSessionAvailable": "Er is geen sessie beschikbaar om een transcriptie voor te maken.",
      "TranscriptionNoRecordingAvailable": "Er is geen opname beschikbaar om een transcriptie voor te maken.",
      "TranscriptionAlreadyAvailable": "Er is al een transcriptie beschikbaar voor deze opname.",
      "TranscriptionCreateAccepted": "De transcriptietaak is geaccepteerd. Deze pagina wordt ververst tot deze klaar is.",
      "TranscriptionCreateInProgress": "De transcriptie wordt aangemaakt. Dit kan even duren.",
      "TranscriptionCreateSuccess": "De transcriptie is aangemaakt.",
      "TranscriptionCreateFailed": "De transcriptietaak is mislukt.",
      "TranscriptionCreateError": "De transcriptie kon niet worden aangemaakt.",
      "CreateMeetingMinutes": "Notulen maken",
      "CreateMeetingMinutesTitle": "Notulen maken",
      "MeetingMinutesSession": "Sessie",
      "MeetingMinutesRecording": "Opname",
      "MeetingMinutesLanguage": "Taal",
      "MeetingMinutesLanguageDutch": "Nederlands",
      "MeetingMinutesLanguageEnglish": "Engels",
      "MeetingMinutesLanguageGerman": "Duits",
      "MeetingMinutesLanguageSpanish": "Spaans",
      "MeetingMinutesLanguageFrench": "Frans",
      "MeetingMinutesPrompt": "Type notulen",
      "MeetingMinutesPromptRequired": "Kies een type notulen.",
      "MeetingMinutesPromptCustom": "Custom",
      "MeetingMinutesPromptCustomDescription": "Zelf een prompt invullen",
      "MeetingMinutesCustomPrompt": "Custom prompt",
      "MeetingMinutesCustomPromptRequired": "Vul een custom prompt in.",
      "NoTranscriptionSourceRecordings": "Er zijn nog geen opnamebestanden beschikbaar waarvoor een transcriptie kan worden gemaakt.",
      "NoMinutesSourceTranscriptions": "Er zijn nog geen transcripties beschikbaar waarvoor notulen kunnen worden gemaakt.",
      "NoMeetingMinutes": "Er zijn nog geen notulen beschikbaar.",
      "NoMeetingMinutesContent": "De notulen zijn nog niet leesbaar.",
      "MeetingMinutesCreateNotAvailable": "Het maken van notulen is nog niet beschikbaar.",
      "MeetingMinutesCreateSuccess": "De notulen zijn in de wachtrij geplaatst.",
      "MeetingMinutesCreateInProgress": "De notulen worden aangemaakt. Dit kan even duren.",
      "MeetingMinutesCreateError": "De notulen konden niet worden aangemaakt.",
      "MeetingMinutesLoadError": "De notulen konden niet worden geladen.",
      "MeetingMinutesNoSessionAvailable": "Er is geen sessie beschikbaar om notulen voor te maken.",
      "MeetingMinutesNoRecordingAvailable": "Er is geen opname beschikbaar om notulen voor te maken.",
      "MeetingMinutesNoTranscriptAvailable": "Er is nog geen transcript beschikbaar om notulen van te maken.",
      "DownloadMeetingMinutes": "Notulen downloaden",
      "DownloadMeetingMinutesAsWord": "Download als Word",
      "DownloadMeetingMinutesAsMarkdown": "Download als MD",
      "DeleteMeetingMinutes": "Notulen verwijderen",
      "DeleteMeetingMinutesConfirm": "Weet je zeker dat je deze notulen wilt verwijderen?",
      "MeetingMinutesDeleteSuccess": "De notulen zijn verwijderd.",
      "MeetingMinutesDeleteError": "De notulen konden niet worden verwijderd.",
      "DeleteRecordingTranscript": "Transcript verwijderen",
      "DeleteRecordingTranscriptConfirm": "Weet je zeker dat je dit transcript wilt verwijderen?",
      "RecordingTranscriptDeleteSuccess": "Het transcript is verwijderd.",
      "RecordingTranscriptDeleteError": "Het transcript kon niet worden verwijderd.",
      "DeleteRecordingFile": "Opnamebestand verwijderen",
      "DeleteRecordingFileConfirm": "Weet je zeker dat je dit opnamebestand wilt verwijderen?",
      "RecordingFileDeleteSuccess": "Het opnamebestand is verwijderd.",
      "RecordingFileDeleteError": "Het opnamebestand kon niet worden verwijderd.",
      "DeleteAllRecordingFiles": "Verwijder alles",
      "DeleteAllRecordingFilesConfirm": "Weet je zeker dat je alle bestanden van deze opname wilt verwijderen?",
      "RecordingFilesDeleteSuccess": "Alle bestanden van deze opname zijn verwijderd.",
      "RecordingFilesDeletePartialError": "Niet alle bestanden van deze opname konden worden verwijderd.",
      "RecordingFilesDeleteError": "De bestanden van deze opname konden niet worden verwijderd.",
      "Errors": {
        "ErrorCode": {
          "AI_MINUTES_OPENAI_CONNECTION_ERROR": "Er kon geen verbinding worden gemaakt met OpenAI. Probeer het later opnieuw.",
          "AI_MINUTES_OPENAI_AUTHENTICATION_ERROR": "OpenAI-authenticatie is mislukt. Controleer de API-key, het project en de organisatie van de AI-agent.",
          "AI_MINUTES_OPENAI_INSUFFICIENT_QUOTA": "De OpenAI-credits of ingestelde limiet zijn op. Controleer de billing en limieten van de AI-agent.",
          "AI_MINUTES_OPENAI_INVALID_API_KEY": "De OpenAI API-key klopt niet. Controleer de API-key in de AI-agent instellingen.",
          "AI_MINUTES_OPENAI_PERMISSION_DENIED": "De OpenAI API-key heeft geen toegang tot dit model, project of deze organisatie.",
          "AI_MINUTES_OPENAI_RATE_LIMIT": "OpenAI verwerkt nu te veel verzoeken. Probeer het zo opnieuw.",
          "AI_MINUTES_OPENAI_REQUEST_ERROR": "OpenAI kon de aanvraag voor de notulen niet verwerken.",
          "AI_MINUTES_OPENAI_SERVER_ERROR": "OpenAI is tijdelijk niet beschikbaar. Probeer het later opnieuw."
        }
      },
      "RecordingFilesLoadError": "De opnamebestanden konden niet worden geladen.",
      "RecordingTranscriptLoadError": "Het transcript kon niet worden geladen.",
      "NoRecordingFiles": "Er zijn nog geen opnamebestanden beschikbaar.",
      "NoRecordingTranscriptContent": "Er is geen transcripttekst beschikbaar.",
      "DownloadRecordingFile": "Bestand downloaden",
      "RecordingFileDownloadError": "Het bestand kon niet worden gedownload.",
      "RecordingSession": "Opname",
      "UnknownRecording": "Onbekende opname",
      "RecordingFileTypeArtifact": "Onbekend bestand",
      "RecordingFileTypeMeetingMinutes": "Notulen",
      "RecordingFileTypeMixedAudio": "Gemixte audio",
      "RecordingFileTypeVideo": "Video-opname",
      "RecordingFileTypeSeparateAudio": "Ruwe multitrack-audio",
      "RecordingFileTypeSpeakerAudio": "Audio per spreker",
      "RecordingFileTypeSpeakerMap": "Sprekerkoppeling",
      "RecordingFileTypeSpeakerTranscriptJson": "Transcript per spreker (JSON)",
      "RecordingFileTypeStreamMap": "Streammetadata",
      "RecordingFileTypeTranscript": "Transcript",
      "RecordingFileTypeTranscriptJson": "Transcript (JSON)",
      "FromDate": "Begindatum",
      "UntilDate": "Einddatum"
    },
    "SmsStatistics": {
      "LoadError": "Het SMS-logboek kon niet worden geladen.",
      "StatusSent": "Verzonden",
      "StatusFailed": "Mislukt",
      "OverviewSection": "SMS-overzicht",
      "DeliverySection": "Aflevering",
      "RecipientsSection": "Ontvangers",
      "TypesSection": "SMS-types",
      "totalSms": "Totaal aantal SMS-berichten",
      "sentSms": "Verzonden SMS-berichten",
      "failedSms": "Mislukte SMS-berichten",
      "sendSuccessRate": "Verzendsucces",
      "deliveredSms": "Afgeleverde SMS-berichten",
      "undeliveredSms": "Niet-afgeleverde SMS-berichten",
      "deliveryRate": "Afleverratio",
      "totalRecipients": "Totaal aantal ontvangers",
      "uniqueRecipients": "Unieke ontvangers",
      "averageRecipientsPerSms": "Gemiddeld aantal ontvangers per SMS",
      "typeAuthentication": "Authenticatie",
      "typeSharingcenter": "OMNI Sessions",
      "typeOther": "Overig",
      "DailyStatisticsSection": "Dagelijkse SMS-statistieken",
      "SmsPerDayTitle": "SMS-berichten per dag",
      "SmsTypesPerDayTitle": "SMS-types per dag",
      "TotalSmsPerDay": "Totaal per dag",
      "SentSmsPerDay": "Verzonden per dag",
      "FailedSmsPerDay": "Mislukt per dag",
      "NoDailyChartData": "Er zijn geen gegevens beschikbaar in de geselecteerde periode.",
      "NoSmsTypesChartData": "Er zijn geen trendgegevens per SMS-type beschikbaar in de geselecteerde periode.",
      "SmsListSection": "SMS-overzicht",
      "FromDate": "Begindatum",
      "UntilDate": "Einddatum",
      "CreatedAt": "Aangemaakt op",
      "Customer": "Klant",
      "Recipients": "Ontvangers",
      "SmsSent": "Verzonden",
      "SmsDelivered": "Afgeleverd"
    },
    "EmailStatistics": {
      "LoadError": "Het e-maillogboek kon niet worden geladen.",
      "StatusSent": "Verzonden",
      "StatusFailed": "Mislukt",
      "OverviewSection": "E-mailoverzicht",
      "RecipientsSection": "Ontvangers",
      "TypesSection": "E-mailtypes",
      "totalEmails": "Totaal aantal e-mails",
      "sentEmails": "Verzonden e-mails",
      "failedEmails": "Mislukte e-mails",
      "sendSuccessRate": "Verzendsucces",
      "totalRecipients": "Totaal aantal ontvangers",
      "uniqueRecipients": "Unieke ontvangers",
      "averageRecipientsPerEmail": "Gemiddeld aantal ontvangers per e-mail",
      "typeTriggers": "Triggers",
      "typeAuthentication": "Authenticatie",
      "typeSharingcenter": "OMNI Sessions",
      "typeInvoices": "Facturen",
      "typeSubscriptions": "Abonnementen",
      "typeDomains": "Domeinen",
      "typeWebhosting": "Webhosting",
      "typeQueue": "E-mailqueue",
      "typeOther": "Overig",
      "DailyStatisticsSection": "Dagelijkse e-mailstatistieken",
      "EmailsPerDayTitle": "E-mails per dag",
      "EmailTypesPerDayTitle": "E-mailtypes per dag",
      "TotalEmailsPerDay": "Totaal per dag",
      "SentEmailsPerDay": "Verzonden per dag",
      "FailedEmailsPerDay": "Mislukt per dag",
      "NoDailyChartData": "Er zijn geen gegevens beschikbaar in de geselecteerde periode.",
      "NoEmailTypesChartData": "Er zijn geen trendgegevens per e-mailtype beschikbaar in de geselecteerde periode.",
      "EmailListSection": "E-mailoverzicht",
      "FromDate": "Begindatum",
      "UntilDate": "Einddatum",
      "CreatedAt": "Aangemaakt op",
      "Customer": "Klant",
      "Recipients": "Ontvangers",
      "MailSent": "Verzonden",
      "MailSentAt": "Verzonden op"
    },
    "LicenseStatistics": {
      "LoadError": "De licentiestatistieken konden niet worden geladen.",
      "OverviewSection": "Licentieoverzicht",
      "CapacitySection": "Capaciteit",
      "FinancialSection": "Omzet",
      "LicenseRevenueSection": "Licenties",
      "SlaRevenueSection": "SLA's",
      "PartnerProgramRevenueSection": "Partnerprogramma's",
      "LicenseRevenueSubject": "licenties",
      "SlaRevenueSubject": "SLA's",
      "PartnerProgramRevenueSubject": "partnerprogramma's",
      "RenewalSection": "Verlengingen en wijzigingen",
      "ScopeSection": "Scope",
      "TrendSection": "Trends",
      "ProductBreakdownSection": "Per product",
      "CustomerBreakdownSection": "Per klant",
      "LicenseListSection": "Licenties",
      "activeLicenses": "Actieve licenties",
      "totalSeats": "Afgenomen seats",
      "assignedSeats": "Toegewezen seats",
      "availableSeats": "Beschikbare seats",
      "occupancyRate": "Bezettingsgraad",
      "renewalsNext30Days": "Verlengingen binnen 30 dagen",
      "fullLicenses": "Volledig benut",
      "unusedLicenses": "Onbenut",
      "underusedLicenses": "Onderbenut",
      "periodRevenue": "Omzet in periode",
      "currentMrr": "Huidige MRR",
      "currentArr": "Huidige ARR",
      "projectedMrr": "Verwachte MRR peildatum",
      "futureProjectedMrr": "Verwachte MRR incl. toekomstige wijzigingen",
      "projectedMrrDelta": "Verwachte MRR-wijziging peildatum",
      "projectedArr": "Verwachte ARR peildatum",
      "futureProjectedArr": "Verwachte ARR incl. toekomstige wijzigingen",
      "projectedArrDelta": "Verwachte ARR-wijziging peildatum",
      "pendingChanges": "Geplande wijzigingen",
      "pendingSeatDelta": "Geplande seat-wijziging",
      "pendingProductChanges": "Geplande productwijzigingen",
      "endingOnRenewal": "Eindigt bij verlenging",
      "activeProducts": "Producten in gebruik",
      "activeCustomers": "Klanten met licenties",
      "periodRevenueCaption": "Prorata licentieomzet over de geselecteerde periode. Start of stopt een subscription halverwege een maand, dan tellen alleen de actieve dagen mee.",
      "currentMrrCaption": "Monthly Recurring Revenue: maandelijkse terugkerende licentieomzet als run-rate. Jaarbedragen worden omgerekend naar maandbedrag; gedeeltelijke maanden worden niet geprorateerd.",
      "currentArrCaption": "Annual Recurring Revenue: jaarlijkse terugkerende licentieomzet als run-rate. Dit is de huidige MRR maal 12.",
      "projectedMrrCaption": "Verwachte MRR op basis van licenties die op de peildatum binnen de selectie vallen. Toekomstige aankopen met een latere startdatum tellen hier niet mee.",
      "futureProjectedMrrCaption": "Dezelfde verwachte MRR, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "projectedMrrDeltaCaption": "Verschil tussen verwachte MRR op peildatum en huidige MRR.",
      "projectedArrCaption": "Verwachte ARR nadat geplande licentiewijzigingen bij de volgende verlenging zijn toegepast. Dit is de verwachte MRR maal 12.",
      "futureProjectedArrCaption": "Dezelfde verwachte ARR, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "projectedArrDeltaCaption": "Verschil tussen verwachte ARR op peildatum en huidige ARR.",
      "RevenueBreakdownPeriodRevenueCaption": "Prorata omzet voor {subject} over de geselecteerde periode. Start of stopt een subscription halverwege een maand, dan tellen alleen de actieve dagen mee.",
      "RevenueBreakdownCurrentMrrCaption": "Monthly Recurring Revenue: maandelijkse terugkerende omzet voor {subject} als run-rate. Jaarbedragen worden omgerekend naar maandbedrag; gedeeltelijke maanden worden niet geprorateerd.",
      "RevenueBreakdownCurrentArrCaption": "Annual Recurring Revenue: jaarlijkse terugkerende omzet voor {subject} als run-rate. Dit is de huidige MRR maal 12.",
      "RevenueBreakdownProjectedMrrCaption": "Verwachte MRR voor {subject} op basis van licenties die op de peildatum binnen de selectie vallen. Toekomstige aankopen met een latere startdatum tellen hier niet mee.",
      "RevenueBreakdownFutureProjectedMrrCaption": "Dezelfde verwachte MRR voor {subject}, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "RevenueBreakdownProjectedMrrDeltaCaption": "Verschil tussen verwachte MRR op peildatum en huidige MRR voor {subject}.",
      "RevenueBreakdownProjectedArrCaption": "Verwachte ARR voor {subject} nadat geplande licentiewijzigingen bij de volgende verlenging zijn toegepast. Dit is de verwachte MRR maal 12.",
      "RevenueBreakdownFutureProjectedArrCaption": "Dezelfde verwachte ARR voor {subject}, maar dan inclusief bekende toekomstige wijzigingen zoals licenties met een startdatum na de peildatum.",
      "RevenueBreakdownProjectedArrDeltaCaption": "Verschil tussen verwachte ARR op peildatum en huidige ARR voor {subject}.",
      "pendingChangesCaption": "Aantal licenties met geplande wijzigingen voor de volgende verlenging.",
      "pendingSeatDeltaCaption": "Netto wijziging in seats door geplande licentiewijzigingen.",
      "pendingProductChangesCaption": "Aantal geplande wijzigingen waarbij het licentieproduct wijzigt.",
      "endingOnRenewalCaption": "Aantal licenties dat bij de volgende verlenging naar 0 seats gaat.",
      "FromDate": "Trend vanaf",
      "UntilDate": "Peildatum",
      "ForecastRange": "Forecastperiode",
      "ForecastMonthsOption": "{months} maanden",
      "DateRangeHelp": "De begindatum bepaalt waar de trendgrafieken starten. De peildatum bepaalt de stand in de cards en is tegelijk het einde van de trendperiode.",
      "PeriodRevenueTrendTitle": "Omzet per maand",
      "RevenueTrendTitle": "MRR per maand",
      "FutureRevenueForecastTitle": "Verwachte MRR-ontwikkeling",
      "SeatTrendTitle": "Seats per maand",
      "RenewalTrendTitle": "Verlengingen per maand",
      "PeriodRevenuePerMonth": "Omzet",
      "CurrentMrrPerMonth": "Huidige MRR",
      "ProjectedMrrPerMonth": "Verwachte MRR",
      "ForecastMrr": "Verwachte MRR",
      "TotalSeatsPerMonth": "Afgenomen seats",
      "AssignedSeatsPerMonth": "Toegewezen seats",
      "AvailableSeatsPerMonth": "Beschikbare seats",
      "RenewalsPerMonth": "Verlengingen",
      "PendingChangesPerMonth": "Geplande wijzigingen",
      "NoPeriodRevenueTrendData": "Er zijn geen omzetgegevens beschikbaar in de geselecteerde periode.",
      "NoRevenueTrendData": "Er zijn geen omzettrendgegevens beschikbaar in de geselecteerde periode.",
      "NoFutureRevenueForecastData": "Er zijn geen forecastgegevens beschikbaar voor de gekozen periode.",
      "NoSeatTrendData": "Er zijn geen seattrendgegevens beschikbaar in de geselecteerde periode.",
      "NoRenewalTrendData": "Er zijn geen verlengingstrendgegevens beschikbaar in de geselecteerde periode.",
      "Name": "Naam",
      "Customer": "Klant",
      "Product": "Product",
      "ActiveLicenses": "Actieve licenties",
      "TotalSeats": "Afgenomen seats",
      "AssignedSeats": "Toegewezen seats",
      "AvailableSeats": "Beschikbaar",
      "OccupancyRate": "Bezettingsgraad",
      "CurrentMrr": "MRR",
      "RenewDate": "Verlengdatum",
      "PendingChanges": "Geplande wijzigingen",
      "Pending": "Gepland",
      "User": "Gebruiker",
      "Email": "E-mail",
      "StartDate": "Startdatum",
      "EndDate": "Einddatum",
      "NoAssignedUsers": "Geen toegewezen gebruikers."
    },
    "AiQueueStatistics": {
      "PageTitle": "AI-taakwachtrij",
      "LoadError": "De AI-taakwachtrij kon niet worden geladen.",
      "OverviewSection": "Wachtrijoverzicht",
      "TranscriptionSection": "Statistieken voor transcripties",
      "MinutesSection": "Statistieken voor notulen",
      "StatusSection": "Wachtrijstatus",
      "DailyStatisticsSection": "Dagelijkse statistieken",
      "QueueListSection": "Taken",
      "FilterLoadError": "De filters voor de AI-taakwachtrij konden niet worden geladen.",
      "totalItems": "Taken",
      "activeItems": "Actieve taken",
      "currentState": "Huidige status",
      "successRate": "Succespercentage",
      "queuedItems": "Wachtend",
      "processingItems": "Wordt verwerkt",
      "completedItems": "Voltooid",
      "failedItems": "Mislukt",
      "retryScheduledItems": "Geplande nieuwe pogingen",
      "TotalTasksPerDay": "Taken per dag",
      "CompletedTasksPerDay": "Voltooid per dag",
      "FailedTasksPerDay": "Mislukt per dag",
      "TranscriptionTasksPerDayTitle": "Transcriptietaken per dag",
      "MinutesTasksPerDayTitle": "Notulentaken per dag",
      "NoDailyChartData": "Er zijn geen grafiekgegevens voor deze periode.",
      "CreatedAt": "Aangemaakt op",
      "UpdatedAt": "Bijgewerkt op",
      "NextAttemptAt": "Volgende poging",
      "FromDate": "Begindatum",
      "UntilDate": "Einddatum",
      "Status": "Status",
      "TaskType": "Taak",
      "Provider": "Provider",
      "RecordingPath": "Opname",
      "Attempts": "Poging",
      "DeleteQueueItemTitle": "Wachtrij-item verwijderen",
      "DeleteQueueItemText": "Weet je zeker dat je wachtrij-item {0} wilt verwijderen?",
      "DeleteQueueItemSuccess": "Wachtrij-item verwijderd.",
      "DeleteQueueItemFail": "Het wachtrij-item kon niet worden verwijderd. {msg}",
      "QueueRetryNowTitle": "Nieuwe poging vrijgeven",
      "QueueRetryNowText": "Wil je geplande nieuwe poging {item} nu beschikbaar maken voor de wachtrij?",
      "QueueRetryNowSuccess": "Nieuwe poging is beschikbaar voor de wachtrij.",
      "QueueRetryNowFail": "De nieuwe poging kon niet worden vrijgegeven. {msg}",
      "State": {
        "active": "Actief",
        "idle": "Inactief"
      },
      "Statuses": {
        "queued": "Wachtend",
        "processing": "Wordt verwerkt",
        "completed": "Voltooid",
        "failed": "Mislukt",
        "retryScheduled": "Gepland"
      },
      "TaskTypes": {
        "transcription": "Transcriptie",
        "minutes": "Notulen"
      },
      "Providers": {
        "whisper": "Whisper",
        "chatgpt": "ChatGPT",
        "ollama": "Ollama"
      }
    },
    "FeedbackStatistics": {
      "LoadError": "De feedbackantwoorden konden niet worden geladen.",
      "OverviewSection": "Feedbackoverzicht",
      "totalFeedbackAnswers": "Ingevulde feedbackformulieren",
      "uniqueParticipants": "Respondenten",
      "totalAnswers": "Totaal aantal antwoorden",
      "averageScore": "Gemiddelde score",
      "AverageScoreCaption": "Gebaseerd op {count} score-antwoorden",
      "Answers": "Antwoorden",
      "FeedbackQuestion": "Feedbackvraag",
      "GroupByLabel": "Groepeer per",
      "GroupByMeeting": "Per vergadering",
      "GroupByQuestion": "Per feedbackvraag",
      "MeetingFeedbackSection": "Feedbackantwoorden",
      "Question": "Vraag",
      "Value": "Waarde",
      "AnswerListSection": "Overzicht feedbackantwoorden",
      "FromDate": "Begindatum",
      "UntilDate": "Einddatum"
    },
    "Globals": {
      "Account-invitations": "Accountuitnodigingen",
      "Apply": "Toepassen",
      "Asset-management": "Monitoring & assets",
      "Assets": {
        "Asset type": "Type activum",
        "Assets": "Activa",
        "Calculations": "Berekeningen",
        "Hetzner": {
          "Hetzner": "Hetzner",
          "Public IPs": "Publieke IPs",
          "Storages": "Opslagruimtes",
          "Virtual machines": "Virtuele machines",
          "Virtual machines backups": "Virtuele machine backups"
        },
        "Locked Vault Backups": {
          "Backups": "Backups",
          "Locked Vault Backups": "Locked Vault Backups"
        },
        "Microsoft Azure": {
          "Disks": "Schijven",
          "Host Pools Session Hosts": "Host Pools Sessie hosts",
          "Microsoft Azure": "Microsoft Azure",
          "Recovery Services Backup Policies": "Back-upbeleid van Recovery Services",
          "Recovery Services Protected Items": "Beveiligde items van Recovery Services",
          "Reservations": "Reserveringen",
          "Virtual Machines": "Virtuele machines"
        },
        "Microsoft Graph": {
          "Applications": "Applicaties",
          "Audit Logs Sign Ins": "Aanmeldingslogboeken",
          "Devices": "Apparaten",
          "Microsoft Graph": "Microsoft Graph",
          "Microsoft licenses": "Microsoft-licenties",
          "Teams": "Teams",
          "Users": "Gebruikers en gedeelde postvakken"
        },
        "Microsoft Security": {
          "Machines": "Machines",
          "Microsoft Security": "Microsoft Security",
          "Vulnerabilities": "Kwetsbaarheden",
          "Vulnerabilities By Machines and Software": "Kwetsbaarheden per machines en software"
        },
        "Overview": "Overzicht",
        "TransIP": {
          "Block storage backups": "Block opslagback-ups",
          "Block storages": "Block opslag",
          "TransIP": "TransIP",
          "Virtual machine backups": "Back-ups van virtuele machines",
          "Virtual machines": "Virtuele machines"
        },
        "Veeam": {
          "Job sessions": "Taak sessies",
          "Jobs": "Taken",
          "Veeam": "Veeam"
        },
        "Virtual machines": "Virtuele machines"
      },
      "Attention": "Let op",
      "Audit-logs": "Audit logs",
      "Back": "Terug",
      "Back to": "Terug naar @.lower:{to}",
      "Back to previous page": "Terug naar de vorige pagina",
      "Cancel": "Annuleren",
      "Change": "Wijzigen",
      "Changed": "@:{key} aangepast.",
      "Choose customer": "Kies @.lower:Customers.Customer",
      "Click to copy ID": "Klik op het pictogram om de ID te kopiëren.",
      "Clone item": "Kloon @.lower:{item}",
      "Close": "Sluiten",
      "Collapse menu": "Menu samenvouwen",
      "Communication": "Communicatie",
      "Copy": "Kopiëren",
      "Contacts": "Contactpersonen",
      "Continue": "Volgende",
      "Contracts": "Contracten",
      "Copy fail": "Kan tekst niet naar klembord kopiëren. {error}",
      "Copy success": "Tekst naar het klembord gekopieerd.",
      "Countries": {
        "ABW": "Aruba",
        "AFG": "Afghanistan",
        "AGO": "Angola",
        "AIA": "Anguilla",
        "ALA": "Aland-eilanden",
        "ALB": "Albanië",
        "AND": "Andorra",
        "ARE": "Verenigde Arabische Emiraten (de)",
        "ARG": "Argentinië",
        "ARM": "Armenië",
        "ASM": "Amerikaans Samoa",
        "ATA": "Antarctica",
        "ATF": "Franse Zuidelijke Gebieden (de)",
        "ATG": "Antigua en Barbuda",
        "AUS": "Australië",
        "AUT": "Oostenrijk",
        "AZE": "Azerbeidzjan",
        "BDI": "Boeroendi",
        "BEL": "België",
        "BEN": "Benin",
        "BES": "Bonaire, Sint Eustatius en Saba",
        "BFA": "Burkina Faso",
        "BGD": "Bangladesh",
        "BGR": "Bulgarije",
        "BHR": "Bahrein",
        "BHS": "Bahama's (de)",
        "BIH": "Bosnië-Herzegovina",
        "BLM": "Saint Barthélemy",
        "BLR": "Wit-Rusland",
        "BLZ": "Belize",
        "BMU": "Bermuda",
        "BOL": "Bolivia (plurinationale staat)",
        "BRA": "Brazilië",
        "BRB": "Barbados",
        "BRN": "Brunei Darussalam",
        "BTN": "Bhutan",
        "BVT": "Bouvet-eiland",
        "BWA": "Botswana",
        "CAF": "Centraal-Afrikaanse Republiek (de)",
        "CAN": "Canada",
        "CCK": "Cocos (Keeling) Eilanden (de)",
        "CHE": "Zwitserland",
        "CHL": "Chili",
        "CHN": "China",
        "CIV": "Ivoorkust",
        "CMR": "Kameroen",
        "COD": "Congo (de Democratische Republiek der)",
        "COG": "Kongo (de)",
        "COK": "Cook Eilanden (de)",
        "COL": "Colombia",
        "COM": "Comoren (de)",
        "CPV": "Cabo Verde",
        "CRI": "Costa Rica",
        "CUB": "Cuba",
        "CUW": "Curacao",
        "CXR": "Kersteiland",
        "CYM": "Kaaimaneilanden (de)",
        "CYP": "Cyprus",
        "CZE": "Tsjechië",
        "DEU": "Duitsland",
        "DJI": "Djibouti",
        "DMA": "Dominica",
        "DNK": "Denemarken",
        "DOM": "Dominicaanse Republiek (de)",
        "DZA": "Algerije",
        "ECU": "Ecuador",
        "EGY": "Egypte",
        "ERI": "Eritrea",
        "ESH": "Westelijke Sahara",
        "ESP": "Spanje",
        "EST": "Estland",
        "ETH": "Ethiopië",
        "FIN": "Finland",
        "FJI": "Fiji",
        "FLK": "Falklandeilanden (de) [Malvinas]",
        "FRA": "Frankrijk",
        "FRO": "Faeröer Eilanden (de)",
        "FSM": "Micronesië (Federale Staten van)",
        "GAB": "Gabon",
        "GBR": "Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland (de)",
        "GEO": "Georgië",
        "GGY": "Guernsey",
        "GHA": "Ghana",
        "GIB": "Gibraltar",
        "GIN": "Guinea",
        "GLP": "Guadeloupe",
        "GMB": "Gambia (de)",
        "GNB": "Guinee-Bissau",
        "GNQ": "Equatoriaal-Guinea",
        "GRC": "Griekenland",
        "GRD": "Grenada",
        "GRL": "Groenland",
        "GTM": "Guatemala",
        "GUF": "Frans Guyana",
        "GUM": "Guam",
        "GUY": "Guyana",
        "HKG": "Hong Kong",
        "HMD": "Heard- en McDonaldeilanden",
        "HND": "Honduras",
        "HRV": "Kroatie",
        "HTI": "Haïti",
        "HUN": "Hongarije",
        "IDN": "Indonesië",
        "IMN": "Isle of Man",
        "IND": "India",
        "IOT": "Brits Indische Oceaanterritorium (de)",
        "IRL": "Ierland",
        "IRN": "Iran (Islamitische Republiek)",
        "IRQ": "Irak",
        "ISL": "IJsland",
        "ISR": "Israël",
        "ITA": "Italië",
        "JAM": "Jamaica",
        "JEY": "Jersey",
        "JOR": "Jordanië",
        "JPN": "Japan",
        "KAZ": "Kazachstan",
        "KEN": "Kenia",
        "KGZ": "Kirgizië",
        "KHM": "Cambodja",
        "KIR": "Kiribati",
        "KNA": "Saint Kitts en Nevis",
        "KOR": "Korea (de Republiek)",
        "KWT": "Koeweit",
        "LAO": "Lao Democratische Volksrepubliek (de)",
        "LBN": "Libanon",
        "LBR": "Liberia",
        "LBY": "Libië",
        "LCA": "Saint Lucia",
        "LIE": "Liechtenstein",
        "LKA": "Sri Lanka",
        "LSO": "Lesotho",
        "LTU": "Litouwen",
        "LUX": "Luxemburg",
        "LVA": "Letland",
        "MAC": "Macao",
        "MAF": "Saint Martin (Frans deel)",
        "MAR": "Marokko",
        "MCO": "Monaco",
        "MDA": "Moldavië (de Republiek)",
        "MDG": "Madagascar",
        "MDV": "Maldiven",
        "MEX": "Mexico",
        "MHL": "Marshall Eilanden (de)",
        "MKD": "Republiek Noord-Macedonië",
        "MLI": "Mali",
        "MLT": "Malta",
        "MMR": "Myanmar",
        "MNE": "Montenegro",
        "MNG": "Mongolië",
        "MNP": "Noordelijke Marianen (de)",
        "MOZ": "Mozambique",
        "MRT": "Mauritanië",
        "MSR": "Montserrat",
        "MTQ": "Martinique",
        "MUS": "Mauritius",
        "MWI": "Malawi",
        "MYS": "Maleisië",
        "MYT": "Mayotte",
        "NAM": "Namibië",
        "NCL": "Nieuw-Caledonië",
        "NER": "Niger (de)",
        "NFK": "Norfolkeiland",
        "NGA": "Nigeria",
        "NIC": "Nicaragua",
        "NIU": "Niue",
        "NLD": "Nederland",
        "NOR": "Noorwegen",
        "NPL": "Nepal",
        "NRU": "Nauru",
        "NZL": "Nieuw-Zeeland",
        "OMN": "Oman",
        "PAK": "Pakistan",
        "PAN": "Panama",
        "PCN": "Pitcairn",
        "PER": "Peru",
        "PHL": "Filipijnen (de)",
        "PLW": "Palau",
        "PNG": "Papoea-Nieuw-Guinea",
        "POL": "Polen",
        "PRI": "Puerto Rico",
        "PRK": "Korea (de Democratische Volksrepubliek)",
        "PRT": "Portugal",
        "PRY": "Paraguay",
        "PSE": "Palestina, staat",
        "PYF": "Frans-Polynesië",
        "QAT": "Qatar",
        "REU": "Réunion",
        "ROU": "Roemenië",
        "RUS": "Russische Federatie (de)",
        "RWA": "Rwanda",
        "SAU": "Saoedi-Arabië",
        "SDN": "Soedan (de)",
        "SEN": "Senegal",
        "SGP": "Singapore",
        "SGS": "Zuid-Georgië en de Zuidelijke Sandwicheilanden",
        "SHN": "Sint-Helena, Ascension en Tristan da Cunha",
        "SJM": "Svalbard en Jan Mayen",
        "SLB": "Solomon eilanden",
        "SLE": "Sierra Leone",
        "SLV": "El Salvador",
        "SMR": "San Marino",
        "SOM": "Somalië",
        "SPM": "Saint Pierre en Miquelon",
        "SRB": "Servië",
        "SSD": "Zuid Soedan",
        "STP": "Sao Tomé en Principe",
        "SUR": "Suriname",
        "SVK": "Slowakije",
        "SVN": "Slovenië",
        "SWE": "Zweden",
        "SWZ": "Eswatini",
        "SXM": "Sint Maarten (Nederlands deel)",
        "SYC": "Seychellen",
        "SYR": "Syrische Arabische Republiek",
        "TCA": "Turks- en Caicoseilanden (de)",
        "TCD": "Tsjaad",
        "TGO": "Togo",
        "THA": "Thailand",
        "TJK": "Tadzjikistan",
        "TKL": "Tokelau",
        "TKM": "Turkmenistan",
        "TLS": "Timor-Leste",
        "TON": "Tonga",
        "TTO": "Trinidad en Tobago",
        "TUN": "Tunesië",
        "TUR": "Turkije",
        "TUV": "Tuvalu",
        "TWN": "Taiwan",
        "TZA": "Tanzania, Verenigde Republiek van",
        "UGA": "Oeganda",
        "UKR": "Oekraïne",
        "UMI": "Kleine afgelegen eilanden van de Verenigde Staten (de)",
        "URY": "Uruguay",
        "USA": "Verenigde Staten van Amerika (de)",
        "UZB": "Oezbekistan",
        "VAT": "Heilige Stoel (de)",
        "VCT": "Saint Vincent en de Grenadines",
        "VEN": "Venezuela (Bolivariaanse Republiek)",
        "VGB": "Maagdeneilanden (Brits)",
        "VIR": "Maagdeneilanden (VS)",
        "VNM": "Vietnam",
        "VUT": "Vanuatu",
        "WLF": "Wallis en Futuna",
        "WSM": "Samoa",
        "YEM": "Jemen",
        "ZAF": "Zuid-Afrika",
        "ZMB": "Zambia",
        "ZWE": "Zimbabwe"
      },
      "Created": "Aangemaakt",
      "Current": "Huidige",
      "Current time": "Huidige tijd",
      "Customer number": "Klantnummer:",
      "Customer-offers": "Offertes",
      "Customer-profile": "Klantgegevens",
      "Customer-users": "Klant gebruikers",
      "Customers": "Klanten",
      "Data": "Gegevens",
      "Date": "Datum",
      "Datepicker": {
        "days": "Zondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrijdag_Zaterdag",
        "daysShort": "Zo_Ma_Di_Wo_Do_Vr_Za_Zo",
        "months": "Januari_Februari_Maart_April_Mei_Juni_Juli_Augustus_September_Oktober_November_December",
        "monthsShort": "Jan_Feb_Maa_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Dec",
        "pluralDay": "Dag"
      },
      "Day": "Dag",
      "Days": "Dag | Dagen",
      "Default": "Standaard",
      "Delete": "Verwijder",
      "Delete item": "Verwijder @.lower:{item}",
      "Customer-phone-numbers": "Telefoonnummers",
      "Customer-setting-configurations": "Klantinstellingen",
      "Sharingcenter-profile-setting-configurations": "Profielinstellingen",
      "Licenses": "Licenties",
      "Project-task-time-tracking": "Urenregistraties",
      "Project-task-types": "Projecttaaktypen",
      "Project-tasks": "Projecttaken",
      "Delete dependencies": "Blokkerende afhankelijkheden",
      "Delete item archive": "Archiveer {0}",
      "Delete item force delete": "{0} en alle onderliggende gegevens geforceerd verwijderen",
      "Description": "Omschrijving",
      "Deselect All": "Deselecteer alles",
      "Direct-debit": "SEPA batches",
      "Domain-details": "Details",
      "Domain-ns-groups": "NS Groepen",
      "Domains": "Domeinen",
      "Done": "Gereed",
      "Download": "Download | Download {type}",
      "Download fail": "Downloaden van bestand mislukt.",
      "Download success": "Downloaden van bestand gelukt.",
      "Edit": "Bewerken",
      "Edit data": "Gegevens bewerken",
      "Edit item": "@:{item} bewerken",
      "Edit item fail": "Bewerken van {item} mislukt. {msg}",
      "Edit item success": "{item} zijn gewijzigd.",
      "Email address changed": "E-mailadres aangepast",
      "Email-management": "E-mailbeheer",
      "Employee login": "Medewerker login",
      "Empty": "NB",
      "Error": "Error",
      "Error calling phone number": "Fout bij bellen naar telefoonnummer",
      "Errors": {
        "404": "De opgevraagde pagina is niet gevonden.",
        "Data error": "Er was een probleem met het laden van de data.",
        "Delete item has dependencies": "Het item heeft afhankelijkheden. Verwijder de afhankelijkheden eerst.",
        "Delete item has dependencies or archive": "Het item heeft afhankelijkheden. Verwijder de afhankelijkheden eerst of archiveer het item.",
        "Delete item has dependencies or force delete": "Het item heeft afhankelijkheden. Verwijder de afhankelijkheden eerst of kies geforceerd verwijderen.",
        "Email in use": "Het opgegeven e-mailadres is al in gebruik. Log met je oude e-mailadres in en probeer te wijzigen naar een adres welke nog niet in gebruik is.",
        "Error loading data": "De lijst van {item} kon vanwege een fout niet worden geladen.",
        "ErrorCode": {
          "default": "Validatie is mislukt voor het veld: '@:{key}'. {msg}",
          "EXPORT_FAILED": "Exporteren van gegevens is mislukt, probeer het later opnieuw.",
          "SUBSCRIPTION_ALREADY_ATTACHED": "Opgegeven abonnement is al aan een andere dienst gekoppeld.",
          "SUBSCRIPTION_ALREADY_ATTACHED_DIFFERENT_SERVICE_ID": "Opgegeven abonnement is al gekoppeld aan een dienst met een ander ID.",
          "SUBSCRIPTION_ALREADY_ATTACHED_DIFFERENT_SERVICE_TYPE": "Opgegeven abonnement is al aan een ander type dienst gekoppeld.",
          "SUBSCRIPTION_DIFFERENT_PRODUCT_TYPE": "Opgegeven abonnement heeft een afwijkend producttype.",
          "SUBSCRIPTION_NOT_FOUND": "Opgegeven abonnement kan niet worden gevonden.",
          "UNIQUE_FIELD_ERROR_NOT_UNIQUE": "Het veld '@.lower:{key}' is niet uniek."
        },
        "ColorHex": {
          "INVALID_COLOR": "De opgegeven kleurcode is niet geldig."
        },
        "FileUploader": {
          "Accept": "Het geselecteerde bestand is niet toegestaan",
          "Max-file-size": "Het geselecteerde bestand is te groot (max. {maxMB})",
          "Max-total-size": "Het geselecteerde bestand is te groot (max. {maxMB})"
        },
        "Formats": {
          "BIC": "De opgegeven BIC-code is ongeldig.",
          "default": "@:{key} bevat een ongeldige waarde.",
          "domain": "@:{key} is geen geldig domein.",
          "email": "Het opgegeven e-mailadres is ongeldig.",
          "exclusiveMaximum": "Het veld moet kleiner zijn dan {exclusiveMaximum}.",
          "exclusiveMinimum": "Het veld moet groter zijn dan {exclusiveMinimum}.",
          "IBAN": "Het opgegeven IBAN-nummer is ongeldig.",
          "ipv4": "@:{key} bevat geen geldige IPv4-adres.",
          "ipv6": "@:{key} bevat geen geldige IPv6-adres.",
          "maximum": "Het veld moet een maximumwaarde hebben van {maximum}.",
          "maxItems": "Kies maximaal {maxItems} optie(s).",
          "maxLength": "@:{key} mag maximaal {maxLength} karakter(s) bevatten.",
          "minimum": "Het veld moet een minimumwaarde hebben van {minimum}.",
          "minItems": "Kies minimaal {minItems} optie(s).",
          "minLength": "@:{key} moet minimaal {minimum} karakter(s) bevatten.",
          "notInFuture": "@:{key} mag niet in de toekomst liggen.",
          "notInPast": "@:{key} mag niet in het verleden liggen.",
          "phone": "Het opgegeven telefoonnummer is ongeldig.",
          "uri": "@:{key} bevat geen geldige URI.",
          "validateCocNumber": "@:{key} heeft een vereiste lengte van {requiredLength}.",
          "validateTaxNumber": "@:{key} is ongeldig voor het geselecteerde land."
        },
        "Item fail": "Er is een fout opgetreden bij het verwerken van uw aanvraag, probeer het opnieuw. {msg}",
        "No options available": "Geen opties beschikbaar",
        "Patterns": {
          "E164PhoneNumber": "Voer een geldig internationaal telefoonnummer in, bijvoorbeeld +31612345678.",
          "UppercaseAlphanumeric": "@:{key} mag alleen hoofdletters en cijfers bevatten.",
          "default": "@:{key} voldoet niet aan het vereiste patroon: '{pattern}'."
        },
        "Required": {
          "betweenFieldValues": "@:{key} moet tussen @:{requiredKeyFrom} en @:{requiredKeyTo} zijn.",
          "default": "@:{key} is een verplicht veld.",
          "greaterThan": "@:{key} moet groter zijn dan @:{requiredKey}.",
          "greaterThanOrEqual": "@:{key} moet groter of gelijk zijn aan @:{requiredKey}.",
          "lessThan": "@:{key} moet kleiner zijn dan @:{requiredKey}.",
          "lessThanOrEqual": "@:{key} moet kleiner of gelijk zijn aan @:{requiredKey}.",
          "requiredIf": "@:{key} is een verplicht veld.",
          "requiredIfNot": "@:{key} is een verplicht veld.",
          "requiredIfOneOf": "@:{key} is een verplicht veld.",
          "requiredIfOneOfNot": "@:{key} is een verplicht veld."
        },
        "Type": {
          "default": "@:{key} is een verplicht veld."
        },
        "Unauthorized": "Niet toegestaan",
        "User not found": "De gebruiker {m} kan niet worden opgehaald van de server.",
        "Verification token has expired": "Het verificatietoken is verlopen. Vraag alstublieft een nieuwe aan."
      },
      "Expand menu": "Menu uitvouwen",
      "Export confirm": "Bevestig export",
      "Export confirm text": "Weet je zeker dat je de export wilt maken? De gegevens worden geëxporteerd op basis van de huidige filters.",
      "Failed": "Mislukt",
      "Feedback-answers": "Feedbackantwoorden",
      "Feedback-questions": "Feedbackvragen",
      "Filters": "Filters | Stel filters in",
      "Financial": "Financieel",
      "Finish": "Afronden",
      "Fullscreen": "Volledig scherm | Volledig scherm verlaten",
      "Go to overview": "Overzicht weergeven",
      "Happy birthday": "{name} is vandaag jarig!",
      "History": "Geschiedenis",
      "Home": "Terug naar het begin",
      "Hours": "Uur | Uren",
      "Hrs": "Uur | Uren",
      "Https required": "HTTPS vereist",
      "Information": "Informatie",
      "Invalid": "@:{key} is niet geldig.",
      "Invalid date": "Ongeldige datum: {format}.",
      "Invalid time": "Ongeldige tijd: {format}.",
      "Invoices": "Facturen",
      "Item action": "{action} {type}",
      "Item fail": "Actie: {action}. <br />Service: {type}  <br />Doel: {item}.  <br />Resultaat: MISLUKT",
      "Item success": "Actie: {action}. <br />Service: {type}  <br />Doel: {item}.  <br />Resultaat: SUCCES",
      "Languages": {
        "Dutch": "Nederlands",
        "English": "Engels"
      },
      "Last 2 weeks": "Laatste 2 weken",
      "Last 3 days": "Laatste 3 dagen",
      "Last 30 days": "Laatste 30 dagen",
      "Last 90 days": "Laatste 90 dagen",
      "Last hour": "Afgelopen uur",
      "Last update": "Gewijzigd",
      "Last week": "Vorige week",
      "Last x hours": "Afgelopen {amount} uren",
      "Legend": "Legenda",
      "Limit exceeded": "Limiet overschreden voor '{key}'",
      "Loading": "Bezig met laden, een moment alstublieft...",
      "Logout": "Uitloggen",
      "Main": "Hoofdpagina",
      "Management": "Beheer",
      "Mandatory": "@:{key} is een verplicht veld.",
      "Meeting-statistics": "Vergader statistieken",
      "Meeting-statistics-detail": "Vergader statistieken - Vergaderdetails",
      "Max end date": "Max datum: {maxEndDate}.",
      "Max end dateTime": "Max datum/tijd: {maxEndDate}.",
      "Max end time": "Max tijd: {maxEndDate}.",
      "Maximize": "Maximaliseren",
      "Min start date": "Min datum: {minStartDate}.",
      "Min start dateTime": "Min datum/tijd: {minStartDate}.",
      "Min start time": "Min tijd: {minStartDate}.",
      "Mins": "Min | Minuten",
      "Minutes": "Minuut | Minuten",
      "Seconds": "Seconde | Seconden",
      "Month": "Maand",
      "Months": "Maanden",
      "My profile": "Mijn profiel",
      "Never": "Nooit",
      "New item": "Nieuw @.lower:{item} | Nieuwe @.lower:{item}",
      "New label": "Nieuwe label",
      "New-domain": "Nieuw domein",
      "New-webhosting-account": "Nieuw account",
      "Next": "Volgende",
      "No": "Nee",
      "No data": "Geen resultaten gevonden.",
      "No items found": "Geen {item} gevonden.",
      "No results": "Geen resultaten gevonden met de ingestelde filters.",
      "No suggestions": "Geen suggesties",
      "None": "Geen",
      "Not allowed": "U bent niet gemachtigd de opgevraagde pagina te bekijken. Neem contact op met de beheerder wanneer u denkt dat dit onterecht is.",
      "Not applicable": "n.v.t.",
      "Not synchronized": "niet gesynchroniseerd | Niet gesynchroniseerd",
      "Of": "van",
      "Off": "Uit",
      "On": "Aan",
      "Omni-sessions": "OMNI Sessions",
      "Options": "opties",
      "Page": "pagina",
      "Please note": "Let op",
      "Please wait": "Even geduld...",
      "Rate limit exceeded": "Te veel verzoeken. Probeer het later opnieuw.",
      "Rate limit retry": "Wacht nog {time}",
      "Preview file item": "Voorbeeldweergave",
      "Product-groups": "Productgroepen",
      "Productmanagement": "Productbeheer",
      "Products": "Producten",
      "Profile": "Gebruikersprofiel",
      "ProjectManagement": "Projectmanagement",
      "Projects": "Projecten",
      "PublicNameserver": "OMNI Networks DNS",
      "Refresh item": "{item} vernieuwen",
      "Refresh list": "Lijst vernieuwen",
      "Reload after current action": "Laad opnieuw na het afronden van de huidige actie.",
      "Reload app": "Herladen",
      "Later": "Later",
      "PwaUpdateAvailable": "Update beschikbaar",
      "PwaUpdateMessage": "Sla eventuele wijzigingen op voordat je de app bijwerkt. Na het bijwerken keer je terug naar deze pagina.",
      "PwaUpdateNow": "Nu bijwerken",
      "PwaUpdateRequired": "Update vereist",
      "PwaUnsupported": "Deze versie van de app wordt niet meer ondersteund. Verder werken en opslaan is niet meer mogelijk. Werk de app bij om verder te gaan. Na het bijwerken keer je terug naar je bestemming.",
      "PwaSaveFirst": "Sla eventuele wijzigingen op voordat je bijwerkt.",
      "PwaLoadFailed": "Deze pagina kan niet worden geladen. Probeer de app bij te werken. Daarna keer je terug naar je bestemming.",
      "PwaUpdateFailed": "Bijwerken is niet gelukt. Controleer je verbinding en probeer opnieuw.",
      "Reset": "Resetten",
      "Restore": "Herstellen",
      "Send": "Verzenden",
      "Sip-accounts": "SIP-Accounts",
      "Reset default": "Standaardwaarde herstellen",
      "Reset defaults": "Standaardwaarden herstellen",
      "Retry": "Probeer opnieuw",
      "Roles": "Rollen",
      "Routes": {
        "account-invite": "Accountuitnodiging",
        "activateMfa": "Activeer MFA",
        "asset-management": "Monitoring & assets",
        "asset-monitoring": "Asset monitoring",
        "asset-overview": "Asset overzicht",
        "audit-logs": "Audit logs",
        "account-invitations": "Accountuitnodigingen",
        "mailchimp-account-invitations": "Accountuitnodigingen",
        "contacts": "Contacten",
        "contracts": "Contracten",
        "customer-api-accounts": "API-accounts",
        "customer-contacts": "Contacten",
        "customer-offers": "Offertes",
        "customer-phone-numbers": "Telefoonnummers",
        "customer-sip-accounts": "SIP-Accounts",
        "customer-profile": "Klantprofiel",
        "customer-users": "Klantgebruikers",
        "customers": "Klanten",
        "customers-old": "Klanten (oud)",
        "direct-debit": "Automatische incasso",
        "documentation": "Documentatie",
        "intranet": "Intranet",
        "domain-details": "Domein details",
        "domain-ns-groups": "Nameservergroepen",
        "domains": "Domeinen",
        "dmarc": "DMARC",
        "email-management": "E-mailbeheer",
        "feedback": "Feedback",
        "financial": "Financieel",
        "forgot": "Wachtwoord vergeten",
        "invoices": "Facturen",
        "api-accounts": "API-accounts",
        "login": "Inloggen",
        "logout": "Uitloggen",
        "main": "Home",
        "management": "Beheer",
        "meeting-statistics": "Vergader statistieken",
        "meeting-statistics-detail": "Vergader statistieken - Vergaderdetails",
        "feedback-statistics": "Feedback statistieken",
        "new-domain": "Nieuw domein",
        "new-webhosting-account": "Nieuw hostingaccount",
        "product-groups": "Productgroepen",
        "product-management": "Productbeheer",
        "products": "Producten",
        "profile": "Gebruikersprofiel",
        "project-management": "Projectbeheer",
        "projects": "Projecten",
        "statistics": "Statistieken",
        "statistics-overview": "Overzicht",
        "statistics-meetings": "Meetings",
        "statistics-meetings-detail": "Meetings - Vergaderdetails",
        "statistics-feedback": "Feedback",
        "statistics-sms": "SMS",
        "statistics-email": "E-mail",
        "statistics-licenses": "Licenties",
        "relationship-management": "Relatiebeheer",
        "reset": "Wachtwoord resetten",
        "roles": "Rollen",
        "sales-orders": "Verkooporders",
        "settings": "Instellingen",
        "settings-management": "Instellingenbeheer",
        "sc-appointment-form": "Nieuw",
        "sc-calendar": "Agenda",
        "sc-contacts": "Contacten",
        "sc-groups": "Groepen",
        "sc-meeting": "Vergadering",
        "sc-meeting-recordings": "Opnamen",
        "sc-meeting-statistics": "Statistieken",
        "sc-meeting-statistics-detail": "Statistieken - Vergaderdetails",
        "sc-call-colleague": "Collega's",
        "sc-new-appointment": "Nieuw",
        "sc-overview": "Overzicht",
        "sc-profile": "Gebruikersprofiel",
        "sc-profiles": "Profielen",
        "sc-settings": "Instellingen",
        "sharing-center": "OMNI Sessions",
        "sharing-center-calendar-admin": "Agenda",
        "sharing-center-contact-admin": "Contacten",
        "sharing-center-group-admin": "Groepen",
        "sharing-center-profile-admin": "Profielen",
        "sms-management": "SMS-beheer",
        "sms-statistics": "SMS statistieken",
        "email-statistics": "E-mail statistieken",
        "license-statistics": "Licentie statistieken",
        "ai-queue": "AI-taakwachtrij",
        "ssl-certificates": "SSL-certificaten",
        "license-partner-programs": "Partner programma's",
        "license-slas": "SLA's",
        "subscriptions": "Abonnementen",
        "task-types": "Taaktypes",
        "tasks": "Taken",
        "time-tracking": "Tijdregistratie",
        "unauthorized": "Onbevoegd",
        "users": "Gebruikers",
        "vat": "BTW",
        "verify": "Verifieer account",
        "verifyIdentity": "Verifieer identiteit",
        "verifyMfa": "Verifieer MFA",
        "vision-insights": "Vision insights",
        "vpn-certificates": "VPN-certificaten",
        "vpn-access-graph": "VPN-toegangsschema",
        "vpn-firewalls": "VPN-firewalls",
        "vpn-mac-address-groups": "MAC-adresgroepen",
        "whitelabels": "Whitelabel",
        "backups": "Backups",
        "backups-cloud": "Cloudback-ups",
        "backups-locked-vault": "Locked Vault",
        "backups-microsoft-365": "Microsoft 365",
        "backups-overview": "Overzicht",
        "licenses": "Licenties",
        "licenses-microsoft": "Microsoft-licenties",
        "licenses-omni": "OMNI-licenties",
        "licenses-overview": "Overzicht",
        "webhosting": "Webhosting",
        "webhosting-account-details": "Webhostingaccount details",
        "webhosting-accounts": "Webhostingaccounts",
        "webhosting-packages": "Webhosting pakketten",
        "microsoft-sign-in-monitor": "Microsoft-aanmeldmonitor",
        "stock-locations": "Voorraadlocaties",
        "assets": "Assetbeheer",
        "stock": "Voorraad",
        "stock-movements": "Voorraadmutaties",
        "logistics": "Logistiek",
        "purchase-orders": "Inkooporders",
        "webhooks": "Webhooks",
        "webhook-queue": "Webhook-afleveringen",
        "webhook-logs": "Webhook-logs",
        "sharingcenter-appointments": "Afspraken",
        "suppliers": "Leveranciers",
        "supplier-contacts": "Leverancierscontacten"
      },
      "Rows per page": "Rijen per pagina",
      "Rows selected": "{count} van {total} {type} record(s) geselecteerd",
      "Sales-orders": "Verkooporders",
      "Save": "Opslaan",
      "Save and add another": "Opslaan en nieuwe toevoegen",
      "Save and close": "Opslaan en sluiten",
      "Save and sync": "Opslaan en synchroniseren",
      "Save, sync and close": "Opslaan, synchroniseren en sluiten",
      "Search": "Zoeken",
      "Select All": "Selecteer alles",
      "Select language": "App taal",
      "Select regional settings": "Weergave taal (datums, tijden en waardes)",
      "Selected customer": "Geselecteerde klant",
      "Selected items": "{selected} van {total} @.lower:{items} geselecteerd",
      "Setting": "Instelling",
      "Settings": "Instellingen",
      "Settings-management": "Instellingenbeheer",
      "Sharing-center": "OMNI Sessions",
      "Show all": "Alles tonen",
      "Show more": "Toon meer",
      "Ssl-certificates": "SSL-certificaten",
      "Status": "Status ",
      "Subscriptions": "Abonnementen",
      "Success": "Succes",
      "Switching customer has failed": "Het wisselen van klant is mislukt.",
      "Table of contents": "Inhoudsopgave",
      "Task-types": "Taaktypen",
      "Tasks": "Taken",
      "Time-tracking": "Urenregistratie",
      "Today": "Vandaag",
      "Total": "Totaal",
      "Matching records": "Resultaten",
      "Unauthorized": "Niet toegestaan",
      "Unknown": "Onbekend",
      "Update available": "Update beschikbaar. Laad opnieuw om te bij te werken.",
      "Users": "Gebruikers",
      "Value": "Waarde",
      "Vat": "BTW",
      "VAT": "BTW",
      "View item": "@:{item} weergeven",
      "Vision insights": "Vision insights",
      "VPN management": "VPN beheer",
      "Vpn-certificates": "VPN-certificaten",
      "Vpn-firewall-verification-logs": "VPN-firewallverificatielogs",
      "Vpn-firewalls": "VPN-firewalls",
      "Vpn-mac-address-groups": "MAC-adresgroepen",
      "Webhosting": "Hosting",
      "Webhosting-account-details": "Details",
      "Webhosting-accounts": "Hostingaccounts",
      "Webhosting-packages": "Hostingpakketten",
      "Week": "Week",
      "Weeks": "Week | Weken",
      "Windowed": "Zwevend",
      "Year": "Jaar",
      "Yes": "Ja",
      "Monitoring-assets": "Monitoring & assets",
      "Microsoft-sign-in-monitor": "Microsoft-aanmeldmonitor",
      "Data updated at": "Bijgewerkt om {time}",
      "Refresh": "Vernieuwen",
      "Color": "Kleur",
      "Confirmation": "Bevestiging",
      "Statistics selection hint": "Waarde binnen de huidige selectie en filters.",
      "Supplier-services": "Diensten en contractafspraken",
      "Supplier-contacts": "Leverancierscontacten",
      "Supplier-assessments": "Leveranciersbeoordelingen",
      "Supplier-documents": "Leveranciersdocumenten",
      "Purchase-orders": "Inkooporders"
    },
    "Feedback": {
      "How was the quality": "Hoe was de kwaliteit?"
    },
    "Settings": {
      "Search settings": "Zoek instellingen",
      "Files": {
        "Selection remove": "Selectie verwijderen",
        "Remove undo": "Verwijderen ongedaan maken",
        "Delete file": "Verwijder bestand",
        "View file": "Bekijk bestand",
        "Download file": "Download bestand"
      },
      "Custom sub groups": {
        "Sharing Center - Meeting": "OMNI Sessions - Meeting"
      },
      "UI translations": {
        "Enum": {},
        "Options": {
          "Disabled": "Uitgeschakeld",
          "MfaMethods authenticator": "Authenticator-app",
          "MfaMethods email": "E-mail",
          "MfaMethods sms": "SMS",
          "Unlimited": "Onbeperkt",
          "1 month": "1 maand",
          "2 weeks": "2 weken",
          "1 week": "1 week",
          "3 days": "3 dagen",
          "24 hours": "24 uur",
          "12 hours": "12 uur",
          "1 hour": "1 uur",
          "15 minutes": "15 minuten",
          "Not allowed": "Niet toegestaan",
          "Hide participant list": "Verberg deelnemerslijst",
          "Show participant names and email addresses": "Toon deelnemernamen en e-mailadressen",
          "Hide participant status": "Deelnemersstatus verbergen",
          "Show each recipient’s own status only": "Toon elke ontvanger alleen de eigen status",
          "Show each recipient’s own status, and show all to the organizer": "Toon elke ontvanger alleen de eigen status, en toon alle aan de organisator",
          "Show all participant statuses": "Toon alle deelnemersstatussen",
          "TopBarState hide": "Verbergen",
          "TopBarState hide_in_meeting": "Verbergen in meeting",
          "TopBarState show": "Tonen",
          "LeftMenuState hide": "Verbergen",
          "LeftMenuState hide_in_meeting": "Verbergen in meeting",
          "LeftMenuState collapsed_in_meeting": "Ingeklapt in meeting",
          "LeftMenuState normal": "Normaal",
          "ShowMenuItemsSecondMenu statistics": "Statistieken",
          "ShowMenuItemsSecondMenu settings": "Instellingen",
          "ShowMenuItemsSecondMenu profile": "Profiel",
          "ShowMenuItemsSecondMenu logout": "Uitloggen",
          "MeetingFeatures camera": "Camera",
          "MeetingFeatures chat": "Chat",
          "MeetingFeatures speaker": "Speaker",
          "MeetingFeatures send-group-chat-message": "Chatbericht versturen aan iedereen",
          "MeetingFeatures closedcaptions": "Ondertiteling",
          "MeetingFeatures desktop": "Scherm delen",
          "MeetingFeatures filmstrip": "Filmstrip in- en uitklappen",
          "MeetingFeatures fullscreen": "Volledig scherm",
          "MeetingFeatures breakout-rooms": "Breakout rooms",
          "MeetingFeatures hangup": "Ophangen",
          "MeetingFeatures highlight": "Highlight",
          "MeetingFeatures livestreaming": "Livestream",
          "MeetingFeatures microphone": "Microfoon",
          "MeetingFeatures noisesuppression": "Ruisonderdrukking",
          "MeetingFeatures participants-pane": "Deelnemerspaneel",
          "MeetingFeatures raisehand": "Hand opsteken",
          "MeetingFeatures reactions": "Reacties",
          "MeetingFeatures chat-reactions": "Chatreacties",
          "MeetingFeatures giphy": "GIFs",
          "MeetingFeatures lobby": "Lobby",
          "MeetingFeatures remote-mute": "Deelnemers muten",
          "MeetingFeatures recording": "Opname",
          "MeetingFeatures security": "Beveiliging",
          "MeetingFeatures select-background": "Achtergrond kiezen",
          "MeetingFeatures videoblur": "Achtergrond vervagen",
          "MeetingFeatures settings": "Instellingen",
          "MeetingFeatures shareaudio": "Audio delen",
          "MeetingFeatures sharedvideo": "Video delen",
          "MeetingFeatures shortcuts": "Sneltoetsen",
          "MeetingFeatures stats": "Statistieken",
          "MeetingFeatures tileview": "Tegelweergave",
          "MeetingFeatures toggle-camera": "Camera wisselen",
          "MeetingFeatures torch": "Zaklamp",
          "MeetingFeatures geolocation": "Locatie delen",
          "MeetingFeatures videoquality": "Videokwaliteit",
          "MeetingFeatures invite": "Gebruikers uitnodigen",
          "MeetingFeatures whiteboard": "Whiteboard",
          "MeetingFeatures polls": "Polls",
          "MeetingFeatures create-polls": "Polls maken",
          "MeetingFeatures download": "Apps downloaden",
          "MeetingFeatures help": "Help",
          "CameraFacingMode user": "Frontcamera",
          "CameraFacingMode environment": "Achtercamera (indien beschikbaar)",
          "DisableInitialMediaRequest disable": "Initiële mediarequest uitschakelen",
          "DisableInitialMediaRequest disable_agents": "Initiële mediarequest uitschakelen voor agenten",
          "DisableInitialMediaRequest disable_guests": "Initiële mediarequest uitschakelen voor gasten",
          "DisableInitialMediaRequest enable": "Initiële mediarequest inschakelen",
          "PrejoinScreen enable": "Prejoin-scherm inschakelen",
          "PrejoinScreen disable": "Prejoin-scherm uitschakelen",
          "PrejoinScreen disable_agents": "Prejoin-scherm uitschakelen voor agenten",
          "PrejoinScreen disable_guests": "Prejoin-scherm uitschakelen voor gasten",
          "MeetingHandoff enable": "Meeting-overname inschakelen",
          "MeetingHandoff disable": "Meeting-overname uitschakelen",
          "MeetingHandoff disable_agents": "Meeting-overname uitschakelen voor agenten",
          "MeetingHandoff disable_guests": "Meeting-overname uitschakelen voor gasten",
          "Filmstrip enable": "Filmstrip inschakelen",
          "Filmstrip disable": "Filmstrip uitschakelen",
          "Filmstrip disable_agents": "Filmstrip uitschakelen voor agenten",
          "Filmstrip disable_guests": "Filmstrip uitschakelen voor gasten",
          "BreakoutRoomsHiddenButtons auto-assign-button": "Automatisch toewijzen-knop verbergen",
          "BreakoutRoomsHiddenButtons join-room-button": "Deelnemen aan ruimte-knop verbergen",
          "HiddenConferenceInfo subject": "Onderwerp verbergen",
          "HiddenConferenceInfo timer": "Timer verbergen",
          "HiddenConferenceInfo participants-stats": "Deelnemersstatistieken verbergen",
          "LobbyBypass owner": "Lobby-bypass voor eigenaar",
          "LobbyBypass agents": "Lobby-bypass voor agenten",
          "LobbyBypass guests": "Lobby-bypass voor gasten",
          "RemoteVideoMenuDisabledActions kick": "Deelnemer verwijderen verbergen",
          "RemoteVideoMenuDisabledActions grant-moderator": "Moderator maken verbergen",
          "RemoteVideoMenuPrivateChat none": "Geen",
          "RemoteVideoMenuPrivateChat all": "Alle privéchat uitschakelen",
          "RemoteVideoMenuPrivateChat allow-moderator-chat": "Privéchat met moderators toestaan",
          "RemoteVideoMenuPrivateChat disable-visitor-chat": "Privéchat voor bezoekers uitschakelen",
          "ParticipantsPaneHiddenItems moderator-settings-tab": "Moderatorsinstellingen-tab verbergen",
          "ParticipantsPaneHiddenItems more-actions-button": "Meer acties-knop verbergen",
          "ParticipantsPaneHiddenItems mute-all-button": "Alles dempen-knop verbergen",
          "MeetingNotifications disabled connection_CONNFAIL": "Verbinding mislukt",
          "MeetingNotifications disabled dialog_cameraConstraintFailedError": "Camera-instelling mislukt",
          "MeetingNotifications disabled dialog_cameraNotSendingData": "Camera stuurt geen beeld",
          "MeetingNotifications disabled dialog_kickTitle": "Je bent verwijderd",
          "MeetingNotifications disabled dialog_liveStreaming": "Livestream",
          "MeetingNotifications disabled dialog_lockTitle": "Vergadering vergrendelen mislukt",
          "MeetingNotifications disabled dialog_maxUsersLimitReached": "Maximum aantal deelnemers bereikt",
          "MeetingNotifications disabled dialog_micNotSendingData": "Microfoon stuurt geen geluid",
          "MeetingNotifications disabled dialog_passwordNotSupportedTitle": "Wachtwoord niet ondersteund",
          "MeetingNotifications disabled dialog_recording": "Opname",
          "MeetingNotifications disabled dialog_remoteControlTitle": "Remote control",
          "MeetingNotifications disabled dialog_reservationError": "Reserveringsfout",
          "MeetingNotifications disabled dialog_screenSharingFailedTitle": "Scherm delen mislukt",
          "MeetingNotifications disabled dialog_serviceUnavailable": "Dienst niet beschikbaar",
          "MeetingNotifications disabled dialog_sessTerminated": "Sessie beëindigd",
          "MeetingNotifications disabled dialog_sessionRestarted": "Sessie herstart",
          "MeetingNotifications disabled dialog_tokenAuthFailed": "Authenticatie mislukt",
          "MeetingNotifications disabled dialog_tokenAuthFailedWithReasons": "Authenticatie mislukt (details)",
          "MeetingNotifications disabled dialog_transcribing": "Transcriptie",
          "MeetingNotifications disabled dialOut_statusMessage": "Uitbelstatus",
          "MeetingNotifications disabled liveStreaming_busy": "Livestream bezet",
          "MeetingNotifications disabled liveStreaming_failedToStart": "Livestream starten mislukt",
          "MeetingNotifications disabled liveStreaming_unavailableTitle": "Livestream niet beschikbaar",
          "MeetingNotifications disabled lobby_joinRejectedMessage": "Toegang geweigerd",
          "MeetingNotifications disabled lobby_notificationTitle": "Lobby melding",
          "MeetingNotifications disabled notify_audioUnmuteBlockedTitle": "Microfoon aanzetten geblokkeerd",
          "MeetingNotifications disabled notify_chatMessages": "Chatberichten",
          "MeetingNotifications disabled notify_connectedOneMember": "Een deelnemer heeft zich aangesloten",
          "MeetingNotifications disabled notify_connectedThreePlusMembers": "Meerdere deelnemers hebben zich aangesloten",
          "MeetingNotifications disabled notify_connectedTwoMembers": "Twee deelnemers hebben zich aangesloten",
          "MeetingNotifications disabled notify_dataChannelClosed": "Datakanaal gesloten",
          "MeetingNotifications disabled notify_hostAskedUnmute": "Host vraagt om microfoon aan te zetten",
          "MeetingNotifications disabled notify_invitedOneMember": "Een deelnemer is uitgenodigd",
          "MeetingNotifications disabled notify_invitedThreePlusMembers": "Meerdere deelnemers zijn uitgenodigd",
          "MeetingNotifications disabled notify_invitedTwoMembers": "Twee deelnemers zijn uitgenodigd",
          "MeetingNotifications disabled notify_kickParticipant": "Deelnemer verwijderd",
          "MeetingNotifications disabled notify_leftOneMember": "Een deelnemer is vertrokken",
          "MeetingNotifications disabled notify_leftThreePlusMembers": "Meerdere deelnemers zijn vertrokken",
          "MeetingNotifications disabled notify_leftTwoMembers": "Twee deelnemers zijn vertrokken",
          "MeetingNotifications disabled notify_linkToSalesforce": "Salesforce-koppeling",
          "MeetingNotifications disabled notify_localRecordingStarted": "Lokale opname gestart",
          "MeetingNotifications disabled notify_localRecordingStopped": "Lokale opname gestopt",
          "MeetingNotifications disabled notify_moderationInEffectCSTitle": "Moderatie actief (content)",
          "MeetingNotifications disabled notify_moderationInEffectTitle": "Moderatie actief (audio)",
          "MeetingNotifications disabled notify_moderationInEffectVideoTitle": "Moderatie actief (video)",
          "MeetingNotifications disabled notify_moderator": "Moderator toegewezen",
          "MeetingNotifications disabled notify_mutedRemotelyTitle": "Gedempt door moderator",
          "MeetingNotifications disabled notify_mutedTitle": "Gedempt bij binnenkomst",
          "MeetingNotifications disabled notify_newDeviceAudioTitle": "Nieuw audiodevice gedetecteerd",
          "MeetingNotifications disabled notify_newDeviceCameraTitle": "Nieuwe camera gedetecteerd",
          "MeetingNotifications disabled notify_noiseSuppressionFailedTitle": "Ruisonderdrukking mislukt",
          "MeetingNotifications disabled notify_participantWantsToJoin": "Deelnemer wil deelnemen",
          "MeetingNotifications disabled notify_participantsWantToJoin": "Deelnemers willen deelnemen",
          "MeetingNotifications disabled notify_passwordRemovedRemotely": "Wachtwoord verwijderd",
          "MeetingNotifications disabled notify_passwordSetRemotely": "Wachtwoord ingesteld",
          "MeetingNotifications disabled notify_raisedHand": "Hand opgestoken",
          "MeetingNotifications disabled notify_screenShareNoAudio": "Scherm delen zonder audio",
          "MeetingNotifications disabled notify_screenSharingAudioOnlyTitle": "Schermdelen alleen audio",
          "MeetingNotifications disabled notify_selfViewTitle": "Zelfbeeld verborgen",
          "MeetingNotifications disabled notify_startSilentTitle": "Zonder audio gestart",
          "MeetingNotifications disabled notify_suboptimalExperienceTitle": "Minder optimale ervaring",
          "MeetingNotifications disabled notify_unmute": "Ontdempingsverzoek",
          "MeetingNotifications disabled notify_videoMutedRemotelyTitle": "Video gedempt door moderator",
          "MeetingNotifications disabled notify_videoUnmuteBlockedTitle": "Video aanzetten geblokkeerd",
          "MeetingNotifications disabled prejoin_errorDialOut": "Uitbelfout",
          "MeetingNotifications disabled prejoin_errorDialOutDisconnected": "Uitbellen verbroken",
          "MeetingNotifications disabled prejoin_errorDialOutFailed": "Uitbellen mislukt",
          "MeetingNotifications disabled prejoin_errorDialOutStatus": "Uitbelstatus fout",
          "MeetingNotifications disabled prejoin_errorStatusCode": "Statuscode fout",
          "MeetingNotifications disabled prejoin_errorValidation": "Validatiefout",
          "MeetingNotifications disabled recording_busy": "Opname bezig",
          "MeetingNotifications disabled recording_failedToStart": "Opname starten mislukt",
          "MeetingNotifications disabled recording_unavailableTitle": "Opname niet beschikbaar",
          "MeetingNotifications disabled toolbar_noAudioSignalTitle": "Geen audiosignaal",
          "MeetingNotifications disabled toolbar_noisyAudioInputTitle": "Ruis op audio-ingang",
          "MeetingNotifications disabled toolbar_talkWhileMutedPopup": "Praten terwijl gedempt",
          "MeetingNotifications disabled transcribing_failed": "Transcriptie mislukt",
          "MeetingSounds ASKED_TO_UNMUTE_SOUND": "Verzoek om microfoon aan te zetten",
          "MeetingSounds E2EE_OFF_SOUND": "E2EE uit",
          "MeetingSounds E2EE_ON_SOUND": "E2EE aan",
          "MeetingSounds INCOMING_MSG_SOUND": "Binnenkomend bericht",
          "MeetingSounds KNOCKING_PARTICIPANT_SOUND": "Aankloppen deelnemer",
          "MeetingSounds LIVE_STREAMING_OFF_SOUND": "Livestream uit",
          "MeetingSounds LIVE_STREAMING_ON_SOUND": "Livestream aan",
          "MeetingSounds NO_AUDIO_SIGNAL_SOUND": "Geen audiosignaal",
          "MeetingSounds NOISY_AUDIO_INPUT_SOUND": "Ruis op audio-ingang",
          "MeetingSounds OUTGOING_CALL_EXPIRED_SOUND": "Uitgaand gesprek verlopen",
          "MeetingSounds OUTGOING_CALL_REJECTED_SOUND": "Uitgaand gesprek afgewezen",
          "MeetingSounds OUTGOING_CALL_RINGING_SOUND": "Uitgaand gesprek overgaan",
          "MeetingSounds OUTGOING_CALL_START_SOUND": "Uitgaand gesprek gestart",
          "MeetingSounds PARTICIPANT_JOINED_SOUND": "Deelnemer toegevoegd",
          "MeetingSounds PARTICIPANT_LEFT_SOUND": "Deelnemer vertrokken",
          "MeetingSounds RAISE_HAND_SOUND": "Hand opsteken",
          "MeetingSounds REACTION_SOUND": "Reactie",
          "MeetingSounds RECORDING_OFF_SOUND": "Opname uit",
          "MeetingSounds RECORDING_ON_SOUND": "Opname aan",
          "MeetingSounds TALK_WHILE_MUTED_SOUND": "Praten terwijl gedempt"
        },
        "Group": {
          "General": "Algemeen",
          "Sharing Center": "OMNI Sessions",
          "OMNI Sessions - Telephony": "OMNI Sessions - Telefonie"
        },
        "Label": {
          "Customer logo": "Logo",
          "Customer logo (mark)": "Beeldmerk",
          "Portal name": "Portal naam",
          "Support email address": "Support e-mailadres",
          "Customer signature for emails": "Klant e-mailhandtekening",
          "Primary color": "Primaire kleur",
          "MFA enabled": "MFA ingeschakeld",
          "MFA primary method": "Primaire MFA-methode",
          "MFA fallback methods": "MFA-fallbackmethoden",
          "Default customer": "Standaard geselecteerde klant bij inloggen",
          "Top bar state": "Topbalkstatus",
          "Top bar state iframe": "Topbalkstatus (iframe)",
          "Left menu state": "Linkermenu-status",
          "Left menu state iframe": "Linkermenu-status (iframe)",
          "Show left menu items in second menu": "Toon menu-items in tweede menu",
          "Show left menu items in second menu iframe": "Toon menu-items in tweede menu (iframe)",
          "AI agent": "AI-agent",
          "AI agent settings": "AI-agent instellingen",
          "Whisper agent": "Whisper-agent",
          "Whisper agent settings": "Whisper-agent instellingen",
          "Sharing Center - Product name": "Productnaam",
          "Sharing Center - Default subject": "Standaard onderwerp",
          "Sharing Center - ICS invite participant visibility": "Deelnemerszichtbaarheid ICS invite",
          "Sharing Center - ICS invite participant status visibility": "Deelnemersstatus ICS invite",
          "Sharing Center - Pre-join time": "Toegang vóór start",
          "Sharing Center - Post-join time": "Toegang na einde",
          "Sharing Center - Feedback questions": "Feedbackvragen",
          "Sharing Center - Meeting max participants": "Meeting maximaal aantal deelnemers",
          "Sharing Center - Meeting max participants live invite": "Meeting max deelnemers live uitnodigen",
          "Sharing Center - Meeting e2e enabled": "Meeting E2E beschikbaar",
          "Sharing Center - Meeting default e2e encrypted": "Meeting standaard E2E versleuteld",
          "Sharing Center - Meeting p2p enabled": "Meeting P2P ingeschakeld",
          "Sharing Center - Meeting p2p max participants": "Meeting P2P maximaal aantal deelnemers",
          "Sharing Center - Meeting auto transcriptions enabled": "Automatische transcripties",
          "Sharing Center - Meeting auto AI minutes enabled": "Automatische AI-notulen",
          "Sharing Center - Meeting default AI minutes hidden prompt": "Meeting standaard verborgen prompt voor AI-notulen",
          "Sharing Center - Meeting default AI minutes prompt": "Meeting standaard prompt voor AI-notulen",
          "Sharing Center - Meeting default AI minutes prompt NL": "Meeting standaard prompt voor AI-notulen (Nederlands)",
          "Sharing Center - Meeting default AI minutes prompt EN": "Meeting standaard prompt voor AI-notulen (Engels)",
          "Sharing Center - Features agents": "Meeting functies",
          "Sharing Center - Features guests": "Meeting functies (gasten)",
          "Sharing Center - Meeting chat smileys disabled": "Meeting chat-smileys uitgeschakeld",
          "Sharing Center - Meeting breakout rooms hidden buttons": "Meeting breakoutruimtes verborgen knoppen",
          "Sharing Center - Meeting notifications disabled": "Meeting meldingen uitgeschakeld",
          "Sharing Center - Meeting notifications disabled guests": "Meeting meldingen uitgeschakeld (gasten)",
          "Sharing Center - Meeting sounds disabled": "Meeting geluiden uitgeschakeld",
          "Sharing Center - Meeting sounds disabled guests": "Meeting geluiden uitgeschakeld (gasten)",
          "Sharing Center - Meeting remote video menu enabled": "Meeting deelnemersvideomenu ingeschakeld",
          "Sharing Center - Meeting remote video menu disabled actions": "Meeting deelnemersvideomenu verborgen acties",
          "Sharing Center - Meeting remote video menu private chat": "Meeting deelnemersvideomenu privéchat",
          "Sharing Center - Meeting participants pane enabled": "Meeting deelnemerspaneel ingeschakeld",
          "Sharing Center - Meeting participants pane hidden items": "Meeting deelnemerspaneel verborgen onderdelen",
          "Sharing Center - Meeting lobby enabled": "Meeting lobby ingeschakeld",
          "Sharing Center - Meeting lobby auto knock": "Meeting lobby automatisch aankloppen",
          "Sharing Center - Meeting lobby chat enabled": "Meeting lobbychat ingeschakeld",
          "Sharing Center - Meeting lobby bypass": "Meeting lobby bypass",
          "Sharing Center - Meeting prejoin screen": "Meeting prejoin-scherm",
          "Sharing Center - Meeting handoff": "Meeting-overname",
          "Sharing Center - Meeting filmstrip": "Meeting filmstrip",
          "Sharing Center - Tileview enabled": "Tegelweergave ingeschakeld",
          "Sharing Center - Number of visible tiles": "Aantal zichtbare tegels",
          "Sharing Center - Tileview enabled guests": "Tegelweergave ingeschakeld (gasten)",
          "Sharing Center - Number of visible tiles guests": "Aantal zichtbare tegels (gasten)",
          "Sharing Center - Meeting toolbar always visible": "Meeting toolbar altijd zichtbaar",
          "Sharing Center - Meeting toolbar initial timeout": "Meeting toolbar initiële timeout",
          "Sharing Center - Meeting toolbar timeout": "Meeting toolbar timeout",
          "Sharing Center - Meeting hidden conference info": "Meeting verborgen conference-info",
          "Sharing Center - Meeting mute microphone": "Meeting microfoon dempen",
          "Sharing Center - Meeting mute microphone guests": "Meeting microfoon dempen (gasten)",
          "Sharing Center - Meeting camera off": "Meeting camera uit",
          "Sharing Center - Meeting camera off guests": "Meeting camera uit (gasten)",
          "Sharing Center - Meeting camera facing mode": "Meeting camerastand",
          "Sharing Center - Meeting camera facing mode guests": "Meeting camerastand (gasten)",
          "Sharing Center - Meeting initial media request": "Meeting initiële mediarequest",
          "Sharing Center - Meeting force my video on stage": "Meeting zet mijn video op het podium",
          "OMNI Sessions - Inbound phone number": "Inkomend telefoonnummer",
          "OMNI Sessions - Outbound phone number": "Uitgaand telefoonnummer",
          "Sharing Center - Meeting base URL": "Meeting basis-URL",
          "Sharing Center - Meeting app ID": "Meeting app-ID",
          "Sharing Center - Meeting app secret": "Meeting app-secret",
          "Sharing Center - Meeting audience": "Meeting token audience",
          "Sharing Center - Meeting subject": "Meeting token subject",
          "Sharing Center - Meeting background color": "Meeting achtergrondkleur",
          "Sharing Center - Meeting background image URL": "Meeting achtergrondafbeelding URL",
          "Sharing Center - Meeting DID page URL": "Meeting DID page URL",
          "Sharing Center - Meeting invite domain": "Meeting invite domain",
          "Sharing Center - Meeting logo click URL": "Meeting logo klik-URL",
          "Sharing Center - Meeting logo image URL": "Meeting logo afbeelding URL",
          "Sharing Center - Meeting avatar backgrounds": "Meeting avatar backgrounds",
          "Sharing Center - Meeting pre-meeting background": "Meeting pre-meeting background",
          "Sharing Center - Meeting disable virtual backgrounds": "Virtuele achtergronden uitschakelen",
          "Sharing Center - Meeting disable adding background images": "Achtergrondafbeeldingen toevoegen uitschakelen",
          "Sharing Center - Meeting custom virtual background 1": "Aangepaste virtuele achtergrond 1",
          "Sharing Center - Meeting custom virtual background 2": "Aangepaste virtuele achtergrond 2",
          "Sharing Center - Meeting custom virtual background 3": "Aangepaste virtuele achtergrond 3",
          "Sharing Center - Meeting custom virtual background 4": "Aangepaste virtuele achtergrond 4",
          "Sharing Center - Meeting custom virtual background 5": "Aangepaste virtuele achtergrond 5",
          "Sharing Center - Meeting virtual backgrounds": "Meeting virtual backgrounds",
          "Sharing Center - Meeting virtual backgrounds include defaults": "Virtuele achtergronden inclusief standaard achtergronden",
          "Sharing Center - Meeting user documentation URL": "Meeting gebruikersdocumentatie-URL",
          "Sharing Center - Meeting download apps URL": "Meeting apps-download-URL",
          "Sharing Center - Meeting translations": "Meeting translations",
          "Sharing Center - Meeting CSS": "Meeting CSS",
          "Sharing Center - Meeting custom icons - icon Add User": "Meeting custom icons - icon Add User",
          "Sharing Center - Meeting custom icons - icon Arrow Back": "Meeting custom icons - icon Arrow Back",
          "Sharing Center - Meeting custom icons - icon Arrow Down": "Meeting custom icons - icon Arrow Down",
          "Sharing Center - Meeting custom icons - icon Arrow Down Large": "Meeting custom icons - icon Arrow Down Large",
          "Sharing Center - Meeting custom icons - icon Arrow Left": "Meeting custom icons - icon Arrow Left",
          "Sharing Center - Meeting custom icons - icon Arrow Up": "Meeting custom icons - icon Arrow Up",
          "Sharing Center - Meeting custom icons - icon Arrow Up Large": "Meeting custom icons - icon Arrow Up Large",
          "Sharing Center - Meeting custom icons - icon Audio Only": "Meeting custom icons - icon Audio Only",
          "Sharing Center - Meeting custom icons - icon Audio Only Off": "Meeting custom icons - icon Audio Only Off",
          "Sharing Center - Meeting custom icons - icon Bluetooth": "Meeting custom icons - icon Bluetooth",
          "Sharing Center - Meeting custom icons - icon Bell": "Meeting custom icons - icon Bell",
          "Sharing Center - Meeting custom icons - icon Calendar": "Meeting custom icons - icon Calendar",
          "Sharing Center - Meeting custom icons - icon Camera Refresh": "Meeting custom icons - icon Camera Refresh",
          "Sharing Center - Meeting custom icons - icon Car": "Meeting custom icons - icon Car",
          "Sharing Center - Meeting custom icons - icon Chat Unread": "Meeting custom icons - icon Chat Unread",
          "Sharing Center - Meeting custom icons - icon Check": "Meeting custom icons - icon Check",
          "Sharing Center - Meeting custom icons - icon Close Circle": "Meeting custom icons - icon Close Circle",
          "Sharing Center - Meeting custom icons - icon Close Large": "Meeting custom icons - icon Close Large",
          "Sharing Center - Meeting custom icons - icon Cloud Upload": "Meeting custom icons - icon Cloud Upload",
          "Sharing Center - Meeting custom icons - icon Code": "Meeting custom icons - icon Code",
          "Sharing Center - Meeting custom icons - icon Connection": "Meeting custom icons - icon Connection",
          "Sharing Center - Meeting custom icons - icon Connection Inactive": "Meeting custom icons - icon Connection Inactive",
          "Sharing Center - Meeting custom icons - icon Copy": "Meeting custom icons - icon Copy",
          "Sharing Center - Meeting custom icons - icon Device Headphone": "Meeting custom icons - icon Device Headphone",
          "Sharing Center - Meeting custom icons - icon Dots Horizontal": "Meeting custom icons - icon Dots Horizontal",
          "Sharing Center - Meeting custom icons - icon Download": "Meeting custom icons - icon Download",
          "Sharing Center - Meeting custom icons - icon E2EE": "Meeting custom icons - icon E2EE",
          "Sharing Center - Meeting custom icons - icon Edit": "Meeting custom icons - icon Edit",
          "Sharing Center - Meeting custom icons - icon Enlarge": "Meeting custom icons - icon Enlarge",
          "Sharing Center - Meeting custom icons - icon Enter Fullscreen": "Meeting custom icons - icon Enter Fullscreen",
          "Sharing Center - Meeting custom icons - icon Envelope": "Meeting custom icons - icon Envelope",
          "Sharing Center - Meeting custom icons - icon Emotions Angry": "Meeting custom icons - icon Emotions Angry",
          "Sharing Center - Meeting custom icons - icon Emotions Disgusted": "Meeting custom icons - icon Emotions Disgusted",
          "Sharing Center - Meeting custom icons - icon Emotions Fearful": "Meeting custom icons - icon Emotions Fearful",
          "Sharing Center - Meeting custom icons - icon Emotions Happy": "Meeting custom icons - icon Emotions Happy",
          "Sharing Center - Meeting custom icons - icon Emotions Neutral": "Meeting custom icons - icon Emotions Neutral",
          "Sharing Center - Meeting custom icons - icon Emotions Sad": "Meeting custom icons - icon Emotions Sad",
          "Sharing Center - Meeting custom icons - icon Emotions Surprised": "Meeting custom icons - icon Emotions Surprised",
          "Sharing Center - Meeting custom icons - icon Exclamation Solid": "Meeting custom icons - icon Exclamation Solid",
          "Sharing Center - Meeting custom icons - icon Exclamation Triangle": "Meeting custom icons - icon Exclamation Triangle",
          "Sharing Center - Meeting custom icons - icon Exit Fullscreen": "Meeting custom icons - icon Exit Fullscreen",
          "Sharing Center - Meeting custom icons - icon Face Smile": "Meeting custom icons - icon Face Smile",
          "Sharing Center - Meeting custom icons - icon Favorite": "Meeting custom icons - icon Favorite",
          "Sharing Center - Meeting custom icons - icon Favorite Solid": "Meeting custom icons - icon Favorite Solid",
          "Sharing Center - Meeting custom icons - icon Feedback": "Meeting custom icons - icon Feedback",
          "Sharing Center - Meeting custom icons - icon Gear": "Meeting custom icons - icon Gear",
          "Sharing Center - Meeting custom icons - icon Google": "Meeting custom icons - icon Google",
          "Sharing Center - Meeting custom icons - icon Hangup": "Meeting custom icons - icon Hangup",
          "Sharing Center - Meeting custom icons - icon Help": "Meeting custom icons - icon Help",
          "Sharing Center - Meeting custom icons - icon Highlight": "Meeting custom icons - icon Highlight",
          "Sharing Center - Meeting custom icons - icon Image": "Meeting custom icons - icon Image",
          "Sharing Center - Meeting custom icons - icon Info": "Meeting custom icons - icon Info",
          "Sharing Center - Meeting custom icons - icon Info Circle": "Meeting custom icons - icon Info Circle",
          "Sharing Center - Meeting custom icons - icon Message": "Meeting custom icons - icon Message",
          "Sharing Center - Meeting custom icons - icon Meter": "Meeting custom icons - icon Meter",
          "Sharing Center - Meeting custom icons - icon Mic": "Meeting custom icons - icon Mic",
          "Sharing Center - Meeting custom icons - icon Mic Slash": "Meeting custom icons - icon Mic Slash",
          "Sharing Center - Meeting custom icons - icon Moderator": "Meeting custom icons - icon Moderator",
          "Sharing Center - Meeting custom icons - icon Noise Suppression Off": "Meeting custom icons - icon Noise Suppression Off",
          "Sharing Center - Meeting custom icons - icon Noise Suppression On": "Meeting custom icons - icon Noise Suppression On",
          "Sharing Center - Meeting custom icons - icon Arrow Right": "Meeting custom icons - icon Arrow Right",
          "Sharing Center - Meeting custom icons - icon Office365": "Meeting custom icons - icon Office365",
          "Sharing Center - Meeting custom icons - icon Performance": "Meeting custom icons - icon Performance",
          "Sharing Center - Meeting custom icons - icon Phone Ringing": "Meeting custom icons - icon Phone Ringing",
          "Sharing Center - Meeting custom icons - icon Pin": "Meeting custom icons - icon Pin",
          "Sharing Center - Meeting custom icons - icon Pinned": "Meeting custom icons - icon Pinned",
          "Sharing Center - Meeting custom icons - icon Play": "Meeting custom icons - icon Play",
          "Sharing Center - Meeting custom icons - icon Plus": "Meeting custom icons - icon Plus",
          "Sharing Center - Meeting custom icons - icon Raise Hand": "Meeting custom icons - icon Raise Hand",
          "Sharing Center - Meeting custom icons - icon Record": "Meeting custom icons - icon Record",
          "Sharing Center - Meeting custom icons - icon Record Account": "Meeting custom icons - icon Record Account",
          "Sharing Center - Meeting custom icons - icon Record Contact": "Meeting custom icons - icon Record Contact",
          "Sharing Center - Meeting custom icons - icon Record Lead": "Meeting custom icons - icon Record Lead",
          "Sharing Center - Meeting custom icons - icon Record Opportunity": "Meeting custom icons - icon Record Opportunity",
          "Sharing Center - Meeting custom icons - icon Remote Control Start": "Meeting custom icons - icon Remote Control Start",
          "Sharing Center - Meeting custom icons - icon Remote Control Stop": "Meeting custom icons - icon Remote Control Stop",
          "Sharing Center - Meeting custom icons - icon Reply": "Meeting custom icons - icon Reply",
          "Sharing Center - Meeting custom icons - icon Restore": "Meeting custom icons - icon Restore",
          "Sharing Center - Meeting custom icons - icon Ring Group": "Meeting custom icons - icon Ring Group",
          "Sharing Center - Meeting custom icons - icon Screenshare": "Meeting custom icons - icon Screenshare",
          "Sharing Center - Meeting custom icons - icon Search": "Meeting custom icons - icon Search",
          "Sharing Center - Meeting custom icons - icon Security Off": "Meeting custom icons - icon Security Off",
          "Sharing Center - Meeting custom icons - icon Security On": "Meeting custom icons - icon Security On",
          "Sharing Center - Meeting custom icons - icon Send": "Meeting custom icons - icon Send",
          "Sharing Center - Meeting custom icons - icon Share": "Meeting custom icons - icon Share",
          "Sharing Center - Meeting custom icons - icon Share Doc": "Meeting custom icons - icon Share Doc",
          "Sharing Center - Meeting custom icons - icon Shortcuts": "Meeting custom icons - icon Shortcuts",
          "Sharing Center - Meeting custom icons - icon SIP": "Meeting custom icons - icon SIP",
          "Sharing Center - Meeting custom icons - icon Sites": "Meeting custom icons - icon Sites",
          "Sharing Center - Meeting custom icons - icon Stop": "Meeting custom icons - icon Stop",
          "Sharing Center - Meeting custom icons - icon Subtitles": "Meeting custom icons - icon Subtitles",
          "Sharing Center - Meeting custom icons - icon Tile View": "Meeting custom icons - icon Tile View",
          "Sharing Center - Meeting custom icons - icon Trash": "Meeting custom icons - icon Trash",
          "Sharing Center - Meeting custom icons - icon User Deleted": "Meeting custom icons - icon User Deleted",
          "Sharing Center - Meeting custom icons - icon Users": "Meeting custom icons - icon Users",
          "Sharing Center - Meeting custom icons - icon User": "Meeting custom icons - icon User",
          "Sharing Center - Meeting custom icons - icon Video": "Meeting custom icons - icon Video",
          "Sharing Center - Meeting custom icons - icon Video Off": "Meeting custom icons - icon Video Off",
          "Sharing Center - Meeting custom icons - icon Volume Off": "Meeting custom icons - icon Volume Off",
          "Sharing Center - Meeting custom icons - icon Volume Up": "Meeting custom icons - icon Volume Up",
          "Sharing Center - Meeting custom icons - icon Warning": "Meeting custom icons - icon Warning",
          "Sharing Center - Meeting custom icons - icon Warning Circle": "Meeting custom icons - icon Warning Circle",
          "Sharing Center - Meeting custom icons - icon Whiteboard": "Meeting custom icons - icon Whiteboard",
          "Sharing Center - Meeting custom icons - icon Whiteboard Hide": "Meeting custom icons - icon Whiteboard Hide",
          "Sharing Center - Meeting custom icons - icon Wifi1 Bar": "Meeting custom icons - icon Wifi1 Bar",
          "Sharing Center - Meeting custom icons - icon Wifi2 Bars": "Meeting custom icons - icon Wifi2 Bars",
          "Sharing Center - Meeting custom icons - icon Wifi3 Bars": "Meeting custom icons - icon Wifi3 Bars",
          "Sharing Center - Meeting custom icons - icon Yahoo": "Meeting custom icons - icon Yahoo",
          "Sharing Center - Meeting theme palette - Action01": "Primaire actie",
          "Sharing Center - Meeting theme palette - Action01 Active": "Primaire actie (ingedrukt)",
          "Sharing Center - Meeting theme palette - Action01 Hover": "Primaire actie (hover)",
          "Sharing Center - Meeting theme palette - Action02": "Secundaire actie",
          "Sharing Center - Meeting theme palette - Action02 Active": "Secundaire actie (ingedrukt)",
          "Sharing Center - Meeting theme palette - Action02 Hover": "Secundaire actie (hover)",
          "Sharing Center - Meeting theme palette - Action03": "Subtiele actie",
          "Sharing Center - Meeting theme palette - Action03 Active": "Subtiele actie (ingedrukt)",
          "Sharing Center - Meeting theme palette - Action03 Hover": "Subtiele actie (hover)",
          "Sharing Center - Meeting theme palette - Action Danger": "Waarschuwingsactie",
          "Sharing Center - Meeting theme palette - Action Danger Active": "Waarschuwingsactie (ingedrukt)",
          "Sharing Center - Meeting theme palette - Action Danger Hover": "Waarschuwingsactie (hover)",
          "Sharing Center - Meeting theme palette - Disabled01": "Disabled achtergrond",
          "Sharing Center - Meeting theme palette - Field01": "Formulierveld accent",
          "Sharing Center - Meeting theme palette - Focus01": "Focus ring",
          "Sharing Center - Meeting theme palette - Icon01": "Primaire iconkleur",
          "Sharing Center - Meeting theme palette - Icon02": "Secundaire icon/accent",
          "Sharing Center - Meeting theme palette - Icon03": "Inactieve iconkleur",
          "Sharing Center - Meeting theme palette - Icon04": "Contrast iconkleur",
          "Sharing Center - Meeting theme palette - Icon Error": "Error iconkleur",
          "Sharing Center - Meeting theme palette - Link01": "Primaire link",
          "Sharing Center - Meeting theme palette - Link01 Active": "Link (ingedrukt)",
          "Sharing Center - Meeting theme palette - Link01 Hover": "Link (hover)",
          "Sharing Center - Meeting theme palette - Success01": "Succes status primair",
          "Sharing Center - Meeting theme palette - Success02": "Succes status secundair",
          "Sharing Center - Meeting theme palette - Support01": "Supportkleur 01",
          "Sharing Center - Meeting theme palette - Support02": "Supportkleur 02",
          "Sharing Center - Meeting theme palette - Support03": "Supportkleur 03",
          "Sharing Center - Meeting theme palette - Support04": "Supportkleur 04",
          "Sharing Center - Meeting theme palette - Support05": "Supportkleur 05",
          "Sharing Center - Meeting theme palette - Support06": "Supportkleur 06",
          "Sharing Center - Meeting theme palette - Support07": "Supportkleur 07",
          "Sharing Center - Meeting theme palette - Support08": "Supportkleur 08",
          "Sharing Center - Meeting theme palette - Support09": "Supportkleur 09",
          "Sharing Center - Meeting theme palette - Text01": "Primaire tekst",
          "Sharing Center - Meeting theme palette - Text02": "Secundaire tekst",
          "Sharing Center - Meeting theme palette - Text03": "Minder opvallende tekst",
          "Sharing Center - Meeting theme palette - Text04": "Contrast tekst",
          "Sharing Center - Meeting theme palette - Text Error": "Fouttekst",
          "Sharing Center - Meeting theme palette - Ui01": "Basis container achtergrond",
          "Sharing Center - Meeting theme palette - Ui02": "Verhoogde container achtergrond",
          "Sharing Center - Meeting theme palette - Ui03": "Input/control achtergrond",
          "Sharing Center - Meeting theme palette - Ui04": "Lichte border/surface",
          "Sharing Center - Meeting theme palette - Ui05": "Inactieve indicator",
          "Sharing Center - Meeting theme palette - Ui06": "Donkere separator",
          "Sharing Center - Meeting theme palette - Ui07": "Sterke divider",
          "Sharing Center - Meeting theme palette - Ui08": "Gedempte action fill",
          "Sharing Center - Meeting theme palette - Ui09": "Info badge achtergrond",
          "Sharing Center - Meeting theme palette - Ui10": "Actieve indicator achtergrond",
          "Sharing Center - Meeting theme palette - Ui Background": "App achtergrond",
          "Sharing Center - Meeting theme palette - Warning01": "Waarschuwing accent",
          "Sharing Center - Meeting theme palette - Warning02": "Waarschuwing highlight"
        },
        "Description": {
          "Customer logo": "Upload een logo.",
          "Customer logo (mark)": "Het beeldmerk in een vierkant.",
          "Portal name": "De naam die wordt gebruikt voor de portal, mails en communicatie.",
          "Support email address": "Het support e-mailadres dat wordt gebruikt voor portaalcommunicatie.",
          "Customer signature for emails": "Gebruik de klanthandtekening en contactgegevens in authenticatiemails.",
          "Primary color": "De primaire kleur die in het portaal wordt gebruikt.",
          "MFA enabled": "Schakel multi-factor-authenticatie (MFA) in.",
          "MFA primary method": "Kies de primaire multi-factor-authenticatiemethode (MFA).",
          "MFA fallback methods": "Kies een of meer fallback multi-factor-authenticatiemethoden (MFA).",
          "Default customer": "Selecteer een standaardklant bij het inloggen.",
          "Top bar state": "Stel de standaardstatus in voor de topbalk.",
          "Top bar state iframe": "Stel de standaardstatus in voor de topbalk wanneer embedded wordt uitgevoerd (iframe).",
          "Left menu state": "Stel de standaardstatus in voor het linkermenu.",
          "Left menu state iframe": "Stel de standaardstatus in voor het linkermenu wanneer embedded wordt uitgevoerd (iframe).",
          "Show left menu items in second menu": "Toon menu-items van het linkermenu ook in het tweede menu. Handig wanneer het linkermenu verborgen is of als snelkoppeling binnen embedded producten.",
          "Show left menu items in second menu iframe": "Toon menu-items van het linkermenu ook in het tweede menu wanneer embedded wordt uitgevoerd (iframe). Handig wanneer het linkermenu verborgen is of als snelkoppeling binnen embedded producten.",
          "AI agent": "Kies welke AI-agent beschikbaar is.",
          "AI agent settings": "JSON-configuratie voor de geselecteerde AI-agent.",
          "Whisper agent": "Kies welke Whisper-agent beschikbaar is.",
          "Whisper agent settings": "JSON-configuratie voor de geselecteerde Whisper-agent.",
          "Sharing Center - Product name": "De productnaam die wordt gebruikt voor mails en communicatie.",
          "Sharing Center - Default subject": "Stel een standaardonderwerp in bij het aanmaken van een nieuwe afspraak. Dit kan altijd worden aangepast vóór het opslaan.",
          "Sharing Center - ICS invite participant visibility": "Bepaal wat niet-organizers kunnen zien in ICS-uitnodigingen.",
          "Sharing Center - ICS invite participant status visibility": "Bepaal of RSVP-status wordt opgenomen in ICS-uitnodigingen.",
          "Sharing Center - Pre-join time": "Bepaal hoelang vóór de starttijd deelnemers toegang krijgen tot de afspraak.",
          "Sharing Center - Post-join time": "Bepaal hoelang ná de eindtijd deelnemers nog toegang hebben tot de afspraak.",
          "Sharing Center - Feedback questions": "Bepaal welke feedbackvragen aan deelnemers worden getoond nadat een afspraak is beëindigd.",
          "Sharing Center - Meeting max participants": "Stel het maximale aantal deelnemers in dat is toegestaan in een meeting.",
          "Sharing Center - Meeting max participants live invite": "Nodig deelnemers uit tijdens de meeting.",
          "Sharing Center - Meeting e2e enabled": "Sta toe dat end-to-end-encryptie in meetings kan worden gebruikt.",
          "Sharing Center - Meeting default e2e encrypted": "Schakel end-to-end-encryptie standaard in wanneer beschikbaar.",
          "Sharing Center - Meeting p2p enabled": "Schakel peer-to-peer-modus in voor kleine meetings.",
          "Sharing Center - Meeting p2p max participants": "Stel het maximale aantal deelnemers in voor peer-to-peer-modus.",
          "Sharing Center - Meeting auto transcriptions enabled": "Verwerk beschikbare meetingopnamen automatisch naar transcripties voor deze klant.",
          "Sharing Center - Meeting auto AI minutes enabled": "Genereer automatisch AI-notulen zodra er voor deze klant een transcriptie beschikbaar is.",
          "Sharing Center - Meeting default AI minutes hidden prompt": "Standaard verborgen prompt voor AI-notulen in meetings.",
          "Sharing Center - Meeting default AI minutes prompt": "Standaard prompt voor AI-notulen in meetings.",
          "Sharing Center - Meeting default AI minutes prompt NL": "Standaard Nederlandse prompt voor AI-notulen in meetings.",
          "Sharing Center - Meeting default AI minutes prompt EN": "Standaard Engelse prompt voor AI-notulen in meetings.",
          "Sharing Center - Features agents": "Schakel functies in die in de meeting beschikbaar moeten zijn voor agenten.",
          "Sharing Center - Features guests": "Schakel functies in die in de meeting beschikbaar moeten zijn voor gasten.",
          "Sharing Center - Meeting chat smileys disabled": "Schakel smileys in de meetingchat uit.",
          "Sharing Center - Meeting breakout rooms hidden buttons": "Selecteer welke knoppen voor breakoutruimtes verborgen zijn.",
          "Sharing Center - Meeting notifications disabled": "Selecteer welke meetingmeldingen zijn uitgeschakeld.",
          "Sharing Center - Meeting notifications disabled guests": "Selecteer welke meetingmeldingen zijn uitgeschakeld voor gasten.",
          "Sharing Center - Meeting sounds disabled": "Selecteer welke meetinggeluiden zijn uitgeschakeld.",
          "Sharing Center - Meeting sounds disabled guests": "Selecteer welke meetinggeluiden zijn uitgeschakeld voor gasten.",
          "Sharing Center - Meeting remote video menu enabled": "Schakel het deelnemersvideomenu in meetings in of uit.",
          "Sharing Center - Meeting remote video menu disabled actions": "Selecteer welke acties in het deelnemersvideomenu verborgen zijn.",
          "Sharing Center - Meeting remote video menu private chat": "Selecteer hoe privéchat vanuit het deelnemersvideomenu wordt beperkt. Geen laat de standaardinstelling ongemoeid.",
          "Sharing Center - Meeting participants pane enabled": "Schakel het deelnemerspaneel in meetings in of uit.",
          "Sharing Center - Meeting participants pane hidden items": "Selecteer welke onderdelen in het deelnemerspaneel verborgen zijn.",
          "Sharing Center - Meeting lobby enabled": "Schakel de meetinglobby in of uit.",
          "Sharing Center - Meeting lobby auto knock": "Laat deelnemers automatisch aankloppen wanneer de lobby is ingeschakeld.",
          "Sharing Center - Meeting lobby chat enabled": "Sta chatten toe in het lobbyscherm.",
          "Sharing Center - Meeting lobby bypass": "Selecteer wie de meetinglobby mag omzeilen. Deze instelling wordt ook toegepast wanneer de lobby tijdens de vergadering is ingeschakeld.",
          "Sharing Center - Meeting prejoin screen": "Bepaal of het prejoin-scherm wordt getoond voor agenten en gasten.",
          "Sharing Center - Meeting handoff": "Bepaal of deelnemers een actieve meeting mogen overnemen op een ander apparaat. Als dit is uitgeschakeld, wordt deelnemen vanaf een ander apparaat geblokkeerd.",
          "Sharing Center - Meeting filmstrip": "Bepaal of de filmstrip wordt getoond voor agenten en gasten.",
          "Sharing Center - Tileview enabled": "Schakel tegelweergave in wanneer drie of meer deelnemers zijn toegetreden.",
          "Sharing Center - Number of visible tiles": "Stel het optimale aantal tegels in dat in tegelweergave wordt getoond. Afhankelijk van het schermformaat kan het exacte aantal afwijken.",
          "Sharing Center - Tileview enabled guests": "Schakel tegelweergave in voor gasten wanneer drie of meer deelnemers zijn toegetreden.",
          "Sharing Center - Number of visible tiles guests": "Stel het optimale aantal tegels in dat in tegelweergave voor gasten wordt getoond. Afhankelijk van het schermformaat kan het exacte aantal afwijken.",
          "Sharing Center - Meeting toolbar always visible": "Houd de meeting toolbar zichtbaar in plaats van automatisch te verbergen.",
          "Sharing Center - Meeting toolbar initial timeout": "Stel in hoelang de meeting toolbar zichtbaar blijft na het deelnemen, in seconden.",
          "Sharing Center - Meeting toolbar timeout": "Stel in hoelang de meeting toolbar zichtbaar blijft na gebruikersinteractie, in seconden.",
          "Sharing Center - Meeting hidden conference info": "Selecteer welke conference-info in de meetinginterface verborgen is.",
          "Sharing Center - Meeting mute microphone": "Microfoon standaard dempen bij het starten van een vergadering.",
          "Sharing Center - Meeting mute microphone guests": "Microfoon standaard dempen bij het starten van een vergadering voor gasten.",
          "Sharing Center - Meeting camera off": "Camera standaard uit bij het starten van een vergadering.",
          "Sharing Center - Meeting camera off guests": "Camera standaard uit bij het starten van een vergadering voor gasten.",
          "Sharing Center - Meeting camera facing mode": "Selecteer welke camera de voorkeur heeft bij het starten van een vergadering.",
          "Sharing Center - Meeting camera facing mode guests": "Selecteer welke camera de voorkeur heeft wanneer gasten een vergadering starten.",
          "Sharing Center - Meeting initial media request": "Bepaal of camera-/microfoontoegang direct wordt opgevraagd bij het starten van een vergadering.",
          "Sharing Center - Meeting force my video on stage": "Zet je eigen video standaard op het podium bij het starten van een vergadering.",
          "Sharing Center - Meeting base URL": "De basis-URL van de server die wordt gebruikt voor OMNI Sessions-vergaderingen.",
          "Sharing Center - Meeting app ID": "De applicatie-ID die wordt gebruikt voor authenticatie met de meeting server.",
          "Sharing Center - Meeting app secret": "De geheime sleutel die wordt gebruikt om authenticatietokens veilig te ondertekenen.",
          "Sharing Center - Meeting audience": "De audience-claim (aud) die wordt gebruikt bij het genereren van authenticatietokens.",
          "Sharing Center - Meeting subject": "De subject-claim (sub) die wordt gebruikt bij het genereren van authenticatietokens.",
          "Sharing Center - Meeting background color": "Primaire achtergrondkleur die wordt gebruikt in de meeting-interface.",
          "Sharing Center - Meeting background image URL": "Achtergrondafbeelding die wordt weergegeven achter de meeting-interface.",
          "Sharing Center - Meeting DID page URL": "URL met inbel- of DID-informatie die bij de meeting hoort.",
          "Sharing Center - Meeting invite domain": "Domein dat wordt gebruikt bij het genereren van meeting-uitnodigingslinks.",
          "Sharing Center - Meeting logo click URL": "URL die wordt geopend wanneer op het meeting-logo wordt geklikt.",
          "Sharing Center - Meeting logo image URL": "Logo-afbeelding die wordt weergegeven in de meeting-interface.",
          "Sharing Center - Meeting avatar backgrounds": "Lijst met achtergrondafbeeldingen achter deelnemersavatars.",
          "Sharing Center - Meeting pre-meeting background": "Achtergrond die wordt getoond in de wachtruimte of lobby vóór de meeting.",
          "Sharing Center - Meeting disable virtual backgrounds": "Schakel virtuele achtergronden uit in de meeting-interface.",
          "Sharing Center - Meeting disable adding background images": "Voorkom dat gebruikers tijdens de meeting zelf achtergrondafbeeldingen toevoegen.",
          "Sharing Center - Meeting custom virtual background 1": "Virtuele achtergrond 1 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting custom virtual background 2": "Virtuele achtergrond 2 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting custom virtual background 3": "Virtuele achtergrond 3 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting custom virtual background 4": "Virtuele achtergrond 4 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting custom virtual background 5": "Virtuele achtergrond 5 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting virtual backgrounds": "Lijst met aangepaste virtuele achtergronden die beschikbaar zijn tijdens de meeting.",
          "Sharing Center - Meeting virtual backgrounds include defaults": "Wanneer ingeschakeld worden de standaard virtuele achtergronden toegevoegd aan de aangepaste achtergronden.",
          "Sharing Center - Meeting user documentation URL": "URL die wordt geopend via de Help-knop in het overflow-menu van de meeting.",
          "Sharing Center - Meeting download apps URL": "URL die wordt geopend via de Download onze apps-knop in het overflow-menu van de meeting.",
          "Sharing Center - Meeting translations": "JSON-configuratie voor het overschrijven van UI-teksten in de meeting-interface.",
          "Sharing Center - Meeting CSS": "CSS-overschrijvingen die worden toegepast op de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Add User": "URL naar het aangepaste icoon voor 'add user' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Back": "URL naar het aangepaste icoon voor 'arrow back' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Down": "URL naar het aangepaste icoon voor 'arrow down' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Down Large": "URL naar het aangepaste icoon voor 'arrow down large' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Left": "URL naar het aangepaste icoon voor 'arrow left' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Up": "URL naar het aangepaste icoon voor 'arrow up' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Up Large": "URL naar het aangepaste icoon voor 'arrow up large' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Audio Only": "URL naar het aangepaste icoon voor 'audio only' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Audio Only Off": "URL naar het aangepaste icoon voor 'audio only off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Bluetooth": "URL naar het aangepaste icoon voor 'bluetooth' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Bell": "URL naar het aangepaste icoon voor 'bell' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Calendar": "URL naar het aangepaste icoon voor 'calendar' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Camera Refresh": "URL naar het aangepaste icoon voor 'camera refresh' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Car": "URL naar het aangepaste icoon voor 'car' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Chat Unread": "URL naar het aangepaste icoon voor 'chat unread' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Check": "URL naar het aangepaste icoon voor 'check' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Close Circle": "URL naar het aangepaste icoon voor 'close circle' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Close Large": "URL naar het aangepaste icoon voor 'close large' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Cloud Upload": "URL naar het aangepaste icoon voor 'cloud upload' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Code": "URL naar het aangepaste icoon voor 'code' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Connection": "URL naar het aangepaste icoon voor 'connection' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Connection Inactive": "URL naar het aangepaste icoon voor 'connection inactive' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Copy": "URL naar het aangepaste icoon voor 'copy' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Device Headphone": "URL naar het aangepaste icoon voor 'device headphone' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Dots Horizontal": "URL naar het aangepaste icoon voor 'dots horizontal' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Download": "URL naar het aangepaste icoon voor 'download' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon E2EE": "URL naar het aangepaste icoon voor 'e2ee' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Edit": "URL naar het aangepaste icoon voor 'edit' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Enlarge": "URL naar het aangepaste icoon voor 'enlarge' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Enter Fullscreen": "URL naar het aangepaste icoon voor 'enter fullscreen' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Envelope": "URL naar het aangepaste icoon voor 'envelope' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Angry": "URL naar het aangepaste icoon voor 'emotions angry' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Disgusted": "URL naar het aangepaste icoon voor 'emotions disgusted' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Fearful": "URL naar het aangepaste icoon voor 'emotions fearful' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Happy": "URL naar het aangepaste icoon voor 'emotions happy' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Neutral": "URL naar het aangepaste icoon voor 'emotions neutral' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Sad": "URL naar het aangepaste icoon voor 'emotions sad' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Surprised": "URL naar het aangepaste icoon voor 'emotions surprised' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Exclamation Solid": "URL naar het aangepaste icoon voor 'exclamation solid' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Exclamation Triangle": "URL naar het aangepaste icoon voor 'exclamation triangle' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Exit Fullscreen": "URL naar het aangepaste icoon voor 'exit fullscreen' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Face Smile": "URL naar het aangepaste icoon voor 'face smile' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Favorite": "URL naar het aangepaste icoon voor 'favorite' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Favorite Solid": "URL naar het aangepaste icoon voor 'favorite solid' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Feedback": "URL naar het aangepaste icoon voor 'feedback' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Gear": "URL naar het aangepaste icoon voor 'gear' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Google": "URL naar het aangepaste icoon voor 'google' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Hangup": "URL naar het aangepaste icoon voor 'hangup' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Help": "URL naar het aangepaste icoon voor 'help' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Highlight": "URL naar het aangepaste icoon voor 'highlight' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Image": "URL naar het aangepaste icoon voor 'image' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Info": "URL naar het aangepaste icoon voor 'info' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Info Circle": "URL naar het aangepaste icoon voor 'info circle' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Message": "URL naar het aangepaste icoon voor 'message' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Meter": "URL naar het aangepaste icoon voor 'meter' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Mic": "URL naar het aangepaste icoon voor 'mic' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Mic Slash": "URL naar het aangepaste icoon voor 'mic slash' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Moderator": "URL naar het aangepaste icoon voor 'moderator' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Noise Suppression Off": "URL naar het aangepaste icoon voor 'noise suppression off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Noise Suppression On": "URL naar het aangepaste icoon voor 'noise suppression on' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Right": "URL naar het aangepaste icoon voor 'arrow right' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Office365": "URL naar het aangepaste icoon voor 'office365' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Performance": "URL naar het aangepaste icoon voor 'performance' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Phone Ringing": "URL naar het aangepaste icoon voor 'phone ringing' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Pin": "URL naar het aangepaste icoon voor 'pin' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Pinned": "URL naar het aangepaste icoon voor 'pinned' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Play": "URL naar het aangepaste icoon voor 'play' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Plus": "URL naar het aangepaste icoon voor 'plus' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Raise Hand": "URL naar het aangepaste icoon voor 'raise hand' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record": "URL naar het aangepaste icoon voor 'record' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record Account": "URL naar het aangepaste icoon voor 'record account' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record Contact": "URL naar het aangepaste icoon voor 'record contact' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record Lead": "URL naar het aangepaste icoon voor 'record lead' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record Opportunity": "URL naar het aangepaste icoon voor 'record opportunity' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Remote Control Start": "URL naar het aangepaste icoon voor 'remote control start' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Remote Control Stop": "URL naar het aangepaste icoon voor 'remote control stop' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Reply": "URL naar het aangepaste icoon voor 'reply' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Restore": "URL naar het aangepaste icoon voor 'restore' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Ring Group": "URL naar het aangepaste icoon voor 'ring group' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Screenshare": "URL naar het aangepaste icoon voor 'screenshare' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Search": "URL naar het aangepaste icoon voor 'search' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Security Off": "URL naar het aangepaste icoon voor 'security off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Security On": "URL naar het aangepaste icoon voor 'security on' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Send": "URL naar het aangepaste icoon voor 'send' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Share": "URL naar het aangepaste icoon voor 'share' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Share Doc": "URL naar het aangepaste icoon voor 'share doc' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Shortcuts": "URL naar het aangepaste icoon voor 'shortcuts' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon SIP": "URL naar het aangepaste icoon voor 'sip' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Sites": "URL naar het aangepaste icoon voor 'sites' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Stop": "URL naar het aangepaste icoon voor 'stop' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Subtitles": "URL naar het aangepaste icoon voor 'subtitles' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Tile View": "URL naar het aangepaste icoon voor 'tile view' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Trash": "URL naar het aangepaste icoon voor 'trash' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon User Deleted": "URL naar het aangepaste icoon voor 'user deleted' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Users": "URL naar het aangepaste icoon voor 'users' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon User": "URL naar het aangepaste icoon voor 'user' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Video": "URL naar het aangepaste icoon voor 'video' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Video Off": "URL naar het aangepaste icoon voor 'video off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Volume Off": "URL naar het aangepaste icoon voor 'volume off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Volume Up": "URL naar het aangepaste icoon voor 'volume up' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Warning": "URL naar het aangepaste icoon voor 'warning' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Warning Circle": "URL naar het aangepaste icoon voor 'warning circle' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Whiteboard": "URL naar het aangepaste icoon voor 'whiteboard' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Whiteboard Hide": "URL naar het aangepaste icoon voor 'whiteboard hide' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Wifi1 Bar": "URL naar het aangepaste icoon voor 'wifi1 bar' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Wifi2 Bars": "URL naar het aangepaste icoon voor 'wifi2 bars' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Wifi3 Bars": "URL naar het aangepaste icoon voor 'wifi3 bars' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Yahoo": "URL naar het aangepaste icoon voor 'yahoo' in de meeting-interface.",
          "Sharing Center - Meeting theme palette - Action01": "Primaire CTA-knoppen, actieve switch/checkbox states, accenten in notificaties/indicatoren/file sharing/polls.",
          "Sharing Center - Meeting theme palette - Action01 Active": "Active/pressed state van primaire webknoppen.",
          "Sharing Center - Meeting theme palette - Action01 Hover": "Hover state primaire knoppen; selectie-outline in contextmenu, filmstrip en settings previews.",
          "Sharing Center - Meeting theme palette - Action02": "Secundaire knoppen/chips, new-messages knop, deelnemers/lobby acties, prejoin secondary actions.",
          "Sharing Center - Meeting theme palette - Action02 Active": "Active state van secundaire knoppen (o.a. new-messages).",
          "Sharing Center - Meeting theme palette - Action02 Hover": "Hover state van secundaire knoppen en chat actieknoppen.",
          "Sharing Center - Meeting theme palette - Action03": "Subtiele icon-knoppen/chips, input action chips, chat message acties, country picker rows.",
          "Sharing Center - Meeting theme palette - Action03 Active": "Ingedrukte state van subtiele webknop.",
          "Sharing Center - Meeting theme palette - Action03 Hover": "Hover state van subtiele knop/rows.",
          "Sharing Center - Meeting theme palette - Action Danger": "Acties met grote impact, zoals ophangen/einde meeting of verwijderen.",
          "Sharing Center - Meeting theme palette - Action Danger Active": "Ingedrukte state van waarschuwingsknop.",
          "Sharing Center - Meeting theme palette - Action Danger Hover": "Hover state van waarschuwingsknop.",
          "Sharing Center - Meeting theme palette - Disabled01": "Disabled state van knoppen en disabled action containers.",
          "Sharing Center - Meeting theme palette - Field01": "Achtergrond/accent van form-velden (o.a. Salesforce, speaker stats search, recording controls).",
          "Sharing Center - Meeting theme palette - Focus01": "Focus-outline voor input/select/button/switch/tabs.",
          "Sharing Center - Meeting theme palette - Icon01": "Standaard iconkleur voor de meeste iconen (toolbox, chat, deelnemers, filmstrip, welcome).",
          "Sharing Center - Meeting theme palette - Icon02": "Secundaire icon-achtergrondaccenten (chat/filmstrip).",
          "Sharing Center - Meeting theme palette - Icon03": "Disabled/secondary iconen (checkbox/select disabled, captions, polls, file sharing).",
          "Sharing Center - Meeting theme palette - Icon04": "Iconen op lichte/gekleurde badges en labels (raised hand, notificaties, toolbar counters).",
          "Sharing Center - Meeting theme palette - Icon Error": "Error-iconen in connection indicator, notificaties, recording en mic-foutstatussen.",
          "Sharing Center - Meeting theme palette - Link01": "Klikbare links in chat/dialogs/deeplinking/polls/settings/welcome.",
          "Sharing Center - Meeting theme palette - Link01 Active": "Active state van links en enkele mobile/nav actie-accenten.",
          "Sharing Center - Meeting theme palette - Link01 Hover": "Hover state van links in o.a. connection stats/invite/recording/subtitles.",
          "Sharing Center - Meeting theme palette - Success01": "Succes-indicatoren (connection ok, audio-preview ok, success notificaties, prejoin status).",
          "Sharing Center - Meeting theme palette - Success02": "Secundaire success badges/labels (o.a. copy/speaker stats).",
          "Sharing Center - Meeting theme palette - Support01": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support02": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support03": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support04": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support05": "Chat accentkleur (message/recipient highlights).",
          "Sharing Center - Meeting theme palette - Support06": "Tweede chat accentkleur (recipient/status accent).",
          "Sharing Center - Meeting theme palette - Support07": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support08": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support09": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Text01": "Hoofdtekstkleur in vrijwel alle schermen en kerncomponenten.",
          "Sharing Center - Meeting theme palette - Text02": "Subtekst/placeholder/ondersteunende labels.",
          "Sharing Center - Meeting theme palette - Text03": "Minder prominente of disabled tekst, hulptekst en secondary labels.",
          "Sharing Center - Meeting theme palette - Text04": "Tekst op lichte/gekleurde achtergronden (waarschuwing badges, secondary surfaces).",
          "Sharing Center - Meeting theme palette - Text Error": "Validatie- en foutteksten (o.a. input/select errors, notification error text).",
          "Sharing Center - Meeting theme palette - Ui01": "Hoofdsurfaces van panelen/dialogs/lists in app en zijpanelen.",
          "Sharing Center - Meeting theme palette - Ui02": "Hover/selected surfaces en verhoogde paneldelen.",
          "Sharing Center - Meeting theme palette - Ui03": "Input/select achtergronden, separators, borders en submenu surfaces.",
          "Sharing Center - Meeting theme palette - Ui04": "Lichte randen/achtergronden voor badges, menu-randen en chips.",
          "Sharing Center - Meeting theme palette - Ui05": "Inactieve tracks/borders (switch/tabs/connection/polls/forms).",
          "Sharing Center - Meeting theme palette - Ui06": "Donkere outlines/separators (mobile nav, sliders, recording/polls).",
          "Sharing Center - Meeting theme palette - Ui07": "Sterke scheidingslijn/border kleur in native dialogs/lijsten/menu's.",
          "Sharing Center - Meeting theme palette - Ui08": "Neutrale knopvulling (beperkt gebruikt, met name native button style).",
          "Sharing Center - Meeting theme palette - Ui09": "Subtiele info/highlight achtergrond (labels, speaker stats, recording tags).",
          "Sharing Center - Meeting theme palette - Ui10": "Active tab/notification/chip/track achtergronden en accentvakken.",
          "Sharing Center - Meeting theme palette - Ui Background": "Algemene pagina/scherm achtergrond (basis canvas van app en grote containers).",
          "Sharing Center - Meeting theme palette - Warning01": "Warning badges/indicatoren/notificaties (prejoin, connection, dial-in limits).",
          "Sharing Center - Meeting theme palette - Warning02": "Raised-hand/highlight warning badges in filmstrip/deelnemers/recording/visitors."
        },
        "Placeholder": {},
        "Tooltip": {
          "Customer logo": "Upload een logo.",
          "Customer logo (mark)": "Het beeldmerk in een vierkant.",
          "Portal name": "De naam die wordt gebruikt voor de portal, mails en communicatie.",
          "Support email address": "Het support e-mailadres dat wordt gebruikt voor portaalcommunicatie.",
          "Customer signature for emails": "Gebruik de klanthandtekening en contactgegevens in authenticatiemails.",
          "Primary color": "De primaire kleur die in het portaal wordt gebruikt.",
          "MFA enabled": "Schakel multi-factor-authenticatie (MFA) in.",
          "MFA primary method": "Kies de primaire multi-factor-authenticatiemethode (MFA).",
          "MFA fallback methods": "Kies een of meer fallback multi-factor-authenticatiemethoden (MFA).",
          "Default customer": "Selecteer een standaardklant bij het inloggen.",
          "Top bar state": "Stel de standaardstatus in voor de topbalk.",
          "Top bar state iframe": "Stel de standaardstatus in voor de topbalk wanneer embedded wordt uitgevoerd (iframe).",
          "Left menu state": "Stel de standaardstatus in voor het linkermenu.",
          "Left menu state iframe": "Stel de standaardstatus in voor het linkermenu wanneer embedded wordt uitgevoerd (iframe).",
          "Show left menu items in second menu": "Toon menu-items van het linkermenu ook in het tweede menu. Handig wanneer het linkermenu verborgen is of als snelkoppeling binnen embedded producten.",
          "Show left menu items in second menu iframe": "Toon menu-items van het linkermenu ook in het tweede menu wanneer embedded wordt uitgevoerd (iframe). Handig wanneer het linkermenu verborgen is of als snelkoppeling binnen embedded producten.",
          "AI agent": "Kies welke AI-agent beschikbaar is.",
          "AI agent settings": "JSON-configuratie voor de geselecteerde AI-agent.",
          "Whisper agent": "Kies welke Whisper-agent beschikbaar is.",
          "Whisper agent settings": "JSON-configuratie voor de geselecteerde Whisper-agent.",
          "Sharing Center - Product name": "De productnaam die wordt gebruikt voor mails en communicatie.",
          "Sharing Center - Default subject": "Stel een standaardonderwerp in bij het aanmaken van een nieuwe afspraak. Dit kan altijd worden aangepast vóór het opslaan.",
          "Sharing Center - ICS invite participant visibility": "Bepaal wat niet-organizers kunnen zien in ICS-uitnodigingen.",
          "Sharing Center - ICS invite participant status visibility": "Bepaal of RSVP-status wordt opgenomen in ICS-uitnodigingen.",
          "Sharing Center - Pre-join time": "Bepaal hoelang vóór de starttijd deelnemers toegang krijgen tot de afspraak.",
          "Sharing Center - Post-join time": "Bepaal hoelang ná de eindtijd deelnemers nog toegang hebben tot de afspraak.",
          "Sharing Center - Feedback questions": "Bepaal welke feedbackvragen aan deelnemers worden getoond nadat een afspraak is beëindigd.",
          "Sharing Center - Meeting max participants": "Stel het maximale aantal deelnemers in dat is toegestaan in een meeting.",
          "Sharing Center - Meeting max participants live invite": "Nodig deelnemers uit tijdens de meeting.",
          "Sharing Center - Meeting e2e enabled": "Sta toe dat end-to-end-encryptie in meetings kan worden gebruikt.",
          "Sharing Center - Meeting default e2e encrypted": "Schakel end-to-end-encryptie standaard in wanneer beschikbaar.",
          "Sharing Center - Meeting p2p enabled": "Schakel peer-to-peer-modus in voor kleine meetings.",
          "Sharing Center - Meeting p2p max participants": "Stel het maximale aantal deelnemers in voor peer-to-peer-modus.",
          "Sharing Center - Meeting auto transcriptions enabled": "Verwerk beschikbare meetingopnamen automatisch naar transcripties voor deze klant.",
          "Sharing Center - Meeting auto AI minutes enabled": "Genereer automatisch AI-notulen zodra er voor deze klant een transcriptie beschikbaar is.",
          "Sharing Center - Meeting default AI minutes hidden prompt": "Standaard verborgen prompt voor AI-notulen in meetings.",
          "Sharing Center - Meeting default AI minutes prompt": "Standaard prompt voor AI-notulen in meetings.",
          "Sharing Center - Meeting default AI minutes prompt NL": "Standaard Nederlandse prompt voor AI-notulen in meetings.",
          "Sharing Center - Meeting default AI minutes prompt EN": "Standaard Engelse prompt voor AI-notulen in meetings.",
          "Sharing Center - Features agents": "Schakel functies in die in de meeting beschikbaar moeten zijn voor agenten.",
          "Sharing Center - Features guests": "Schakel functies in die in de meeting beschikbaar moeten zijn voor gasten.",
          "Sharing Center - Meeting chat smileys disabled": "Schakel smileys in de meetingchat uit.",
          "Sharing Center - Meeting breakout rooms hidden buttons": "Selecteer welke knoppen voor breakoutruimtes verborgen zijn.",
          "Sharing Center - Meeting notifications disabled": "Selecteer welke meetingmeldingen zijn uitgeschakeld.",
          "Sharing Center - Meeting notifications disabled guests": "Selecteer welke meetingmeldingen zijn uitgeschakeld voor gasten.",
          "Sharing Center - Meeting sounds disabled": "Selecteer welke meetinggeluiden zijn uitgeschakeld.",
          "Sharing Center - Meeting sounds disabled guests": "Selecteer welke meetinggeluiden zijn uitgeschakeld voor gasten.",
          "Sharing Center - Meeting remote video menu enabled": "Schakel het deelnemersvideomenu in meetings in of uit.",
          "Sharing Center - Meeting remote video menu disabled actions": "Selecteer welke acties in het deelnemersvideomenu verborgen zijn.",
          "Sharing Center - Meeting remote video menu private chat": "Selecteer hoe privéchat vanuit het deelnemersvideomenu wordt beperkt. Geen laat de standaardinstelling ongemoeid.",
          "Sharing Center - Meeting participants pane enabled": "Schakel het deelnemerspaneel in meetings in of uit.",
          "Sharing Center - Meeting participants pane hidden items": "Selecteer welke onderdelen in het deelnemerspaneel verborgen zijn.",
          "Sharing Center - Meeting lobby enabled": "Schakel de meetinglobby in of uit.",
          "Sharing Center - Meeting lobby auto knock": "Laat deelnemers automatisch aankloppen wanneer de lobby is ingeschakeld.",
          "Sharing Center - Meeting lobby chat enabled": "Sta chatten toe in het lobbyscherm.",
          "Sharing Center - Meeting lobby bypass": "Selecteer wie de meetinglobby mag omzeilen. Deze instelling wordt ook toegepast wanneer de lobby tijdens de vergadering is ingeschakeld.",
          "Sharing Center - Meeting prejoin screen": "Bepaal of het prejoin-scherm wordt getoond voor agenten en gasten.",
          "Sharing Center - Meeting handoff": "Bepaal of deelnemers een actieve meeting mogen overnemen op een ander apparaat. Als dit is uitgeschakeld, wordt deelnemen vanaf een ander apparaat geblokkeerd.",
          "Sharing Center - Meeting filmstrip": "Bepaal of de filmstrip wordt getoond voor agenten en gasten.",
          "Sharing Center - Tileview enabled": "Schakel tegelweergave in wanneer drie of meer deelnemers zijn toegetreden.",
          "Sharing Center - Number of visible tiles": "Stel het optimale aantal tegels in dat in tegelweergave wordt getoond. Afhankelijk van het schermformaat kan het exacte aantal afwijken.",
          "Sharing Center - Tileview enabled guests": "Schakel tegelweergave in voor gasten wanneer drie of meer deelnemers zijn toegetreden.",
          "Sharing Center - Number of visible tiles guests": "Stel het optimale aantal tegels in dat in tegelweergave voor gasten wordt getoond. Afhankelijk van het schermformaat kan het exacte aantal afwijken.",
          "Sharing Center - Meeting toolbar always visible": "Houd de meeting toolbar zichtbaar in plaats van automatisch te verbergen.",
          "Sharing Center - Meeting toolbar initial timeout": "Stel in hoelang de meeting toolbar zichtbaar blijft na het deelnemen, in seconden.",
          "Sharing Center - Meeting toolbar timeout": "Stel in hoelang de meeting toolbar zichtbaar blijft na gebruikersinteractie, in seconden.",
          "Sharing Center - Meeting hidden conference info": "Selecteer welke conference-info in de meetinginterface verborgen is.",
          "Sharing Center - Meeting mute microphone": "Microfoon standaard dempen bij het starten van een vergadering.",
          "Sharing Center - Meeting mute microphone guests": "Microfoon standaard dempen bij het starten van een vergadering voor gasten.",
          "Sharing Center - Meeting camera off": "Camera standaard uit bij het starten van een vergadering.",
          "Sharing Center - Meeting camera off guests": "Camera standaard uit bij het starten van een vergadering voor gasten.",
          "Sharing Center - Meeting camera facing mode": "Selecteer welke camera de voorkeur heeft bij het starten van een vergadering.",
          "Sharing Center - Meeting camera facing mode guests": "Selecteer welke camera de voorkeur heeft wanneer gasten een vergadering starten.",
          "Sharing Center - Meeting initial media request": "Bepaal of camera-/microfoontoegang direct wordt opgevraagd bij het starten van een vergadering.",
          "Sharing Center - Meeting force my video on stage": "Zet je eigen video standaard op het podium bij het starten van een vergadering.",
          "Sharing Center - Meeting base URL": "De basis-URL van de server die wordt gebruikt voor OMNI Sessions-vergaderingen.",
          "Sharing Center - Meeting app ID": "De applicatie-ID die wordt gebruikt voor authenticatie met de meeting server.",
          "Sharing Center - Meeting app secret": "De geheime sleutel die wordt gebruikt om authenticatietokens veilig te ondertekenen.",
          "Sharing Center - Meeting audience": "De audience-claim (aud) die wordt gebruikt bij het genereren van authenticatietokens.",
          "Sharing Center - Meeting subject": "De subject-claim (sub) die wordt gebruikt bij het genereren van authenticatietokens.",
          "Sharing Center - Meeting background color": "Primaire achtergrondkleur die wordt gebruikt in de meeting-interface.",
          "Sharing Center - Meeting background image URL": "Achtergrondafbeelding die wordt weergegeven achter de meeting-interface.",
          "Sharing Center - Meeting DID page URL": "URL met inbel- of DID-informatie die bij de meeting hoort.",
          "Sharing Center - Meeting invite domain": "Domein dat wordt gebruikt bij het genereren van meeting-uitnodigingslinks.",
          "Sharing Center - Meeting logo click URL": "URL die wordt geopend wanneer op het meeting-logo wordt geklikt.",
          "Sharing Center - Meeting logo image URL": "Logo-afbeelding die wordt weergegeven in de meeting-interface.",
          "Sharing Center - Meeting avatar backgrounds": "Lijst met achtergrondafbeeldingen achter deelnemersavatars.",
          "Sharing Center - Meeting pre-meeting background": "Achtergrond die wordt getoond in de wachtruimte of lobby vóór de meeting.",
          "Sharing Center - Meeting disable virtual backgrounds": "Schakel virtuele achtergronden uit in de meeting-interface.",
          "Sharing Center - Meeting disable adding background images": "Voorkom dat gebruikers tijdens de meeting zelf achtergrondafbeeldingen toevoegen.",
          "Sharing Center - Meeting custom virtual background 1": "Virtuele achtergrond 1 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting custom virtual background 2": "Virtuele achtergrond 2 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting custom virtual background 3": "Virtuele achtergrond 3 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting custom virtual background 4": "Virtuele achtergrond 4 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting custom virtual background 5": "Virtuele achtergrond 5 die beschikbaar is tijdens de meeting.",
          "Sharing Center - Meeting virtual backgrounds": "Lijst met aangepaste virtuele achtergronden die beschikbaar zijn tijdens de meeting.",
          "Sharing Center - Meeting virtual backgrounds include defaults": "Wanneer ingeschakeld worden de standaard virtuele achtergronden toegevoegd aan de aangepaste achtergronden.",
          "Sharing Center - Meeting user documentation URL": "URL die wordt geopend via de Help-knop in het overflow-menu van de meeting.",
          "Sharing Center - Meeting download apps URL": "URL die wordt geopend via de Download onze apps-knop in het overflow-menu van de meeting.",
          "Sharing Center - Meeting translations": "JSON-configuratie voor het overschrijven van UI-teksten in de meeting-interface.",
          "Sharing Center - Meeting CSS": "CSS-overschrijvingen die worden toegepast op de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Add User": "URL naar het aangepaste icoon voor 'add user' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Back": "URL naar het aangepaste icoon voor 'arrow back' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Down": "URL naar het aangepaste icoon voor 'arrow down' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Down Large": "URL naar het aangepaste icoon voor 'arrow down large' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Left": "URL naar het aangepaste icoon voor 'arrow left' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Up": "URL naar het aangepaste icoon voor 'arrow up' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Up Large": "URL naar het aangepaste icoon voor 'arrow up large' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Audio Only": "URL naar het aangepaste icoon voor 'audio only' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Audio Only Off": "URL naar het aangepaste icoon voor 'audio only off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Bluetooth": "URL naar het aangepaste icoon voor 'bluetooth' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Bell": "URL naar het aangepaste icoon voor 'bell' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Calendar": "URL naar het aangepaste icoon voor 'calendar' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Camera Refresh": "URL naar het aangepaste icoon voor 'camera refresh' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Car": "URL naar het aangepaste icoon voor 'car' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Chat Unread": "URL naar het aangepaste icoon voor 'chat unread' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Check": "URL naar het aangepaste icoon voor 'check' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Close Circle": "URL naar het aangepaste icoon voor 'close circle' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Close Large": "URL naar het aangepaste icoon voor 'close large' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Cloud Upload": "URL naar het aangepaste icoon voor 'cloud upload' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Code": "URL naar het aangepaste icoon voor 'code' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Connection": "URL naar het aangepaste icoon voor 'connection' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Connection Inactive": "URL naar het aangepaste icoon voor 'connection inactive' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Copy": "URL naar het aangepaste icoon voor 'copy' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Device Headphone": "URL naar het aangepaste icoon voor 'device headphone' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Dots Horizontal": "URL naar het aangepaste icoon voor 'dots horizontal' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Download": "URL naar het aangepaste icoon voor 'download' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon E2EE": "URL naar het aangepaste icoon voor 'e2ee' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Edit": "URL naar het aangepaste icoon voor 'edit' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Enlarge": "URL naar het aangepaste icoon voor 'enlarge' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Enter Fullscreen": "URL naar het aangepaste icoon voor 'enter fullscreen' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Envelope": "URL naar het aangepaste icoon voor 'envelope' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Angry": "URL naar het aangepaste icoon voor 'emotions angry' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Disgusted": "URL naar het aangepaste icoon voor 'emotions disgusted' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Fearful": "URL naar het aangepaste icoon voor 'emotions fearful' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Happy": "URL naar het aangepaste icoon voor 'emotions happy' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Neutral": "URL naar het aangepaste icoon voor 'emotions neutral' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Sad": "URL naar het aangepaste icoon voor 'emotions sad' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Surprised": "URL naar het aangepaste icoon voor 'emotions surprised' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Exclamation Solid": "URL naar het aangepaste icoon voor 'exclamation solid' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Exclamation Triangle": "URL naar het aangepaste icoon voor 'exclamation triangle' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Exit Fullscreen": "URL naar het aangepaste icoon voor 'exit fullscreen' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Face Smile": "URL naar het aangepaste icoon voor 'face smile' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Favorite": "URL naar het aangepaste icoon voor 'favorite' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Favorite Solid": "URL naar het aangepaste icoon voor 'favorite solid' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Feedback": "URL naar het aangepaste icoon voor 'feedback' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Gear": "URL naar het aangepaste icoon voor 'gear' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Google": "URL naar het aangepaste icoon voor 'google' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Hangup": "URL naar het aangepaste icoon voor 'hangup' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Help": "URL naar het aangepaste icoon voor 'help' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Highlight": "URL naar het aangepaste icoon voor 'highlight' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Image": "URL naar het aangepaste icoon voor 'image' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Info": "URL naar het aangepaste icoon voor 'info' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Info Circle": "URL naar het aangepaste icoon voor 'info circle' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Message": "URL naar het aangepaste icoon voor 'message' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Meter": "URL naar het aangepaste icoon voor 'meter' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Mic": "URL naar het aangepaste icoon voor 'mic' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Mic Slash": "URL naar het aangepaste icoon voor 'mic slash' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Moderator": "URL naar het aangepaste icoon voor 'moderator' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Noise Suppression Off": "URL naar het aangepaste icoon voor 'noise suppression off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Noise Suppression On": "URL naar het aangepaste icoon voor 'noise suppression on' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Right": "URL naar het aangepaste icoon voor 'arrow right' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Office365": "URL naar het aangepaste icoon voor 'office365' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Performance": "URL naar het aangepaste icoon voor 'performance' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Phone Ringing": "URL naar het aangepaste icoon voor 'phone ringing' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Pin": "URL naar het aangepaste icoon voor 'pin' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Pinned": "URL naar het aangepaste icoon voor 'pinned' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Play": "URL naar het aangepaste icoon voor 'play' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Plus": "URL naar het aangepaste icoon voor 'plus' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Raise Hand": "URL naar het aangepaste icoon voor 'raise hand' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record": "URL naar het aangepaste icoon voor 'record' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record Account": "URL naar het aangepaste icoon voor 'record account' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record Contact": "URL naar het aangepaste icoon voor 'record contact' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record Lead": "URL naar het aangepaste icoon voor 'record lead' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Record Opportunity": "URL naar het aangepaste icoon voor 'record opportunity' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Remote Control Start": "URL naar het aangepaste icoon voor 'remote control start' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Remote Control Stop": "URL naar het aangepaste icoon voor 'remote control stop' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Reply": "URL naar het aangepaste icoon voor 'reply' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Restore": "URL naar het aangepaste icoon voor 'restore' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Ring Group": "URL naar het aangepaste icoon voor 'ring group' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Screenshare": "URL naar het aangepaste icoon voor 'screenshare' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Search": "URL naar het aangepaste icoon voor 'search' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Security Off": "URL naar het aangepaste icoon voor 'security off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Security On": "URL naar het aangepaste icoon voor 'security on' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Send": "URL naar het aangepaste icoon voor 'send' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Share": "URL naar het aangepaste icoon voor 'share' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Share Doc": "URL naar het aangepaste icoon voor 'share doc' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Shortcuts": "URL naar het aangepaste icoon voor 'shortcuts' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon SIP": "URL naar het aangepaste icoon voor 'sip' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Sites": "URL naar het aangepaste icoon voor 'sites' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Stop": "URL naar het aangepaste icoon voor 'stop' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Subtitles": "URL naar het aangepaste icoon voor 'subtitles' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Tile View": "URL naar het aangepaste icoon voor 'tile view' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Trash": "URL naar het aangepaste icoon voor 'trash' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon User Deleted": "URL naar het aangepaste icoon voor 'user deleted' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Users": "URL naar het aangepaste icoon voor 'users' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon User": "URL naar het aangepaste icoon voor 'user' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Video": "URL naar het aangepaste icoon voor 'video' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Video Off": "URL naar het aangepaste icoon voor 'video off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Volume Off": "URL naar het aangepaste icoon voor 'volume off' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Volume Up": "URL naar het aangepaste icoon voor 'volume up' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Warning": "URL naar het aangepaste icoon voor 'warning' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Warning Circle": "URL naar het aangepaste icoon voor 'warning circle' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Whiteboard": "URL naar het aangepaste icoon voor 'whiteboard' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Whiteboard Hide": "URL naar het aangepaste icoon voor 'whiteboard hide' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Wifi1 Bar": "URL naar het aangepaste icoon voor 'wifi1 bar' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Wifi2 Bars": "URL naar het aangepaste icoon voor 'wifi2 bars' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Wifi3 Bars": "URL naar het aangepaste icoon voor 'wifi3 bars' in de meeting-interface.",
          "Sharing Center - Meeting custom icons - icon Yahoo": "URL naar het aangepaste icoon voor 'yahoo' in de meeting-interface.",
          "Sharing Center - Meeting theme palette - Action01": "Primaire CTA-knoppen, actieve switch/checkbox states, accenten in notificaties/indicatoren/file sharing/polls.",
          "Sharing Center - Meeting theme palette - Action01 Active": "Active/pressed state van primaire webknoppen.",
          "Sharing Center - Meeting theme palette - Action01 Hover": "Hover state primaire knoppen; selectie-outline in contextmenu, filmstrip en settings previews.",
          "Sharing Center - Meeting theme palette - Action02": "Secundaire knoppen/chips, new-messages knop, deelnemers/lobby acties, prejoin secondary actions.",
          "Sharing Center - Meeting theme palette - Action02 Active": "Active state van secundaire knoppen (o.a. new-messages).",
          "Sharing Center - Meeting theme palette - Action02 Hover": "Hover state van secundaire knoppen en chat actieknoppen.",
          "Sharing Center - Meeting theme palette - Action03": "Subtiele icon-knoppen/chips, input action chips, chat message acties, country picker rows.",
          "Sharing Center - Meeting theme palette - Action03 Active": "Ingedrukte state van subtiele webknop.",
          "Sharing Center - Meeting theme palette - Action03 Hover": "Hover state van subtiele knop/rows.",
          "Sharing Center - Meeting theme palette - Action Danger": "Acties met grote impact, zoals ophangen/einde meeting of verwijderen.",
          "Sharing Center - Meeting theme palette - Action Danger Active": "Ingedrukte state van waarschuwingsknop.",
          "Sharing Center - Meeting theme palette - Action Danger Hover": "Hover state van waarschuwingsknop.",
          "Sharing Center - Meeting theme palette - Disabled01": "Disabled state van knoppen en disabled action containers.",
          "Sharing Center - Meeting theme palette - Field01": "Achtergrond/accent van form-velden (o.a. Salesforce, speaker stats search, recording controls).",
          "Sharing Center - Meeting theme palette - Focus01": "Focus-outline voor input/select/button/switch/tabs.",
          "Sharing Center - Meeting theme palette - Icon01": "Standaard iconkleur voor de meeste iconen (toolbox, chat, deelnemers, filmstrip, welcome).",
          "Sharing Center - Meeting theme palette - Icon02": "Secundaire icon-achtergrondaccenten (chat/filmstrip).",
          "Sharing Center - Meeting theme palette - Icon03": "Disabled/secondary iconen (checkbox/select disabled, captions, polls, file sharing).",
          "Sharing Center - Meeting theme palette - Icon04": "Iconen op lichte/gekleurde badges en labels (raised hand, notificaties, toolbar counters).",
          "Sharing Center - Meeting theme palette - Icon Error": "Error-iconen in connection indicator, notificaties, recording en mic-foutstatussen.",
          "Sharing Center - Meeting theme palette - Link01": "Klikbare links in chat/dialogs/deeplinking/polls/settings/welcome.",
          "Sharing Center - Meeting theme palette - Link01 Active": "Active state van links en enkele mobile/nav actie-accenten.",
          "Sharing Center - Meeting theme palette - Link01 Hover": "Hover state van links in o.a. connection stats/invite/recording/subtitles.",
          "Sharing Center - Meeting theme palette - Success01": "Succes-indicatoren (connection ok, audio-preview ok, success notificaties, prejoin status).",
          "Sharing Center - Meeting theme palette - Success02": "Secundaire success badges/labels (o.a. copy/speaker stats).",
          "Sharing Center - Meeting theme palette - Support01": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support02": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support03": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support04": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support05": "Chat accentkleur (message/recipient highlights).",
          "Sharing Center - Meeting theme palette - Support06": "Tweede chat accentkleur (recipient/status accent).",
          "Sharing Center - Meeting theme palette - Support07": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support08": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Support09": "Momenteel niet gemapt in colorMap en niet gebruikt.",
          "Sharing Center - Meeting theme palette - Text01": "Hoofdtekstkleur in vrijwel alle schermen en kerncomponenten.",
          "Sharing Center - Meeting theme palette - Text02": "Subtekst/placeholder/ondersteunende labels.",
          "Sharing Center - Meeting theme palette - Text03": "Minder prominente of disabled tekst, hulptekst en secondary labels.",
          "Sharing Center - Meeting theme palette - Text04": "Tekst op lichte/gekleurde achtergronden (waarschuwing badges, secondary surfaces).",
          "Sharing Center - Meeting theme palette - Text Error": "Validatie- en foutteksten (o.a. input/select errors, notification error text).",
          "Sharing Center - Meeting theme palette - Ui01": "Hoofdsurfaces van panelen/dialogs/lists in app en zijpanelen.",
          "Sharing Center - Meeting theme palette - Ui02": "Hover/selected surfaces en verhoogde paneldelen.",
          "Sharing Center - Meeting theme palette - Ui03": "Input/select achtergronden, separators, borders en submenu surfaces.",
          "Sharing Center - Meeting theme palette - Ui04": "Lichte randen/achtergronden voor badges, menu-randen en chips.",
          "Sharing Center - Meeting theme palette - Ui05": "Inactieve tracks/borders (switch/tabs/connection/polls/forms).",
          "Sharing Center - Meeting theme palette - Ui06": "Donkere outlines/separators (mobile nav, sliders, recording/polls).",
          "Sharing Center - Meeting theme palette - Ui07": "Sterke scheidingslijn/border kleur in native dialogs/lijsten/menu's.",
          "Sharing Center - Meeting theme palette - Ui08": "Neutrale knopvulling (beperkt gebruikt, met name native button style).",
          "Sharing Center - Meeting theme palette - Ui09": "Subtiele info/highlight achtergrond (labels, speaker stats, recording tags).",
          "Sharing Center - Meeting theme palette - Ui10": "Active tab/notification/chip/track achtergronden en accentvakken.",
          "Sharing Center - Meeting theme palette - Ui Background": "Algemene pagina/scherm achtergrond (basis canvas van app en grote containers).",
          "Sharing Center - Meeting theme palette - Warning01": "Warning badges/indicatoren/notificaties (prejoin, connection, dial-in limits).",
          "Sharing Center - Meeting theme palette - Warning02": "Raised-hand/highlight warning badges in filmstrip/deelnemers/recording/visitors."
        },
        "Help": {}
      }
    },
    "Unsubscribe-mail": {
      "The email address has been successfully unsubscribed": "Het e-mailadres {email} is succesvol uitgeschreven.",
      "The link is invalid": "De link is ongeldig."
    },
    "Users": {
      "After Authenticator QR scan": "Klik na het scannen van de QR-code op {0}.",
      "After install authenticator next": "Nadat u de Authenticator-app op uw apparaat hebt geïnstalleerd, klikt u op {0}.",
      "After setup authenticator account next": "Wanneer u klaar bent om door te gaan, klikt u op {0}.",
      "Active sessions": "Actieve sessies",
      "Active sessions description": "Beheer uw actieve login-sessies per apparaat.",
      "All sessions revoked": "Alle actieve sessies zijn ingetrokken.",
      "Assigned roles": "Toegewezen rollen",
      "Authenticator allow notifications": "Sta meldingen toe wanneer daarom wordt gevraagd.",
      "Authenticator select other account": "Voeg vervolgens een account toe. Wanneer je gebruik maakt van de Microsoft Authenticator-app, selecteer dan \"Ander account\"",
      "Avatar": "Foto kiezen",
      "Avatar item": "Foto",
      "Avatar item fail": "Foto kon niet gewijzigd worden",
      "Avatar item success": "Foto succesvol gewijzigd",
      "Back to login": "Terug naar inloggen",
      "Back to password reset request": "Nieuw wachtwoord aanvragen",
      "Capslock enabled": "Let op: de caps lock toets is ingeschakeld",
      "Profile photo": "Profielfoto",
      "Change photo": "Foto wijzigen",
      "Change view": "Wijzig weergave",
      "Confirm identity fail": "Fout bij het bevestigen van de gebruiker.",
      "Confirm identity success": "Gebruiker {fullName} is bevestigd.",
      "Delete": "verwijderen",
      "Delete item": "Verwijder gebruiker",
      "Delete item fail": "Fout bij het verwijderen van gebruiker.",
      "Delete item success": "Gebruiker {fullName} succesvol verwijderd.",
      "Delete item text": "Weet je zeker dat je het account voor {0} wilt {1}?",
      "Delete user": "Gebruiker verwijderen",
      "Delete user fail": "De gebruiker kon niet worden verwijderd.",
      "Delete user success": "Gebruiker {fullName} succesvol verwijderd.",
      "Delete user text": "Weet je zeker dat je het account voor {0} wilt {1}?",
      "Download Authenticator app": "Download Authenticator app",
      "Download authenticator first": "Download eerst de app",
      "Edit item": "Bewerk gebruiker",
      "Edit item email fail": "Fout bij het aanvragen van de e-mailadreswijziging.",
      "Edit item fail": "Fout bij het bewerken van de gebruiker.",
      "Edit item fail email": "Huidig wachtwoord is onjuist.",
      "Edit item fail profile": "Fout bij het wijzigen van het profiel.",
      "Edit item profile": "Profiel bewerken",
      "Edit item success": "Gebruiker {fullName} is gewijzigd.",
      "Edit item success password": "Wachtwoord is gewijzigd.",
      "Edit item success profile": "Profiel is gewijzigd.",
      "Edit user": "Gebruiker wijzigen",
      "Edit user email fail": "Fout bij het verzoek tot wijzigen van het e-mailadres.",
      "Edit user fail": "Fout bij het wijzigen van de gebruiker.",
      "Edit user success": "Gebruiker {fullName} is gewijzigd.",
      "Email": "E-mailadres",
      "Email address change": "E-mailadres aanpassen",
      "Email change": "Om het @.lower:Shared.Users.Email definitief te wijzigen, is er een bericht naar het nieuwe @.lower:Shared.Users.Email gestuurd met instructies.",
      "Email change success": "Het @.lower:Shared.Users.Email is bevestigd.",
      "Email check": "Contoleer het e-mailadres.",
      "Email edit": "Klik op het pen icoon om het wachtwoord aan te passen.",
      "Email edit header": "Hieronder kunt u het e-mailadres wijzigen.",
      "Email edit message": "{0}: Het nieuwe e-mailadres dient bevestigd te worden. Volg de instructies in de e-mail die naar het nieuwe e-mailadres zijn verzonden.",
      "Email in use": "Het opgegeven e-mailadres is al in gebruik.",
      "Email invalid": "E-mailadres is niet geldig.",
      "Email mandatory": "E-mailadres is verplicht.",
      "Error loading data": "De lijst met gebruikers kon vanwege een fout niet worden geladen.",
      "Errors": {
        "ErrorCode": {
          "TOTP_DEVICE_NAME_MISSING": "Apparaat naam is verplicht.",
          "TOTP_TOKEN_INVALID": "Code is ongeldig."
        }
      },
      "First name": "Voornaam",
      "First name mandatory": "Voornaam is verplicht.",
      "FirstName": "Voornaam",
      "FirstName mandatory": "Voornaam is verplicht.",
      "Forgot": "Wachtwoord vergeten",
      "Help login": "Hulp nodig bij inloggen?",
      "Full name": "Volledige naam",
      "Install authenticator on phone": "Installeer {0} of {1} op uw telefoon.",
      "IsSSO": "Via SSO?",
      "IsVerified": "Activatie bevestigd?",
      "Keep me logged in": "Ingelogd blijven",
      "Last name": "Achternaam",
      "Last name mandatory": "Achternaam is verplicht.",
      "LastActivity": "Laatst actief",
      "LastLoginAt": "Laatst ingelogd",
      "LastName": "Achternaam",
      "LastName mandatory": "Achternaam is verplicht.",
      "Locale": "Taal",
      "LocaleOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Login": "Inloggen",
      "Login failed": "De combinatie gebruikersnaam/wachtwoord is onjuist.",
      "Login with Microsoft": "Inloggen met Microsoft",
      "Login with SSO": "Inloggen met SSO",
      "Lost MFA code?": " Bent u de code kwijt?",
      "Manually add code": "Of voeg de code handmatig toe aan de Authenticator-app.",
      "Mark self": "Jij",
      "MFA enter code": "Voer de code in die wordt weergegeven in de Authenticator-app.",
      "MFA lost code": "Stuur een e‑mail naar {0} met het verzoek om uw beveiligingsinstellingen te verwijderen. Voor uw veiligheid zullen wij uw identiteit moeten verifiëren om dit proces te voltooien. Om het proces soepel te laten verlopen, verzoeken wij u om de e‑mail bij voorkeur vanaf hetzelfde e‑mailadres te versturen en onder vermelding van uw klantnummer.",
      "MFA lost code after setup": "Als u de code verliest, stuur dan een e‑mail naar {0} met het verzoek om uw beveiligingsinstellingen te verwijderen. Voor uw veiligheid zullen wij uw identiteit moeten verifiëren om dit proces te voltooien. Om het proces soepel te laten verlopen, verzoeken wij u om de e‑mail bij voorkeur vanaf hetzelfde e‑mailadres te versturen en onder vermelding van uw klantnummer.",
      "MFA code resent": "Er is een nieuwe code verstuurd.",
      "MFA setup code send failed": "Kon de verificatiecode niet versturen. Probeer het opnieuw.",
      "MFA resend cooldown": "Probeer over {seconds}s opnieuw.",
      "MFA resend blocked": "Probeer over {time} opnieuw.",
      "MFA session expired": "Uw sessie is verlopen. Log opnieuw in om door te gaan.",
      "MFA setup completed": "Voltooid!",
      "MFA setup completed text": "U hebt uw beveiligingsgegevens ingesteld. Klik op {0} om door te gaan met inloggen.",
      "MFA Status": "MFA-status",
      "MFA verify failed": "De opgegeven token is niet geldig.",
      "New item": "Nieuwe gebruiker",
      "New item fail": "Fout bij het toevoegen van de gebruiker. {msg}",
      "New item success": "Gebruiker {fullName} succesvol toegevoegd.",
      "New user": "Gebruiker toevoegen",
      "New user fail": "Fout bij het aanmaken van de gebruiker. {msg}",
      "New user success": "Gebruiker {fullName} succesvol toegevoegd.",
      "No login methods configured": "Er is geen loginmethode geconfigureerd voor dit domein.",
      "Password": "Wachtwoord",
      "Password change": "Wachtwoord wijzigen",
      "Password change message": "Om uw wachtwoord te wijzigen, voer uw oude wachtwoord in en daarna twee keer uw nieuwe wachtwoord.",
      "Password change set": "Voer hieronder uw gewenste wachtwoord in en bevestig dit.",
      "Password checks": {
        "At least n Characters": "Wachtwoord is minimaal {n} tekens lang.",
        "Contains numbers": "Bevat minimaal één cijfer.",
        "Contains special char": "Bevat minimaal één speciaal teken.",
        "Contains uppercase": "Bevat minimaal één hoofdletter.",
        "Digits": "Het wachtwoord moet minimaal 1 cijfer bevatten.",
        "Lowercase": "Het wachtwoord moet minimaal 1 kleine letter bevatten.",
        "Min": "Het wachtwoord moet minimaal {n} tekens lang zijn.",
        "Not_same": "Nieuwe wachtwoorden zijn niet hetzelfde.",
        "Passwords different then old password": "Wachtwoord is niet gelijk aan het huidige wachtwoord.",
        "Passwords equal": "Beide wachtwoorden zijn gelijk.",
        "Same_old": "Het nieuwe wachtwoord is hetzelfde als het oude wachtwoord.",
        "Symbols": "Het wachtwoord moet minimaal 1 symbool bevatten.",
        "Uppercase": "Het wachtwoord moet minimaal 1 hoofdletter bevatten."
      },
      "Password confirm": "Herhaal wachtwoord",
      "Password current": "Huidig wachtwoord",
      "Password fail": "Controleer het wachtwoord.",
      "Password mandatory": "Wachtwoord is verplicht.",
      "Password new": "Nieuw wachtwoord",
      "Password reset": "Wachtwoord resetten",
      "Password reset fail": "Verzoek om wachtwoord opnieuw in te stellen is mislukt. {msg}",
      "Password reset new text": "Voer hieronder het nieuwe wachtwoord in.",
      "Password reset request success": "Er is een e-mail voor het herstellen van uw wachtwoord verstuurd naar {email}.",
      "Password reset success": "Het wachtwoord is succesvol gewijzigd.",
      "Password reset text": "Vul uw e-mailadres in om uw wachtwoord opnieuw in te stellen.",
      "Password reset token invalid": "De link is ongeldig of verlopen.",
      "Phone": "Telefoon",
      "Refresh list": "Lijst met gebruikers vernieuwen",
      "Revoke": "Intrekken",
      "Revoke all sessions": "Alle sessies intrekken",
      "Revoke all sessions text": "Weet u zeker dat u alle actieve sessies wilt intrekken?",
      "Revoke session": "Sessie intrekken",
      "Revoke session text": "Weet u zeker dat u deze sessie wilt intrekken?",
      "Session created at": "Aangemaakt op",
      "Session OS": "OS",
      "Session Browser": "Browser",
      "Session Device": "Apparaat",
      "Session device": "Apparaat",
      "Session expires at": "Verloopt op",
      "Session expires at info": "Deze tijd wordt automatisch verlengd zolang je actief bent, tot de maximale levensduur.",
      "Session list load fail": "Actieve sessies konden niet worden geladen.",
      "Session max lifetime": "Maximale levensduur",
      "Session max lifetime info": "Om te voorkomen dat sessies onbeperkt actief blijven, vervallen ze na een maximale levensduur en moet opnieuw worden ingelogd.",
      "Session revoked": "Sessie is ingetrokken.",
      "IP address": "IP-adres",
      "RegionalSettings": "Regionale instellingen",
      "RegionalSettingsOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Request forgot": "Aanvragen",
      "Resend invite": "Uitnodiging opnieuw versturen",
      "Resend invite button": "Uitnodiging versturen",
      "Resend invite text": "Weet je zeker dat je de uitnodiging aan {fullName} opnieuw wilt versturen?",
      "Resend MFA code": "Code opnieuw sturen",
      "ResendInvite": "Uitnodiging opnieuw versturen",
      "ResendInvite item success": "Uitnodiging opnieuw verzonden.",
      "Reset mfa": "MFA resetten",
      "Reset MFA text": "Weet je zeker dat je Multi-Factor Authenticatie (MFA) wilt resetten voor {fullName}?",
      "ResetMFA": "Herstel MFA",
      "ResetMFA item success": "MFA succesvol gereset.",
      "Roles": "Rol(len)",
      "Roles mandatory": "Er dient tenminste 1 rol te worden toegewezen.",
      "Scan QR code": "Scan de QR-code",
      "Set password": "Wachtwoord instellen",
      "Setup authenticator account": "Authenticator-account instellen",
      "Setup your authenticator account": "Stel uw account in",
      "SSO Microsoft": "Login via {0} Microsoft",
      "Totp device name": "Apparaat naam",
      "Trust MFA device": "Vertrouw dit apparaat voor {days} dagen",
      "Use another MFA method": "Andere methode gebruiken",
      "Use Authenticator app to scan QR code": "Gebruik de Authenticator-app om de QR-code te scannen. Hiermee wordt de Authenticator-app verbonden met uw account.",
      "User": "Gebruiker",
      "Value": "Afbeelding",
      "Verify": "Verifiëren",
      "Verify code": "Controleer de code",
      "Choose MFA method": "Kies een andere verificatiemethode",
      "Choose MFA method text": "Selecteer hoe u uw login wilt bevestigen.",
      "Verify MFA": "Code verifiëren",
      "MFA method authenticator": "Authenticator-app",
      "MFA method authenticator description": "Gebruik een code uit uw Authenticator-app",
      "MFA method authenticator setup description": "Stel de Authenticator-app in en gebruik daarna een code",
      "MFA method email": "E-mail",
      "MFA method email description": "Ontvang een code per e-mail",
      "MFA method sms": "SMS",
      "MFA method sms description": "Ontvang een code per sms",
      "Verify MFA text authenticator": "Bevestig uw login door de code in te voeren die wordt weergegeven in de Authenticator-app op uw apparaat.",
      "Verify MFA text email": "Bevestig uw login door de code in te voeren die naar uw e-mailadres is verzonden.",
      "Verify MFA setup text email": "Bevestig uw login door de code in te voeren die naar uw e-mailadres is verzonden.",
      "Verify MFA text sms": "Bevestig uw login door de code in te voeren die per sms is verzonden.",
      "Verify MFA text": "Bevestig uw login door de code in te voeren die wordt weergegeven in de Authenticator-app op uw apparaat.",
      "Verify token invalid": "De link is ongeldig of verlopen."
    },
    "OverviewCards": {
      "openPurchaseOrders": "Nog te bestellen",
      "awaitingPurchaseOrders": "Wacht op levering",
      "overduePurchaseOrders": "Leverdatum verstreken",
      "reservedStock": "Gereserveerd",
      "availableStock": "Beschikbaar",
      "stockProductCount": "{count} verschillend product | {count} verschillende producten",
      "reservedAssets": "Gereserveerd",
      "supplierWarrantiesExpiring": "Leveranciersgarantie verloopt binnen 30 dagen",
      "customerWarrantiesExpiring": "Klantgarantie verloopt binnen 30 dagen",
      "totals": {
        "stock": "Totaal aanwezig"
      },
      "totalHints": {
        "stock": "Totaal aantal aanwezige stuks over alle locaties en vakken, inclusief gereserveerde voorraad en klantvoorraad."
      },
      "archived": "Gearchiveerd",
      "runningContracts": "Lopende contracten",
      "endingContracts": "Einddatum binnen 30 dagen",
      "licenseProducts": "Licentieproducten",
      "hostingProducts": "Hostingproducten",
      "bundles": "Productbundels",
      "monthly": "Maandelijks",
      "yearly": "Jaarlijks",
      "cancelled": "Opgezegd",
      "sso": "Aanmelden via SSO",
      "verified": "Activatie bevestigd",
      "unverified": "Activatie niet bevestigd",
      "regularUsers": "Persoonlijke accounts",
      "virtualUsers": "Virtuele accounts",
      "apiAccounts": "API-accounts",
      "receivesMail": "Ontvangt e-mail",
      "noMail": "Ontvangt geen e-mail",
      "customAddress": "Afwijkend adres",
      "draftInvoices": "Conceptfacturen",
      "openInvoices": "Openstaande facturen",
      "overdueInvoices": "Betaaltermijn verstreken",
      "autoRenew": "Automatisch verlengen",
      "noAutoRenew": "Zonder automatische verlenging",
      "quarantine": "In quarantaine",
      "wildcard": "Wildcardcertificaten",
      "domainValidated": "Domeinvalidatie",
      "renewSoon": "Verlengen binnen 30 dagen",
      "openTasks": "Open taken",
      "startedTasks": "In uitvoering",
      "doneTasks": "Afgeronde taken",
      "sent": "Verzonden",
      "notSent": "Niet verzonden",
      "lastDay": "Afgelopen 24 uur",
      "delivered": "Afgeleverd",
      "online": "Online",
      "offline": "Offline",
      "defaultGateway": "Standaardgateway",
      "loadFailed": "De totalen konden niet worden geladen. De tabel blijft beschikbaar.",
      "active": "Actief",
      "withDefaultContract": "Met standaardcontract",
      "recentlyCreated": "Toegevoegd in 30 dagen",
      "recentlyUpdated": "Bijgewerkt in 7 dagen",
      "withRoles": "Met rollen",
      "withContract": "Met contract",
      "withSupplierContract": "Met contractafspraak",
      "invoicedEntries": "Gefactureerde registraties",
      "uninvoicedEntries": "Nog te factureren",
      "queued": "Klaar voor verzending",
      "awaitingApproval": "Wacht op goedkeuring",
      "failed": "Mislukt",
      "enabled": "Ingeschakeld",
      "disabled": "Uitgeschakeld",
      "draftOffers": "Conceptoffertes",
      "sentOffers": "Verstuurde offertes",
      "acceptedOffers": "Geaccepteerde offertes",
      "activeHosting": "Actieve hosting",
      "pendingHosting": "Hosting in afwachting",
      "suspendedHosting": "Geblokkeerde hosting",
      "publicProfiles": "Openbare profielen",
      "meetingProfiles": "Vergaderprofielen",
      "chatProfiles": "Chatprofielen",
      "inbound": "Inkomend bellen",
      "outbound": "Uitgaand bellen",
      "encryptedTransport": "Beveiligd met TLS",
      "internalRoles": "Interne rollen",
      "customerRoles": "Klantrollen",
      "pendingInvitations": "Openstaande uitnodigingen",
      "acceptedInvitations": "Geaccepteerde uitnodigingen",
      "total": "{name} totaal",
      "totalHint": "Totaal aantal geregistreerde items.",
      "hints": {
        "openPurchaseOrders": "Inkooporders met de status Open.",
        "awaitingPurchaseOrders": "Bestelde of deels ontvangen inkooporders waarop nog aantallen openstaan.",
        "overduePurchaseOrders": "Bestelde of deels ontvangen orders met een nog te ontvangen regel waarvan de verwachte leverdatum vóór vandaag ligt. De regeldatum gaat voor de algemene verwachte leverdatum.",
        "reservedStock": "Aantal aanwezige stuks dat is gereserveerd voor verkooporders.",
        "availableStock": "Aantal aanwezige stuks dat niet is gereserveerd. Klantvoorraad blijft bestemd voor de gekoppelde klant.",
        "reservedAssets": "Aanwezige assets die aan een verkooporder zijn gereserveerd.",
        "supplierWarrantiesExpiring": "Assets met een lopende leveranciersgarantie die vandaag of binnen 30 dagen afloopt. Afgeschreven assets tellen niet mee.",
        "customerWarrantiesExpiring": "Assets met een gestarte klantgarantie die vandaag of binnen 30 dagen afloopt. Afgeschreven assets tellen niet mee.",
        "runningContracts": "Contracten die zijn ingegaan en waarvan de einddatum nog niet is verstreken.",
        "endingContracts": "Contracten die binnen 30 dagen aflopen.",
        "licenseProducts": "Producten die als licentie worden aangeboden.",
        "hostingProducts": "Producten voor webhosting.",
        "bundles": "Producten die meerdere onderdelen bundelen.",
        "monthly": "Abonnementen met een maandelijkse factuurperiode.",
        "yearly": "Abonnementen met een jaarlijkse factuurperiode.",
        "cancelled": "Abonnementen waarvoor een opzegging is vastgelegd.",
        "sso": "Gebruikers die via Single Sign-On aanmelden.",
        "verified": "Gebruikers die hun accountactivatie hebben bevestigd.",
        "unverified": "Gebruikers die hun accountactivatie nog niet hebben bevestigd.",
        "regularUsers": "Persoonlijke accounts die aan een klant zijn gekoppeld. Een account kan bij meerdere klanten voorkomen.",
        "virtualUsers": "Virtuele accounts die aan een klant zijn gekoppeld, bijvoorbeeld voor een gedeelde functie.",
        "apiAccounts": "Accounts voor toegang via de API.",
        "receivesMail": "Contacten waarvoor het ontvangen van e-mail is ingeschakeld.",
        "noMail": "Contacten waarvoor het ontvangen van e-mail is uitgeschakeld.",
        "customAddress": "Contacten met een eigen adres in plaats van het adres van de relatie.",
        "draftInvoices": "Facturen die nog als concept klaarstaan.",
        "openInvoices": "Uitgegeven facturen waarvan nog een bedrag moet worden betaald.",
        "autoRenew": "Domeinen waarvoor automatische verlenging is ingeschakeld.",
        "noAutoRenew": "Domeinen waarvoor automatische verlenging is uitgeschakeld.",
        "quarantine": "Domeinen met de status quarantaine.",
        "wildcard": "Certificaten die meerdere subdomeinen beveiligen.",
        "domainValidated": "Certificaten met domeinvalidatie (DV).",
        "renewSoon": "Certificaten met een verlengdatum binnen 30 dagen.",
        "openTasks": "Taken die nog niet zijn gestart.",
        "startedTasks": "Taken waaraan wordt gewerkt.",
        "doneTasks": "Taken die als afgerond zijn gemarkeerd.",
        "sent": "Berichten waarvoor een geslaagde verzending is geregistreerd.",
        "notSent": "Berichten waarvoor nog geen geslaagde verzending is geregistreerd.",
        "lastDay": "Gebeurtenissen van de afgelopen 24 uur.",
        "delivered": "SMS-berichten waarvan de aflevering is bevestigd.",
        "online": "VPN-certificaten met een actieve verbinding.",
        "offline": "VPN-certificaten met de status offline.",
        "defaultGateway": "VPN-certificaten waarbij de VPN-verbinding als standaardgateway is ingesteld.",
        "active": "Items die niet zijn gearchiveerd.",
        "withDefaultContract": "Actieve klanten met een ingesteld standaardcontract.",
        "recentlyCreated": "Toegevoegd in de afgelopen 30 dagen.",
        "recentlyUpdated": "Gewijzigd in de afgelopen 7 dagen.",
        "withRoles": "Accounts met ten minste één toegewezen rol.",
        "withContract": "Projecten die aan een contract zijn gekoppeld.",
        "withSupplierContract": "Actieve leveranciers met minimaal één vastgelegde contractreferentie.",
        "invoicedEntries": "Urenregistraties die als gefactureerd zijn gemarkeerd.",
        "uninvoicedEntries": "Urenregistraties die nog niet als gefactureerd zijn gemarkeerd.",
        "queued": "Goedgekeurde e-mails die nog moeten worden verzonden. Een eerdere verzendpoging kan zijn mislukt.",
        "awaitingApproval": "E-mails waarvan verzending nog moet worden goedgekeurd.",
        "failed": "Mislukte verwerkingen. Bij e-mail is de melding nog niet succesvol verzonden.",
        "enabled": "Items die zijn ingeschakeld voor gebruik.",
        "disabled": "Items die zijn uitgeschakeld.",
        "draftOffers": "Offertes die nog als concept klaarstaan.",
        "sentOffers": "Offertes met de status verstuurd.",
        "acceptedOffers": "Offertes die zijn geaccepteerd.",
        "activeHosting": "Hostingaccounts met de status actief.",
        "pendingHosting": "Hostingaccounts die nog in afwachting zijn.",
        "suspendedHosting": "Hostingaccounts waarvan het gebruik is geblokkeerd.",
        "publicProfiles": "Profielen die openbaar beschikbaar zijn.",
        "meetingProfiles": "Profielen voor het plannen van vergaderingen.",
        "chatProfiles": "Profielen voor chatgesprekken.",
        "inbound": "Telefoonnummers waarop inkomende gesprekken zijn toegestaan.",
        "outbound": "Telefoonnummers waarmee uitgaande gesprekken zijn toegestaan.",
        "encryptedTransport": "SIP-accounts die TLS gebruiken voor beveiligde signalering.",
        "internalRoles": "Rollen voor interne Vision-gebruikers.",
        "customerRoles": "Rollen voor gebruikers van het klantportaal.",
        "pendingInvitations": "Uitnodigingen die nog niet zijn geaccepteerd en nog geldig zijn.",
        "acceptedInvitations": "Uitnodigingen die zijn geaccepteerd.",
        "archived": "Items die als archief worden bewaard.",
        "overdueInvoices": "Openstaande facturen waarvan de betaaltermijn is verstreken.",
        "initializedBatches": "Incassobatches waarvoor het batchbestand nog moet worden aangemaakt.",
        "generatedBatches": "Incassobatches waarvoor het batchbestand is aangemaakt.",
        "withoutRoles": "Accounts zonder toegewezen rollen.",
        "recentAuditEvents": "Geregistreerde activiteiten van de afgelopen 24 uur.",
        "failedAuditEvents": "Activiteiten waarbij een fout is geregistreerd.",
        "impersonatedAuditEvents": "Activiteiten uitgevoerd tijdens een gebruikersovername."
      },
      "selectionHint": "Statistieken voor de geselecteerde periode en filters.",
      "initializedBatches": "Openstaande batches",
      "generatedBatches": "Verwerkte batches",
      "withoutRoles": "Zonder rollen",
      "recentAuditEvents": "Gebeurtenissen in 24 uur",
      "failedAuditEvents": "Fouten",
      "impersonatedAuditEvents": "Via gebruikersovername"
    },
    "OverviewTitles": {
      "email-logs": "E-maillogs",
      "email-queue": "E-mailwachtrij",
      "email-triggers": "E-mailtriggers",
      "sms-logs": "SMS-logs",
      "suppliers": "Leveranciers",
      "supplier-contacts": "Leverancierscontacten"
    },
    "DialogSubtitles": {
      "services": {
        "customers": "Klantgegevens, contactpersonen en gekoppelde diensten.",
        "customer-contacts": "Contactgegevens en communicatievoorkeuren van de klant.",
        "contracts": "Contractafspraken, facturatie en gekoppelde abonnementen.",
        "contacts": "Contactgegevens voor domeinregistratie en hosting.",
        "products": "Productgegevens, prijzen en beschikbaarheid.",
        "product-groups": "Indeling van producten en bijbehorende instellingen.",
        "subscriptions": "Producten, looptijd en facturatie van het abonnement.",
        "customer-offers": "Producten, prijzen en voorwaarden van de offerte.",
        "sales-orders": "Bestelgegevens, orderregels en verwerking.",
        "invoices": "Factuurgegevens, factuurregels en betaalstatus.",
        "sepa": "Incasso-opdrachten en verwerking van de batch.",
        "licenses": "Licentiegegevens, gebruik en gekoppelde gebruikers.",
        "license-slas": "Serviceafspraken en beschikbaarheidsvoorwaarden.",
        "license-partner-programs": "Partnerafspraken en bijbehorende licentievoorwaarden.",
        "webhosting": "Hostingpakket, domeinen en accountinstellingen.",
        "webhosting-packages": "Pakketinstellingen, capaciteit en beschikbare functies.",
        "domains": "Domeinregistratie, contactpersonen en DNS-instellingen.",
        "domain-ns-groups": "Nameservers die samen voor domeinen worden gebruikt.",
        "ssl-certificates": "Certificaatgegevens, domeinen en geldigheidsduur.",
        "projects": "Projectgegevens, planning en verantwoordelijken.",
        "project-tasks": "Taakgegevens, planning en voortgang.",
        "project-task-types": "Taakcategorie en bijbehorende instellingen.",
        "project-task-time-tracking": "Geregistreerde tijd en verwerking in de facturatie.",
        "users": "Gebruikersgegevens, toegang en accountinstellingen.",
        "customer-users": "Gebruikersaccount en toegang tot de klantomgeving.",
        "customer-api-accounts": "API-account en toegang tot klantgegevens.",
        "roles": "Rechten en toegang tot onderdelen van Vision.",
        "account-invitations": "Uitnodiging en toegang tot de klantomgeving.",
        "settings": "Instellingen en waarden voor dit onderdeel.",
        "whitelabels": "Huisstijl, afzendergegevens en portaalinstellingen.",
        "vat": "Btw-tarief en toepassing op factuurregels.",
        "audit-logs": "Uitgevoerde actie, betrokken gebruiker en vastgelegde wijzigingen.",
        "dmarc": "Resultaten van e-mailauthenticatie en rapportgegevens.",
        "feedback-questions": "Vraagstelling, antwoordmogelijkheden en toepassing.",
        "email-queue": "Berichtinhoud, ontvangers en geplande verzending.",
        "email-logs": "Verzonden bericht, ontvangers en afleverstatus.",
        "email-triggers": "Voorwaarden, ontvangers en planning van automatische e-mails.",
        "sms-logs": "Berichtinhoud, ontvanger en afleverstatus.",
        "vpn-certificates": "Certificaat en toegang tot het VPN-netwerk.",
        "vpn-firewalls": "Firewallregels, toegangsbeleid en verificatie.",
        "vpn-mac-address-groups": "Apparaten die samen voor netwerktoegang worden gebruikt.",
        "sharingcenter-calendars": "Agenda-instellingen, eigenaar en beschikbaarheid.",
        "sharingcenter-contacts": "Contactgegevens, eigenaarschap en gedeelde toegang.",
        "sharingcenter-groups": "Groepsgegevens, leden en gedeelde toegang.",
        "sharingcenter-profiles": "Profielinstellingen, beschikbaarheid en communicatie.",
        "sharingcenter-calendar-appointments": "Afspraakgegevens, deelnemers en beschikbaarheid.",
        "sharingcenter-meeting-files": "Opnames, transcripties en notulen van de vergadering.",
        "customer-sip-accounts": "Telefonie-account, verbinding en beveiliging.",
        "customer-phone-numbers": "Telefoonnummer, routering en gebruik.",
        "ai-queue": "Verwerkingsopdracht, status en resultaat.",
        "customer-assets": "Gekoppelde systemen en de status van klantassets.",
        "profile": "Persoonlijke gegevens en accountinstellingen."
      },
      "actions": {
        "details": "Bekijk de gegevens en beschikbare acties.",
        "delete": "Controleer de selectie voordat je deze verwijdert.",
        "export": "Exporteer de geselecteerde gegevens naar een bestand.",
        "preview": "Voorbeeld van het geselecteerde bestand.",
        "color": "Kies een kleur of voer een kleurcode in.",
        "profilePhoto": "Bekijk of wijzig de afbeelding van je profiel.",
        "changeEmail": "Wijzig het e-mailadres waarmee je je aanmeldt.",
        "emailChanged": "Je account gebruikt voortaan het nieuwe e-mailadres.",
        "changePassword": "Stel een nieuw wachtwoord in voor je account.",
        "resetMfa": "Laat de gebruiker multifactorauthenticatie opnieuw instellen.",
        "resendInvite": "Stuur de gebruiker opnieuw een uitnodiging voor het portaal.",
        "revokeInvite": "Trek de toegang via deze uitnodiging in.",
        "reissueInvite": "Maak een nieuwe uitnodiging voor deze ontvanger.",
        "apiToken": "Bekijk het API-token voor dit account.",
        "regenerateToken": "Vervang het bestaande API-token van dit account.",
        "rotateWebhookSecret": "Vervang de ondertekeningssleutel van deze webhook.",
        "retryWebhookDelivery": "Bied deze webhook-aflevering opnieuw aan bij de ontvanger.",
        "copyRoles": "Neem de roltoewijzingen van een andere gebruiker over.",
        "assignRoles": "Selecteer de rollen voor de betreffende gebruiker of klant.",
        "restoreSetting": "Herstel de standaardwaarde van deze instelling.",
        "refreshAssets": "Haal de actuele gegevens op voor de geselecteerde klanten.",
        "approveMail": "Geef de geselecteerde berichten vrij voor verzending.",
        "removeMail": "Verwijder de geselecteerde berichten uit de wachtrij.",
        "requeueMail": "Zet de geselecteerde berichten opnieuw klaar voor verzending.",
        "retryJob": "Bied deze opdracht opnieuw aan voor verwerking.",
        "confirmTime": "Controleer de geregistreerde uren en de gekozen verwerking.",
        "changeAppointmentProfile": "Kies welke profielinstellingen voor de afspraak worden gebruikt.",
        "deleteOccurrence": "Verwijder alleen deze afspraak uit de reeks.",
        "deleteFutureOccurrences": "Verwijder deze afspraak en de volgende afspraken uit de reeks.",
        "revokeSession": "Beëindig de toegang via deze aanmeldsessie.",
        "revokeAllSessions": "Beëindig de toegang via alle getoonde aanmeldsessies.",
        "deleteTranscript": "Verwijder de opgeslagen transcriptie van deze opname.",
        "deleteMinutes": "Verwijder de opgeslagen notulen van deze vergadering.",
        "deleteRecording": "Verwijder het geselecteerde opnamebestand.",
        "deleteAllRecordings": "Verwijder alle opnamebestanden van deze vergadering.",
        "createTranscript": "Kies de taal en instellingen voor de transcriptie.",
        "createMinutes": "Kies de instellingen voor het opstellen van de notulen.",
        "changeOwner": "Draag het eigenaarschap van de agenda over.",
        "changeSharing": "Controleer de wijzigingen in eigenaarschap en gedeelde toegang.",
        "futureAppointments": "Bepaal wat er met de toekomstige afspraken gebeurt.",
        "deleteCalendar": "Controleer welke agenda en afspraken worden verwijderd.",
        "calendarColor": "Kies de kleur waarmee deze agenda wordt weergegeven.",
        "upgrade": "Vergelijk de kosten van de huidige en nieuwe abonnementskeuze.",
        "domainTransferCode": "Gebruik deze code om het domein naar een andere provider te verhuizen.",
        "domainDnssec": "Beheer de DNSSEC-beveiliging van dit domein.",
        "domainRestore": "Herstel de registratie van het geselecteerde domein.",
        "domainForceDelete": "Controleer de voorwaarden voor het verwijderen van dit domein.",
        "domainMove": "Verhuis het domein en bepaal de afhandeling van het huidige abonnement.",
        "domainHosting": "Koppel het domein aan een ander hostingaccount.",
        "hostingUpgrade": "Kies een nieuw hostingpakket en controleer de kosten.",
        "hostingDetails": "Kies de ontvanger van de hostingaccountgegevens.",
        "uploadPrices": "Importeer productprijzen en controleer de wijzigingen.",
        "acceptOffer": "Controleer de offerte en bevestig de acceptatie.",
        "rejectOffer": "Leg vast waarom deze offerte wordt afgewezen.",
        "invoiceMail": "Kies welk factuurbericht naar de klant wordt verstuurd.",
        "licenseConditions": "Voorwaarden die gelden voor het gebruik van de licentie.",
        "syncPrices": "Werk abonnementsprijzen bij op basis van de productprijzen.",
        "contractTakeover": "Verplaats het abonnement naar een ander contract.",
        "cancelSubscription": "Leg de einddatum en afhandeling van het abonnement vast.",
        "undoCancellation": "Maak de geplande opzegging van het abonnement ongedaan.",
        "confirmMail": "Controleer het bericht en de ontvangers voordat je het klaarzet.",
        "downloadVpn": "Download het certificaat voor de VPN-verbinding.",
        "createInvoice": "Zet de geselecteerde uren om naar factuurregels.",
        "rawReport": "Bekijk de oorspronkelijke gegevens van het DMARC-rapport."
      }
    },
    "ApiAccounts": {
      "IP whitelist": "IP-whitelist",
      "IP whitelist hint": "Leeg = toegang vanaf elk IP-adres. Vul één publiek IPv4- of IPv6-adres per regel in. Komma’s zijn ook toegestaan.",
      "Invalid IP whitelist": "Vul maximaal 100 geldige, losse IPv4- of IPv6-adressen in, zonder poort of subnet.",
      "All IP addresses": "Alle IP-adressen"
    },
    "Webhooks": {
      "Tabs": {
        "webhooks": "Configuraties",
        "webhook-queue": "Afleveringen",
        "webhook-logs": "Logs"
      },
      "Fields": {
        "name": "Naam",
        "scope": "Bereik",
        "customer": "Klant",
        "service": "Service",
        "events": "Gebeurtenissen",
        "destinationHost": "Bestemming",
        "adminOnly": "Alleen Admin",
        "active": "Actief",
        "webhookName": "Webhook",
        "method": "Gebeurtenis",
        "status": "Status",
        "attempts": "Pogingen",
        "attempt": "Poging",
        "statusCode": "HTTP-status",
        "errorCode": "Foutcode",
        "createdAt": "Tijdstip",
        "eventId": "Gebeurtenis-ID",
        "recordId": "Record-ID",
        "durationMs": "Duur",
        "finishedAt": "Afgerond op"
      },
      "Global": "Alle klanten",
      "Scopes": {
        "customer": "Eén klant",
        "global": "Alle klanten"
      },
      "Events": {
        "create": "Aanmaken",
        "patch": "Wijzigen"
      },
      "Statuses": {
        "queued": "In wachtrij",
        "processing": "In verwerking",
        "retry": "Opnieuw proberen",
        "delivered": "Afgeleverd",
        "failed": "Mislukt",
        "cancelled": "Geannuleerd"
      },
      "ReadOnlyHelp": "Deze webhook wordt beheerd door de beheerder. U kunt de configuratie bekijken, maar niet wijzigen.",
      "SetupHelp": "Gebruik een openbare HTTPS-URL op poort 443. Nieuwe webhooks zijn uitgeschakeld. Configureer eerst de sleutel bij de ontvanger en activeer daarna de webhook.",
      "AdminSetupHelp": "Gebruik een HTTPS-URL met een geldig certificaat. Admin kan ook interne bestemmingen en een eigen poort instellen. Nieuwe webhooks zijn uitgeschakeld. Configureer eerst de sleutel bij de ontvanger en activeer daarna de webhook.",
      "AdminOnlyHelp": "Deze bestemming wordt alleen in Admin beheerd. De configuratie, afleveringen en logs zijn niet zichtbaar in de klantportal.",
      "SecretOnce": "Deze sleutel wordt één keer getoond. Kopieer hem nu naar de ontvanger. Een nieuwe sleutel vervangt direct de oude.",
      "Rotate": "Sleutel vernieuwen",
      "RotateWarning": "De huidige sleutel wordt direct ongeldig. Ingeplande afleveringen worden geannuleerd; je kunt bewaarde afleveringen handmatig opnieuw aanbieden.",
      "Remove": "Webhook verwijderen",
      "RemoveWarning": "Webhook {name} verwijderen? Ingeplande afleveringen worden geannuleerd.",
      "Retry": "Opnieuw aanbieden",
      "RetryWarning": "Deze aflevering opnieuw aanbieden met de huidige webhookconfiguratie? De ontvanger krijgt dezelfde event-ID en payload. De ontvanger moet dubbele events kunnen herkennen.",
      "Details": "Details bekijken",
      "PayloadExpired": "De payload is verlopen. Metadata en afleverlogs blijven 90 dagen beschikbaar.",
      "Enabled": "Actief",
      "Disabled": "Uitgeschakeld",
      "Payload": "Payload",
      "Empty": {
        "webhooks": "Er zijn nog geen webhooks ingesteld.",
        "webhook-queue": "Er zijn nog geen webhook-afleveringen.",
        "webhook-logs": "Er zijn nog geen webhooklogs."
      }
    }
  }
}
